(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /*
                                                                            * Actions
                                                                            *
                                                                            * See app.js on how this is being used.
                                                                            * 
                                                                            */

/**
                                                                                                                                                               * App default state
                                                                                                                                                               * @return {[Object]} [app default states]
                                                                                                                                                               */
var getDefaultAppState = exports.getDefaultAppState = function getDefaultAppState() {return {
				modal: undefined, // object: app modal data
				currentActivePage: undefined, // string. current active page(home, contact)
				userLogin: false, // bool: check if user logined
				orientation: undefined, // string: window orientation
				bp: undefined, // string: breakpoints
				viewmode: undefined, // string: breakpoints. See enum/index
				currentPage: undefined, // object: current active page object
				isPageHidden: false, // bool
				isSidbarActive: false, // bool
				isLangSelectorActive: false, // bool
				searchProps: undefined, // Object: app search data
				scrollTop: 0, // Number: window scroll value
				lastScrollTop: 0, // Number: window scroll value
				hasHero: true, // bool
				brightcoveinstalled: false };};


/**
                                                                       * App default props
                                                                       * @return {[Object]} [app default props]
                                                                       */
var getDefaultProps = exports.getDefaultProps = function getDefaultProps() {return {
				//version: '1.1.0',
				locale: '',
				//theme: '',
				brightcoveURL: '',
				browserVer: void 0,
				touchSupport: false,
				rootURL: ''
				//isLocal: window.location.href.indexOf('localhost') !== -1,
		};};

var APP_BP_CHANGE = exports.APP_BP_CHANGE = 'app:breakPointChange';
var bpChange = exports.bpChange = function bpChange() {var bp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;return (
				{
						type: APP_BP_CHANGE,
						bp: bp });};



var APP_SCROLL_TOP_CHANGE = exports.APP_SCROLL_TOP_CHANGE = 'app:scrollY';
var scrollTopChange = exports.scrollTopChange = function scrollTopChange() {var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;return (
				{
						type: APP_SCROLL_TOP_CHANGE,
						scrollTop: scrollTop });};



var APP_PAGE_VISIBILITY = exports.APP_PAGE_VISIBILITY = 'app:pageVisibility';
var pageVisibilityChange = exports.pageVisibilityChange = function pageVisibilityChange() {var isPageHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;return (
				{
						type: APP_PAGE_VISIBILITY,
						isPageHidden: isPageHidden });};



var APP_SIDEBAR = exports.APP_SIDEBAR = 'app:sidebar';
var sideBarAction = exports.sideBarAction = function sideBarAction(isSidbarActive) {return (
				{
						type: APP_SIDEBAR,
						isSidbarActive: isSidbarActive });};



var APP_LANG_SELECTOR = exports.APP_LANG_SELECTOR = 'app:langSelector';
var langSelector = exports.langSelector = function langSelector(isLangSelectorActive) {return (
				{
						type: APP_LANG_SELECTOR,
						isLangSelectorActive: isLangSelectorActive });};



var APP_SHOW_SEARCH = exports.APP_SHOW_SEARCH = 'app:showsearch';
var globalSearch = exports.globalSearch = function globalSearch(searchProps) {return (
				{
						type: APP_SHOW_SEARCH,
						searchProps: searchProps });};



var APP_POPUP = exports.APP_POPUP = 'app:popup';
var showPopup = exports.showPopup = function showPopup(content) {return (
				{
						type: APP_POPUP,
						content: content });};



var APP_VIDEO = exports.APP_VIDEO = 'app:video';

},{}],2:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.appActions = undefined;




var _appAction = require('./app-action');var appActions = _interopRequireWildcard(_appAction);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}exports.

appActions = appActions; /*
                         * Action index
                         * 
                         */

},{"./app-action":1}],3:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; /*
                                                                                                                                                                                                                                                                                                                                   * UI Component Mixin
                                                                                                                                                                                                                                                                                                                                   * 
                                                                                                                                                                                                                                                                                                                                   * @version 0.1
                                                                                                                                                                                                                                                                                                                                   */


/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * This fn handles the very first initiation process on objects that inherit this.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * @return {[type]} [description]
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */
var init = function init() {var extraState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	/**
                                                                                                                                                                                                                                          * rId: random id
                                                                                                                                                                                                                                          * cId: component id used to get the js object
                                                                                                                                                                                                                                          */
	var created = '' + new Date().getTime();
	var rId = Math.floor(Math.random() * 9999);
	var cId = this.name + '-' + created.substr(created.length - 4) + '-' + rId;

	this.el.setAttribute('cId', cId);
	this.cId = cId;

	if (!Object.prototype.hasOwnProperty.call(this, 'state')) {

		this.prevState = null;
		this.state = Object.assign({ init: true }, extraState);

	}

};

/**
       * This method updates any state change and subsequently calls onStateUpdate method if exist to handle post-change state.
       *
       * @param  {Object} newStates - incoming new states
       * @param  {Boolean} notifyUpdate - flag whether onStateUpdate method gets called or not
       * @return {Object} - returning self
       */
var setState = function setState(newStates) {var notifyUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

	this.prevState = _extends({}, this.state);
	this.state = Object.assign(this.state, newStates);

	var eq = function eq(obj1, obj2) {

		var props1 = Object.getOwnPropertyNames(obj1);
		var props2 = Object.getOwnPropertyNames(obj2);

		if (props1.length === props2.length) {

			var isEqual = true;

			props1.forEach(function (k) {

				if (obj1[k] !== obj2[k]) {

					isEqual = false;

				}


			});
			return isEqual;

		}

		return false;

	};

	if (notifyUpdate && !eq(this.prevState, this.state) && typeof this.onStateUpdate === 'function') {

		this.onStateUpdate();

	}

	return this;

};

/**
       * getter method to get string value of object.
       * @return {String} object name
       */
var getName = function getName() {return undefined.name;};exports.


init = init;exports.
setState = setState;exports.
getName = getName;

},{}],4:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });








var _uiFilter = require('./ui-filter');var _uiFilter2 = _interopRequireDefault(_uiFilter);
var _uiInput = require('./ui-input');var _uiInput2 = _interopRequireDefault(_uiInput);
var _uiDots = require('./ui-dots');var _uiDots2 = _interopRequireDefault(_uiDots);

var _uiDropdownlist = require('./ui-dropdownlist');var _uiDropdownlist2 = _interopRequireDefault(_uiDropdownlist);
var _uiPagination = require('./ui-pagination');var _uiPagination2 = _interopRequireDefault(_uiPagination);
var _uiCheckbox = require('./ui-checkbox');var _uiCheckbox2 = _interopRequireDefault(_uiCheckbox);
var _uiSelector = require('./ui-selector');var _uiSelector2 = _interopRequireDefault(_uiSelector);
var _uiSelectorOrderby = require('./ui-selector-orderby');var _uiSelectorOrderby2 = _interopRequireDefault(_uiSelectorOrderby);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/**
                                                                                                                                                                                                                                                                                                                                                                                                                                                           * Component List Map holding references
                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                                                                                           * @name of component - this should match [data-name] attribute on dom element
                                                                                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                                                                                           * e.g.
                                                                                                                                                                                                                                                                                                                                                                                                                                                           * [{name of component}, Component Object]
                                                                                                                                                                                                                                                                                                                                                                                                                                                           */ /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * Component Index
                                                                                                                                                                                                                                                                                                                                                                                                                                                              *
                                                                                                                                                                                                                                                                                                                                                                                                                                                              * 
                                                                                                                                                                                                                                                                                                                                                                                                                                                              */ /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Load all components to be used.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                  */var componentList = new Map([['ui-filter', _uiFilter2.default], ['ui-input', _uiInput2.default], ['ui-dots', _uiDots2.default], //['ui-dropdown', UIDropDown],
['ui-dropdownlist', _uiDropdownlist2.default], ['ui-pagination', _uiPagination2.default],
['ui-checkbox', _uiCheckbox2.default],
['ui-selector', _uiSelector2.default],
['ui-selector-orderby', _uiSelectorOrderby2.default]]);


/**
                                                                                                                 * UIComponent prototype
                                                                                                                 * @type {Object}
                                                                                                                 */ //import UIDropDown from './ui-dropdown';
var UIComponent = {

  /**
                                        * method that to handle inheritance
                                        * @param  {[Object]} props []
                                        * @param  {[HTMLElement]} el    [registered dom element]
                                        * @return {[Object]}       [extended component object]
                                        */
  create: function create(props, el) {

    var proto = componentList.get(props.name) ? componentList.get(props.name) : {};
    var c = this.extend(proto, props);
    c.el = el;
    return c;

  },

  /**
         * Simple concatenation method.
         * @param  {[Object]} extentions [concat properties to the object]
         * @return {[Object]}            [self]
         */
  extend: function extend() {

    var obj = Object.create(this); // delegation

    // concat with extention
    for (var _len = arguments.length, extentions = Array(_len), _key = 0; _key < _len; _key++) {extentions[_key] = arguments[_key];}var _loop = function _loop(i) {

      var ext = extentions[i];

      Object.getOwnPropertyNames(ext).forEach(function (p) {

        obj[p] = ext[p];

      });};for (var i = 0; i < extentions.length; i++) {_loop(i);

    }

    return obj;

  } };exports.default =


UIComponent;

},{"./ui-checkbox":5,"./ui-dots":6,"./ui-dropdownlist":7,"./ui-filter":8,"./ui-input":9,"./ui-pagination":10,"./ui-selector":12,"./ui-selector-orderby":11}],5:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });









var _action = require('./action');function _toConsumableArray(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;} else {return Array.from(arr);}} /*
                                                                                                                                                                                                                             * UI Checkbox/tab component
                                                                                                                                                                                                                             *
                                                                                                                                                                                                                             * use:
                                                                                                                                                                                                                             *
                                                                                                                                                                                                                             * class="ui-component ui-checkbox" data-name="ui-checkbox"
                                                                                                                                                                                                                             *
                                                                                                                                                                                                                             * 
                                                                                                                                                                                                                             */var UICheckbox = { refs: {}, /**
                                                                                                                                                                                                                                                             * Initialize component
                                                                                                                                                                                                                                                             * See action.js init.
                                                                                                                                                                                                                                                             */init: function init() {var _this = this;
		// call super
		_action.init.call(this);

		var items = [].slice.call(this.el.querySelectorAll('.ui-checkbox-item')); // filter items
		var listRef = this.el.querySelector('.ui-checkbox-list');
		//const arrows = [].slice.call(this.el.querySelectorAll('.ui-checkbox-arrow')); // arrow ui, optional

		// ref
		this.refs = {
			list: listRef,
			items: items
			//arrows,
		};

		this.refs.items.forEach(function (item) {
			var checkbox = item.querySelector('input[type=checkbox]');
			if (checkbox) {
				checkbox.addEventListener('change', _this.inputHandler.bind(_this));
			}
		});

		/*not used
          		this.refs.arrows.forEach(arrow => {
          			arrow.addEventListener('click', this.arrowHandler.bind(this));
          		});
          */
		// active can be set initially
		var id = this.refs.items.findIndex(function (f) {return f.classList.contains('active');});
		var currentItems = [];

		if (id !== -1) {
			currentItems.push(id);
		}

		// default state
		this.state = {
			//		direction: undefined,
			//		ticker: undefined,
			//		slideId: 0,
			//		min: 0,
			//		max: 0,
			//		uiEnabled: false,
			currentItems: currentItems };


		//	this.translate();
	},

	/**
        * Input events handlers
        * @param  {[Event]} e [various events]
        */
	inputHandler: function inputHandler(e) {var

		currentItems = this.state.currentItems;
		var t = e.target;

		var i = this.refs.items.findIndex(function (item) {return item.querySelector('input[type=checkbox]') === t;});
		var j = currentItems.indexOf(i);

		if (j === -1) {
			currentItems.push(i);
		} else {
			// remove
			currentItems.splice(j, 1);
		}

		this.setState({
			currentItems: [].concat(_toConsumableArray(currentItems)) });


	},

	/**
        * Handle Arrow UI when it's enabled.
        * @param  {[MouseEvent]} e [click event.]
        */
	/*not used
                  arrowHandler(e) {
                  	e.preventDefault();
                  	const { min, max, slideId } = this.state;
                  	if (slideId >= min && slideId <= max) {
                  		this.setState({
                  			slideId: e.target.dataset['type'] === 'left' ? slideId - 1 : slideId + 1,
                  		});
                  	}
                  },
                  */

	/**
                                * See action.js setState
                                */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var


		currentItems =


		this.state.currentItems;

		if (this.prevState.currentItems !== currentItems) {
			this.update();

			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
				this.onChange.apply(null, [this, 'uiCheckboxChange']);
			}
		}

		/*	not used
      	if (this.prevState.slideId !== slideId) {
      		this.translate();
      	}
      	if (this.prevState.uiEnabled !== uiEnabled) {
      		this.el.classList[uiEnabled ? 'add' : 'remove']('show-arrow-ui');
      	}
      */
	},

	/**
        * Browser reisze
        */
	resize: function resize() {
		//this.checkUI();
		//this.el.querySelector('.ui-checkbox-masker').scrollLeft = 0;
	},

	// check if this needs arrow ui
	/* not used
 checkUI() {
 	// check if this needs arrow ui
 	const list = this.refs.list;
 	const lastItem = this.refs.items.slice(0).pop();
 	const totalW = lastItem.offsetWidth + lastItem.offsetLeft;
 	const maskerW = list.parentNode.offsetWidth;
 	const uiEnabled = list.offsetWidth > list.parentNode.offsetWidth || totalW > list.parentNode.offsetWidth;
 		this.setState({
 		uiEnabled,
 		slideId: 0,
 		min: 0,
 		max: Math.floor(totalW / maskerW),
 	});
 },
 */

	/**
       * Handle/Update dom with the current states
       */
	update: function update() {var


		currentItems =
		this.state.currentItems;

		this.refs.items.forEach(function (item) {return item.classList.remove('active');});
		var copy = currentItems.slice(0);

		while (copy.length) {
			var curr = this.refs.items[copy.pop()];
			curr.classList.add('active');

			var input = curr.querySelector('input[type=checkbox]');

			if (input) {
				input.checked = true;
			}
		}
	} };exports.default =


























































UICheckbox;

},{"./action":3}],6:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });









var _action = require('./action');

var UIDots = {

	/**
                              * Initialize component
                              * See action.js init.
                              */
	init: function init() {

		// call super
		_action.init.call(this, {
			currentId: -1,
			totalLength: undefined });


		// click event
		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * Click handler
        * @param  {[MouseEvent]} e [mouse event]
        */
	clickHandler: function clickHandler(e) {

		e.preventDefault();

		var t = e.target;

		if (t && t.matches('.ui-dots__item')) {

			this.setState({ currentId: +t.getAttribute('data-id') });

		}

	},


	/**
        * inital children elements creation with given length
        * @param  {[Number]} length
        * @return {[type]}        [description]
        */
	createDots: function createDots(length) {

		var frag = document.createDocumentFragment();
		var i = 0;

		while (i < length) {

			var dot = document.createElement('a');
			dot.className = 'ui-dots__item';
			dot.setAttribute('data-id', i);
			frag.appendChild(dot);

			i++;

		}

		// append to el
		this.el.innerHTML = '';
		this.el.appendChild(frag);

		// ref
		this.dots = [].slice.call(this.el.querySelectorAll('.ui-dots__item'));

		// check if item lengh. If <=1, no points to display
		if (length <= 1) {

			this.el.style.display = 'none';

		}

		return this;

	},

	/**
        * See action.js setState
        */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var


		currentId =
		this.state.currentId;

		if (this.prevState.currentId !== currentId) {

			this.update();

			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {

				this.onChange.apply(null, [this, 'uidotschange']);

			}

		}

	},

	/**
        * Handle/Update dom with the current states
        */
	update: function update() {var


		currentId =
		this.state.currentId;

		var prev = this.dots.filter(function (dot) {return dot.classList.contains('active');})[0];
		if (prev) {

			prev.classList.remove('active');

		}

		var currneItem = this.el.querySelector('.ui-dots__item:nth-child(' + (currentId + 1) + ')');
		if (currneItem) {

			currneItem.classList.add('active');

		}

	} }; /*
      * UI dots
      *
      * use:
      *
      * class="ui-component ui-dots" data-name="ui-dots"
      *
      * 
      */exports.default = UIDots;

},{"./action":3}],7:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });










var _action = require('./action');

var UIDropDownList = {
  refs: {},

  init: function init() {
    _action.init.call(this, {
      currentId: -1,
      currentValue: "" });


    this.refs = {
      selectEl: this.el.querySelector('select') };


    if (this.refs.selectEl)
    {
      var selOption = this.refs.selectEl.querySelector("option[selected]");
      if (selOption)
      {
        this.state.currentValue = selOption.value;
        this.state.currentId = selOption.index;
      }
    }

    this.el.addEventListener('change', this.selectChange.bind(this));
    this.el.addEventListener('click', this.clickHandler.bind(this));
  },

  getSelectedValue: function getSelectedValue()
  {
    return this.state.currentValue;
  },

  getSelectedIndex: function getSelectedIndex()
  {
    return this.state.currentId;
  },

  clickHandler: function clickHandler(e) {
    e.preventDefault();

    var t = e.target;

    //grab the click on any child a.link and send to parent module
    if (t && t.tagName === 'A') {
      var role = t.getAttribute('data-role');

      // outter cb
      if (this && Object.prototype.hasOwnProperty.call(this, 'mouseHandler') && typeof this.mouseHandler === 'function') {
        this.mouseHandler.apply(null, [this, e.type, role]);
      }
    }
  },

  /**
         * Select handler
         * @param  {[Event]} e [input change event]
         */
  selectChange: function selectChange(e) {
    var val = "";
    if (e.target.selectedIndex >= 0)
    {
      val = e.target.options[e.target.selectedIndex].value;
    }
    this.setState({
      currentId: e.target.selectedIndex,
      currentValue: val });


    // invoke outer fn
    if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
      this.onChange.apply(null, [this, 'uidropdownchange']);
    }
  },

  hasValue: function hasValue() {
    return this.state.currentId >= 0;
  },

  hasValueOtherThanFirst: function hasValueOtherThanFirst() {
    return this.state.currentId > 0;
  },

  /**
         * See action.js setState
         */
  setState: _action.setState }; /*
                                * UI Dropdown list
                                *   used only to get child a.link click
                                * 
                                * use:
                                *
                                * class="ui-component ui-dropdown" data-name="ui-dropdownlist"
                                * 
                                * @author jam
                                */exports.default = UIDropDownList;

},{"./action":3}],8:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _action = require('./action');

var UIFilter = {

	refs: {},

	/**
                      * Initialize component
                      * See action.js init.
                      */
	init: function init() {var _this = this;

		// call super
		_action.init.call(this);

		// two version. component used as a filter | colleciton of links
		if (this.useLink) {
			this.el.classList.add('use-link');
		}

		// ref
		this.refs = {
			list: this.el.querySelector('.ui-filter-list'),
			items: [].slice.call(this.el.querySelectorAll('.ui-filter-item')), // filter items
			//	arrows: [].slice.call(this.el.querySelectorAll('.ui-filter-arrow')), // arrow ui
			colorBar: this.el.querySelector('.color-bar') // optional
		};

		// interacte filter items and attache events
		this.refs.items.forEach(function (filterItem) {
			filterItem.addEventListener('mouseenter', _this.itemHandler.bind(_this));
			filterItem.addEventListener('mouseleave', _this.itemHandler.bind(_this));
			filterItem.addEventListener('click', _this.itemHandler.bind(_this));
		});

		/* not used
          		this.refs.arrows.forEach(arrow => {
          			arrow.addEventListener('click', this.arrowHandler.bind(this));
          		});
          		*/

		// active can be set initially
		var id = this.refs.items.findIndex(function (f) {return f.classList.contains('active');});

		if (id !== -1) {
			var curr = this.refs.items[id];

			this.changeColorBar({
				width: curr.offsetWidth + 'px',
				left: curr.offsetLeft + 'px' });

		}

		// default states
		this.state = {
			//	direction: void 0,
			currentId: id !== -1 ? id : void 0
			//	ticker: void 0,
			//	slideId: 0,
			//	min: 0,
			//	max: 0,
			//	uiEnabled: false,
		};

		//this.translate();

	},

	/**
        * Item events handlers
        * @param  {[MouseEvent]} e [various events]
        */
	itemHandler: function itemHandler(e) {var _this2 = this;

		var t = e.target;

		switch (e.type) {

			case 'mouseenter':
				// handle color bar if exist
				this.changeColorBar({
					width: t.offsetWidth + 'px',
					left: t.offsetLeft + 'px' });

				break;

			case 'mouseleave':
				// go back to selected(curr)
				if (this.refs.colorBar) {

					var curr = this.refs.items[this.state.currentId];

					// sorta debounce, color bar go back to curr selected
					this.cTimer = setTimeout(function () {
						_this2.changeColorBar({
							width: curr.offsetWidth + 'px',
							left: curr.offsetLeft + 'px' });


					}, 500);
				}

				break;

			case 'click':
				if (!this.useLink) {
					e.preventDefault();
					var id = this.refs.items.findIndex(function (f) {return f === t;});
					this.setState({ currentId: id });
				}
				break;

			default:
			//
		}


	},

	/**
        * Handle Arrow UI when it's enabled.
        * @param  {[MouseEvent]} e [click event.]
        */
	/* not used
                  arrowHandler(e) {
                  	e.preventDefault();
                  		const { min, max, slideId } = this.state;
                  		if (slideId >= min && slideId <= max) {
                  		this.setState({
                  			slideId: e.target.dataset['type'] === 'left' ? slideId - 1 : slideId + 1,
                  		});
                  	}
                  },
                  */



	/**
                                * handles color bar if exists.
                                */
	changeColorBar: function changeColorBar(style) {var _this3 = this;

		clearTimeout(this.cTimer);

		if (this.refs.colorBar) {
			Object.getOwnPropertyNames(style).forEach(function (prop) {
				_this3.refs.colorBar.style[prop] = style[prop];
			});
		}
	},

	/**
        * See action.js setState
        */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var


		fId =


		this.state.currentId;

		if (this.prevState.currentId !== fId) {
			this.update();

			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
				this.onChange.apply(null, [this, 'uifilterchange']);
			}
		}
		/* not used
      		if (this.prevState.slideId !== slideId) {
      			this.translate();
      		}
      
      		if (this.prevState.uiEnabled !== uiEnabled) {
      			this.el.classList[uiEnabled ? 'add' : 'remove']('show-arrow-ui');
      		}
      */
	},

	/**
        * Browser reisze
        */
	resize: function resize() {

		//na	this.checkUI();
		this.el.querySelector('.ui-filter-masker').scrollLeft = 0;
	},

	// check if this needs arrow ui
	/*not used
 checkUI() {
 		// check if this needs arrow ui
 	const list = this.refs.list;
 	const lastItem = this.refs.items.slice(0).pop();
 	const totalW = lastItem.offsetWidth + lastItem.offsetLeft;
 	const maskerW = list.parentNode.offsetWidth;
 	const uiEnabled = list.offsetWidth > list.parentNode.offsetWidth || totalW > list.parentNode.offsetWidth;
 		this.setState({
 		uiEnabled,
 		slideId: 0,
 		min: 0,
 		max: Math.floor(totalW / maskerW),
 	});
 },
 */



	/**
       * Handle/Update dom with the current states
       */
	update: function update() {var


		fId =
		this.state.currentId;

		// default behavior
		var prev = this.el.querySelector('.ui-filter-item.active');
		var curr = this.refs.items[fId];

		if (prev) {
			prev.classList.remove('active');
		}
		curr.classList.add('active');

		this.changeColorBar({
			width: curr.offsetWidth + 'px',
			left: curr.offsetLeft + 'px' });

	} }; /*
      * UI Filter/Tab
      *
      * -filter: this dispatches external callback to "parent" to notify change
      * -useLink: this is a collection of links elements. no notification to any outter modules.
      *
      * use:
      *
      * class="ui-component ui-filter" data-name="ui-filter"
      *
      * 
      */exports.default =














































UIFilter;

},{"./action":3}],9:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });








var _action = require('./action');

var UIInput = {

	inputEl: null,

	init: function init() {

		// prefill, if querystring(name) is set in url, then use it.
		var qs = window.location.search.split('&').reduce(function (obj, str) {

			var p = str.split('=');
			var REG = /(^\?|$&)/g;
			var k = p[0] ? p[0].replace(REG, '') : void 0;
			var v = p[1] ? p[1].replace(REG, '') : void 0;

			if (!Object.prototype.hasOwnProperty.call(obj, k) && typeof k !== 'undefined') {
				obj[k] = v;
			}

			return obj;
		}, {});

		this.input = this.el.getElementsByTagName('input')[0];
		this.input.addEventListener('input', this.inputHandler.bind(this));
		this.input.addEventListener('focus', this.inputHandler.bind(this));
		this.input.addEventListener('blur', this.inputHandler.bind(this));

		var n = this.input.name;
		var value = Object.prototype.hasOwnProperty.call(qs, n) ? qs[n] : '';

		// this.input.value = decodeURIComponent(value);
		_action.init.call(this, { value: value });
		this.el.addEventListener('click', this.clickHandler.bind(this));
	},

	clickHandler: function clickHandler(e) {
		e.preventDefault();
		var t = e.target;

		if (t && (t.tagName === 'A' || t.tagName === 'BUTTON')) {
			var role = t.getAttribute('data-role');

			// outter cb
			if (this && Object.prototype.hasOwnProperty.call(this, 'mouseHandler') && typeof this.mouseHandler === 'function') {
				this.mouseHandler.apply(null, [this, e.type, role]);
			}
		}
	},

	inputHandler: function inputHandler(e) {

		switch (e.type) {
			case 'focus':
				this.el.classList.add('focus');
				break;
			case 'blur':
				this.el.classList.remove('focus');
				this.el.classList.remove('changing');
				break;
			case 'input':
				this.el.classList.add('changing');
				this.setState({ value: this.input.value });
				break;
			default:}



		// outter cb invocation
		if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
			this.onChange.apply(null, [this, e.type]);
		}
	},

	setState: _action.setState,
	onStateUpdate: function onStateUpdate() {},
	update: function update() {},

	get input() {
		return this.inputEl;
	},

	set input(input) {
		this.inputEl = input;
	},

	hasValue: function hasValue() {
		return this.input.value !== "";
	} }; /*
      * UI Input
      * type: text | number
      *
      * use:
      *
      * class="ui-component ui-input" data-name="ui-input"
      */exports.default = UIInput;

},{"./action":3}],10:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });









var _action = require('./action');

var renderItem = function renderItem(props) {

	var item = '<a href="' + props.url + '" class="' + props.cn + '" aria-selected="' + props.ariasel + '">' + props.page + '</a>';

	return item;

}; /*
   * UI Pagination component
   *
   * use:
   *
   * class="ui-component ui-pagination" data-name="ui-pagination" data-total-length="{length}"
   *
   * 
   */var UIPagination = { refs: {}, /**
                                     * Initialize component
                                     * See action.js init.
                                     */init: function init() {var
		totalLength = this.totalLength,isStatic = this.isStatic;

		_action.init.call(this, {
			currentId: -1,
			totalLength: totalLength || 999 // total(int). if data-total-length isn't set on dom element, default is 999
		});

		// ref
		this.refs.buttons = [].slice.call(this.el.querySelectorAll('.ui-pagination__btn'));

		if (isStatic) {

			this.renderStaticItems();

		}

		// click event
		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	renderStaticItems: function renderStaticItems() {var

		totalLength = this.totalLength,url = this.url;
		var container = this.el.querySelector('.ui-pagination__count');

		var qs = window.location.search.split('&').reduce(function (obj, str) {

			var p = str.split('=');
			var REG = /(^\?|$&)/g;
			var k = p[0] ? p[0].replace(REG, '') : void 0;
			var v = p[1] ? p[1].replace(REG, '') : void 0;

			if (!Object.prototype.hasOwnProperty.call(obj, k) && typeof k !== 'undefined') {

				obj[k] = v;

			}

			return obj;

		}, {});
		var pageQueryString = 'page';

		var currentPage = qs[pageQueryString] ? parseInt(qs[pageQueryString], 10) : 1;
		var totalPagesLength = Math.ceil(totalLength / 10);

		var maxPaginationLengthPerPage = 7;
		var reachedLast = totalPagesLength - maxPaginationLengthPerPage <= currentPage;

		var startIndex = reachedLast ? totalPagesLength - maxPaginationLengthPerPage : currentPage;

		// -3, -2, -1,
		// when totalPagesLength <= maxPaginationLengthPerPage
		if (startIndex < 1) {

			startIndex = 1;

		}

		var endIndex = reachedLast ? totalPagesLength : currentPage + maxPaginationLengthPerPage;

		// console.log('total results length', totalLength);
		// console.log('total Pages Length', totalLength, '/', 10, ' -> ', totalPagesLength);
		// console.log('reachedLast', reachedLast);
		// console.log('current page: ', currentPage, '/', totalPagesLength);
		// console.log(startIndex, '-', endIndex);

		var renderedHTML = '';
		for (var i = startIndex; i <= endIndex; ++i) {

			var isActive = i === currentPage;

			var p = {
				url: url + '&' + pageQueryString + '=' + i,
				page: i,
				cn: 'ui-pagination__index ' + (isActive ? 'active' : ''),
				ariasel: '' + (isActive ? 'true' : 'false') };


			renderedHTML += renderItem(p);

		}

		container.innerHTML = renderedHTML;

		// check if the first page | last page
		var arrows = this.el.querySelectorAll('.ui-pagination__arrow');
		arrows[0].href = url + '&' + pageQueryString + '=' + (currentPage - 1);
		arrows[1].href = url + '&' + pageQueryString + '=' + (currentPage + 1);

		if (currentPage === 1) {

			arrows[0].classList.add('inactive');

		}

		if (reachedLast) {

			arrows[1].classList.add('inactive');

		}

		if (totalPagesLength <= maxPaginationLengthPerPage + 1) {

			arrows[0].classList.add('inactive');
			arrows[1].classList.add('inactive');

		}

	},

	/**
        * [clickHandler description]
        * @param  {[MouseEvent]} e [
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		if (t && t.matches('.ui-pagination__btn')) {

			e.preventDefault();

			var isLeftBtn = this.refs.buttons.findIndex(function (btn) {return btn === t;}) === 0;var _state =




			this.state,cId = _state.currentId,totalLength = _state.totalLength;

			var currentId = cId;

			if (isLeftBtn) {

				currentId = currentId === 0 ? totalLength - 1 : currentId - 1;

			} else {

				currentId = currentId === totalLength - 1 ? 0 : currentId + 1;

			}

			this.setState({ currentId: currentId });

		}

	},

	/**
        * See action.js setState
        */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var _state2 =




		this.state,currentId = _state2.currentId,totalLength = _state2.totalLength;

		if (this.prevState.totalLength !== totalLength) {

			if (totalLength < 2) {

				this.el.style.display = 'none';

			}

		}

		if (this.prevState.currentId !== currentId) {

			// console.log(`${currentId}/${totalLength-1}`);
			this.update();

			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {

				this.onChange.apply(null, [this, 'uipaginationchange']);

			}

		}

	},

	/**
       * Handle/Update dom with the current states
       */
	update: function update() {var _state3 =




		this.state,currentId = _state3.currentId,totalLength = _state3.totalLength;

		var prevInactive = this.el.querySelector('.inactive');
		if (prevInactive) {

			prevInactive.classList.remove('inactive');

		}

		var deactiveCandidate = void 0;

		if (currentId === 0) {

			deactiveCandidate = this.refs.buttons[0];

		} else if (currentId === totalLength - 1) {

			deactiveCandidate = this.refs.buttons[1];

		}

		if (deactiveCandidate) {

			deactiveCandidate.classList.add('inactive');

		}

		// current/total
		this.el.querySelector('.ui-pagination__curr').innerHTML = currentId + 1;
		this.el.querySelector('.ui-pagination__total').innerHTML = totalLength;

	} };exports.default =




UIPagination;

},{"./action":3}],11:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });









var _action = require('./action');

var UISelectorOrderBy = {

	refs: {},

	/**
                      * Initialize component
                      * See action.js init.
                      */
	init: function init() {var _this = this;

		// call super
		_action.init.call(this);

		// ref
		this.refs = {
			list: this.el.querySelector('.l-list'),
			items: [].slice.call(this.el.querySelectorAll('.ui-sort-item button')), // sort button items
			orderbyLabel: null,
			currentItem: null };


		// find the current active item and set label if enabled
		//const activeItem = this.el.querySelector('.l-list div.active button');
		this.refs.orderbyLabel = this.el.querySelector('.ui-selector-label span');
		var id = this.refs.items.findIndex(function (f) {return f.parentNode.classList.contains('active');});
		if (id >= 0) {
			this.refs.currentItem = this.refs.items[id];
			if (this.refs.currentItem && this.refs.orderbyLabel) {
				this.refs.orderbyLabel.innerHTML = this.refs.currentItem.textContent.trim();
			}
		}

		//initial dropdown
		this.el.addEventListener('click', this.mouseHandler.bind(this), false);

		// item selection from list
		this.refs.items.forEach(function (filterItem) {
			filterItem.addEventListener('click', _this.itemHandler.bind(_this));
		});

		// default states
		this.state = {
			currentId: id !== -1 ? id : void 0,
			active: false };

	},

	setOrderbyLabel: function setOrderbyLabel(id) {
		if (id >= 0) {
			//remove active state of previous item
			if (this.refs.currentItem) {
				this.refs.currentItem.parentNode.classList.remove('active');
			}

			this.refs.currentItem = this.refs.items[id];
			if (this.refs.currentItem && this.refs.orderbyLabel) {
				this.refs.orderbyLabel.innerHTML = this.refs.currentItem.textContent.trim();
				this.refs.currentItem.parentNode.classList.add('active');
			}
		}
	},

	mouseHandler: function mouseHandler(e) {
		var t = e.target;
		if (t.matches('.ui-selector-label')) {
			e.preventDefault();

			// toggle
			this.setState({
				active: !this.state.active });

		}
	},

	/**
        * Item events handlers
        * @param  {[MouseEvent]} e [various events]
        */
	itemHandler: function itemHandler(e) {
		var t = e.target;

		switch (e.type) {
			case 'click':
				e.preventDefault();
				var id = this.refs.items.findIndex(function (f) {return f === t;});
				if (id >= 0) {
					this.setState({ currentId: id, active: false });
				}
				break;
			default:}

	},

	reset: function reset() {
		// close
		this.setState({
			active: false });

	},

	/**
        * See action.js setState
        */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var _state =




		this.state,fId = _state.currentId,active = _state.active;

		if (this.prevState.active !== active || this.prevState.currentId !== fId) {
			if (this.prevState.active !== active) {
				this.el.classList[this.state.active ? 'add' : 'remove']('active');
			}
			if (this.prevState.currentId !== fId) {
				this.setOrderbyLabel(fId);
			}
			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
				this.onChange.apply(null, [this, 'uiSelectorChange']);
			}
		}
	} }; /*
      * UI Selector for Order by
      *
      * use:
      *
      * class="ui-component ui-selector-orderby" data-name="ui-selector-orderby"
      *
      * 
      */exports.default = UISelectorOrderBy;

},{"./action":3}],12:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });









var _action = require('./action');

var UISelector = {
	refs: {},

	/**
                      * Initialize component
                      * See action.js init.
                      */
	init: function init() {

		// call super
		_action.init.call(this);

		// res
		this.refs.list = this.el.querySelector('.l-list');

		var hasEnoughChildren = false;
		if (this.refs.list != null)
		{
			hasEnoughChildren = this.refs.list.children.length > 1;
		}

		// concat state
		Object.assign(this.state, {
			active: false,
			currentItem: activeLangItem,
			activeValue: langDropDownLabel,
			useDropdown: true });


		// if option's length < 2
		if (!hasEnoughChildren) {

			this.el.classList.add('has-limited-item');

		}

		// find the current active lang item and set label if enabled
		var activeLangItem = this.el.querySelector('.l-list div.active a');
		var langDropDownLabel = this.el.querySelector('.ui-selector-label span');

		if (this.autoSelect &&
		activeLangItem &&
		langDropDownLabel) {

			langDropDownLabel.innerHTML = activeLangItem.textContent.trim();
			this.el.querySelector('.ui-selector-label').href = activeLangItem.href;

		}

		this.el.addEventListener('click', this.mouseHandler.bind(this), false);
	},

	mouseHandler: function mouseHandler(e) {
		var t = e.target;var
		useDropdown = this.state.useDropdown;

		if (t.matches('.ui-selector-label') && useDropdown) {
			e.preventDefault();

			// toggle
			this.setState({
				active: !this.state.active });

		}

	},

	/**
        * Handle dom elements with state
        */
	update: function update() {
		this.el.classList[this.state.active ? 'add' : 'remove']('active');
	},

	reset: function reset() {

		// close
		this.setState({
			active: false });


	},

	/**
        * See action.js setState
        */
	setState: _action.setState,

	/**
                                                          * handler method that handles post-state update.
                                                          */
	onStateUpdate: function onStateUpdate() {var

		active =
		this.state.active;

		if (this.prevState.active !== active) {
			this.update();

			// invoke outer fn
			if (Object.prototype.hasOwnProperty.call(this, 'onChange') && typeof this.onChange === 'function') {
				this.onChange.apply(null, [this, 'uiSelectorChange']);
			}
		}
	} }; /*
      * UI Selector
      *
      * use:
      *
      * class="ui-component ui-selector" data-name="ui-selector"
      *
      * 
      */exports.default = UISelector;

},{"./action":3}],13:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.defaultState = exports.defaultProps = undefined;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; /*
                                                                                                                                                                                                                                                                                                                                                                                           * Abstract module
                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                           * Super class object for all modules providing interfaces with inheritance
                                                                                                                                                                                                                                                                                                                                                                                           *
                                                                                                                                                                                                                                                                                                                                                                                           */

var _framework = require('../../framework');

/**
                                                                                           * module default props
                                                                                           * @return {[Object]}
                                                                                           */
var defaultProps = exports.defaultProps = function defaultProps() {return (
		{
			mId: -1, // int: random id by created
			staticHTML: true, // boolean: true or false: as default, each module renders it's own template in render function. if true, keep inner html as it is
			name: 'abstract', // string:name of module
			isExperienceEditor: false });};



/**
                                                                       * module default state
                                                                       * @return {[Object]}
                                                                       */
var defaultState = exports.defaultState = function defaultState() {return (
		{
			isInit: false // boolean: true or false
		});};


/**
                 * Abstract module
                 * @type {Object}
                 */
var AbstractModule = {

	/**
                                              * Initialize module
                                              */
	init: function init(option) {

		/**
                                                           * created: time stamp
                                                           * rId: random id
                                                           * mId: module id used to get the instance via module manager
                                                           */
		var created = '' + new Date().getTime();
		var rId = Math.floor(Math.random() * 9999);
		var mId = option.data.name + '-' + created.substr(created.length - 4) + '-' + rId;

		this.props = Object.assign(defaultProps(), option.data || {}, this.getInternalProps(), { mId: mId });
		this.state = Object.assign(defaultState(), this.getInternalState());
		this.prevState = void 0;

		this.el = option.el;
		this.el.setAttribute('mId', mId);
		this.el.classList.add('init');

		this.context = option.context;

		// theme check
		// if (Object.prototype.hasOwnProperty.call(option, 'theme')) {
		// 	this.el.classList.add(option.theme);
		// }

		// default State
		this.setState({ isInit: true }, false);
		this.scanLinks(this.el.getElementsByTagName('a'));

		return this;

	},

	/**
        * This method updates any state change and subsequently calls onStateUpdate method if exist to handle post-change state.
        *
        * @param  {Object} newStates - incoming new states
        * @param  {Boolean} notifyUpdate - flag whether onStateUpdate method gets called or not
        * @return {Object} - returning self
        */
	setState: function setState(newState) {var notifyUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		this.prevState = _extends({}, this.state);
		this.state = Object.assign(this.state, newState);

		if (notifyUpdate && !_framework.util.compareObjects(this.prevState, this.state)) {

			this.onStateUpdate(this.prevState, this.state);

		}

		return this;

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {},

	// Methods to override

	// internal method to be called as "onRender"
	mounted: function mounted() {},

	// internal method to add events
	initEvent: function initEvent() {},

	/**
                                                                          * resize event handler. Implement in module class if needed.
                                                                          * @param  {[Event]} e [resize revent]
                                                                          */
	//resize(e) { },

	/**
  * scroll event handler. Implement in module class if needed.
  * @param  {[Event]} e [resize revent]
  */
	//scroll(e) { },

	/**
  * viwe mode(breakpoint) handler. Implement in module class if needed.
  *
  * this gets fired when each breakpoint hits
  * See app.js onStateUpdate
  */
	//viewmodeUpdate() { },

	/**
  * page visibility handler
  *
  * this gets fired when the current window tab is on/off
  * See app.js onStateUpdate
  */
	pageVisibilityChange: function pageVisibilityChange(isPageHidden) {},

	// deploy self
	destroy: function destroy() {

		_framework.ModuleManager.getInstance().removeModule(this);

		// remove el from dom
		if (this.el && this.el.parentNode) {

			this.el.parentNode.removeChild(this.el);

		}

	},

	// all link(a tag) handlers
	scanLinks: function scanLinks(allLinks) {},

	// update
	// this is a result of subscribing
	update: function update(prevAppState, appState) {},

	// getter
	getInternalProps: function getInternalProps() {

		return {};

	},

	getInternalState: function getInternalState() {

		return {};

	} };exports.default =



AbstractModule;

},{"../../framework":72}],14:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _framework = require('../../framework');

var Accordion = {

   refs: {},

   mounted: function mounted() {
      this.el.addEventListener('click', this.clickHandler.bind(this));
   },
   clickHandler: function clickHandler(e) {

      var t = e.target;
      if (t.matches('.top-row')) {
         e.preventDefault();
         this.updateAccordionRow(t);

      }

   },
   updateAccordionRow: function updateAccordionRow(ele) {
      var isActive = ele.classList.contains('active');
      var tabTitle = ele.getAttribute('data-title');
      var accordionButton = ele;
      var controlsId = ele.getAttribute('aria-controls');
      var accordionSection = document.getElementById(controlsId);
      var expanded = accordionButton.getAttribute('aria-expanded');
      accordionButton.classList.toggle('expanded');
      ele.classList[isActive ? 'remove' : 'add']('active');
      accordionSection.classList[isActive ? 'remove' : 'add']('open');
      if (accordionButton.classList.contains('expanded')) {
         accordionSection.setAttribute('aria-hidden', false);
         accordionButton.setAttribute('aria-expanded', true);
      } else
      {
         accordionSection.setAttribute('aria-hidden', true);
         accordionButton.setAttribute('aria-expanded', false);
      }
      _framework.util.gaSendEvent('Interactive Feature', 'Click', isActive ? 'Accordion - Close - ' + tabTitle : 'Accordion - Open - ' + tabTitle, 1);

   },

   getInternalProps: function getInternalProps() {
      return {};
   },

   getInternalState: function getInternalState() {
      return {};
   } }; /**
        * Accordion
        *
        * use:
        * class="module accordion" data-name="accordion"
        *
        * related src:
        * view: Views/CSLShared/Modules/Structure/_AccordionContainer.cshtml
        * view: Views/CSLShared/Modules/_AccordionItem.cshtml
        * css: app/styles/modules/_accordion.scss
        *
        * 
        */$(window).on('load', function () {$(".accordion__row").each(function () {if ($(this).find('.text ul').length > 0) {if ($(this).find('.text').hasClass('col-3')) {$(this).find('.text').removeClass('col-3');$(this).find('.text ul').addClass('col-3');} else
         if ($(this).find('.text').hasClass('col-2'))
         {
            $(this).find('.text').removeClass('col-2');
            $(this).find('.text ul').addClass('col-2');
         }
      }

   });
});exports.default =

Accordion;

},{"../../framework":72}],15:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });





















var _framework = require('../../framework');

/**
                                                                                           * runtime render function
                                                                                           * @param  {[Object]} props    [data to render each item]
                                                                                           * @param  {[Boolean]} isTile  [boolean flag indicating whether list or tile]
                                                                                           * @return {[Element]}         [renedered dom Element]
                                                                                           */
var renderItem = function renderItem(props, isTile) {var

	LinkUrl = props.LinkUrl,LinkTitle = props.LinkTitle,Headline = props.Headline,ImageUrl = props.ImageUrl,ImageAlt = props.ImageAlt,FormattedDate = props.FormattedDate,Abstract = props.Abstract,SortOrder = props.SortOrder;

	var item = document.createElement('div');
	item.className = props.className;
	item.setAttribute("data-sort", '' + SortOrder);

	var html = '';

	if (isTile) {

		// tile
		html = '<a class="m-tile__link" href="' + LinkUrl + '" aria-label="' + Headline + '" tabindex="0"><div class="m-tile__inner">';

		// check image
		if (ImageUrl) {
			html += '<figure class="m-tile__image"><img src="' + ImageUrl + '" alt="' + ImageAlt + '"></figure>';
		}
		html += '<div class="m-tile__content">\t\t\t\t\t\n\t\t\t\t\t\t<h4 class="m-tile__title">' +
		Headline + '</h4>\n\t\t\t\t\t\t<p class="m-tile__desc">' +
		Abstract + '</p>\n\t\t\t\t\t\t<div class="m-tile__meta">\n\t\t\t\t\t\t\t<span class="m-tile__meta-sub">' +

		FormattedDate + '</span>\n\t\t\t\t\t\t\t<span class="m-tile__meta-sub ui-icon-btn"><i class="icon-right-arrow-sm" aria-hidden="true"></i></span>\t\t\t\t\t\t\n\t\t\t\t\t\t</div></div></div></a>';


	} else
	{
		// list
		html = '<a href="' + LinkUrl + '" class="m-tile__inner" aria-label="' + Headline + '" tabindex="0"><div class="m-list__title">' + Headline + '</div></a>\n\t\t<div class="m-list__meta">\n\t\t\t<span class="pagination">' +

		FormattedDate + '</span>\n\t\t</div>\n\t\t<p class="m-list__desc">' +

		Abstract + '</p>\n\t\t<div class="ui-wrapper">\n\t\t\t<a href="' +

		LinkUrl + '" class="ui-btn ui-btn--secondary" title="' + Headline + '" aria-label="' + Headline + '" tabindex="0" >' + LinkTitle + '</a>\n\t\t</div>';

	}

	item.innerHTML = html.trim();
	return item;
};

/**
       * render items
       * @param  {[Array]}  list
       * @param  {[String]} itemName [render target name]
       * @return {[Array]}           [rendered item collection]
       */ /**
          * Advanced Mosaic
          *
          * Fetch results and runtime render items.
          *
          * props to note:
          *
          *   listItemName: m-tile m-tile--1x2 | m-list
          *   localUri: local(test) uri
          *   baseUri: service uri
          *   mosaic: sitecore Id to fetch list
          *
          * use:
          * class="module mosaic" data-name="mosaic"
          *
          * related src:
          * view: Views/CSLShared/Modules/News/AdvancedMosaic.cshtml
          * css: app/styles/modules/_mosaic.scss
          *
          */ // dependency
var renderItems = function renderItems(list, itemName, ctaTile, ctaPosition, lastArticleIndex) {var isTile = itemName === 'm-tile';var className = itemName + ' ' + (isTile ? 'm-tile--1x2' : '');var itemList = [];var i;var cnt = lastArticleIndex;if (list) {for (i = 0; i < list.length; i++) {//skip CTA tile position
			if (ctaTile && cnt == ctaPosition) {cnt++;}var props = list[i];props.className = className;props.SortOrder = cnt;var renderedItem = renderItem(props, isTile);
			itemList.push(renderedItem);
			cnt++;
		}
	}

	return itemList;
};

/**
       * AdvancedMosaic
       * @type {Object}
       */
var AdvancedMosaic = {
	uiComponents: [],
	refs: {},

	/**
                      * When mounted
                      */
	mounted: function mounted() {var _props =

		this.props,listItemName = _props.listItemName,offsetIndex = _props.offsetIndex,haveCtaTile = _props.haveCtaTile,ctaPosition = _props.ctaPosition;
		var grid = this.el.querySelector('.grid');
		var tileItems = null;
		var ctaTileEl = null;
		var isoInstance = null;
		var lastArticleIndex = 0;

		//tile layout
		if (listItemName === 'm-tile') {
			tileItems = Array.from(this.el.querySelectorAll('.grid .' + listItemName));
			lastArticleIndex = tileItems.length;

			//change the position of the CTA tile (if any)
			if (haveCtaTile && ctaPosition > 0 && ctaPosition <= tileItems.length + 1) {
				ctaTileEl = this.el.querySelector('.m-tile__cta');
			}

			// iso option
			var IsoOption = {
				layoutMode: 'masonry',
				itemSelector: '.m-tile',
				percentPosition: true,
				transitionDuration: 300,
				masonry: {
					gutter: 30,
					columnWidth: '.m-sizer',
					initLayout: true },

				getSortData: {
					sortIndex: '[data-sort] parseInt' },

				sortBy: 'sortIndex' };


			// get iso instance
			isoInstance = (0, _framework.iso)(grid, IsoOption);

			// iso events
			isoInstance.on('layoutComplete', this.isoLayout.bind(this));
		}

		// refs
		this.refs = {
			iso: isoInstance,
			items: tileItems,
			grid: grid,
			ctaTile: ctaTileEl,
			ctaPosition: ctaPosition,
			uiFilter: void 0,
			offsetIndex: offsetIndex, //initial value from page
			lastArticleIndex: lastArticleIndex, //used for the sort index 
			imagesLoaded: false };


		//order by date or most popular
		var orderEl = this.el.querySelector('.ui-component[data-name="ui-selector-orderby"]');
		if (orderEl) {
			var uiFilter = _framework.ModuleManager.getInstance().getComponentById(orderEl.getAttribute('cid'));
			if (uiFilter)
			{
				uiFilter.onChange = this.uiChanged.bind(this);
			}
		}

		// ui filter instance
		if (this.el.querySelector('.ui-component[data-name="ui-filter"]')) {
			var _uiFilter = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-component[data-name="ui-filter"]').getAttribute('cid'));
			_uiFilter.onChange = this.uiChanged.bind(this);

			// check if uiFilter length === 1(just all)
			// hide filter
			if (_uiFilter.refs.items.length === 1) {
				this.el.classList.add('hide-ui');
			}

			this.refs.uiFilter = _uiFilter;

			// initial load with no filter applied
			_uiFilter.setState({ currentId: 0 });

		} else {
			// when there is no filter, apply all
			this.setState({
				currentFilterVal: 'all',
				currentFilterText: 'all' });

		}

		this.el.addEventListener('click', this.clickHandler.bind(this));
	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;

		if (t.matches('.js-load-more')) {var
			pageCount = this.state.pageCount;
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Mosaic load more', 1);

			e.preventDefault();
			this.setState({
				pageCount: pageCount + 1 });

		} else

		{
			var linkEl = _framework.util.ancestorMatchClass(t, "m-tile__link");
			if (linkEl)
			{
				_framework.util.gaSendEvent('Link', 'Mosaic Tile Link Click', linkEl.getAttribute('aria-label'), 1);
			}
		}
	},

	/**
        * When internal ui components are dispatching "change" status
        * refs.items refers to the filter items. See ui-filter.
        */
	uiChanged: function uiChanged() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var
		ui = args[0],e = args[1];var
		currentId = ui.state.currentId,refs = ui.refs;

		switch (e) {
			case 'uiSelectorChange':
				this.setState({
					pageCount: 0, // reset page count to 0 to reload all
					orderBy: refs.items[currentId].getAttribute('data-orderby') });

				break;
			case 'uifilterchange':
				this.setState({
					pageCount: 0, // reset page count to 0 to reload all
					currentFilterVal: refs.items[currentId].getAttribute('data-filter'),
					currentFilterText: refs.items[currentId].getAttribute('aria-label') });

				break;
			default:}

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {
		if (prevState.pageCount !== state.pageCount) {
			this.fetchItems();
		} else
		if (prevState.currentFilterVal !== state.currentFilterVal)
		{
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Mosaic filter - ' + state.currentFilterText, 1);
			this.fetchItems();
		} else
		if (prevState.orderBy !== state.orderBy)
		{
			//console.log("order by: "+state.orderBy);
			this.fetchItems();
		}
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso) {
			this.refs.iso.layout();
		}
		return this;
	},

	/**
        * Fetch data to render items
        * Called when filter changes or 'load more' selected. When filter changes, pageCount is reset.
        */
	fetchItems: function fetchItems() {var _this = this;

		// 1. set fetching state
		this.el.classList.add('fetching');var _refs =

		this.refs,iso = _refs.iso,grid = _refs.grid;var _props2 =
		this.props,mosaic = _props2.mosaic,baseUri = _props2.baseUri,localUri = _props2.localUri,listItemName = _props2.listItemName,stickyItem = _props2.stickyItem,resultsOnFirstPage = _props2.resultsOnFirstPage;var _state =
		this.state,currentFilterVal = _state.currentFilterVal,pageCount = _state.pageCount,orderBy = _state.orderBy;
		var isLoadmore = pageCount !== 0;

		// if this is not loadmore, then we are filtering. Remove all except non-filtered items, which will be hidden
		if (!isLoadmore) {
			var removalCandidates = Array.from(grid.querySelectorAll('.' + listItemName + ':not(.js-keepitem)'));
			removalCandidates.forEach(function (ele) {return ele.parentNode.removeChild(ele);});
			if (iso)
			{
				iso.remove(removalCandidates);
			}
			this.refs.offsetIndex = 0;
			this.refs.lastArticleIndex = 1;

			//set class to indicate filtering (will hide sticky in css)
			this.el.classList[currentFilterVal != "all" ? 'add' : 'remove']('filtering');
		}
		var isTile = listItemName === 'm-tile';

		// page and offsetIndex = 0, when switching filters
		var serviceURI = localUri;
		serviceURI = baseUri + '?mosaicid=' + mosaic;
		serviceURI += '&stickyid=' + stickyItem;
		serviceURI += '&isUsingTile=' + isTile;
		serviceURI += orderBy === 'date' ? '' : '&orderBy=' + orderBy;
		serviceURI += currentFilterVal === 'all' ? '' : '&filter=' + currentFilterVal;
		serviceURI += '&resultsOnFirstPage=' + resultsOnFirstPage;
		serviceURI += '&pageIndex=' + pageCount;
		serviceURI += '&offsetIndex=' + this.refs.offsetIndex;

		fetch(serviceURI, {
			method: 'GET',
			credentials: 'same-origin' }).

		then(function (res) {return res.json();}).
		then(function (data) {var
			Articles = data.Articles,IsShowMoreVisible = data.IsShowMoreVisible,OffsetIndex = data.OffsetIndex;
			var renderedItems = renderItems(Articles, listItemName, _this.refs.ctaTile, _this.refs.ctaPosition, _this.refs.lastArticleIndex);
			if (iso) {
				iso.insert(renderedItems);
			} else
			{
				var docFrag = document.createDocumentFragment();
				renderedItems.forEach(function (ele) {return docFrag.appendChild(ele);});
				_this.refs.grid.appendChild(docFrag);
			}

			// check loadMore
			_this.el.classList[IsShowMoreVisible ? 'remove' : 'add']('hide-load-more');
			_this.refs.offsetIndex = OffsetIndex;
			if (renderedItems)
			{
				_this.refs.lastArticleIndex += renderedItems.length;
			}
		}).
		catch(function (e) {return console.log("AdvMosaic.FetchItems: " + e);}).
		then(function () {
			setTimeout(function () {
				_this.resize().el.classList.remove('fetching');
			}, 150);
		});

		return this;
	},

	isoLayout: function isoLayout() {
		// console.log(args);
		this.loadImages();
	},

	loadImages: function loadImages()
	{var _this2 = this;
		// check image load
		if (!this.refs.imagesLoaded)
		{
			this.refs.imagesLoaded = true;
			this.refs.iso.items.forEach(function (item) {
				var img = item.element.getElementsByTagName('img')[0];
				if (img) {
					var imgSrc = img.getAttribute('data-lazysrc');
					if (imgSrc)
					{
						img.setAttribute('src', imgSrc);
					}
				}
			});
			//resize to force re-layout
			setTimeout(function () {_this2.resize();}, 150);
		}
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			pageCount: 0, //initial load 
			currentFilterVal: 'all', // default all. It won't trigger state update
			currentFilterText: 'all',
			orderBy: 'date' };

	} };exports.default =


AdvancedMosaic;

},{"../../framework":72}],16:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _framework = require('../../framework');

var ArticlePagingMosaic = {
	refs: {},

	/**
                      * When mounted
                      */
	mounted: function mounted() {var _props =
		this.props,tagid = _props.tagid,tag = _props.tag,orderbyPopular = _props.orderbyPopular;

		var grid = this.el.querySelector('.grid');
		var tileItems = Array.from(this.el.querySelectorAll('.grid .m-tile'));

		// iso option
		var IsoOption = {
			layoutMode: 'masonry',
			itemSelector: '.m-tile',
			percentPosition: true,
			transitionDuration: 300,
			masonry: {
				gutter: 30,
				columnWidth: '.m-sizer',
				initLayout: true },

			getSortData: {
				sortIndex: '[data-sort] parseInt' },

			sortBy: 'sortIndex' };


		// get iso instance
		var isoInstance = (0, _framework.iso)(grid, IsoOption);

		// iso events
		isoInstance.on('layoutComplete', this.isoLayout.bind(this));

		// refs
		this.refs = {
			iso: isoInstance,
			items: tileItems,
			uiFilter: void 0,
			imagesLoaded: false };


		if (tagid !== "all")
		{
			this.state.currentFilterVal = tagid;
			this.state.currentFilterText = tag;
		}
		if (orderbyPopular)
		{
			this.state.orderBy = "popular";
		}

		//order by date or most popular
		var orderEl = this.el.querySelector('.ui-component[data-name="ui-selector-orderby"]');
		if (orderEl) {
			var uiFilter = _framework.ModuleManager.getInstance().getComponentById(orderEl.getAttribute('cid'));
			if (uiFilter)
			{
				uiFilter.onChange = this.uiChanged.bind(this);
			}
		}

		// ui filter instance
		if (this.el.querySelector('.ui-component[data-name="ui-filter"]')) {
			var _uiFilter = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-component[data-name="ui-filter"]').getAttribute('cid'));
			_uiFilter.onChange = this.uiChanged.bind(this);

			// check if uiFilter length === 1(just all)
			// hide filter
			if (_uiFilter.refs.items.length === 1) {
				this.el.classList.add('hide-ui');
			}

			this.refs.uiFilter = _uiFilter;
		}

		this.el.addEventListener('click', this.clickHandler.bind(this));
	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;
		var linkEl = _framework.util.ancestorMatchClass(t, "m-tile__link");
		if (linkEl)
		{
			_framework.util.gaSendEvent('Link', 'Mosaic Tile Link Click', linkEl.getAttribute('aria-label'), 1);
		}
	},

	/**
        * When internal ui components are dispatching "change" status
        * refs.items refers to the filter items. See ui-filter.
        */
	uiChanged: function uiChanged() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var
		ui = args[0],e = args[1];var
		currentId = ui.state.currentId,refs = ui.refs;

		switch (e) {
			case 'uiSelectorChange':
				this.setState({
					orderBy: refs.items[currentId].getAttribute('data-orderby') });

				break;
			case 'uifilterchange':
				this.setState({
					currentFilterVal: refs.items[currentId].getAttribute('data-filter'),
					currentFilterText: refs.items[currentId].getAttribute('aria-label') });

				break;
			default:}

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {
		if (prevState.currentFilterVal !== state.currentFilterVal)
		{
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Mosaic filter - ' + state.currentFilterText, 1);
			this.fetchItems();
		} else
		if (prevState.orderBy !== state.orderBy)
		{
			//console.log("order by: "+state.orderBy);
			this.fetchItems();
		}
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso) {
			this.refs.iso.layout();
		}
		return this;
	},

	/**
        * Called when filter or sort changes. 
        * Refetch the page with the selected filter or orderby. PageCount is reset.
        */
	fetchItems: function fetchItems() {var _state =
		this.state,currentFilterVal = _state.currentFilterVal,currentFilterText = _state.currentFilterText,orderBy = _state.orderBy;

		var fetchUrl = "?page=0";
		if (currentFilterVal !== 'all')
		{
			fetchUrl += '&tag=' + currentFilterText + '&tagid=' + currentFilterVal;
		}
		if (orderBy === 'popular')
		{
			fetchUrl += '&orderBy=popular';
		}

		window.location.href = fetchUrl;
	},

	isoLayout: function isoLayout() {
		// console.log(args);
		this.loadImages();
	},

	loadImages: function loadImages()
	{var _this = this;
		// check image load
		if (!this.refs.imagesLoaded)
		{
			this.refs.imagesLoaded = true;
			this.refs.iso.items.forEach(function (item) {
				var img = item.element.getElementsByTagName('img')[0];
				if (img) {
					var imgSrc = img.getAttribute('data-lazysrc');
					if (imgSrc)
					{
						img.setAttribute('src', imgSrc);
					}
				}
			});
			//resize to force re-layout
			setTimeout(function () {_this.resize();}, 150);
		}
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			currentFilterVal: 'all', // default all. It won't trigger state update
			currentFilterText: 'all',
			orderBy: 'date' };

	} }; /**
      * Article Paging Mosaic
      *
      * use:
      * class="module advanced-mosaic" data-name="article-paging-mosaic"
      *
      * related src:
      * view: Views/CSLShared/Modules/News/ArticlePagingMosaic.cshtml
      * css: app/styles/modules/_mosaic.scss
      *
      */ // dependency
exports.default = ArticlePagingMosaic;

},{"../../framework":72}],17:[function(require,module,exports){
"use strict";Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * ArticleTaglist
                                                                            *
                                                                            * use:
                                                                            * class="module article-taglist" data-name="article-taglist"
                                                                            *
                                                                            * related src:
                                                                            * view: \Views\CSLShared\Modules\News\ArticleTagList.cshtml
                                                                            * css: app/styles/modules/_ArticleTagList.scss
                                                                            *
                                                                            * This js is needed for app-proto to set 'no-hero' style
                                                                            */

var ArticleTaglist = {
                                                                            mounted: function mounted() {} };exports.default =


ArticleTaglist;

},{}],18:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * Article
                                                                            *
                                                                            * use:
                                                                            * class="module article" data-name="article"
                                                                            *
                                                                            * related src:
                                                                            * view: Views/CSLShared/Modules/Article/_Article.cshtml
                                                                            * css: app/styles/modules/_article.scss
                                                                            *
                                                                            * 
                                                                            */

var Article = {

	/**
                                * When mounted
                                *
                                * start writing scrip here for this module
                                */
	mounted: function mounted() {
		// find iframe|object
		var iframes = [].slice.call(this.el.getElementsByTagName('iframe'));
		var objects = [].slice.call(this.el.getElementsByTagName('object'));

		objects.concat(iframes).forEach(function (obj) {

			var wrapper = document.createElement('div');
			wrapper.className = 'media-reponsive-container';

			var parent = obj.parentNode;
			parent.insertBefore(wrapper, obj);
			wrapper.appendChild(obj);

		});

		// check sidebar
		var hasSidebar = this.el.querySelector('.article__sidebar') !== null &&
		this.el.querySelectorAll('.article__sidebar .m-tile').length > 0;

		// check social-share. check the children element lengh as well.
		// Editor can add 0 since now it's coming from BE
		var socialItems = this.el.querySelectorAll('.module.social-share .social-share__item');
		var hasSocial = socialItems.length > 1; // except label

		this.setState({
			hasSocial: hasSocial,
			hasSidebar: hasSidebar });


	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.hasSidebar !== state.hasSidebar) {


			this.el.classList[state.hasSidebar ? 'add' : 'remove']('has-sidebar');

		}

		if (prevState.hasSocial !== state.hasSocial) {

			this.el.classList[state.hasSocial ? 'add' : 'remove']('has-social-share');

			if (state.hasSocial) {

				var social = this.el.querySelector('.module.social-share');
				this.el.querySelector('.article__inner').appendChild(social);

			}

		}

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {};

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			hasSidebar: false, // boolean: check if sidebar exists
			hasSocial: false // boolean: check if social module exists
		};

	} };exports.default =



Article;

},{}],19:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });




















var _framework = require('../../framework');

/**
                                                                                           * runtime render function
                                                                                           * @param  {[Object]} props    [data to render each item]
                                                                                           * @return {[Element]}         [renedered dom Element]
                                                                                           */
var renderItem = function renderItem(props) {var

	LinkUrl = props.LinkUrl,Headline = props.Headline,ImageUrl = props.ImageUrl,ImageAlt = props.ImageAlt,FormattedDate = props.FormattedDate,Abstract = props.Abstract;
	var className = 'm-tile' + ' ' + 'm-tile--1x2';

	var item = document.createElement('div');
	item.className = className;

	// tile
	var html = '<a class="m-tile__link" href="' + LinkUrl + '" aria-label="' + Headline + '" tabindex="0"><div class="m-tile__inner">';

	// check image
	if (ImageUrl) {
		html += '<figure class="m-tile__image"><img src="' + ImageUrl + '" alt="' + ImageAlt + '"></figure>';
	}
	html += '<div class="m-tile__content">\t\t\t\t\t\n\t\t\t\t\t<h4 class="m-tile__title">' +
	Headline + '</h4>\n\t\t\t\t\t<p class="m-tile__desc">' +
	Abstract + '</p>\n\t\t\t\t\t<div class="m-tile__meta">\n\t\t\t\t\t\t<span class="m-tile__meta-sub">' +

	FormattedDate + '</span>\n\t\t\t\t\t\t<span class="m-tile__meta-sub ui-icon-btn"><i class="icon-right-arrow-sm"></i></span>\t\t\t\t\t\t\n\t\t\t\t\t</div></div></div></a>';



	item.innerHTML = html.trim();
	return item;
};

/**
       * render items
       * @param  {[Array]}  list
       * @return {[Array]}           [rendered item collection]
       */ /**
          * ArticletagMosaic
          *
          * Fetch results and runtime render items.
          *
          * props to note:
          *
          *	 selectedFilter:	tag filtering by
          *   baseUri: service uri
          *   mosaic: sitecore Id to fetch list
          *
          * use:
          * class="module mosaic" data-name="articletag-mosaic"
          *
          * related src:
          * view: Views/CSLShared/Modules/News/ArticleTagMosaic.cshtml
          * css: app/styles/modules/_mosaic.scss
          *
          */ // dependency
var renderItems = function renderItems(list) {return list.reduce(function (items, itemProps) {var renderedItem = renderItem(itemProps);items.push(renderedItem);return items;}, []);}; /**
                                                                                                                                                                                        * ArticletagMosaic
                                                                                                                                                                                        * @type {Object}
                                                                                                                                                                                        */var ArticletagMosaic = { refs: {}, /**
                                                                                                                                                                                                                              * When mounted
                                                                                                                                                                                                                              */mounted: function mounted() {var _this = this; //prop names must match data attribute names (camel cased)
		var _props = this.props,selectedFilter = _props.selectedFilter,offsetIndex = _props.offsetIndex;var grid = this.el.querySelector('.grid'); // iso option
		var IsoOption = { layoutMode: 'masonry',
			itemSelector: '.m-tile',
			percentPosition: true,
			transitionDuration: 300,
			masonry: {
				gutter: 30,
				columnWidth: '.m-sizer',
				initLayout: true } };



		// get iso instance
		var isoInstance = (0, _framework.iso)(grid, IsoOption);

		// iso events
		isoInstance.on('layoutComplete', this.isoLayout.bind(this));

		// check image load
		isoInstance.items.forEach(function (item) {
			var img = item.element.getElementsByTagName('img')[0];

			if (img) {
				var src = img.src;
				var dummyImg = new Image();

				dummyImg.onload = function () {
					_this.refs.iso.layout();
				};
				dummyImg.src = src;
			}
		});

		// refs
		this.refs = {
			iso: isoInstance,
			items: Array.from(this.el.querySelectorAll('.m-tile')),
			grid: grid,
			offsetIndex: offsetIndex //initial value from page
		};

		this.el.addEventListener('click', this.clickHandler.bind(this));

		this.setState({
			pageCount: 0, // skip initial load
			tagFilter: selectedFilter });

	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;

		if (t.matches('.js-load-more')) {var
			pageCount = this.state.pageCount;
			e.preventDefault();

			this.setState({
				pageCount: pageCount + 1 });

		}
	},

	isoLayout: function isoLayout() {
		// console.log(args);
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso) {
			this.refs.iso.layout();
		}

		return this;
	},


	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {
		if (prevState.pageCount !== state.pageCount) {
			this.fetchItems();
		}
	},

	/**
        * Fetch data to render items
        * @param  {Boolean} [isLoadmore=false] [either this is loadmore or not]
        * @return {[Object]}                   [self]
        */
	fetchItems: function fetchItems() {var _this2 = this;

		// 1. set fetching state
		this.el.classList.add('fetching');var _refs =

		this.refs,iso = _refs.iso,grid = _refs.grid;var _props2 =
		this.props,mosaic = _props2.mosaic,baseUri = _props2.baseUri;var _state =
		this.state,tagFilter = _state.tagFilter,pageCount = _state.pageCount;
		var isLoadmore = pageCount !== 0;

		// if this is not loadmore, remove all 
		if (!isLoadmore) {
			var removalCandidates = Array.from(grid.querySelectorAll('.m-tile'));
			removalCandidates.forEach(function (ele) {return ele.parentNode.removeChild(ele);});
			iso.remove(removalCandidates);
			this.refs.offsetIndex = 0;
		}

		var serviceURI = baseUri + '?mosaicid=' + mosaic;
		if (tagFilter !== 'all')
		{
			serviceURI += '&filter=' + tagFilter;
		}
		serviceURI += '&pageIndex=' + pageCount;
		serviceURI += '&offsetIndex=' + this.refs.offsetIndex;


		fetch(serviceURI, {
			method: 'GET',
			credentials: 'same-origin' }).

		then(function (res) {return res.json();}).
		then(function (data) {var
			Articles = data.Articles,HaveMoreArticles = data.HaveMoreArticles,OffsetIndex = data.OffsetIndex;

			// new items
			var renderedItems = renderItems(Articles);
			iso.insert(renderedItems);

			// check loadMore-bility
			_this2.el.classList[HaveMoreArticles ? 'remove' : 'add']('hide-load-more');
			_this2.refs.offsetIndex = OffsetIndex;
		}).
		catch(function (e) {return console.log("ArticleTag.FetchItems: " + e);}).
		then(function () {
			setTimeout(function () {
				_this2.resize().el.classList.remove('fetching');
			}, 150);
		});

		return this;
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			pageCount: 0, //initial load 
			tagFilter: 'all' // default all. 
		};
	} };exports.default =


ArticletagMosaic;

},{"../../framework":72}],20:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });





var _framework = require('../../framework');

var Banner = {
	refs: {},

	mounted: function mounted() {
		var lazyFigureEl = this.el.querySelector('.banner__image');
		var lazyImgEl = this.el.querySelector('.banner__image img');
		this.refs = {
			lazyFigure: lazyFigureEl,
			lazyImg: lazyImgEl,
			checkLazyLoad: lazyFigureEl || lazyImgEl };


		//force load if browser does not support or Google bot
		var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);
		if (!supportScroll)
		{
			this.loadImages();
		}
	},

	viewmodeUpdate: function viewmodeUpdate() {
		this.checkInView();
	},
	scroll: function scroll(e) {
		this.checkInView();
	},
	checkInView: function checkInView()
	{

		if (!this.refs.checkLazyLoad) {return;}var
		bp = this.context.state.bp;
		var shouldLoad = _framework.util.checkIfInView(this.el, bp);
		if (shouldLoad)
		{
			this.loadImages();
		}
	},

	loadImages: function loadImages()
	{
		this.refs.checkLazyLoad = false;
		if (this.refs.lazyFigure)
		{
			var figStyle = this.refs.lazyFigure.getAttribute('data-lazystyle');
			if (figStyle)
			{
				this.refs.lazyFigure.setAttribute('style', figStyle);
			}
		}
		if (this.refs.lazyImg)
		{
			var imgSrc = this.refs.lazyImg.getAttribute('data-lazysrc');
			if (imgSrc)
			{
				this.refs.lazyImg.setAttribute('src', imgSrc);
			}
		}
		//		console.log(`${this.props.mId}, shouldLoad:${shouldLoad}`);		
	} }; /**
      * Banner module
      * 
      * use:
      * class="module banner" data-name="banner"
      */exports.default = Banner;

},{"../../framework":72}],21:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * centralize module
                                                                            * 
                                                                            * class="module centralize" data-name="centralize"
                                                                            * 
                                                                            * 
                                                                            */

var Centralize = {

	uiComponents: [],

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {

		this.refs = {
			anchorsRel: this.el.querySelectorAll('a') };


		var disclaimerText = this.el.querySelector('.disclaimer-text').value;

		this.refs.anchorsRel.forEach(function (anchorsRel) {
			if (anchorsRel.getAttribute("rel") == "external") {
				anchorsRel.setAttribute("target", "_blank");
			}
			if (anchorsRel.getAttribute("class") == "interstitial") {
				anchorsRel.setAttribute("data-confirm", disclaimerText);
				anchorsRel.setAttribute("disclaimer", disclaimerText);
			}
		});

	},



	getInternalProps: function getInternalProps() {

		return {};

	},

	getInternalState: function getInternalState() {

		return {};

	} };exports.default =



Centralize;

},{}],22:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });




var _framework = require('../../framework');

var ClinicalTrialDetail = {
	refs: {},

	mounted: function mounted() {var _this = this;
		this.props.trialId = this.el.getAttribute('data-nct-id');

		var uiInputText = null;

		// zipcode
		var uiInputTextSel = this.el.querySelector('.ui-component[data-name="ui-input"][data-type="text"]');
		if (uiInputTextSel) {
			uiInputText = _framework.ModuleManager.getInstance().getComponentById(uiInputTextSel.getAttribute('cid'));
			if (uiInputText) {
				uiInputText.mouseHandler = function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var
					input = args[0],type = args[1],role = args[2];
					if (role === 'submit-search') {
						_this.goToZipcodeSearch();
					}
				};
			}
		}

		this.refs = {
			uiInputText: uiInputText };

	},

	goToZipcodeSearch: function goToZipcodeSearch()
	{
		var input = this.refs.uiInputText;
		if (this.props.trialId && input && input.hasValue())
		{
			//		util.gaSendEvent('Interactive Feature', 'Click', 'ZipcodeSearch-Submit', 1);
			window.location.href = window.location.pathname + "?trialid=" + this.props.trialId + "&zipcode=" + input.input.value;
		}
	} }; /**
      * clinical trials module
      * use:
      * class="module clinical-trial" data-name="clinical-trial-detail"
      */exports.default =
ClinicalTrialDetail;

},{"../../framework":72}],23:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });




var _framework = require('../../framework');

var ClinicalTrial = {
	refs: {},

	mounted: function mounted() {var

		listItemName = this.props.listItemName;

		this.refs = {
			items: Array.from(this.el.querySelectorAll('.' + listItemName)) };




		//condition filter
		var uiDropDownSel = this.el.querySelector('.ui-component[data-name="ui-dropdownlist"]');
		if (uiDropDownSel) {
			var uiDropDown = _framework.ModuleManager.getInstance().getComponentById(uiDropDownSel.getAttribute('cid'));
			if (uiDropDown) {
				uiDropDown.onChange = this.uiChanged.bind(this);
			}
		}

	},

	uiChanged: function uiChanged() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var


		ui = args[0],e = args[1];var
		currentValue = ui.state.currentValue;

		switch (e) {
			case 'uidropdownchange':
				this.setState({
					currentFilterVal: currentValue });


				break;
			default:}

	},
	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.currentFilterVal !== state.currentFilterVal) {
			this.filterItems();
		}
	},


	filterItems: function filterItems() {var

		currentFilterVal = this.state.currentFilterVal;
		var currentPhase = $('#select-zipcodestatus').val().toLowerCase();
		// hide those that don't match condition
		//this.refs.items.forEach(item => {
		//	item.classList.remove('off');
		//	if (currentFilterVal!=='all')
		//	{
		//		const val = item.getAttribute('data-filter').toLowerCase();
		//		const val1 = item.getAttribute('data-overallstatus').toLowerCase();
		//		if(currentPhase == 'all')
		//		{
		//			if(val !== currentFilterVal.toLowerCase())
		//			{
		//				item.classList.add('off');
		//			}
		//		}
		//		else {
		//		 if((val !== currentFilterVal.toLowerCase()) || (val1 !== $('#select-zipcodestatus').val().toLowerCase()))
		//		{
		//			item.classList.add('off');
		//		}
		//	}
		//	}

		//});

		return this;
	} }; /**
      * clinical trials module
      * use:
      * class="module clinical-trial" data-name="clinical-trial"
      */exports.default = ClinicalTrial;

},{"../../framework":72}],24:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });
















var _framework = require('../../framework');

var ContentList = {

  /**
                                        */
  mounted: function mounted() {

    //	const { listItemName, loadMore, type } = this.props;
    var listItemName = this.props.listItemName;

    // item per load should be different per type
    //		const itemPerLoadWithCol = type ? parseInt(type.replace('col-', ''), 10) : 2; // if type is null, then default 2
    //		this.props.itemPerLoad = !Number.isNaN(itemPerLoadWithCol) ? itemPerLoadWithCol : this.props.itemPerLoad;

    this.refs = {
      items: Array.from(this.el.querySelectorAll('.' + listItemName)),
      //		loadMoreBtn: this.el.querySelector('.js-load-more'),
      checkLazyLoad: true };


    //force load if browser does not support or Google bot
    var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);
    if (!supportScroll)
    {
      loadImages();
    }
    /*
        if (loadMore) {
        	// hide all at first
        	this.refs.items.forEach(c => {
        		c.classList.add('off');
        	});
        		this.setState({
        		loadCount: 1,
        	});
        	} else {
        	this.el.classList.add('hide-load-more');
        }
        	this.el.addEventListener('click', this.clickHandler.bind(this));
        */



  },

  /**
         * when load more click, set internal state
         * @param  {[MouseEvent]} e [mouse event]
         */
  /*
                   clickHandler(e) {
                   	const t = e.target;
                   		if (t.matches('.js-load-more')) {
                   		e.preventDefault();
                   			this.setState({
                   			loadCount: this.state.loadCount + 1,
                   		});
                   	}
                   },
                   */


  /**
                                 * When internal state changes
                                 *
                                 * @param  {[type]} prevState [previous internal state]
                                 * @param  {[type]} state     [current internal state]
                                 */
  //	onStateUpdate(prevState, state) {
  //		if (prevState.loadCount !== state.loadCount) {
  //			this.loadMoreHandler();
  //		}
  //	},
  /*
  	// when loadCount changes, load more
  	loadMoreHandler() {
  		const { itemPerLoad, showAll } = this.props;
  		const { loadCount } = this.state;
  
  		const startIndex = (loadCount - 1) * itemPerLoad;
  		const endIndex = (showAll && loadCount > 1) ? 9999 : loadCount * this.props.itemPerLoad;
  
  		for (let i = startIndex; i < endIndex; i++) {
  			const c = this.refs.items[i];
  			if (c) {
  				c.classList.remove('off');
  			}
  		}
  
  		// check loadMore-bility
  		if (endIndex >= this.refs.items.length) {
  			this.el.classList.add('hide-load-more');
  		}
  	},
  */
  viewmodeUpdate: function viewmodeUpdate() {
    this.checkInView();
  },
  scroll: function scroll(e) {
    this.checkInView();
  },

  // if the module is in view, load all the images
  checkInView: function checkInView()
  {
    if (!this.refs.checkLazyLoad) {return;}var
    bp = this.context.state.bp;
    var shouldLoad = _framework.util.checkIfInView(this.el, bp);
    if (shouldLoad)
    {
      this.loadImages();
    }
  },

  loadImages: function loadImages()
  {
    this.refs.checkLazyLoad = false;
    this.refs.items.forEach(function (c) {
      var imgEl = c.querySelector(".js-lazyload");
      if (imgEl)
      {
        var imgSrc = imgEl.getAttribute('data-lazysrc');
        if (imgSrc)
        {
          imgEl.setAttribute('src', imgSrc);
        }
      }
    });

    //	console.log(`${this.props.mId}, shouldLoad:${shouldLoad}`);
  },



  getInternalState: function getInternalState() {
    return {
      //			loadCount: 0, // Number: increment to track load more
    };
  } }; /**
       * Content List
       **
       * props to note:
       *   type: col-2 | col-3 | col-4
       
       * use:
       		class="module content"
        		data-name="content-list"
       		data-list-item-name="content__item"
       *
       * related src:
       * view: Views/CSLShared/Modules/Structure/_ContentListContainerc.cshtml
       * view: Views/CSLShared/Modules/Structure/_ContentItemList.cshtml
       * css: app/styles/modules/_content.scss
       *
       */$(window).on('load', function () {var hashID = window.location.hash.replace("#", "");var contentItemList = document.getElementsByClassName("content__item");for (var index = 0; index < contentItemList.length; index++) {var anchorID = contentItemList[index].getAttribute("id");if (anchorID == "") {contentItemList[index].removeAttribute("id");}}});exports.default =
ContentList;

},{"../../framework":72}],25:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });






var _glide = require('@glidejs/glide');var _glide2 = _interopRequireDefault(_glide);

var _framework = require('../../framework');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                          * Slider
                                                                                                                                          * data-name="content-slider"
                                                                                                                                          	css: _content-slider.scss
                                                                                                                                          	html: _ContentSlider.cshtml
                                                                                                                                          */var createBulletUI = function createBulletUI(html, item, i) {var bulletUI = '<button class="glide__bullet" data-glide-dir="=' + i + '"></button>';html += bulletUI;

	return html;
}; //import Glide, { Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

var ContentSlider = {
	refs: {},

	/**
                      */
	mounted: function mounted() {

		var bulletContainerVal = this.el.querySelector('.glide__bullets');
		var slideItemsVal = Array.from(this.el.getElementsByClassName('slider__item'));

		// create bullet ui with rendered entries(items)
		if (slideItemsVal)
		{
			var renderedBullets = slideItemsVal.reduce(createBulletUI, '');
			if (bulletContainerVal)
			{
				bulletContainerVal.innerHTML = renderedBullets;
			}
		}

		var midVal = this.el.getAttribute('mid');
		var glideSel = '.content-slider[mid="' + midVal + '"]';
		var autoplay = this.el.getAttribute('data-autoplay');

		var glideElVal;
		if (autoplay == "True")
		{
			glideElVal = new _glide2.default(glideSel, { type: 'carousel', autoplay: 8000 });
		} else

		{
			glideElVal = new _glide2.default(glideSel, { type: 'carousel' });
		}

		this.refs = {
			bulletContainer: bulletContainerVal,
			slideItems: slideItemsVal,
			glideEl: glideElVal };


		this.el.addEventListener('click', this.clickHandler.bind(this));

		glideElVal.mount();
		//glideElVal.mount({ Controls, Swipe })
	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;

		if (t.matches('.glide__arrow'))
		{
			var num = this.refs.glideEl.index;
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Content Slider step ' + num, 1);
		};
	} };exports.default =


ContentSlider;

},{"../../framework":72,"@glidejs/glide":79}],26:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * CookiePolicy module
                                                                            *
                                                                            */

var CookiePolicy = {
	mounted: function mounted() {
		// set isActive to true. BE will render this under a condition --> show
		this.setState({
			isActive: true });


		this.el.addEventListener('click', this.clickHandler.bind(this), false);
	},

	clickHandler: function clickHandler(e) {
		var target = e.target;

		if (target.matches('.js-close-btn')) {
			e.preventDefault();

			this.setState({
				isActive: false });

		}
	},

	onStateUpdate: function onStateUpdate(prevState, state) {var
		isActive = state.isActive;

		if (prevState.isActive !== isActive) {
			this.el.classList[isActive ? 'add' : 'remove']('active');

			// remove from dom
			if (!isActive) {
				this.destroy();
			}
		}
	},


	getInternalState: function getInternalState() {
		return {
			isActive: false };


	} };exports.default =



CookiePolicy;

},{}],27:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * CSL form
                                                                            *
                                                                            * use:
                                                                            * class="module csl-form" data-name="form"
                                                                            *
                                                                            * related src:
                                                                            * view: Views/CSLShared/Modules/_FillForm.cshtml
                                                                            * css: app/styles/modules/_csl-form.scss
                                                                            *
                                                                            */
var Form = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {

		var form = this.el.getElementsByTagName('form')[0];
		this.refs = {
			form: form,
			subscription: this.el.querySelector('.subscription'),
			thankyou: this.el.querySelector('.thankyou') };


		// text area
		var tas = Array.from(this.el.getElementsByTagName('textarea'));
		tas.forEach(function (ta) {
			ta.parentNode.classList.add('no-float');
		});
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {};

	} };exports.default =



Form;

},{}],28:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });










































var _lodash = require('lodash');
var _framework = require('../../framework'); /**
                                             * Dropdown Table
                                             *
                                             * this object is used for:
                                             *
                                             *   download-list(M10)
                                             *   csl-table(M18)
                                             *   dropdown-table(M28)
                                             *   accoridian-list(M29)
                                             *   event-listing(M34)
                                             *   product-accordian-list(M32)
                                             *
                                             * use:
                                             *
                                             * class="module {module name}""
                                             * data-name="{module name}"
                                             * data-list-item-name="{list item name}"
                                             * data-accordian="{true | false}"
                                             * data-inner-accordian="{true | false}"
                                             * data-load-more="{1 | 0}"
                                             * data-item-per-load="{item per load}"
                                             *
                                             * related src:
                                             *
                                             * view:
                                             *   Views/CSLShared/Modules/_DownloadList.cshtml
                                             *   Views/CSLShared/Modules/_Table.cshtml
                                             *   Views/CSLShared/Modules/_DropdownTable.cshtml
                                             *   Views/CSLShared/Modules/_AccordionList.cshtml
                                             *   Views/CSLShared/Modules/_EventListEntry.cshtml
                                             *   Views/CSLShared/Modules/_ProductNestedAccordionList.cshtml
                                             *
                                             * css:
                                             *   app/styles/modules/_download-list.scss
                                             *   app/styles/modules/_csl-table.scss
                                             *   app/styles/modules/_dropdown-table.scss
                                             *   app/styles/modules/_accoridian-list.scss
                                             *   app/styles/modules/_product-accorian.scss
                                             *   app/styles/modules/_event-listing.scss
                                             *   app/styles/modules/_product-accordian-list.scss
                                             *
                                             */var DropdownTable = { refs: {}, /**
                                                                                * When mounted
                                                                                *
                                                                                * start writing scrip here for this module
                                                                                */mounted: function mounted() {var _this = this;var _props = this.props,listItemName = _props.listItemName,loadMore = _props.loadMore; // refs
    this.refs = { //	items: Array.from(this.el.querySelectorAll(`.${listItemName}`)), // tgroup
      //	loadMoreBtn: this.el.querySelector('.js-load-more'),
      table: this.el.getElementsByTagName('table')[0] }; // check if load more is enabled.
    /*
    if (loadMore) {
    	// hide all at first
    	this.refs.items.forEach(c => {
    		c.classList.add('off');
    	});
    		this.setState({
    		loadCount: 1,
    	});
    	} else {
    	*/this.el.classList.add('hide-load-more'); //}
    // some other js plugins will target table generally setting inline styles. nullify it.
    setTimeout(function () {if (_this.refs.table) {_this.refs.table.removeAttribute('style');}}, 500);this.el.addEventListener('click', this.clickHandler.bind(this));window.addEventListener('keydown', this.keyBoardHandler.bind(this));this.scrollToProduct();}, /* 
                                                                                                                                                                                                                                                                     * for the Product Nested Accordion List module 
                                                                                                                                                                                                                                                                     * if a tbody element has a data-id value and
                                                                                                                                                                                                                                                                     * the URL contains the same hash value (bookmark) 
                                                                                                                                                                                                                                                                     * this will scroll to the tbody and open it 
                                                                                                                                                                                                                                                                    */scrollToProduct: function scrollToProduct() {var hashValue = location.hash.substring(1);if (hashValue) {var tbodyItem = this.el.querySelector("tbody[data-id='" + hashValue + "']");if (tbodyItem) {tbodyItem.classList.add('active');tbodyItem.scrollIntoView(true);window.scrollBy(0, 35);}}
  },

  /**
         * accessibility with focus && keyboard(enter)
         *
         * @param  {[KeyboardEvent]} e
         * @return {[type]}   [description]
         */
  keyBoardHandler: function keyBoardHandler(e) {

    var key = e.keyCode;
    var currentFocusAnchor = this.el.querySelector('*:focus');

    // find any focused anchor
    if (key === 13 && currentFocusAnchor) {
      e.preventDefault();
      this.handlAccordian(currentFocusAnchor);
    }

    return false;
  },

  /**
         * Handles all click events
         * @param  {[MouseEvent]} e
         */
  clickHandler: function clickHandler(e) {var

    accordian = this.props.accordian;
    var t = e.target;
    /*
                                        		if (t.matches('.js-load-more')) {
                                        
                                        			// when load more clicked
                                        			e.preventDefault();
                                        
                                        			this.setState({
                                        				loadCount: this.state.loadCount + 1,
                                        			});
                                        
                                        		} else 
                                        		*/
    if (t.matches('.ir-toggle')) {

      // when collapable button clicked
      e.preventDefault();

      this.handlAccordian(t);

    } else if (t.matches('.anchor') && accordian) {

      // when collapable button clicked
      e.preventDefault();

      this.handlAccordian(t);

    } else if (t.matches('.js-show-tooltip') || t.matches('.js-hide-tooltip')) {

      e.preventDefault();

      // when tooltip clicked
      if (t.classList.contains('js-show-tooltip')) {
        // 1. show toopip if exist
        this.toolTipHandler(t, true);
      } else {
        // hide toopip if exist
        this.toolTipHandler(t, false);
      }

      return;

    }

    // if tooltip is open, hide;
    this.toolTipHandler(null, false);
  },

  /**
         * When module has tooptips, handle that.
         * @param  {[Element]}  target element      [clicked dom element used to find parent]
         * @param  {Boolean} [show=true]            [description]
         */
  toolTipHandler: function toolTipHandler(ele) {var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (show) {var
      listItemName = this.props.listItemName;

      // target item
      var parentItem = _framework.util.findParent(ele, '.' + listItemName, '.module');

      if (parentItem) {
        parentItem.classList.add('show-tooltip');
      }

    } else {
      var hasTooltip = this.el.querySelector('.show-tooltip');
      if (hasTooltip) {
        hasTooltip.classList.remove('show-tooltip');
      }
    }
    return this;
  },

  /**
         * Handles accordians
         * @param  {[Element]} ele [clicked dom element]
         */
  handlAccordian: function handlAccordian(ele) {var

    listItemName = this.props.listItemName;

    // find tbody
    var tbody = _framework.util.findParent(ele, '.' + listItemName, '.module');

    // find .ir-toggle
    var innerToggle = ele.matches('.ir-toggle') ? ele : _framework.util.findParent(ele, '.ir-toggle', '.module');

    if (innerToggle) {
      var ir = _framework.util.findParent(innerToggle, '.ir', '.module');
      var isActive = ir.classList.contains('active');
      //ele.text
      _framework.util.gaSendEvent('Interactive Feature', 'Click', isActive ? 'Inner Accordion - Close' : 'Inner Accordion - Open', 1);

      // toggle inner
      ir.classList.toggle('active');
    } else
    if (tbody && tbody.tagName === 'TBODY') {
      var _isActive = tbody.classList.contains('active');

      // outer td toggle
      tbody.classList[_isActive ? 'remove' : 'add']('active');

      if (!_isActive) {
        // shut all inner
        Array.from(tbody.querySelectorAll('.ir.active')).forEach(function (t) {return t.classList.remove('active');});
      }
      _framework.util.gaSendEvent('Interactive Feature', 'Click', _isActive ? 'Accordion - Close' : 'Accordion - Open', 1);
    }
  },

  // when internal state changes
  onStateUpdate: function onStateUpdate(prevState, state) {
    /*
                                                                                                                   if (prevState.loadCount !== state.loadCount) {
                                                                                                                   	this.loadMoreHandler();
                                                                                                                   }
                                                                                                                   */
  },

  /**
         * when loadCount changes, load more
         * @return {[type]} [description]
         */
  /* not used
                   loadMoreHandler() {
                   	const { itemPerLoad, showAll } = this.props;
                   	const { loadCount } = this.state;
                   		const startIndex = (loadCount - 1) * itemPerLoad;
                   	const endIndex = (showAll && loadCount > 1) ? 9999 : loadCount * this.props.itemPerLoad;
                   		for (let i = startIndex; i < endIndex; i++) {
                   			const c = this.refs.items[i];
                   			if (c) {
                   			c.classList.remove('off');
                   		}
                   	}
                   		// check loadMore-bility
                   	if (endIndex >= this.refs.items.length) {
                   		this.el.classList.add('hide-load-more');
                   	}
                   },
                   */






  // setting internal state
  getInternalState: function getInternalState() {
    return {
      //		loadCount: 0,
    };
  } };exports.default =



DropdownTable;

},{"../../framework":72,"lodash":"lodash"}],29:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _lodash = require('lodash');var _lodash2 = _interopRequireDefault(_lodash);
var _enum = require('../../enum');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                * Fact Cards
                                                                                                                                *
                                                                                                                                * use:
                                                                                                                                * class="module fact-cards" data-name="fact-cards"
                                                                                                                                *
                                                                                                                                * related src:
                                                                                                                                * view: Views/CSLShared/Modules/_FactCards.cshtml
                                                                                                                                * css: app/styles/modules/_fact-cards.scss
                                                                                                                                *
                                                                                                                                * 
                                                                                                                                */ // dependency
var FactCards = { /**
                   * When mounted
                   *
                   * start writing scrip here for this module
                   */mounted: function mounted() {}, // when current tab is active
	viewmodeUpdate: function viewmodeUpdate() {this.scroll();},
	/**
                                                                                                                          * This method is to check if in-view animation can start
                                                                                                                          */
	scroll: function scroll() {

		//  if half height if this el is within viewport, then play
		var bp = this.context.state.bp;
		var rect = this.el.getBoundingClientRect();
		var wh = window.innerHeight;
		var isMobileViewPort = bp >= _enum.BP['SIZE_MD'];

		var inViewPort = wh - rect.top >= 0 && rect.bottom >= 0;
		var isOkToAnimate = isMobileViewPort && inViewPort && window.innerHeight - rect.top >= this.el.offsetHeight / 2;

		this.setState({
			inViewPort: inViewPort,
			isOkToAnimate: isOkToAnimate });


	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {var _state =




		this.state,animateCount = _state.animateCount,isOkToAnimate = _state.isOkToAnimate;

		if (this.prevState.isOkToAnimate !== isOkToAnimate) {

			if (isOkToAnimate && animateCount <= this.props.maxAnimateCount) {

				this.animateNumericValue();

			}

		}

	},

	/**
        * Each column contains string value. Animate them in order
        */
	animateNumericValue: function animateNumericValue() {var _this = this;

		var INTERVAL = 8;
		var PLACEHOLDER_STR = '';

		var animateString = function animateString(queue) {

			queue.forEach(function (el) {

				el.innerHTML = el.getAttribute('data-src');

			});

			var el = queue.shift();
			var src = _lodash2.default.unescape(el.getAttribute('data-src'));
			var containNumberValue = src.match(/\d/g, '');

			el.innerHTML = src;

			var animate = function animate(s, index) {

				clearInterval(_this.charTicker);

				// base case
				if (index === src.length) {

					// each complete
					el.innerHTML = src;

					// check queue
					if (queue.length) {

						animateString(queue);

					}

				} else {

					var end = 9;
					var start = 0;

					_this.charTicker = setInterval(function () {

						if (start < end) {

							var before = src.substr(0, index).
							split('').
							map(function (char) {return '<span>' + char + '</span>';}).
							join('');

							var after = src.substr(index + 1).
							replace(/(\d|[a-z])/ig, PLACEHOLDER_STR);
							// .replace(/\S/g, PLACEHOLDER_STR);


							// console.log(before, ' | ', start, ' | ', after);
							el.innerHTML = before + '<span class="current">' + start + '</span>' + after;

							start++;

						} else {

							clearInterval(_this.charTicker);

							animate(src, index + 1);

						}

					}, INTERVAL);

				}

			};

			if (containNumberValue && containNumberValue.length) {

				animate(src, 0);

			}

		};

		// queue
		var queue = Array.from(this.el.querySelectorAll('.js-numeric-val'));

		animateString(queue);

		this.setState({ animateCount: this.state.animateCount + 1 }, false);

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {
			maxAnimateCount: 1 };


	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			inViewPort: false,
			isOkToAnimate: false,
			animateCount: 0 };


	} };exports.default =


FactCards;

},{"../../enum":68,"lodash":"lodash"}],30:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _enum = require('../../enum');

var FeaturedArea = {

	/**
                                          * When mounted
                                          *
                                          * start writing scrip here for this module
                                          */
	mounted: function mounted() {},

	/**
                                                                  * This method is to check if in-view animation can start
                                                                  */
	viewmodeUpdate: function viewmodeUpdate() {

		this.scroll();

	},

	scroll: function scroll() {

		// if half height if this el is within viewport, then play
		var bp = this.context.state.bp;
		var rect = this.el.getBoundingClientRect();
		var wh = window.innerHeight;
		var isNotMobileViewPort = bp >= _enum.BP['SIZE_MD'];

		var inViewPort = wh - rect.top >= 0 && rect.bottom >= 0;
		var isOkToAnimate = isNotMobileViewPort && inViewPort && wh - rect.top >= this.el.offsetHeight * 0.4;

		this.setState({
			inViewPort: inViewPort,
			isOkToAnimate: isOkToAnimate });


	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {var


		animateCount =

		state.animateCount,isOkToAnimate = state.isOkToAnimate;

		// when it is ok to animate, animate-in two images up to maxAnimateCount
		if (this.prevState.isOkToAnimate !== isOkToAnimate) {

			if (isOkToAnimate && animateCount < this.props.maxAnimateCount) {

				if (this.el.classList.contains('in-view-animation')) {

					this.el.classList.remove('in-view-animation');

				}

				this.el.classList.add('in-view-animation');
				this.setState({ animateCount: this.state.animateCount + 1 }, false);

			}

		}

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {
			maxAnimateCount: 1 // number: max cound to animate in-view animation
		};

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			inViewPort: false, // boolean: max cound to animate in-view animation
			isOkToAnimate: false, // boolean: true | false to start in-view animation
			animateCount: 0 // number: current animation count
		};

	} }; /**
      * Featured Area
      *
      * use:
      * class="module fact-cards" data-name="fact-cards"
      *
      * related src:
      * view: Views/CSLShared/Modules/_FeaturedArea.cshtml
      * css: app/styles/modules/_feature-area.scss
      *
      * 
      */ // dependency
exports.default = FeaturedArea;

},{"../../enum":68}],31:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _framework = require('../../framework');

var FullSizeImage = {

   refs: {},

   mounted: function mounted() {
      this.el.addEventListener('click', this.clickHandler.bind(this));
   },

   clickHandler: function clickHandler(e) {

      var t = e.target;
      var share = document.getElementById('fullsizeimage');
      var dl = document.getElementById('directlink');

      if (t.matches('.share-button')) {
         e.preventDefault();
         this.directLinkValue();
         this.showShare(share);
      }

      if (t.matches('.close-btn')) {
         e.preventDefault();
         this.hideShare(share);
      }

      if (t.matches('.directlink')) {
         e.preventDefault();
         this.selectValue(dl);
      }

   },

   showShare: function showShare(ele) {
      ele.classList.add('share');
      _framework.util.gaSendEvent('Interactive Feature', 'Click', 'Share Image', 1);
   },

   hideShare: function hideShare(ele) {
      ele.classList.remove('share');
   },

   directLinkValue: function directLinkValue() {
      var imagePath = document.getElementById('imagepath').innerHTML;
      var fullURL = window.location.protocol + "//" + window.location.host + imagePath;
      document.getElementById('directlink').value = fullURL;
   },

   selectValue: function selectValue(ele) {
      ele.select();
   },

   getInternalProps: function getInternalProps() {
      return {};
   },

   getInternalState: function getInternalState() {
      return {};
   } }; /**
        * Full Size Image
        *
        * use:
        * class="module fullSizeImage" data-name="full-size-image"
        *
        * related src:
        * view: Views/CSLShared/Shared/_FullSizeImage.cshtml
        * css: app/styles/modules/_fullsizeimage.scss
        *
        * 
        */exports.default = FullSizeImage;

},{"../../framework":72}],32:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });














var _action = require('../../action');
var _framework = require('../../framework'); /**
                                             * global Selector
                                             *
                                             * use:
                                             * class="module global-selector" data-name="global-selector"
                                             *
                                             * related src:
                                             *
                                             * view: Views/Shared/_UtilityLinks.cshtml
                                             * css: app/styles/modules/_global-selector.scss
                                             *
                                             * 
                                             */ // dependency
var GlobalSelector = { refs: {}, /**
                                  * When mounted
                                  */mounted: function mounted() {var _this = this;this.refs.closeBtn = this.el.querySelector('.close-btn');this.refs.allLinks = this.el.getElementsByClassName('ls-link');this.el.addEventListener('click', this.clickHandler.bind(this));this.el.addEventListener('blur', function () {_this.context.setState(_action.appActions.langSelector(false));
		});

		// keyboard
		this.el.addEventListener('keydown', function (e) {
			// esc
			if (e.keyCode === 27) {
				//send close
				_this.context.setState(_action.appActions.langSelector(false));
			}
		});
	},

	/**
        * Mouse Click handler
        * @param  {Event} e [Mouse click event]
        * @return {[type]}   [description]
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;
		var isExitable = !t.matches('.ui-btn:not(.close-btn)');

		if (isExitable) {
			e.preventDefault();
			this.context.setState(_action.appActions.langSelector(false));
		}
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {var
		isActive = this.state.isActive;
		this[isActive ? 'open' : 'close']();
	},

	open: function open() {
		this.refs.focusedEl = document.activeElement;

		this.el.classList.add('active');
		_framework.util.gaSendEvent('Interactive Feature', 'Click', 'GlobalSelector-Open', 1);

		// first item auto focus(AA)
		// AA. set focuable to true
		for (var i = 0; i < this.refs.allLinks.length; ++i) {
			var link = this.refs.allLinks[i];
			_framework.util.setFocusable(link, true);
		}

		if (this.refs.allLinks[0]) {
			this.refs.allLinks[0].focus();
		} else {
			this.refs.closeBtn.focus();
		}
	},

	close: function close() {
		this.el.classList.remove('active');
		_framework.util.gaSendEvent('Interactive Feature', 'Click', 'GlobalSelector-Close', 1);

		// AA. set focuable to false
		for (var i = 0; i < this.refs.allLinks.length; ++i) {
			var link = this.refs.allLinks[i];
			_framework.util.setFocusable(link, false);
		}
		if (this.refs.focusedEl)
		{
			this.refs.focusedEl.focus();
		}
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			isActive: false // boolean: open or not
		};
	} };exports.default =


GlobalSelector;

},{"../../action":2,"../../framework":72}],33:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });











var _framework = require('../../framework');

var HaegardaDosingCalc = {

    refs: {},

    mounted: function mounted() {

        this.refs = {
            weightInput: this.el.querySelector('.js-weight-input'),
            lbCheck: this.el.querySelector('.js-unit-type-lb'),
            kgCheck: this.el.querySelector('.js-unit-type-kg'),
            calcBtn: this.el.querySelector('.js-calculate'),
            resetBtn: this.el.querySelector('.js-reset'),
            messageKG: this.el.querySelector('.js-message-kg'),
            messageLB: this.el.querySelector('.js-message-lb'),
            resultUnits: this.el.querySelector('.js-result-units'),
            resultMl: this.el.querySelector('.js-result-ml') };


        var haveInputs =
        this.refs.weightInput != null &&
        this.refs.lbCheck != null &&
        this.refs.kgCheck != null &&
        this.refs.calcBtn != null &&
        this.refs.resetBtn != null &&
        this.refs.messageKG != null &&
        this.refs.messageLB != null &&
        this.refs.resultUnits != null &&
        this.refs.resultMl != null;

        if (haveInputs) {
            this.refs.calcBtn.addEventListener('click', this.calculate.bind(this));
            this.refs.resetBtn.addEventListener('click', this.resetFormAll.bind(this));

            this.refs.weightInput.addEventListener('keydown', this.keyboardHandler.bind(this));
            this.refs.weightInput.addEventListener('input', this.inputHandler.bind(this));
            this.refs.weightInput.addEventListener('blur', this.inputHandler.bind(this));

            this.refs.lbCheck.addEventListener('change', this.resetForm.bind(this));
            this.refs.kgCheck.addEventListener('change', this.resetForm.bind(this));
        };
    },

    /**
           * keyboard down
           *
           * @param  {[KeyboardEvent]} e
           */
    keyboardHandler: function keyboardHandler(e) {
        var key = e.which || e.keyCode;
        var valid = !e.shiftKey && !e.altKey && !e.ctrlKey && (
        // numbers   
        key >= 48 && key <= 57 ||
        // Numeric keypad
        key >= 96 && key <= 105 ||
        // comma, period and minus, . on keypad
        // key == 190 || key == 188 || key == 109 || key == 110 ||
        // Backspace and Tab and Enter
        key == 8 || key == 9 || key == 13 ||
        // Home and End
        key == 35 || key == 36 ||
        // left and right arrows
        key == 37 || key == 39 ||
        // Del and Ins
        key == 46 || key == 45);

        if (!valid)
        {
            e.preventDefault();
        }
        return valid;
    },

    inputHandler: function inputHandler(e) {
        switch (e.type) {
            case 'blur':
                this.validate();
                _framework.util.gaSendEvent('Interactive Feature', 'Dosing Calculator', 'Weight Entered', 1);
                break;
            case 'input':
                this.resetForm();
                break;
            default:}

    },

    calculate: function calculate() {
        if (this.validate()) {
            //hide any message
            this.refs.messageKG.classList.remove('active');
            this.refs.messageLB.classList.remove('active');

            var weight = this.refs.weightInput.value;

            //convert to pounds
            if (this.refs.lbCheck.checked) {
                weight = weight / 2.2;
                _framework.util.gaSendEvent('Interactive Feature', 'Dosing Calculator', 'lb selected');
            } else
            {
                _framework.util.gaSendEvent('Interactive Feature', 'Dosing Calculator', 'kg selected');
            }

            // round to two decimal places
            weight = parseFloat(weight).toFixed(2);
            //calculation
            var dosage = parseFloat(weight * 60).toFixed(0);
            var mL = parseFloat(dosage / 500).toFixed(1);

            this.refs.resultUnits.value = dosage;
            this.refs.resultMl.value = mL;

            _framework.util.gaSendEvent('Interactive Feature', 'Dosing Calculator', 'Calculate Dose');
        }
        return false;
    },

    validate: function validate() {
        var weight = this.refs.weightInput.value;

        //  var isvalid = (/^[1-9]\d*$/.test(weight));
        var isValid = weight != null && isFinite(weight);
        if (isValid) {
            if (this.refs.lbCheck.checked) {
                isValid = weight > 0 && weight <= 999;
            } else
            {
                isValid = weight > 0 && weight <= 499;
            }
        }
        //show message
        if (!isValid) {
            if (this.refs.lbCheck.checked) {
                this.refs.messageLB.classList.add('active');
            } else
            {
                this.refs.messageKG.classList.add('active');
            }
        }
        return isValid;
    },

    resetFormAll: function resetFormAll() {
        this.refs.weightInput.value = "";
        this.resetForm();
    },

    resetForm: function resetForm() {
        this.refs.resultUnits.value = "";
        this.refs.resultMl.value = "";
        this.refs.messageKG.classList.remove('active');
        this.refs.messageLB.classList.remove('active');
    } }; /**
         * Haegarda Dosing Calculator
         *
         * use:
         * class="module haegarda-dosing-calc" data-name="haegarda-dosing-calc"
         *
         * related src:
         *
         * view: Views/CSLShared/Modules/_haegardaDosingCalc.cshtml
         * css: app/styles/modules/_haegarda-dosing-calc.scss
         *
         */exports.default = HaegardaDosingCalc;

},{"../../framework":72}],34:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _action = require('../../action');
var _framework = require('../../framework');

var _moduleManager = require('../../framework/module-manager');var _moduleManager2 = _interopRequireDefault(_moduleManager);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// constants
var IN_ACTIVE_DELAY = 7000; /**
                            * App Header
                            *
                            * use:
                            * class="module header" data-name="header"
                            *
                            * related src:
                            * view: Areas/CSL/Views/Shared/_Header.cshtml
                            * css: app/styles/modules/_header.scss
                            *
                            * 
                            */ // dependency
var Header = { refs: {}, /**
                          * When mounted
                          *
                          * start writing scrip here for this module
                          */mounted: function mounted() {var _this = this; // ui selectors(lang, user login)
      var uiSelectors = Array.from(this.el.querySelectorAll('.ui-selector')).map(function (el) {return _moduleManager2.default.getInstance().getComponentById(el.getAttribute('cid'));});
      // ref
      this.refs = {
         navItems: Array.from(this.el.querySelectorAll('.nav-link')),
         colorBar: this.el.querySelector('.color-bar'),
         uiSelectors: uiSelectors,
         uiFeaturedImages: this.el.querySelectorAll('.expanded-content[data-level="0"] .expanded-content__row .container .header__teaser figure') };


      // iterate all nav items and check if it has child-extended content
      this.refs.navItems.forEach(function (navItem) {

         // check if has children
         var hasChildren = [].slice.call(navItem.children).some(function (c) {return c.matches('.expanded-content');});

         if (hasChildren) {
            var label = navItem.querySelector('a.label');

            label.addEventListener('click', _this.linkHandler.bind(_this));
            navItem.classList.add('has-children');
         }
      });

      this.el.addEventListener('mouseenter', this.mouseHandler.bind(this));
      this.el.addEventListener('mouseleave', this.mouseHandler.bind(this));
      this.el.addEventListener('mousemove', this.mouseHandler.bind(this));
      this.el.addEventListener('click', this.mouseHandler.bind(this));

      // keyboard
      this.el.addEventListener('keydown', function (e) {
         //	console.log(e.keyCode);
         // esc
         if (e.keyCode === 27) {
            //console.log('close all');
            // close all
            _this.closeAll();
         }
      });

      this.reset();
   },

   // complete close if open
   reset: function reset() {
      if (this.state.open) {
         _framework.util.gaSendEvent('Interactive Feature', 'Click', 'RichNav-Close', 1);
      }
      this.closeAll();

      // set open state
      this.setState({
         open: false });


      this.el.classList.remove('open');
      this.el.classList.remove('already-in');
   },

   // all prev hover-intent targets
   closeAll: function closeAll() {

      var allOpenNavLinksA = this.el.querySelectorAll('.nav-link.hover-intent a');
      for (var i = 0; i < allOpenNavLinksA.length; ++i) {
         var aFocus = allOpenNavLinksA[i];
         aFocus.blur();
      }

      var allOpenNavLinks = this.el.querySelectorAll('.nav-link.hover-intent');
      for (var _i = 0; _i < allOpenNavLinks.length; ++_i) {
         allOpenNavLinks[_i].classList.remove('hover-intent');
      }

      var featureOne = this.el.querySelectorAll('.featureItemOne');
      for (var _i2 = 0; _i2 < featureOne.length; ++_i2) {
         featureOne[_i2].classList.remove('invisible');
      }

      // AA
      var allLinksButRootLevel = this.el.querySelectorAll('.nav-link:not([data-level="0"]) a');
      for (var _i3 = 0; _i3 < allLinksButRootLevel.length; ++_i3) {
         var link = allLinksButRootLevel[_i3];
         _framework.util.setFocusable(link, false);
      }

      // close ui selectors(lang, login)
      this.refs.uiSelectors.forEach(function (uiSelector) {return uiSelector.reset();});
   },

   // other links(buttons)
   mouseHandler: function mouseHandler(e) {

      var t = e.target;

      // remove ideltimer
      // clearTimeout(this.idleTimer);
      // this.idleTimer = setTimeout(this.reset.bind(this), IN_ACTIVE_DELAY);
      switch (e.type) {
         case 'mousemove':
            if ($(t).hasClass('menuContainer') || $(t.parentNode).hasClass('header-sub-nav') || $(t.parentNode).hasClass('logo')) {
               $('.nav-link.primary.has-children').removeClass("hover-intent");
               $(".colMenuRowOne").removeClass("displayNone");
               $(".header-sub-menu").addClass("displayNone");
               $('header.header').removeClass("open");
            }
            break;

         case 'click':

            if (t && (t.matches('a[data-type=search]') || t.matches('button[data-type=search]'))) {

               // global search
               e.preventDefault();

               // See search.js(not in place yet)
               var searchProps = {
                  target: e.target,
                  active: true,
                  keyword: '' };


               this.context.setState(_action.appActions.globalSearch(searchProps));

            } else if (t && (t.matches('a[data-type=hamburger]') || t.matches('button[data-type=hamburger]'))) {
               e.preventDefault();
               this.context.setState(_action.appActions.sideBarAction(true));
            } else if (t && (t.matches('a[data-type=utility]') || t.matches('button[data-type=utility]'))) {
               e.preventDefault();
               this.context.setState(_action.appActions.langSelector(true));
            } else if (t && (t.matches('a[data-type=global]') || t.matches('button[data-type=global]'))) {
               e.preventDefault();
               this.context.setState(_action.appActions.langSelector(true));
            }
            break;

         default:}

   },

   // nav item specific handlder
   linkHandler: function linkHandler(e) {

      var t = e.currentTarget;
      var currentNavItem = t.parentNode;
      var lv = +currentNavItem.getAttribute('data-level');

      switch (e.type) {

         case 'click':

            // check if nav item has expanded
            var hasExpandContent = currentNavItem.classList.contains('has-children');

            if (hasExpandContent) {

               e.preventDefault();

               // lv0
               if (lv === 0) {
                  _framework.util.gaSendEvent('Link', 'Menu Nav Link Click', t.text, 1);

                  // close all
                  this.closeAll();

                  // when it's already open before
                  if (this.state.open) {
                     this.el.classList.add('already-in');
                  }

                  currentNavItem.classList.add('hover-intent');

                  //lazy load images
                  if (this.refs.uiFeaturedImages) {
                     for (var i = 0; i < this.refs.uiFeaturedImages.length; ++i) {
                        var featureEl = this.refs.uiFeaturedImages[i];
                        var imgData = featureEl.dataset.backgroundimg;
                        if (imgData) {
                           featureEl.style.backgroundImage = imgData;
                        }
                     }
                     this.refs.uiFeaturedImages = null;
                  }

                  // set open state silently
                  if (!this.state.open) {
                     this.setState({
                        open: true });

                  }

                  // turn the header bg enabled
                  this.el.classList.add('open');

               } else if (lv === 1) {
                  _framework.util.gaSendEvent('Link', 'Menu Nav Link Click', t.text, 1);

                  var prev = this.el.querySelector('.nav-link.hover-intent[data-level="1"]');

                  if (prev) {
                     prev.classList.remove('hover-intent');
                  }

                  // show extended content
                  currentNavItem.classList.add('hover-intent');

                  // get extended content and set width accordingly
                  var extended = currentNavItem.querySelector('.expanded-content');

                  if (extended) {
                     var col = _framework.util.findParent(currentNavItem, '.col');
                     extended.style.width = col.offsetWidth + 'px'; //extended.style.width = `${col.offsetWidth * 2}px`;

                     var featureOne = this.el.querySelectorAll('.featureItemOne');
                     for (var _i4 = 0; _i4 < featureOne.length; ++_i4) {
                        featureOne[_i4].classList.add('invisible');
                     }
                  }
               }

               // AA. set focuable to true only direct children
               var allLinksDirectChildren = currentNavItem.querySelectorAll('.nav-link[data-level="' + (lv + 1) + '"] > a');
               for (var _i5 = 0; _i5 < allLinksDirectChildren.length; ++_i5) {
                  var link = allLinksDirectChildren[_i5];
                  _framework.util.setFocusable(link, true);
               }
            }

            break;

         default:}


   },

   // when app is scrolling, switch modes(collapsed)
   scroll: function scroll() {
      // turn header to collapsed theme
      //const isCollapsed = document.body.scrollTop > 5 || document.documentElement.scrollTop > 5;
      //this.el.classList[isCollapsed ? 'add' : 'remove']('collapsed');
      // Adding Contrast Bg Color to the Hero for the Header section
      //const headerCheck = document.getElementById("headerIdentity");
      //var heroCheck = document.querySelectorAll('.hero').length || document.querySelectorAll('.internal-hero').length ||
      //   document.querySelectorAll('.hero-large').length || document.querySelectorAll('.hero-stacked').length || document.querySelectorAll('.mosaic.advanced-mosaic.iso-tiles.mosaic-tiles.has-hero-image').length || document.querySelectorAll('.module.article-taglist.has-hero-image').length || document.querySelectorAll('.mosaic.tagmosaic.iso-tiles.mosaic-tiles.has-hero-image').length || document.querySelectorAll('.mosaic.paging-mosaic.iso-tiles.has-hero-image').length;
      //if (!isCollapsed && heroCheck === 1) {
      //   headerCheck.classList.add('colorContrast');
      //} else {
      //   headerCheck.classList.remove('colorContrast');
      //}

      // hide expanded content
      /* this.reset();*/

   },

   // setting internal state
   getInternalState: function getInternalState() {

      return {
         isOpen: false // boolean: when extended contents are open or not
      };

   } };exports.default =


Header;

},{"../../action":2,"../../framework":72,"../../framework/module-manager":74}],35:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _moduleManager = require('../../framework/module-manager');var _moduleManager2 = _interopRequireDefault(_moduleManager);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var HeroLarge = {

                  /**
                                    * When mounted
                                    *
                                    * start writing scrip here for this module
                                    */
                  mounted: function mounted() {} }; /**
                                                    * Hero Large
                                                    *
                                                    * use:
                                                    * class="module hero-large" data-name="hero-large"
                                                    *
                                                    * related src:
                                                    *
                                                    * view: Views/CSLShared/Modules/_HeroLarge.cshtml
                                                    * css: app/styles/modules/_hero-large.scss
                                                    *
                                                    * 
                                                    */exports.default = HeroLarge;

},{"../../framework/module-manager":74}],36:[function(require,module,exports){
"use strict";Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * Hero Stacked
                                                                            *
                                                                            * use:
                                                                            * class="module hero-stacked" data-name="hero-stacked"
                                                                            *
                                                                            * related src:
                                                                            *
                                                                            * view: Views/CSLShared/Modules/_HeroStacked.cshtml
                                                                            * css: app/styles/modules/_hero-stacked.scss
                                                                            *
                                                                            */
//import ModuleManager from '../../framework/module-manager';

var HeroStacked = {
                                                                            mounted: function mounted() {} };exports.default =


HeroStacked;

},{}],37:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;}; /**
                                                                                                                                                                                                                                                                                                                                   * Home Hero
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   * This uses slider mixin. See mixin/slider.js
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   * use:
                                                                                                                                                                                                                                                                                                                                   * class="module hero" data-name="home-hero"
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   * related src:
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   * view:
                                                                                                                                                                                                                                                                                                                                   *   Views/CSLShared/Modules/_HomeHeroEntry.cshtm
                                                                                                                                                                                                                                                                                                                                   *   Views/CSLShared/Modules/Structure/_HomeHeroContainer.cshtml
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   * css:
                                                                                                                                                                                                                                                                                                                                   *   app/styles/modules/_hero.scss
                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                   */

// dependency
var _framework = require('../../framework');
var _slider = require('../../mixin/slider');var _slider2 = _interopRequireDefault(_slider);
var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// svg object(wedge)
var thumbSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="1280" height="150" viewBox="0 0 1280 150" preserveAspectRatio="xMinYMin slice"><polygon points="0 0, 1280 0, 1280 98.878, 0 150"/></svg>';

/**
                                                                                                                                                                                                                                                                                                                                                                                                                     * @param  {[Object]} props  [data to create each thumb]
                                                                                                                                                                                                                                                                                                                                                                                                                     * @return {[Element]}       [rendered dom element]
                                                                                                                                                                                                                                                                                                                                                                                                                     */
var createThumb = function createThumb(props) {
	var thumb = document.createElement('div');
	thumb.className = props.className;
	thumb.setAttribute('data-id', props.id);
	thumb.innerHTML = thumbSvg;

	var hc = document.createElement('div');
	hc.className = 'hc';

	if (Object.prototype.hasOwnProperty.call(props, 'innerHTML')) {
		hc.innerHTML = props.innerHTML;
	}

	thumb.appendChild(hc);
	return thumb;
};

/**
       * @param  {Array}  [collection=[]]  [list of data to render thumb items]
       * @return {Element}                 [fragment element that contains all rendered items]
       */
var createThumbs = function createThumbs() {var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return collection.reduce(function (df, prop, i) {
		df.appendChild(createThumb(prop));
		return df;
	}, document.createDocumentFragment());
};

var HomeHero = _framework.Proto.create(_slider2.default, {
	refs: {},
	uiComponents: [],
	gestureTimer: void 0,

	mounted: function mounted() {var _this = this;

		// mixin init
		// See mixin/slider.js for more details
		this.
		sliderInit().
		initComponents().
		createThumbsWithData().
		intitSlideDisplay();
		//.initChildVideo();

		this.el.addEventListener('click', this.clickHandler.bind(this));

		// refs
		this.refs = _extends({},
		_slider2.default.refs, {
			thumbs: Array.from(this.el.querySelectorAll('.hero__thumb')),
			thumbContainer: this.el.querySelector('.hero__thumbs'),
			thumbInner: this.el.querySelector('.hero__thumbs-inner'),
			scrollButton: this.el.querySelector('.hero__scrolldown'),
			scrollButtonShown: true });


		// find c-loader and set the animation duration === interval in ms
		[].slice.call(this.el.querySelectorAll('.js-loader')).forEach(function (cl) {
			cl.classList.remove('run');
			cl.style.animationDuration = _this.props.interval + 'ms'; // children inherit this
		});

		//move any video pop-ups outside of us (since created in child module but don't want to be clipped)
		var videoPopups = Array.from(this.el.querySelectorAll('.popup-brightcove'));
		videoPopups.forEach(function (m) {
			_this.el.parentNode.insertBefore(m, _this.el);
		});

		//init
		this.el.classList.remove('loading');
		this.el.classList.add('loaded');

		// set default
		this.setState({
			slideId: 0,
			isFirst: true });

	},

	/**
        * Mouse Click handler
        * @param  {Event} e [Mouse click event]
        * @return {[type]}   [description]
        */
	clickHandler: function clickHandler(e) {
		var t = e.target;
		var thumb = null;

		// when thumb clicked, send GA event
		if (t.matches('.hero__item__link')) {
			thumb = _framework.util.findParent(t, '.hero__thumb', 'hero__thumbs');
			var hrefVal = t.getAttribute('href');
			if (hrefVal)
			{
				var label = hrefVal;
				var ariaVal = t.getAttribute('aria-label');
				if (ariaVal)
				{
					label = ariaVal;
				}
				var action = 'Internal Link Click';
				if (hrefVal.startsWith("http"))
				{
					action = 'Outbound Link Click';
				}
				_framework.util.gaSendEvent('Link', action, label, 1);
			}
		} else
		if (t.matches('.hero__item__button'))
		{
			thumb = _framework.util.findParent(t, '.hero__thumb', 'hero__thumbs');
			var isBrightcoveVideo = t.hasAttribute('data-brightcoveplayer');
			if (isBrightcoveVideo) {
				var playerID = t.getAttribute('data-brightcoveplayer');
				var playerEl = this.el.parentNode.querySelector('#' + playerID);
				var playerModule = playerEl ? _framework.ModuleManager.getInstance().getModuleById(playerEl.getAttribute('mid')) : null;
				if (playerModule != null) {
					playerModule.setState({ active: true });
				}
			}
		} else
		if (t.matches('.hero__scrolldown'))
		{
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Carousel scrolldown', 1);
			var root = document.getElementsByTagName("html")[0];
			(0, _velocityAnimate2.default)(root, "scroll", { offset: "600px" });
		}
		if (thumb)
		{
			var slideId = thumb.getAttribute('data-id');
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Carousel step ' + slideId, 1);
		}
	},

	goToSlide: function goToSlide(slideId)
	{
		this.setState({ slideId: slideId, isFirst: false });
	},

	/**
        * When internal ui components are dispatching "change" status
        * See scripts/component
        */
	uiChanged: function uiChanged() {for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var
		ui = arg[0],e = arg[1];

		// event type check
		switch (e) {
			case 'uipaginationchange':
			case 'uidotschange':
				this.setState({ slideId: ui.state.currentId, isFirst: false });
				break;
			default:}

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {var _state =
		this.state,slideId = _state.slideId,isFirst = _state.isFirst;

		// when slide id changes
		if (this.prevState.slideId !== slideId) {
			this.slide(this.prevState.slideId, slideId, isFirst);
		}
	},

	/**
        * get internal component instances
        * ui-pagination, ui-dots
        */
	initComponents: function initComponents() {
		// ui components
		var mm = _framework.ModuleManager.getInstance();

		if (this.el.querySelector('.ui-component[data-name="ui-pagination"]')) {
			var uiPagination = mm.getComponentById(this.el.querySelector('.ui-component[data-name="ui-pagination"]').getAttribute('cid'));
			uiPagination.onChange = this.uiChanged.bind(this);
			this.uiComponents.push(uiPagination);
		}

		// ui dots
		if (this.el.querySelector('.ui-component[data-name="ui-dots"]')) {
			var uiDots = mm.getComponentById(this.el.querySelector('.ui-component[data-name="ui-dots"]').getAttribute('cid'));
			uiDots.createDots(this.slides.length);
			uiDots.onChange = this.uiChanged.bind(this);
			this.uiComponents.push(uiDots);
		}

		return this;
	},

	/**
        * Based on rendered entries, we need to create "wedge" thumbs
        * @return {[type]} [description]
        */
	createThumbsWithData: function createThumbsWithData() {
		var thumbData = this.slides.map(function (slideItem, i) {

			// copy innerHTML from slide item
			var innerHTML = slideItem.querySelector('.hero__item__meta').innerHTML;

			// bar loader
			innerHTML += '<span class="bar-loader js-loader"></span>';

			return {
				id: i,
				className: 'hero__thumb',
				innerHTML: innerHTML };


		});

		this.el.querySelector('.hero__thumbs-inner').appendChild(createThumbs(thumbData));
		return this;
	},

	/**
        * lazy load images
        */
	intitSlideDisplay: function intitSlideDisplay() {
		this.slides.forEach(function (slide) {
			if (slide.dataset.img)
			{
				slide.style.backgroundImage = "url(\"" + slide.dataset.img + "\")";
			}
		});
	},

	/**
        * Each entry can play video
       initChildVideo() {
       	this.slides.forEach(slide => {
       		const videoEl = slide.querySelector('.module.video');
       			if (videoEl) {
       			slide.classList.add('has-video');
       			slide.video = ModuleManager.getInstance().getModuleById(videoEl.getAttribute('mid'));
       		}
       	});
       },
        */


	/**
                   * See abstrat.js pageVisibilityChange
                   */
	pageVisibilityChange: function pageVisibilityChange(isPageHidden) {
		if (isPageHidden) {
			// pause timer
			this.pause();
		} else {
			// resume
			this.resume();
		}
	},

	//page has been scrolled
	scroll: function scroll(e)
	{
		if (this.refs.scrollButtonShown && this.context.state.scrollTop > 0)
		{
			this.refs.scrollButtonShown = false;
			this.refs.scrollButton.classList.add('hide-ui');
		}
	},

	// // // // // // // // // // // // // //
	// override slide proto type  // // // //
	// See scripts/mixin/slider.js for more info// //
	// // // // // // // // // // // // // //
	beforeSlide: function beforeSlide() {
		_slider2.default.beforeSlide.call(this);var

		slideId = this.state.slideId;

		// set state, thumb
		if (slideId >= 0) {
			var currentThumb = this.refs['thumbs'][slideId];

			if (currentThumb) {
				// reposition items with index
				// 0-1-2-3
				// 1-2-3-0
				// 2-3-0-1
				// ...
				// 3-0-1-2

				// active one to the begining of the parent
				// get siblings that have smaller id than current

				// no swap children
				// const parent = currentThumb.parentNode;
				// const thumbsInCurrentOrder = [].slice.call(parent.children);
				// const positionIndex = thumbsInCurrentOrder.findIndex(t => t === currentThumb);
				// const before = thumbsInCurrentOrder.slice(0, positionIndex);
				// before.forEach(t => parent.appendChild(t));

				this.refs['thumbs'].forEach(function (t, i) {
					t.classList[i === slideId ? 'add' : 'remove']('active');
				});
			}

			// ui components
			this.uiComponents.forEach(function (m) {
				m.setState({ currentId: slideId }, false).update();
			});
		}
	},

	afterSlide: function afterSlide() {

		_slider2.default.afterSlide.call(this);var

		prevId = this.prevState.slideId;var
		slideId = this.state.slideId;
		var currentItem = this.slides[slideId];
		//const videoId = currentItem.getAttribute('data-video');

		if (prevId !== -1) {
			var prevItem = this.slides[prevId];
			/*
                                                                           prevItem.classList.remove('show-video');
                                                                           if (prevItem.video) {
                                                                           	prevItem.video.stop(videoId);
                                                                           }
                                                                           */
		}
		/*
      		if (isVideoPlayable() && currentItem.video) {
      			currentItem.classList.add('show-video');
      			currentItem.video.playWithData({
      				File: videoId,
      			});
      		}
      */
	},

	gestureHandler: function gestureHandler(e) {var
		slideId = this.state.slideId;

		switch (e.type) {
			case 'swipeleft':
				slideId = slideId === this.slides.length - 1 ? 0 : slideId + 1;
				break;
			case 'swiperight':
				slideId = slideId === 0 ? this.slides.length - 1 : slideId - 1;
				break;
			default:}

		this.goToSlide(slideId);
		/*
                                                    		clearTimeout(this.gestureTimer);
                                                    		this.gestureTimer = setTimeout(() => {
                                                    
                                                    			const clickEvt = new MouseEvent('click', {
                                                    				view: window,
                                                    				bubbles: true,
                                                    				cancelable: true,
                                                    			});
                                                    
                                                    			// somehow direct state setting has a glitch. transitioning isn't smooth.
                                                    			// Instead, emulate click event
                                                    			this.refs.thumbs[slideId].dispatchEvent(clickEvt);
                                                    
                                                    		}, 250);
                                                    		*/
	},

	tickReset: function tickReset() {
		Array.from(this.el.querySelectorAll('.js-loader')).forEach(function (loader) {
			loader.classList.remove('run');
		});
	},

	tickStart: function tickStart() {var
		slideId = this.state.slideId;

		if (slideId >= 0) {
			var currentThumb = this.refs['thumbs'][slideId];
			var loader = currentThumb.querySelector('.js-loader');
			var p = loader.parentNode;

			// reset
			p.removeChild(loader);
			loader.classList.remove('run');

			p.appendChild(loader);
			loader.classList.add('run');
		}
	},

	tickComplete: function tickComplete() {var
		slideId = this.state.slideId;
		this.setState({
			slideId: slideId < this.props.totalLength - 1 ? slideId + 1 : 0,
			isFirst: false });

	},

	getInternalProps: function getInternalProps() {
		return Object.assign({}, _slider2.default.props, {
			autoPlay: true,
			duration: 800,
			slideType: 'each' });

	},

	getInternalState: function getInternalState() {
		return Object.assign({}, _slider2.default.state, {
			slideId: -1,
			isFirst: false });

	} });exports.default =



HomeHero;

},{"../../framework":72,"../../mixin/slider":78,"velocity-animate":"velocity-animate"}],38:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.Centralize = exports.SharedArticleMosaic = exports.RepresentativeSearch = exports.ClinicalTrialDetail = exports.ClinicalTrial = exports.HaegardaDosingCalc = exports.PageTabs = exports.LandingpageDialog = exports.FullSizeImage = exports.Accordion = exports.HeroStacked = exports.HeroLarge = exports.Banner = exports.ContentSlider = exports.VideoBrightcove = exports.PopupBrightcove = exports.CookiePolicy = exports.SimplePopup = exports.UserForm = exports.Timeline = exports.NewsHub = exports.ProductPipeline = exports.Form = exports.SubscriptionBlock = exports.InlineSearch = exports.GlobalSelector = exports.SocialShareImage = exports.SocialShare = exports.Article = exports.NewsCards = exports.MosaicHighlights = exports.ArticleTaglist = exports.ArticletagMosaic = exports.ArticlePagingMosaic = exports.AdvancedMosaic = exports.Mosaic = exports.DropdownTable = exports.List = exports.FactCards = exports.FeaturedArea = exports.SearchResult = exports.SearchOverlay = exports.Popup = exports.Video = exports.ContentList = exports.InternalHero = exports.HomeHero = exports.Sidebar = exports.Header = undefined;

























var _header = require('./header');var _header2 = _interopRequireDefault(_header);
var _sidebar = require('./sidebar');var _sidebar2 = _interopRequireDefault(_sidebar);
var _homeHero = require('./home-hero');var _homeHero2 = _interopRequireDefault(_homeHero);
var _internalHero = require('./internal-hero');var _internalHero2 = _interopRequireDefault(_internalHero);
var _contentList = require('./content-list');var _contentList2 = _interopRequireDefault(_contentList);
var _video = require('./video');var _video2 = _interopRequireDefault(_video);
var _popup = require('./popup');var _popup2 = _interopRequireDefault(_popup);
var _searchOverlay = require('./search-overlay');var _searchOverlay2 = _interopRequireDefault(_searchOverlay);
var _searchResult = require('./search-result');var _searchResult2 = _interopRequireDefault(_searchResult);
var _inlineSearch = require('./inline-search');var _inlineSearch2 = _interopRequireDefault(_inlineSearch);
var _featuredArea = require('./featured-area');var _featuredArea2 = _interopRequireDefault(_featuredArea);
var _factCards = require('./fact-cards');var _factCards2 = _interopRequireDefault(_factCards);

var _list = require('./list');var _list2 = _interopRequireDefault(_list);
var _dropdownTable = require('./dropdown-table');var _dropdownTable2 = _interopRequireDefault(_dropdownTable);

var _mosaic = require('./mosaic');var _mosaic2 = _interopRequireDefault(_mosaic);
var _advancedMosaic = require('./advanced-mosaic');var _advancedMosaic2 = _interopRequireDefault(_advancedMosaic);
var _articlePagingMosaic = require('./article-paging-mosaic');var _articlePagingMosaic2 = _interopRequireDefault(_articlePagingMosaic);
var _articletagMosaic = require('./articletag-mosaic');var _articletagMosaic2 = _interopRequireDefault(_articletagMosaic);
var _articleTaglist = require('./article-taglist');var _articleTaglist2 = _interopRequireDefault(_articleTaglist);
var _newsCards = require('./news-cards');var _newsCards2 = _interopRequireDefault(_newsCards);
var _mosaicHighlights = require('./mosaic-highlights');var _mosaicHighlights2 = _interopRequireDefault(_mosaicHighlights);

var _article = require('./article');var _article2 = _interopRequireDefault(_article);
var _sidebarContent = require('./sidebar-content');var _sidebarContent2 = _interopRequireDefault(_sidebarContent);
var _socialShare = require('./social-share');var _socialShare2 = _interopRequireDefault(_socialShare);
var _socialShareImage = require('./social-share-image');var _socialShareImage2 = _interopRequireDefault(_socialShareImage);
var _globalSelector = require('./global-selector');var _globalSelector2 = _interopRequireDefault(_globalSelector);

var _subscriptionBlock = require('./subscription-block');var _subscriptionBlock2 = _interopRequireDefault(_subscriptionBlock);
var _cslForm = require('./csl-form');var _cslForm2 = _interopRequireDefault(_cslForm);
var _userForm = require('./user-form');var _userForm2 = _interopRequireDefault(_userForm);

var _productPipeline = require('./product-pipeline');var _productPipeline2 = _interopRequireDefault(_productPipeline);
var _newsHub = require('./news-hub');var _newsHub2 = _interopRequireDefault(_newsHub);
var _simplePopup = require('./simple-popup');var _simplePopup2 = _interopRequireDefault(_simplePopup);
var _timeline = require('./timeline');var _timeline2 = _interopRequireDefault(_timeline);
var _cookiePolicy = require('./cookie-policy');var _cookiePolicy2 = _interopRequireDefault(_cookiePolicy);
var _popupBrightcove = require('./popup-brightcove');var _popupBrightcove2 = _interopRequireDefault(_popupBrightcove);
var _videoBrightcove = require('./video-brightcove');var _videoBrightcove2 = _interopRequireDefault(_videoBrightcove);
var _contentSlider = require('./content-slider');var _contentSlider2 = _interopRequireDefault(_contentSlider);
var _banner = require('./banner');var _banner2 = _interopRequireDefault(_banner);
var _heroLarge = require('./hero-large');var _heroLarge2 = _interopRequireDefault(_heroLarge);
var _heroStacked = require('./hero-stacked');var _heroStacked2 = _interopRequireDefault(_heroStacked);
var _accordion = require('./accordion');var _accordion2 = _interopRequireDefault(_accordion);
var _fullSizeImage = require('./full-size-image');var _fullSizeImage2 = _interopRequireDefault(_fullSizeImage);
var _landingpageDialog = require('./landingpage-dialog');var _landingpageDialog2 = _interopRequireDefault(_landingpageDialog);
var _pageTabs = require('./page-tabs');var _pageTabs2 = _interopRequireDefault(_pageTabs);
var _haegardaDosingCalc = require('./haegarda-dosing-calc');var _haegardaDosingCalc2 = _interopRequireDefault(_haegardaDosingCalc);
var _clinicalTrial = require('./clinical-trial');var _clinicalTrial2 = _interopRequireDefault(_clinicalTrial);
var _clinicalTrialDetail = require('./clinical-trial-detail');var _clinicalTrialDetail2 = _interopRequireDefault(_clinicalTrialDetail);
var _representativeSearch = require('./representative-search');var _representativeSearch2 = _interopRequireDefault(_representativeSearch);
var _sharedArticleMosaic = require('./shared-article-mosaic');var _sharedArticleMosaic2 = _interopRequireDefault(_sharedArticleMosaic);
var _centralize = require('./centralize');var _centralize2 = _interopRequireDefault(_centralize);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /*
                                                                                                                                                                                               * Module List
                                                                                                                                                                                               *
                                                                                                                                                                                               * Once you create a new module.js, register it here.
                                                                                                                                                                                               *
                                                                                                                                                                                               * How:
                                                                                                                                                                                               *
                                                                                                                                                                                               *   if you want {test} module,
                                                                                                                                                                                               *
                                                                                                                                                                                               *   1. name "test" is used for name of the javascript file.
                                                                                                                                                                                               *   2. create files as listed below,
                                                                                                                                                                                               *     a. duplicate dummy.js and rename it to test.js in the same directory.
                                                                                                                                                                                               *     b. if necessary _test.scss into app/styles/modules/modules and add the file in style.scss
                                                                                                                                                                                               *
                                                                                                                                                                                               *   3. Module manager(app/script/framework) will use this and try to instatiate a proper js.
                                                                                                                                                                                               *
                                                                                                                                                                                               *     <div class="module markup-module" data-module="test"....
                                                                                                                                                                                               *
                                                                                                                                                                                               *   4. import test.js and add to the Map below using the name(test) as a key
                                                                                                                                                                                               *   5. Make sure to load a correct html template
                                                                                                                                                                                               *
                                                                                                                                                                                               * 
                                                                                                                                                                                               */ /*---------------------------------------*/exports.Header = _header2.default;exports.Sidebar = _sidebar2.default;exports.HomeHero = _homeHero2.default;exports.InternalHero = _internalHero2.default;exports.ContentList = _contentList2.default;exports.Video = _video2.default;exports.Popup = _popup2.default;exports.SearchOverlay = _searchOverlay2.default;exports.SearchResult = _searchResult2.default;exports.FeaturedArea = _featuredArea2.default;exports.FactCards = _factCards2.default;exports.List = _list2.default;exports.DropdownTable = _dropdownTable2.default;exports.Mosaic = _mosaic2.default;exports.AdvancedMosaic = _advancedMosaic2.default;exports.ArticlePagingMosaic = _articlePagingMosaic2.default;exports.ArticletagMosaic = _articletagMosaic2.default;exports.ArticleTaglist = _articleTaglist2.default;exports.MosaicHighlights = _mosaicHighlights2.default;exports.NewsCards = _newsCards2.default;exports.
Article = _article2.default;exports.
SocialShare = _socialShare2.default;exports.
SocialShareImage = _socialShareImage2.default;exports.
GlobalSelector = _globalSelector2.default;exports.
InlineSearch = _inlineSearch2.default;exports.
SubscriptionBlock = _subscriptionBlock2.default;exports.
Form = _cslForm2.default;exports.
ProductPipeline = _productPipeline2.default;exports.
NewsHub = _newsHub2.default;exports.
Timeline = _timeline2.default;exports.
UserForm = _userForm2.default;exports.
SimplePopup = _simplePopup2.default;exports.
CookiePolicy = _cookiePolicy2.default;exports.
PopupBrightcove = _popupBrightcove2.default;exports.
VideoBrightcove = _videoBrightcove2.default;exports.
ContentSlider = _contentSlider2.default;exports.
Banner = _banner2.default;exports.
HeroLarge = _heroLarge2.default;exports.
HeroStacked = _heroStacked2.default;exports.
Accordion = _accordion2.default;exports.
FullSizeImage = _fullSizeImage2.default;exports.
LandingpageDialog = _landingpageDialog2.default;exports.
PageTabs = _pageTabs2.default;exports.
HaegardaDosingCalc = _haegardaDosingCalc2.default;exports.
ClinicalTrial = _clinicalTrial2.default;exports.
ClinicalTrialDetail = _clinicalTrialDetail2.default;exports.
RepresentativeSearch = _representativeSearch2.default;exports.
SharedArticleMosaic = _sharedArticleMosaic2.default;exports.
Centralize = _centralize2.default;

},{"./accordion":14,"./advanced-mosaic":15,"./article":18,"./article-paging-mosaic":16,"./article-taglist":17,"./articletag-mosaic":19,"./banner":20,"./centralize":21,"./clinical-trial":23,"./clinical-trial-detail":22,"./content-list":24,"./content-slider":25,"./cookie-policy":26,"./csl-form":27,"./dropdown-table":28,"./fact-cards":29,"./featured-area":30,"./full-size-image":31,"./global-selector":32,"./haegarda-dosing-calc":33,"./header":34,"./hero-large":35,"./hero-stacked":36,"./home-hero":37,"./inline-search":39,"./internal-hero":40,"./landingpage-dialog":41,"./list":42,"./mosaic":44,"./mosaic-highlights":43,"./news-cards":45,"./news-hub":46,"./page-tabs":47,"./popup":49,"./popup-brightcove":48,"./product-pipeline":50,"./representative-search":51,"./search-overlay":52,"./search-result":53,"./shared-article-mosaic":54,"./sidebar":56,"./sidebar-content":55,"./simple-popup":57,"./social-share":59,"./social-share-image":58,"./subscription-block":60,"./timeline":61,"./user-form":62,"./video":64,"./video-brightcove":63}],39:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _framework = require('../../framework');
var _action = require('../../action'); /**
                                       * Inline Search
                                       *
                                       * use:
                                       * class="module inline-search" data-name="inline-search"
                                       *
                                       * related src:
                                       * view: Views/CSLShared/Modules/Search/_Search.cshtml
                                       * css: app/styles/modules/_inline-search.scss
                                       *
                                       * 
                                       */var InlineSearch = { refs: {}, /**
                                                                         * When mounted
                                                                         *
                                                                         * start writing scrip here for this module
                                                                         */mounted: function mounted() {var _this = this; // get internal ui input component
		var input = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-input').getAttribute('cid'));if (input) {
			input.onChange = this.uiChanged.bind(this);
			input.mouseHandler = function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var

				input = args[0],type = args[1],role = args[2];

				if (role === 'submit' && _this.refs.form) {
					_framework.util.gaSendEvent('Interactive Feature', 'Click', 'SearchWidget-Submit', 1);

					// form submit without firing submit event. this goes straigh to search result page.
					_this.refs.form.submit();
				}

				if (role === 'search') {
					// clear
					input.input.value = '';
				}
			};
		}

		var form = this.el.getElementsByTagName('form')[0];

		if (this.refs.form) {
			this.refs.form.addEventListener('submit', this.submit.bind(this));
		}

		this.refs = {
			input: input,
			form: form };


	},

	// when form submitted
	submit: function submit(e) {

		e.preventDefault();
		this.connectToModal(this.refs.input.input.value);

		return false;
	},

	/**
        * When internal ui input dispatched "change" status
        * See scripts/component
        */
	uiChanged: function uiChanged() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}var

		ui = args[0],e = args[1];

		// event type check
		switch (e) {

			case 'focus':
				this.reset();
				break;

			case 'input':
				this.connectToModal(ui.input.value);
				break;

			case 'change':
				this.setState({
					search: ui.state.value });

				break;

			default:
			//
		}


	},

	// empty input value
	reset: function reset() {
		if (this.refs.input) {
			this.refs.input.input.value = '';
		}
	},

	/**
        * When either form submission or user starts to type words,
        * it should trigger search overlay.
        * See search-overlay.js on how these two modules are communicating
        *
        * @param  {[String]} search [input value]
        * @return {[type]}        [description]
        */
	connectToModal: function connectToModal(search) {

		// See search.js(not in place yet)
		var searchProps = {
			target: this,
			active: true,
			keyword: search };


		this.context.setState(_action.appActions.globalSearch(searchProps));

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			search: void 0 };


	} };exports.default =



InlineSearch;

},{"../../action":2,"../../framework":72}],40:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _moduleManager = require('../../framework/module-manager');var _moduleManager2 = _interopRequireDefault(_moduleManager);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var InternalHero = {

  /**
                                          * When mounted
                                          *
                                          * start writing scrip here for this module
                                          */
  mounted: function mounted() {var _this = this;

    // init video with a bit of delay
    setTimeout(function () {

      _this.initChildVideo();

    }, 1000);

  },

  /**
         * Each entry can play video
         */
  initChildVideo: function initChildVideo() {

    var videoEl = this.el.querySelector('.module.video');

    if (videoEl) {

      var videoId = this.el.getAttribute('data-video-id');

      this.el.classList.add('has-video');
      this.video = _moduleManager2.default.getInstance().getModuleById(videoEl.getAttribute('mid'));

      this.el.classList.add('show-video');
      this.video.play(videoId);

    }

  } }; /**
       * Internal Hero
       *
       * use:
       * class="module internal-hero" data-name="internal-hero"
       *
       * related src:
       *
       * view: Views/CSLShared/Modules/_Hero.cshtml
       * css: app/styles/modules/_internal-hero.scss
       *
       * 
       */exports.default = InternalHero;

},{"../../framework/module-manager":74}],41:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });



var _framework = require('../../framework');

var LandingpageDialog = {
	mounted: function mounted() {
		this.el.addEventListener('click', this.clickHandler.bind(this), false);
	},

	clickHandler: function clickHandler(e) {
		var target = e.target;

		//remove on click
		if (target.matches('.js-close-btn'))
			//	 ||  target.matches('.landingpage-dialog') || target.matches('.landingpage-dialog__container')) 
			{
				_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Landing page dialog close', 1);

				e.preventDefault();
				this.el.classList['remove']('active');
				this.destroy();
			}

		//when user selects I am a Healthcare Prfoessional option, it activates HCP type radio options
		if (target.matches('.radio-button1'))
		{
			Array.from(document.querySelectorAll('input[name="hcp-buttons"]:checked'), function (input) {return input.checked = false;});
			this.el.querySelector('.radio-button-options').classList.add('active');
			this.el.querySelector('.landingpage-dialog__cta_not_confirm').classList.remove('active');
		}

		//when user selects the HCP type radio options, it activates the confirm button
		if (target.matches('.radio-options')) {
			this.el.querySelector('.landingpage-dialog__cta_confirm').classList.add('active');
			this.el.querySelector('.landingpage-dialog__cta_not_confirm').classList.remove('active');
		}

		//when user selects I am not a Healthcare Prfoessional option, it activates the CTA button	
		if (target.matches('.radio-button2'))
		{
			this.el.querySelector('.radio-button-options').classList.remove('active');
			this.el.querySelector('.landingpage-dialog__cta_confirm').classList.remove('active');
			this.el.querySelector('.landingpage-dialog__cta_not_confirm').classList.add('active');
		}
		//set cookie and remove dialog on click
		if (target.matches('.confirm-btn'))
		{
			var days = 90; //number of days the cookie will expire
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			var expires = date.toUTCString();
			document.cookie = "LandingPageDialogConfirm=; expires=" + expires + ';"';

			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Landing page dialog user confrmed', 1);

			e.preventDefault();
			this.el.classList['remove']('active');
			this.destroy();
		}
		if (target.matches('.landingpage-dialog__cta'))
			//	 ||  target.matches('.landingpage-dialog') || target.matches('.landingpage-dialog__container')) 
			{
				_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Landing page dialog close', 1);

				e.preventDefault();
				this.el.classList['remove']('active');
				this.destroy();
			}
	} }; /**
      * Landing Page Dialog module
      *
      */document.addEventListener('DOMContentLoaded', function () {
	var popupClass = document.querySelectorAll('.landingpage-dialog__focus');
	var popupId = document.querySelector('#dialog-popup');
	var popupInnerId = document.querySelector('#dialog-popup-inner');
	var otherElements = document.querySelectorAll('body *:not(#dialog-popup)');

	function openPopup() {
		for (var i = 0; i <= otherElements.length; i++) {
			if (otherElements[i] != undefined)
			otherElements[i].setAttribute('tabindex', '-1');
		}
		for (var i = 0; i <= popupClass.length; i++) {
			if (popupClass[i] != undefined)
			popupClass[i].setAttribute('tabindex', '0');
		}
		popupInnerId.focus();
	}

	function closePopup() {
		otherElements.forEach(function (element) {
			element.removeAttribute('tabindex');
		});
	}
	if (popupId != null || popupId != undefined)
	{
		if (popupId.classList.contains('confirm')) {
			openPopup();
		}
		document.getElementById('landingpage-dialog_close').addEventListener('click', closePopup);
	}

});exports.default =

LandingpageDialog;

},{"../../framework":72}],42:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * List
                                                                            *
                                                                            * use:
                                                                            * class="module header" data-name="header"
                                                                            *
                                                                            * related src:
                                                                            *
                                                                            * view: Views/CSLShared/Modules/_List.cshtml
                                                                            * css: app/styles/modules/_list.scss
                                                                            *
                                                                            * 
                                                                            */

var List = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _props =

		this.props,listItemName = _props.listItemName,loadMore = _props.loadMore;

		this.refs = {
			items: Array.from(this.el.querySelectorAll('.' + listItemName)),
			loadMoreBtn: this.el.querySelector('.js-load-more') };


		// when load more is ena
		// hide all at first
		if (loadMore) {

			this.refs.items.forEach(function (c) {

				c.classList.add('off');

			});

			this.setState({
				loadCount: 1 });


		} else {

			// otherwise, hide load more
			this.el.classList.add('hide-load-more');

		}

		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		if (t.matches('.js-load-more')) {

			e.preventDefault();

			// when load more clicked
			this.setState({
				loadCount: this.state.loadCount + 1 });


		}

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.loadCount !== state.loadCount) {

			this.loadMoreHandler();

		}

	},

	/**
        * when loadCount changes, load more
        */
	loadMoreHandler: function loadMoreHandler() {var _props2 =

		this.props,itemPerLoad = _props2.itemPerLoad,showAll = _props2.showAll;var
		loadCount = this.state.loadCount;

		var startIndex = (loadCount - 1) * itemPerLoad;
		var endIndex = showAll && loadCount > 1 ? 9999 : loadCount * this.props.itemPerLoad;

		for (var i = startIndex; i < endIndex; i++) {

			var c = this.refs.items[i];

			if (c) {

				c.classList.remove('off');

			}

		}

		// check loadMore-bility
		if (endIndex >= this.refs.items.length) {

			this.el.classList.add('hide-load-more');

		}

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {};

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			loadCount: 0 // current load count
		};

	} };exports.default =



List;

},{}],43:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });

















var _framework = require('../../framework');



/**
                                                                                           * ArticletagMosaic
                                                                                           * @type {Object}
                                                                                           */
var MosaicHighlights = {
	refs: {},

	/**
                      * When mounted
                      */
	mounted: function mounted() {
		var grid1 = this.el.querySelector('.js-mosaichigh-first');

		// iso option
		var IsoOption1 = {
			layoutMode: 'masonry',
			itemSelector: '.m-tile',
			percentPosition: true,
			transitionDuration: 300,
			masonry: {
				gutter: 30,
				columnWidth: '.m-sizer',
				initLayout: true } };



		// get iso instance
		var isoInstance1 = (0, _framework.iso)(grid1, IsoOption1);

		// iso events
		isoInstance1.on('layoutComplete', this.isoLayout.bind(this));

		// second grid
		var grid2 = this.el.querySelector('.js-mosaichigh-second');
		var isoInstance2;

		if (grid2)
		{
			// iso option
			var IsoOption2 = {
				layoutMode: 'masonry',
				itemSelector: '.m-tile',
				percentPosition: true,
				transitionDuration: 300,
				masonry: {
					gutter: 30,
					columnWidth: '.m-sizer',
					initLayout: true } };



			// get iso instance
			isoInstance2 = (0, _framework.iso)(grid2, IsoOption2);

			// iso events
			isoInstance2.on('layoutComplete', this.isoLayout.bind(this));
		}

		// refs
		this.refs = {
			iso1: isoInstance1,
			iso2: isoInstance2 };

	},

	isoLayout: function isoLayout() {
		// console.log(args);
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso1) {
			this.refs.iso1.layout();
		}
		if (this.refs.iso2) {
			this.refs.iso2.layout();
		}
		return this;
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {
	} }; /**
      * mosaic-highlights
      *
      * Fetch results and runtime render items.
      *
      * props to note:
      *
      *
      * use:
      * class="module mosaic" data-name="articletag-mosaic"
      *
      * related src:
      * view: Views/CSLShared/Modules/News/MosaicHighlights.cshtml
      * css: app/styles/modules/_MosaicHighlights.scss
      *
      */ // dependency
exports.default = MosaicHighlights;

},{"../../framework":72}],44:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _framework = require('../../framework');

var Mosaic = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;var _props =

		this.props,listItemName = _props.listItemName,loadMore = _props.loadMore;
		var grid = this.el.querySelector('.grid');

		// iso option
		var IsoOption = {
			layoutMode: 'masonry',
			itemSelector: '.' + listItemName,
			percentPosition: true,
			transitionDuration: 300,
			masonry: {
				gutter: 30,
				columnWidth: '.m-sizer',
				initLayout: true } };



		// get iso instance
		var isoInstance = (0, _framework.iso)(grid, IsoOption);

		// iso events
		isoInstance.on('layoutComplete', this.isoLayout.bind(this));

		// check image load
		isoInstance.items.forEach(function (item) {
			var img = item.element.getElementsByTagName('img')[0];

			if (img) {
				var src = img.src;
				var dummyImg = new Image();

				dummyImg.onload = function () {
					_this.refs.iso.layout();
				};
				dummyImg.src = src;
			}
		});

		// refs
		this.refs = {
			iso: isoInstance,
			items: Array.from(this.el.querySelectorAll('.' + listItemName)),
			loadMoreBtn: this.el.querySelector('.js-load-more'),
			grid: grid,
			uiFilter: void 0 };


		// ui filter instance
		if (this.el.querySelector('.ui-component[data-name="ui-filter"]')) {

			var uiFilter = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-component[data-name="ui-filter"]').getAttribute('cid'));
			uiFilter.onChange = this.uiChanged.bind(this);

			// check if uiFilter lenght === 1(just all)
			// hide filter
			if (uiFilter.refs.items.length === 1) {
				this.el.classList.add('hide-ui');
			}

			this.refs.uiFilter = uiFilter;

			// initial load with no filter applied
			uiFilter.setState({ currentId: 0 });

		} else {
			// when there is no filter, apply all
			this.setState({
				loadCount: 1, // reset load more count to 1
				currentFilterVal: 'all' });


		}

		this.el.addEventListener('click', this.clickHandler.bind(this));

		// check load-bility
		this.el.classList[loadMore ? 'remove' : 'add']('hide-load-more');
	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		// load more, check max load count
		// if current count > max load count, then we treat cta(load more btn) as a normal cta
		if (t.matches('.js-load-more')) {var

			loadCount = this.state.loadCount;

			e.preventDefault();

			this.setState({
				loadCount: loadCount + 1 });

		}
	},

	/**
        * When internal ui components are dispatching "change" status
        * See scripts/component
        */
	uiChanged: function uiChanged() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var

		ui = args[0],e = args[1];var
		currentId = ui.state.currentId,refs = ui.refs;

		switch (e) {
			case 'uifilterchange':
				this.setState({
					loadCount: 1, // reset load more count to 1
					currentFilterVal: refs.items[currentId].getAttribute('data-filter') });


				break;
			default:}

	},

	/**
        * When current filter value changes, we need to filter items.
        * @return {[Object]} [self]
        */
	filterItems: function filterItems() {var _state =

		this.state,currentFilterVal = _state.currentFilterVal,loadCount = _state.loadCount;var _props2 =
		this.props,itemPerLoad = _props2.itemPerLoad,loadMore = _props2.loadMore,maxLoadCount = _props2.maxLoadCount;

		var startIndex = 0;
		var endIndex = loadMore ? loadCount * itemPerLoad : 99999;

		if (loadCount === 1) {
			endIndex += 1; // only for the first, stick + itemPerLoad(4)
		}

		// hide all at first
		this.refs.items.forEach(function (item) {
			item.classList.add('off');
		});

		// filter first
		var filtered = this.refs.items.filter(function (item) {
			var val = item.getAttribute('data-filter').toLowerCase();
			var isSticky = val === 'sticky';
			var isFiltered = currentFilterVal === 'all' ? true : val === currentFilterVal.toLowerCase() || isSticky;

			return isFiltered;
		});

		// apply load count
		for (var i = startIndex; i < endIndex; i++) {
			var c = filtered[i];

			if (c) {
				c.classList.remove('off');
			}
		}

		// check loadMore-bility
		this.el.classList[endIndex >= filtered.length ? 'add' : 'remove']('hide-load-more');

		// see more
		this.el.classList[loadCount > maxLoadCount ? 'add' : 'remove']('show-load-more-alternative');

		return this;
	},

	isoLayout: function isoLayout() {
		// console.log(args);
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		// either currentFilterVal, loadCount changes
		if (prevState.loadCount !== state.loadCount || prevState.currentFilterVal !== state.currentFilterVal) {
			this.
			filterItems().
			resize();
		}
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso) {
			this.refs.iso.layout();
		}

		return this;
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			loadCount: 0, // number: current load index
			filterdItems: [], // array: filtered collection with filter value
			currentFilterVal: void 0 // Anything.
		};
	} }; /**
      * Mosaic
      *
      * use:
      * class="module mosaic" data-name="mosaic"
      *
      * related src:
      * view: Views/CSLShared/Modules/News/Mosaic.cshtml
      * css: app/styles/modules/_mosaic.scss
      *
      * 
      */ // dependency
exports.default = Mosaic;

},{"../../framework":72}],45:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _enum = require('../../enum');

var NewsCards = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _props =

		this.props,listItemName = _props.listItemName,loadMore = _props.loadMore;

		// refs
		this.refs = {
			items: Array.from(this.el.querySelectorAll('.' + listItemName + ':not(.not-include)')),
			loadMoreBtn: this.el.querySelector('.js-load-more') };


		// check if load more is enabled.
		if (loadMore) {

			// hide all at first
			this.refs.items.forEach(function (c) {

				c.classList.add('off-only-desktop');

			});

			this.setState({
				loadCount: 1 });


		} else {

			this.el.classList.add('hide-load-more');

		}

		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		// load more, check max load count
		// if current count > max load count, then we treat cta(load more btn) as a normal cta
		if (t.matches('.js-load-more')) {

			e.preventDefault();

			this.setState({
				loadCount: this.state.loadCount + 1 });


		}

	},

	// when loadCount changes, load more
	loadMoreHandler: function loadMoreHandler() {var _props2 =

		this.props,itemPerLoad = _props2.itemPerLoad,showAll = _props2.showAll;var
		loadCount = this.state.loadCount;

		var startIndex = (loadCount - 1) * itemPerLoad;
		var endIndex = showAll && loadCount > 1 ? 9999 : loadCount * this.props.itemPerLoad;

		for (var i = startIndex; i < endIndex; i++) {

			var tile = this.refs.items[i];

			if (tile) {

				tile.classList.remove('off-only-desktop');

			}

		}

		// check loadMore-bility
		if (endIndex >= this.refs.items.length) {

			this.el.classList.add('hide-load-more');

		}

	},

	// when current tab is active
	viewmodeUpdate: function viewmodeUpdate() {var

		bp = this.context.state.bp;

		this.setState({
			loadMoreCapable: bp > _enum.BP['SIZE_MD'] });


	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.loadCount !== state.loadCount) {

			this.loadMoreHandler();

		}

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			loadCount: 0,
			loadMoreCapable: undefined };


	} }; /**
      * News Cards
      *
      * use:
      * class="module new-cards" data-name="new-cards"
      *
      * related src:
      * view: Views/CSLShared/Modules/News/NewsCards.cshtml
      * css: app/styles/modules/_new-cards.scss
      *
      * 
      */exports.default = NewsCards;

},{"../../enum":68}],46:[function(require,module,exports){
"use strict";Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * News hub
                                                                            * current this is a placeholder doing nothing
                                                                            * use:
                                                                            * class="module news-hubs" data-name="news-hubs"
                                                                            *
                                                                            * related src:
                                                                            * view:Views/CSLShared/Modules/News/NewsHub.cshtml
                                                                            * css: app/styles/modules/_news-hubs.scss
                                                                            *
                                                                            * 
                                                                            */

var NewsHub = {

  /**
                                * When mounted
                                *
                                * start writing scrip here for this module
                                */
  mounted: function mounted() {},

  getInternalProps: function getInternalProps() {

    return {};

  },

  getInternalState: function getInternalState() {

    return {};

  } };exports.default =



NewsHub;

},{}],47:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _framework = require('../../framework');

var PageTabs = {

   refs: {},

   mounted: function mounted() {

      this.setPageTabSectionIDs();
      this.buildPageTabs();
      this.el.addEventListener('click', this.clickHandler.bind(this));

   },

   clickHandler: function clickHandler(e) {

      var t = e.target;

      if (t.matches('.tab-item__tab')) {

         e.preventDefault();

         this.selectPageTab(t);
      }

   },

   setPageTabSectionIDs: function setPageTabSectionIDs() {
      var ptSection = document.getElementsByClassName("page-tabs");
      for (var index = 0; index < ptSection.length; index++) {
         ptSection[index].setAttribute("data-pt-section", index);
      }
   },

   buildPageTabs: function buildPageTabs() {

      var ptSectionID = this.el.getAttribute("data-pt-section");
      var ptContainer = this.el.querySelector(".page-tabs__tabs");
      var ptMeta = this.el.getElementsByClassName("tab-item__meta");
      var ptContent = this.el.getElementsByClassName("tab-item__content");

      for (var index = 0; index < ptMeta.length; index++) {
         var ptMetaContents = ptMeta[index].getElementsByClassName("tab-item__tab").item(0).innerHTML;
         var ptMetaTitle = ptMeta[index].getElementsByClassName("tab__title").item(0).innerHTML;
         var ptMetaTitleText = ptMetaTitle.replace(/\"/g, '');
         var ptAnchorText = ptMetaTitleText.toLowerCase();
         var newBtn = document.createElement("button");
         newBtn.setAttribute("class", "tab-item__tab");
         newBtn.setAttribute("tabIndex", "0");
         if (index == "0") {
            newBtn.classList.add('active');
         };
         newBtn.setAttribute("type", "button");
         newBtn.setAttribute("data-tab", ptSectionID + index);
         newBtn.setAttribute("data-tabTitle", ptMetaTitleText);
         newBtn.setAttribute("id", ptAnchorText.replace(/\s/g, ''));
         newBtn.innerHTML = ptMetaContents;
         ptContainer.appendChild(newBtn);
      };

      for (var _index = 0; _index < ptContent.length; _index++) {
         ptContent[_index].setAttribute("data-content", ptSectionID + _index);
         if (_index == "0") {
            ptContent[_index].classList.add("active");
         };
      };
   },

   selectPageTab: function selectPageTab(ele) {

      var isActive = ele.classList.contains('active');
      var selectedTabID = ele.getAttribute("data-tab");
      var selectedTabTitle = ele.getAttribute("data-tabTitle");
      var selectedAnchorID = ele.getAttribute("id");
      if (isActive != true) {

         var tabList = this.el.getElementsByClassName("tab-item__tab");
         var contentList = this.el.getElementsByClassName("tab-item__content");

         for (var index = 0; index < tabList.length; index++) {
            tabList[index].classList.remove("active");
         };

         for (var _index2 = 0; _index2 < contentList.length; _index2++) {
            var cItem = contentList[_index2].getAttribute("data-content");
            if (cItem === selectedTabID) {
               contentList[_index2].classList.add("active");
            } else {
               contentList[_index2].classList.remove("active");
            };
         };

         ele.classList.add('active');

         _framework.util.gaSendEvent('Interactive Feature', 'Click', 'Page Tab - Open - ' + selectedTabTitle, 1);
      };


   },


   getInternalProps: function getInternalProps() {
      return {};
   },

   getInternalState: function getInternalState() {
      return {};
   } }; /**
        * Page Tabs
        *
        * use:
        * class="module page-tab" data-name="page-tab"
        *
        * related src:
        * view: Views/CSLShared/Modules/_PageTabs.cshtml
        * css: app/styles/modules/_page-tabs.scss
        *
        * 
        */var hashID = window.location.hash.replace("#", "");var flag = false;document.addEventListener("click", function (event) {var pageURL = event.target.getAttribute('href');if (pageURL != null && pageURL.includes('#')) {var pagetabID = pageURL.split('#')[1];if (pagetabID != null || pagetabID != undefined) {flag = true;tabChangeEvent(pagetabID);
      }
   }
});

window.addEventListener("load", tabChangeEvent);

function tabChangeEvent(tabID) {
   if (flag == false) {
      tabID = hashID;
   }
   var pageTabList = document.getElementsByClassName("tab-item__tab");
   var pageContentList = document.getElementsByClassName("tab-item__content");

   for (var index = 0; index < pageTabList.length; index++) {
      pageTabList[index].classList.remove("active");
   };

   for (var _index3 = 0; _index3 < pageContentList.length; _index3++) {

      if (pageTabList[_index3].id != "" && pageTabList[_index3].id == tabID) {
         pageContentList[_index3].classList.add("active");
         pageTabList[_index3].classList.add("active");
      } else if (tabID == "") {
         pageContentList[0].classList.add("active");
         pageTabList[0].classList.add("active");
      } else
      {
         pageContentList[_index3].classList.remove("active");
         pageTabList[_index3].classList.remove("active");
      }
   };
}

//});
exports.default =
PageTabs;

},{"../../framework":72}],48:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _framework = require('../../framework');

var PopupBrightcove = {

	refs: {},

	/**
                      * When mounted
                      */
	mounted: function mounted() {

		this.refs = {
			video: this.el.querySelector('.video-brightcove video'),
			closeBtn: this.el.querySelector('.close-btn') };


		this.el.addEventListener('click', this.clickHandler.bind(this));
	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		// either close-btn or "outise" area is clicked
		if (t.matches('.close-btn') || t.tagName === 'SECTION') {
			e.preventDefault();
			this.close();
		}
	},

	/**
        * this module has to be closed from App since this sets global state
        * this.context = app
        */
	close: function close() {

		// update app state
		this.state = false;
		this.onOff(false);

		// if fn exist
		if (this.postClose && typeof this.postClose === 'function') {
			this.postClose.call(this);
		}
	},

	/**
        * visibility toggle
        * @return {[Object]}        [self]
        */
	onOff: function onOff(active) {

		if (active)
		{
			this.loadBrightCoveScript();
			this.el.classList.add('modal--video');
			this.el.classList.add('active');
			this.refs.closeBtn.focus();
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Video Modal - Open', 1);
		} else

		{
			this.el.classList.remove('active');
			this.el.classList.remove('modal--video');
			if (this.refs.video)
			{
				this.refs.video.pause();
			}
			_framework.util.gaSendEvent('Interactive Feature', 'Click', 'Video Modal - Close', 1);
		}
		return this;
	},

	loadBrightCoveScript: function loadBrightCoveScript() {var
		brightcoveinstalled = this.context.state.brightcoveinstalled;

		if (this.context.props.brightcoveURL.length > 0 && !brightcoveinstalled)
		{
			this.context.state.brightcoveinstalled = true;
			var script = document.createElement('script');
			script.src = this.context.props.brightcoveURL;
			document.body.appendChild(script);
		}
	},

	// when internal state changes
	onStateUpdate: function onStateUpdate() {var
		active = this.state.active;

		// when active state changes
		if (this.prevState.active !== active) {
			this.onOff(active);
		}
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			active: false // boolean: whether this module is active or not
		};

	} }; /**
      * Popup - brightcove video player
      *
      * use:
      * class="module popup-brightcove" data-name="popup-brightcove"
      *
      * related src:
      * view: Views/CSLShared/Shared/_ContentListEntry.cshtml
      * view: Views/CSLShared/Shared/_BannerContent.cshtml
      * css: app/styles/modules/_poup.scss
      *
      */ // dependency
exports.default = PopupBrightcove;

},{"../../framework":72}],49:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _moduleManager = require('../../framework/module-manager');var _moduleManager2 = _interopRequireDefault(_moduleManager);
var _action = require('../../action');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// currently, this supports only video
/**
* Popup
*
* use:
* class="module popup" data-name="popup"
*
* related src:
* view: Views/CSLShared/Shared/_VideoModal.cshtml
* css: app/styles/modules/_poup.scss
*
*/ // dependency
var SUPPORTED_TYPES = ['video'];var Popup = { refs: {}, /**
                                                         * When mounted
                                                         *
                                                         * start writing scrip here for this module
                                                         */mounted: function mounted() {var videoModule = null;var videoEl = this.el.querySelector('.module.video');if (videoEl != null)
		{
			videoModule = _moduleManager2.default.getInstance().getModuleById(videoEl.getAttribute('mid'));
		}

		this.refs = {
			video: videoModule,
			closeBtn: this.el.querySelector('.close-btn') };


		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * Handles all click events
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		// either close-btn or "outise" area is clicked
		if (t.matches('.close-btn') || t.tagName === 'SECTION') {

			e.preventDefault();
			this.close();

		}

	},

	/**
        * this module has to be closed from App since this sets global state
        * this.context = app
        */
	close: function close() {

		// update app state
		this.context.setState(_action.appActions.showPopup(null));

		// if fn exist
		if (this.postClose && typeof this.postClose === 'function') {

			this.postClose.call(this);

		}

	},

	/**
        * visibility toggle
        * @return {[Object]}        [self]
        */
	onOff: function onOff(active) {

		this.el.classList[active ? 'add' : 'remove']('active');

		return this;

	},

	/**
        * Each time this module is trigged, we need to clear the "previous" content
        * @return {[type]} [description]
        */
	clearContent: function clearContent() {var _this = this;

		SUPPORTED_TYPES.forEach(function (type) {return _this.el.classList.remove('modal--' + type);});

		// reset video
		if (this.refs['video']) {

			this.refs['video'].stop();

		}

		return this;

	},

	/**
        * Display current popup content
        * @param  {[Object]} content
        */
	displayContent: function displayContent(content) {var

		type = content.type,videoId = content.videoId;
		this.el.classList.add('modal--' + type);

		// type check here
		switch (type) {

			case 'video':

				if (this.refs['video']) {

					this.refs['video'].playWithFetch(videoId);

				}

				break;
			default:
			//
		}


		// focus
		this.refs.closeBtn.focus();
		return this;

	},

	// when internal state changes
	onStateUpdate: function onStateUpdate() {var _state =




		this.state,active = _state.active,content = _state.content;

		// when active state changes
		if (this.prevState.active !== active) {

			this.onOff(active);

		}

		// when popup content changes
		if (this.prevState.content !== content) {

			this[content ? 'displayContent' : 'clearContent'](content);

		}

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			active: false, // boolean: whether this module is active or not
			content: null // obj: this contains type, videoId
		};

	} };exports.default =


Popup;

},{"../../action":2,"../../framework/module-manager":74}],50:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });


















var _framework = require('../../framework');


/**
                                                                                           * runtime render function
                                                                                           * !this used to be Handlebar rendering. No more handlebar handles this rendering as per CSL request
                                                                                           * @param  {[Object]} props    [data to render each item]
                                                                                           * @return {[Element]}         [renedered dom Element]
                                                                                           */
var renderProductDetail = function renderProductDetail(props) {var

	color = props.color,phase = props.phase,productName = props.productName,productCategory = props.productCategory,productPhase = props.productPhase,productContent = props.productContent;

	var htmlString = '\n    <div class="p-detail" data-color="' +
	color + '" data-phase="' + phase + '">\n      <div class="top">\n        <div class="p-cat" style="color:' +

	color + '">' + productCategory + '</div>\n        <div class="p-phase">' +
	productPhase + '</div>\n      </div>\n      <h4>' +

	productName + '</h4>\n      <p class="bottom">\n        ' +

	productContent + '\n      </p>\n      <!--close btn-->\n      <a href="#" class="ui-icon-btn close-btn" aria-label="product detail close" tabindex="0">\n        <i class="icon-close"></i>\n      </a>\n    </div>';







	return htmlString.trim();

}; /**
   * Product Pipeline
   *
   * use:
   * class="module product-pipeline" data-list-item-name="p-item"  data-name="product-pipeline"
   *
   * related src:
   *
   * view:
   *   Views/CSLShared/Modules/Structure/_ProductPipelineContainer.cshtml
   *   Views/CSLShared/Modules/Structure/_ProductPipelineRowContainer.cshtml
   *   Views/CSLShared/Modules/_ProductPipelineEntry.cshtml
   *
   * css: app/styles/modules/_product-pipeline.scss
   *
   * 
   */ // dependency
var ProductPipeline = { ref: {}, /**
                                  * When mounted
                                  *
                                  * start writing scrip here for this module
                                  */mounted: function mounted() {var listItemName = this.props.listItemName;var mm = _framework.ModuleManager.getInstance();var uiCheckbox = mm.getComponentById(this.el.querySelector('.ui-component[data-name="ui-checkbox"]').getAttribute('cid')); /*const tables = [].slice.call(this.el.getElementsByTagName('table'));*/var tables = [].slice.call(this.el.getElementsByClassName('product-pipeline__table'));this.refs = { items: [].slice.call(this.el.querySelectorAll('.' + listItemName)), overlay: this.el.querySelector('.product-pipeline__overlay'),
			filterContainer: this.el.querySelector('.product-pipeline__filters'),
			tables: tables,
			uiCheckbox: uiCheckbox };


		if (uiCheckbox) {

			uiCheckbox.onChange = this.uiChanged.bind(this);

			// select all initially
			uiCheckbox.setState({ currentItems: uiCheckbox.refs.items.map(function (item, i) {return i;}) });

		}

		// get the product length per phase initially
		this.updateTable();

		// click event delegation
		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * When filter value changes, we need to display current "active" item length in the top row.
        * @return {[type]} [description]
        */
	updateTable: function updateTable() {var

		listItemName = this.props.listItemName;
		var tables = this.refs.tables;

		tables.forEach(function (table) {

			//const tableHeaders = Array.from(table.getElementsByTagName('th')).slice(0);
			var tableHeaders = Array.from(table.getElementsByClassName('phase-item')).slice(0);
			var productItemsInTable = Array.from(table.querySelectorAll('.' + listItemName + ':not(.hide)')).slice(0);var _loop = function _loop() {



				var th = tableHeaders.pop();
				var phase = th.getAttribute('data-phase');

				if (phase) {

					// find matching products
					var matchingProducts = productItemsInTable.filter(function (p) {

						// from parent td
						return p.parentNode.getAttribute('data-phase') === phase;

					});

					//th.querySelector('.p-count').innerHTML = matchingProducts.length;

				}};while (tableHeaders.length) {_loop();

			}

		});

	},


	/**
        * Click handler
        *
        * check which one element is clicked.
        *
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {var

		listItemName = this.props.listItemName;
		var t = e.target;

		var isProductClicked = t.matches('.' + listItemName);
		var productNode = _framework.util.findParent(t, '.' + listItemName);
		var overlayClicked = t.matches('.product-pipeline__overlay') || t.matches('.close-btn');

		if (isProductClicked || productNode) {

			e.preventDefault();

			this.setState({
				currentItem: isProductClicked ? t : productNode,
				isOverlayActive: true });


		} else if (overlayClicked) {

			e.preventDefault();

			this.setState({
				isOverlayActive: false });


		}

	},

	/**
        * When UI filter component notifying changes -> update internal state
        *
        * @param  {[type]} arg [ui, event]
        */
	uiChanged: function uiChanged() {var _this = this;for (var _len = arguments.length, arg = Array(_len), _key = 0; _key < _len; _key++) {arg[_key] = arguments[_key];}var

		ui = arg[0],e = arg[1];

		// event type check
		switch (e) {

			case 'uiCheckboxChange':

				// get data-color | data-filter
				var currentFilterValues = ui.state.currentItems.map(function (id) {return ui.refs.items[id].getAttribute(_this.props.filterAttr);}).filter(function (val) {return val;});

				this.setState({ currentFilterValues: currentFilterValues });

				break;

			default:
			//
		}


	},

	/**
       * When internal state changes
       *
       * currentFilterValues: ui filter value to filter p-items
       * currentItem: currently selected p-item
       * isOverlayActive: show/hide item detail in an overlay
       *
       * @param  {[type]} prevState [previous internal state]
       * @param  {[type]} state     [current internal state]
       */
	onStateUpdate: function onStateUpdate(prevState, state) {var _this2 = this;var

		currentFilterValues = state.currentFilterValues,currentItem = state.currentItem,isOverlayActive = state.isOverlayActive,filterMode = state.filterMode;var
		listItemName = this.props.listItemName;

		// filter values changed
		if (prevState.currentFilterValues !== state.currentFilterValues) {

			// filter products
			var filteredProducts = this.refs.items.filter(function (item) {

				var filterVal = item.getAttribute(_this2.props.filterAttr).trim();

				return currentFilterValues.indexOf(filterVal) !== -1;

			});

			if (filteredProducts.length) {

				// filtered item length > 0
				this.refs.items.forEach(function (item) {return item.classList.add('hide');});
				filteredProducts.forEach(function (item) {return item.classList.remove('hide');});

			} else {

				// 0 results => hide all
				this.refs.items.forEach(function (item) {return item.classList.add('hide');});

			}

			// update the table
			this.updateTable();

		}

		// overlay toggle
		// active product item -> show in overlay
		if (prevState.isOverlayActive !== isOverlayActive) {

			this.el.classList[isOverlayActive ? 'add' : 'remove']('show-overlay');
			this.refs.overlay.innerHTML = '';

			// check if currentItem is set
			var prev = this.el.querySelector('.' + listItemName + '.active');

			if (prev) {

				prev.classList.remove('active');

			}

			if (currentItem) {

				currentItem.classList.add('active');

				// from parent div
				var pDiv = currentItem.parentNode;
				var _phase = pDiv.getAttribute('data-phase');

				// from matching div
				var div = this.el.querySelector('div[data-phase="' + _phase + '"]');
				var productPhase = div ? div.querySelector('.p-phase').innerHTML : '';

				// from current item(product item)
				var color = currentItem.getAttribute('data-color').trim();
				var filterVal = currentItem.getAttribute('data-filter').trim();
				var productName = currentItem.querySelector('.p-name').innerHTML;
				var productContent = currentItem.querySelector('.p-content').innerHTML;

				// from matching filter
				var matchingFilter = this.refs.uiCheckbox.refs.items.filter(function (item) {return item.getAttribute('data-filter').trim() === filterVal;});
				var productCategory = matchingFilter.length ? matchingFilter[0].textContent.trim() : '-';

				// render product detail
				var props = {
					color: color,
					phase: _phase,
					productName: productName,
					productPhase: productPhase,
					productCategory: productCategory,
					productContent: productContent };


				this.refs.overlay.innerHTML = renderProductDetail(props);

				// close btn focus
				this.el.querySelector('.close-btn').focus();

			}

		}

		if (prevState.filterMode !== state.filterMode) {

			this.refs.filterContainer.classList[filterMode === 'fix' ? 'add' : 'remove']('fix');

		}

	},

	/**
        * window scroll
        *
        * This module switches its mode between static | fix based on scroll value
        * @return {[ScrollEvent]}
        */
	scroll: function scroll() {

		// fix | static
		var box = this.el.getBoundingClientRect();
		var isFixMode = box.top < 0;

		this.setState({
			filterMode: isFixMode ? 'fix' : 'static' });


	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {
			filterAttr: 'data-color' // string: filter target attribute on p-item
		};

	},

	// setting internal state
	getInternalState: function getInternalState() {

		return {
			currentFilterValues: [], // collection of all filter values
			currentItem: void 0, // current active p-item
			isOverlayActive: false, // boolean: overlay on/off
			filterMode: 'static' // string: static | fixed
		};

	} };exports.default =



ProductPipeline;

},{"../../framework":72}],51:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });




var _framework = require('../../framework');

var RepresentativeSearch = {
    refs: {},

    mounted: function mounted() {

        //state filter
        var uiDropDownState = null;
        var uiDropDownStateSel = this.el.querySelector('.ui-component.js-state-select[data-name="ui-dropdownlist"]');
        if (uiDropDownStateSel) {
            uiDropDownState = _framework.ModuleManager.getInstance().getComponentById(uiDropDownStateSel.getAttribute('cid'));
            if (uiDropDownState) {
                uiDropDownState.onChange = this.uiChangedState.bind(this);
            }
        }
        //area filter
        var uiDropDownArea = null;
        var uiDropDownAreaSel = this.el.querySelector('.ui-component.js-state-area[data-name="ui-dropdownlist"]');
        if (uiDropDownAreaSel) {
            uiDropDownArea = _framework.ModuleManager.getInstance().getComponentById(uiDropDownAreaSel.getAttribute('cid'));
            if (uiDropDownArea) {
                uiDropDownArea.onChange = this.uiChangedArea.bind(this);
            }
        }

        //if have results, show them
        var resultsEl = this.el.querySelector('.representative-search__result');
        if (resultsEl)
        {
            if (!this.checkVisible(this.el))
            {
                this.el.scrollIntoView(true);
            }
        }

        this.refs = {
            dropDownArea: uiDropDownArea,
            dropDownState: uiDropDownState };


        this.el.addEventListener('click', this.clickHandler.bind(this), false);
        this.el.addEventListener('keydown', this.keyboardHandler.bind(this));
    },

    uiChangedState: function uiChangedState() {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var

        ui = args[0],e = args[1];var
        currentValue = ui.state.currentValue;

        switch (e) {
            case 'uidropdownchange':
                this.setState({
                    stateFilter: currentValue });


                break;
            default:}

    },

    uiChangedArea: function uiChangedArea() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}var

        ui = args[0],e = args[1];var
        currentValue = ui.state.currentValue;

        switch (e) {
            case 'uidropdownchange':
                this.setState({
                    areaFilter: currentValue });


                break;
            default:}

    },
    /**
          * When internal state changes
          *
          * @param  {[type]} prevState [previous internal state]
          * @param  {[type]} state     [current internal state]
          */
    onStateUpdate: function onStateUpdate(prevState, state) {
        if (prevState.stateFilter !== state.stateFilter || prevState.areaFilter !== state.areaFilter) {
            this.clearErrorMessage();
            this.hideResults();
        }
    },

    clearErrorMessage: function clearErrorMessage() {
        this.el.classList.remove('js-display-error');
        return this;
    },

    hideResults: function hideResults() {
        this.el.classList.add('js-hide-results');
        return this;
    },

    submitWithParameters: function submitWithParameters() {

        if (this.refs.dropDownArea && this.refs.dropDownArea.hasValueOtherThanFirst() &&
        this.refs.dropDownState && this.refs.dropDownState.hasValueOtherThanFirst()) {
            _framework.util.gaSendEvent('Interactive Feature', 'Click', 'RepresentativeSearch-Submit', 1);
            window.location.href = window.location.pathname + "?repstate=" + this.refs.dropDownState.getSelectedValue() +
            "&reparea=" + this.refs.dropDownArea.getSelectedValue();
        } else
        {
            // show error message
            this.el.classList.add('js-display-error');
        }
    },

    clickHandler: function clickHandler(e) {
        var t = e.target;

        var role;
        if (t && t.tagName === 'A') {
            role = t.getAttribute('data-role');
            var iframe = t.getAttribute('data-iframe');

            if (role === "submit") {
                e.preventDefault();
                this.submitWithParameters();
            }

            if (role === "scheduleBtn") {
                e.preventDefault();

                var schedulePopup = this.el.querySelector('.Schedulepopup');
                var popupIframe = this.el.querySelector('.schedule-iframe');
                popupIframe.setAttribute("src", iframe);
                schedulePopup.classList.add('active');
            }

            if (t.matches('.close-btn') || t.tagName === 'SECTION') {
                e.preventDefault();
                this.close();
            }
        }
    },

    close: function close() {
        var schedulePopupSeletor = this.el.querySelector('.Schedulepopup');
        schedulePopupSeletor.classList.remove('active');
        var popupIframe = this.el.querySelector('.schedule-iframe');
        popupIframe.setAttribute("src", '');
    },

    keyboardHandler: function keyboardHandler(e) {var
        keyCode = e.keyCode;
        if (keyCode === 13) {
            this.submitWithParameters();
            return false;
        }
    },

    checkVisible: function checkVisible(elm) {
        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    },

    // setting initial state
    getInternalState: function getInternalState() {
        return {
            stateFilter: '',
            areaFilter: '' };

    } }; /**
         * representative search module
         * use:
         * class="module representative-search" data-name="representative-search"
         */exports.default = RepresentativeSearch;

},{"../../framework":72}],52:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });















var _lodash = require('lodash');var _lodash2 = _interopRequireDefault(_lodash);
var _action = require('../../action');
var _framework = require('../../framework');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/*not used
                                                                                                                                                                                                                                                                                    // factory functions
                                                                                                                                                                                                                                                                                    const createListItem = (words, search, action) => {
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	const li = document.createElement('li');
                                                                                                                                                                                                                                                                                    	const link = document.createElement('a');
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	const htmlStr = words.reduce((str, word) => {
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    		if (search.some(s => word.toLowerCase() === s || word === s)) {
                                                                                                                                                                                                                                                                                    			str += `<span class="match">${word}</span>`;
                                                                                                                                                                                                                                                                                    		} else {
                                                                                                                                                                                                                                                                                    			str += `<span>${word}</span>`;
                                                                                                                                                                                                                                                                                    		}
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    		return str;
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	}, '');
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	const value = words.join(' ');
                                                                                                                                                                                                                                                                                    	link.className = 'suggestion__link';
                                                                                                                                                                                                                                                                                    	link.href = `${action}?q=${encodeURIComponent(value)}`;
                                                                                                                                                                                                                                                                                    	link.target = '_self';
                                                                                                                                                                                                                                                                                    	link.setAttribute('data-value', value);
                                                                                                                                                                                                                                                                                    	link.innerHTML = htmlStr;
                                                                                                                                                                                                                                                                                    	li.appendChild(link);
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	return li;
                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    const createList = (list, s, action = '/search') => {
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	const df = document.createDocumentFragment();
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	if (s[0] && list.length) {
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    		//  if there is a mathcing item
                                                                                                                                                                                                                                                                                    		list.forEach(word => {
                                                                                                                                                                                                                                                                                    			df.appendChild(createListItem(word, s, action));
                                                                                                                                                                                                                                                                                    		});
                                                                                                                                                                                                                                                                                    	}
                                                                                                                                                                                                                                                                                    
                                                                                                                                                                                                                                                                                    	return df;
                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                    */
var SearchOverlay = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;

		var isInline = this.el.classList.contains('search-module--inline');
		var isOverlay = this.el.classList.contains('search-module--overlay');

		// set type
		this.setState({
			isOverlay: typeof isOverlay === 'undefined',
			isInline: typeof isInline === 'undefined' },
		false);

		// ui input
		var uiInputText = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-input').getAttribute('cid'));
		if (uiInputText) {
			uiInputText.onChange = _lodash2.default.debounce(this.uiChanged.bind(this), 200);
			uiInputText.mouseHandler = function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var

				input = args[0],type = args[1],role = args[2];

				if (role === 'submit' && _this.refs.form) {
					_framework.util.gaSendEvent('Interactive Feature', 'Click', 'SearchWidget-Submit', 1);

					// submit
					_this.refs.form.submit();
				} else
				if (role === 'search') {
					// clear
					input.input.value = '';
				}
			};
		}

		// refs
		this.refs = {
			form: this.el.getElementsByTagName('form')[0],
			input: uiInputText,
			//	suggestedList: this.el.querySelector('.search__suggestion'),
			suggestions: [] };


		this.initEvent();
	},

	/**
        * Init events internally
        * @return {[type]} [description]
        */
	initEvent: function initEvent() {var _this2 = this;

		// click handler
		this.el.addEventListener('click', this.mouseHandler.bind(this));

		// form submit
		if (this.form) {
			this.refs.form.addEventListener('submit', function (e) {
				if (_this2.submitHandler) {
					// callback
					_this2.submitHandler.call(null, e, _this2.form);
				}
			});
		}

		// keyboard event
		this.el.addEventListener('keydown', this.keyboardHandler.bind(this));
	},

	/**
        * When UI filter component notifying changes -> update internal state
        *
        * @param  {[type]} arg [ui, event]
        */
	uiChanged: function uiChanged() {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}var
		ui = args[0],e = args[1];

		// event type check
		switch (e) {

			case 'input':
			case 'change':
				// relay ui input value to internal state
				this.setState({
					search: ui.state.value });


				break;
			default:}

	},

	/**
        * keyboard down
        *
        * @param  {[KeyboardEvent]} e
        */
	keyboardHandler: function keyboardHandler(e) {var
		keyCode = e.keyCode;
		var keyIndex = this.state.keyIndex;

		if (keyCode === 38 || keyCode === 40) {
			keyIndex += keyCode === 38 ? -1 : 1;

			if (keyIndex >= 0 && keyIndex < this.refs.suggestions.length) {
				this.setState({ keyIndex: keyIndex });
			}
		} else
		if (keyCode === 13) {
			var browserVer = this.context.props.browserVer;
			if (browserVer === 'ie-11') {
				_framework.util.gaSendEvent('Interactive Feature', 'Click', 'SearchWidget-Submit', 1);
				this.refs.form.submit();
				return false;
			}
		} else
		if (keyCode === 27) {// esc
			//send close
			var searchProps = {
				target: e.target,
				active: false,
				keyword: '' };

			this.context.setState(_action.appActions.globalSearch(searchProps));
		}
	},

	/**
        * Click handler
        * handles "exit" or link click
        *
        * @param  {[MouseEvent]} e
        */
	mouseHandler: function mouseHandler(e) {
		var t = e.target;
		var type = e.type;

		if (type === 'click') {
			var isExitable = t.matches('.close-btn');

			// close btn. notify globally
			if (isExitable) {
				_framework.util.gaSendEvent('Interactive Feature', 'Click', 'SearchWidget-Close', 1);

				e.preventDefault();

				var searchProps = {
					target: e.target,
					active: false,
					keyword: '' };


				this.context.setState(_action.appActions.globalSearch(searchProps));
			}
		}
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {var
		fetch = this.props.fetch;var _state =







		this.state,active = _state.active,target = _state.target,keyword = _state.keyword,search = _state.search,keyIndex = _state.keyIndex;

		// active, open || close
		if (this.prevState.active !== active) {

			// open || close
			this[active ? 'open' : 'close']();

			// when open
			if (active) {

				// 1. theirs(internal search module)
				if (target && Object.prototype.hasOwnProperty.call(target, 'props') && target.props.name === 'search-input') {
					target.setState({ active: false });
				}

				// 2. mine
				// reset
				if (this.refs.input) {
					this.setState({ search: keyword });
					this.refs.input.input.value = keyword;
					this.refs.input.input.focus();
				}

			} else if (!active) {
				// 1. theirs
				// only yellow search trigger input(search-input.js)
				if (target && Object.prototype.hasOwnProperty.call(target, 'props') && target.props.name === 'search-input') {
					target.setState({ active: true });
				}
			}
		}

		// when search value updates, do word base search & sort
		/* not used
  	if (this.prevState.search !== search) {
  		if (+fetch === 1 || fetch === 'true') {
  			this.suggestedSearch(search);
  		}
  	}
  	*/

		// keyboard index
		if (this.prevState.keyIndex !== keyIndex) {
			var link = this.refs.suggestions[keyIndex].getElementsByTagName('a')[0];
			if (link) {
				link.focus();
			}
		}
	},

	/**
        * Type-ahead + fetching related keywords + rendering items
        * @param  {[String]} search [current search keyword to fetch data]
        */
	/*not used
                  suggestedSearch(search) {
                  	const { suggestedList, form } = this.refs;
                  	//const { testServiceURI, localServiceURI } = this.props;
                  	const { testServiceURI } = this.props;
                  		suggestedList.innerHTML = '';
                  		if (!search) {
                  		return;
                  	}
                  		// fetch suggestions
                  	this.el.classList.add('fetching');
                  		// when we use type ahead, make sure this is correct flag
                  //		const uri = window.location.href.indexOf('csl.com') !== -1 ? testServiceURI + encodeURIComponent(search) : localServiceURI;
                  	const uri =  testServiceURI + encodeURIComponent(search);
                  		fetch(uri, {
                  		method: 'GET',
                  		credentials: 'same-origin',
                  	})
                  		.then(res => res.json())
                  		.then(data => {
                  				const suggestions = data[1];
                  				this.setState({ keyIndex: -1 }, false);
                  				const allSuggestions = suggestions.map(word => word.split(/\s/));
                  				// turn into array
                  			search = Array.isArray(search) ? search : search.split(/\s/);
                  				const newListEls = createList.call(this, allSuggestions, search, form.action ? form.action : '/search');
                  			suggestedList.appendChild(newListEls);
                  			this.refs.suggestions = Array.from(this.refs.suggestedList.children);
                  			})
                  		.catch(e => console.log('Error,', e))
                  		.then(() => {
                  				// lil dealy so it won't blink
                  			setTimeout(() => {
                  					this.el.classList.remove('fetching');
                  				}, 300);
                  			});
                  	},
                  */
















	/**
                                * Show overlay
                                */
	open: function open() {var _this3 = this;
		this.refs.focusedEl = document.activeElement;
		this.el.classList.add('active');

		setTimeout(function () {
			_this3.el.classList.add('animate-in');
		}, 200);
	},

	/**
        * Hide overlay
        */
	close: function close() {var _this4 = this;
		['animate-in', 'active'].forEach(function (c) {return _this4.el.classList.remove(c);});
		if (this.refs.focusedEl)
		{
			this.refs.focusedEl.focus();
		}
	},

	// setting internal props
	getInternalProps: function getInternalProps() {
		return {
			fetch: false, // boolean: if true, type-ahead->fetch enabled. Note, for phase 1, this is disabled.
			overlay: true // boolean: if true, this is attached to overlay version
		};
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {
			isOverlay: true, // if this is used for overlay version
			isInline: false, // if this is used for inline version
			active: false, // boolean: active or not
			keyIndex: -1, //
			target: '' // dom node, e.g search input
		};
	} }; /**
      * Search Overlay
      *
      * use:
      * class="module search-overlay" data-overlay="true" data-name="search-overlay"
      *
      * related src:
      *
      * view:
      *   Views/CSLShared/Shared/_SearchModal.cshtml
      *
      * css: app/styles/modules/_search-overlay.scss
      *
      */ // dependency
exports.default = SearchOverlay;

},{"../../action":2,"../../framework":72,"lodash":"lodash"}],53:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });












var _framework = require('../../framework');

var SearchResult = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;

		// refs
		this.refs = {
			form: this.el.getElementsByTagName('form')[0],
			initialGA: false };


		// ui input
		var uiInputText = _framework.ModuleManager.getInstance().getComponentById(this.el.querySelector('.ui-component[data-name="ui-input"][data-type="text"]').getAttribute('cid'));

		uiInputText.mouseHandler = function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var
			input = args[0],type = args[1],role = args[2];

			if (role === 'submit' && _this.refs.form) {
				_framework.util.gaSendEvent('Interactive Feature', 'Click', 'SearchForm-Submit', 1);

				// submit
				_this.refs.form.submit();
			}

			if (role === 'search') {
				// clear
				input.input.value = '';
			}
		};



	},

	resize: function resize() {var _props =

		this.props,eventCategory = _props.eventCategory,eventAction = _props.eventAction,eventLabel = _props.eventLabel,eventValue = _props.eventValue,eventType = _props.eventType,analyticCall = _props.analyticCall;

		// ga specifc event dispatch. Using resize to allow GA to initialize
		if (!this.refs.initialGA && typeof _framework.analytic === 'function' && analyticCall != null && analyticCall.toLowerCase() === "true") {
			this.refs.initialGA = true;

			(0, _framework.analytic)(eventType, {
				eventCategory: eventCategory,
				eventAction: eventAction,
				eventLabel: eventLabel,
				eventValue: eventValue });


		}
		return this;
	} }; /**
      * Search Result
      *
      * use:
      * class="module search-result" data-name="search-result"
      *
      * related src:
      * view: Views/CSLShared/Modules/Search/_SearchResult.cshtml
      * css: app/styles/modules/_search-result.scss
      *
      * 
      */exports.default = SearchResult;

},{"../../framework":72}],54:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });











var _framework = require('../../framework');

var SharedArticleMosaic = {
	refs: {},

	mounted: function mounted() {
		var grid = this.el.querySelector('.js-mosaic_grid');

		// iso option
		var IsoOption = {
			layoutMode: 'masonry',
			itemSelector: '.m-tile',
			percentPosition: true,
			transitionDuration: 300,
			masonry: {
				gutter: 30,
				columnWidth: '.m-sizer',
				initLayout: true } };



		var isoInstance = (0, _framework.iso)(grid, IsoOption);

		// iso events
		isoInstance.on('layoutComplete', this.isoLayout.bind(this));

		this.refs = {
			iso: isoInstance };

	},

	isoLayout: function isoLayout() {
		// console.log(args);
	},

	// window resize. call iso.layout to reorder
	resize: function resize() {
		if (this.refs.iso) {
			this.refs.iso.layout();
		}
		return this;
	} }; /**
      * shared-article-mosaic
      *
      * use:
      * class="module sharedarticlemosaic" data-name="shared-article-mosaic"
      *
      * related src:
      * view: Views/CSLShared/Modules/News/SharedArticleMosaic.cshtml
      * css: app/styles/modules/_SharedArticleMosaic.scss
      *
      */exports.default = SharedArticleMosaic;

},{"../../framework":72}],55:[function(require,module,exports){
"use strict"; /**
              * Content SideBar release 2.3 (70 * 30 %)
              *
              *
              * related src:
              * view: Views/CSLShared/Modules/Sidebar/_sideBar.cshtml
              * css: app/styles/modules/_contentpage-sidebar.scss
              *
              * 
              */
$(function () {
   // Verifiying Right SideBar with children is available on page loads
   if (document.querySelector(".sb-right-container") && $(".sb-right-container").children().length) {
      $(".sidebar-section").addClass("has-sidebar-content");
   } else
   {
      $(".sb-right-container").remove();
      $(".sb-left-container").addClass("full-width-container");
      $(".sidebar-section").addClass("no-sidebar-content");
      $(".sidebar-section").removeClass("has-sidebar-content");
   }

});

},{}],56:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });















var _util = require('../../framework/util');
var _action = require('../../action'); /**
                                       * SideBar(Mobile nav)
                                       *
                                       * use:
                                       * class="module sidebar" data-name="sidebar"
                                       *
                                       * related src:
                                       *
                                       * view: Views/CSLShared/Menu/MobileNavigation.cshtml
                                       *
                                       * css: app/styles/modules/_sidebar.scss
                                       *
                                       * 
                                       */ // dependency
var SideBar = { refs: {}, /**
                           * When mounted
                           *
                           * start writing scrip here for this module
                           */mounted: function mounted() {// determine if sidebar item has children
		Array.from(this.el.querySelectorAll('.sidebar-item')).forEach(function (n) {var hasChildren = (0, _util.nodeHasChildren)(n, '.sidebar-nav');n.classList.add(hasChildren ? 'has-children' : 'no-children');});

		// refs
		this.label = this.el.querySelector('#sidebar-current span');
		this.el.addEventListener('click', this.clickHandler.bind(this));
		this.el.classList.add('mounted');

		// set the active page
		if (this.context.props.dataPageId && this.context.props.dataPageId.length > 0) {
			//set the matching nav as active
			var navEl = this.el.querySelector('[data-navpageid="' + this.context.props.dataPageId + '"]');
			if (navEl) {
				//walk up the tree
				for (; navEl && navEl !== document; navEl = navEl.parentNode) {
					if (navEl.classList.contains('sidebar__row-primary')) {
						navEl.classList.add('active-page');
					}
				}
			}
		}
	},

	/**
        * Click handler
        * handles "exit"
        *
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {var _this = this;

		var t = e.target;

		// exit
		if (t && t.matches('#sidebar-close-btn')) {
			(0, _util.gaSendEvent)('Interactive Feature', 'Click', 'RichNav-Close', 1);

			e.preventDefault();

			this.
			reset().
			then(function () {

				// this module has to be closed from App since this sets global state
				// this.context = app
				_this.context.setState(_action.appActions.sideBarAction(false));

			});

		} else if (t && t.matches('#sidebar-back-btn')) {

			// go back btn
			e.preventDefault();var _state =

			this.state,navItem = _state.currentNavItem,lv = _state.currentLevel;

			if (navItem) {

				navItem.classList.remove('active');

				// find dirent parent node and update internal state
				this.setState({
					currentNavItem: (0, _util.findParent)(navItem, '.sidebar-item', '.sidebar'),
					currentLevel: lv - 1 });


			}

		} else if (t && t.matches('.sidebar-item a')) {

			// sidebar item click(level nth)
			var _navItem = t.parentNode;
			var hasChildren = (0, _util.nodeHasChildren)(_navItem, '.sidebar-nav');

			// when it has a children
			if (hasChildren) {
				(0, _util.gaSendEvent)('Link', 'Menu Nav Link Click', t.text, 1);

				e.preventDefault();

				// show children nav node
				_navItem.classList.add('active');

				this.setState({
					currentNavItem: _navItem,
					currentLevel: _navItem.getAttribute('data-level') });


			}

		}

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {var


		isActive =


		state.isActive,currentLevel = state.currentLevel,currentNavItem = state.currentNavItem;

		// toggle visibility
		this[isActive ? 'open' : 'close']();
		this.el.classList[currentLevel === -1 ? 'add' : 'remove']('reached-top');

		// update top level indicator if exist
		if (this.label) {

			this.label.innerHTML = currentNavItem ? currentNavItem.getElementsByTagName('a')[0].innerHTML : 'Home';

		}

	},

	/**
        * module reset method
        * this gets called when sidebar closes.
        * reset all relavant dom elemnts, state
        */
	reset: function reset() {var _this2 = this;

		return new Promise(function (res) {

			_this2.setState({
				currentNavItem: null,
				currentLevel: -1 },
			false);

			[].slice.call(_this2.el.querySelectorAll('.sidebar-item.active')).
			forEach(function (navItem) {return navItem.classList.remove('active');});

			setTimeout(function () {

				res();

			}, 0);

		});

	},

	/**
        * Show sidebar
        */
	open: function open() {

		this.el.classList.add('active');

	},

	/**
        * Show sidebar
        */
	close: function close() {

		this.el.classList.remove('active');

	},

	// setting internal states
	getInternalState: function getInternalState() {

		return {
			isActive: false, // boolean: active or not
			currentLevel: -1, // number: interger value that represents current navigation depth(nth)
			currentNavItem: null // element: current active nav item
		};

	} };exports.default =



SideBar;

},{"../../action":2,"../../framework/util":77}],57:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });





var _abstract = require('./abstract');var _abstract2 = _interopRequireDefault(_abstract);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var SimplePopup = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {

		this.refs = {
			inner: this.el.querySelector('.inner'),
			contentContainer: this.el.querySelector('.content-container'),
			closeBtn: this.el.querySelector('.close-btn')


			// click
		};this.el.addEventListener('click', this.mouseHandler.bind(this));

		if (this.props.initialActive) {

			this.setState({
				active: true });


		}

	},

	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.active !== state.active) {

			this[state.active ? 'open' : 'close']();

		}

		if (prevState.content !== state.content) {

			this.insertContent(state.content);

		}


	},

	mouseHandler: function mouseHandler(e) {

		var t = e.target;var _refs =

		this.refs,errorEl = _refs.errorEl,inner = _refs.inner;

		// outside click, click current popup
		// when close button clicked
		if (t.matches('.js-close-btn') || t.matches('.simple-popup')) {

			e.preventDefault();

			this.setState({
				active: false });


		}

	},

	open: function open() {

		this.el.classList.add('active');

		// focus on close btn
		if (this.refs.closeBtn) {

			this.refs.closeBtn.focus();

		}

	},

	close: function close() {var _state =

		this.state,content = _state.content,contentOriginalParent = _state.contentOriginalParent,exitCallBack = _state.exitCallBack;

		this.el.classList.remove('active');

		// when destroy is set, destroy this module
		if (this.props.destroy) {

			this.destroy();

		}

		// exit/close call back
		if (typeof exitCallBack === 'function') {

			exitCallBack.call(null, this);

		}

		this.
		revertContent().
		setState(this.getInternalState(), false);

	},

	setMessage: function setMessage(text) {var scrollToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;var

		inner = this.refs.inner;
		var errorEl = this.el.querySelector('.api-error');

		if (inner && scrollToTop) {

			inner.scrollTop = 0;

		}

		if (errorEl) {

			errorEl.innerHTML = text;
		}

		return this;

	},

	insertContent: function insertContent(content) {

		var isElement = content instanceof HTMLElement;
		var isString = typeof content === 'string';

		if (this.refs.contentContainer) {

			if (isElement) {

				this.refs.contentContainer.appendChild(content);

			}

			if (isString) {

				this.refs.contentContainer.innerHTML = content;

			}

		}

	},

	revertContent: function revertContent() {var _state2 =

		this.state,content = _state2.content,contentOriginalParent = _state2.contentOriginalParent;

		if (content instanceof HTMLElement && contentOriginalParent instanceof HTMLElement) {

			// put it back to dom
			contentOriginalParent.appendChild(content);

		}

		return this;

	},

	destroy: function destroy() {
		// deploy self
		_abstract2.default.destroy.call(this);
		this.el.removeEventListener('click', this.mouseHandler.bind(this));

	},

	getInternalState: function getInternalState() {

		return {
			active: false, // boolean
			contentName: '', // string, identifier the content
			content: '', // html string
			callbackAfterExit: void 0 // fn callback.
		};

	} }; /**
      * Simple Popup
      *
      * 
      */exports.default = SimplePopup;

},{"./abstract":13}],58:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });













var _elemDataset = require('elem-dataset');var _elemDataset2 = _interopRequireDefault(_elemDataset);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// a.social-image will contain an actual social sharer uri. with parsable string in it.
// parse link's href and replace target strings with meta tag values
// (#|$){url} -> url
// (#|$){title} -> title
// (#|$){description} -> description
var parseUrlWithMetaDataImage = function parseUrlWithMetaDataImage(link, socialMetaImage) {var

	type = socialMetaImage.type,title = socialMetaImage.title,description = socialMetaImage.description,url = socialMetaImage.url,parseShareUrl = socialMetaImage.parseShareUrl;
	var target = type === 'email' ? '_self' : '_blank';

	// replace title
	var shareURIimage = parseShareUrl.
	replace(/(#|\$){title}/ig, title).
	replace(/(#|\$){description}/ig, description).
	replace(/(#|\$){url}/ig, url);

	window.open(shareURIimage, target);

}; /**
   * Social Share
   *
   * use:
   * class="module social-share-image" data-name="social-share-image"
   *
   * related src:
   * view: Views/CSLShared/Shared/_FullSizeImage.cshtml
   * css: app/styles/modules/_fullsizeimage.scss
   *
   * 
   */ // dependency
var SocialShareImage = { /**
                          * When mounted
                          *
                          * start writing scrip here for this module
                          */mounted: function mounted() {this.el.addEventListener('click', this.clickHandler.bind(this));}, /**
                                                                                                                             * Click handler
                                                                                                                             *
                                                                                                                             * when each social btn clicked
                                                                                                                             *
                                                                                                                             * @param  {[MouseEvent]} e
                                                                                                                             */clickHandler: function clickHandler(e) {

		var t = e.target;

		if (t.matches('a.ui-social-image')) {

			e.preventDefault();

			var moduleDataImage = this.props.type === 'dynamic' ? (0, _elemDataset2.default)(this.el) : void 0;
			var parentImage = e.target.parentNode;
			var parentDataImage = typeof parentImage.dataset === 'undefined' ? (0, _elemDataset2.default)(parentImage) : parentImage.dataset;

			// create meta obj
			var type = parentDataImage.type.toLowerCase();

			/*build the image URL*/
			var imagePath = document.getElementById('imagepath').innerHTML;
			var url = window.location.protocol + "//" + window.location.host + imagePath;

			var title = moduleDataImage ? encodeURIComponent(moduleDataImage.shareTitle) : encodeURIComponent(document.querySelector('meta[property="og:title"]').content || '');
			var description = moduleDataImage ? encodeURIComponent(moduleDataImage.shareDescription) : encodeURIComponent(document.querySelector('meta[property="og:description"]').content || '');
			var parseShareUrl = t.href;

			var socialMetaImage = {
				type: type,
				title: title,
				description: description,
				url: url,
				parseShareUrl: parseShareUrl };


			//added to check if the social share icon has disclaimer
			var shouldTriggerConfirmImage = t.getAttribute('data-confirm');
			if (shouldTriggerConfirmImage) {

				e.preventDefault();

				// ignore editor warning
				if (window.confirm(shouldTriggerConfirmImage)) {

					//t.removeAttribute('data-confirm');

					var _url = t.getAttribute('data-url');
					var target = t.getAttribute('target') ? t.getAttribute('target') : '_self';

					//window.open(url, target);
					parseUrlWithMetaDataImage(t, socialMetaImage);

				}

			}

			//end added to check if the social share icon has disclaimer
			else
				{
					// socialBtnHandler.call(this, socialMeta);
					parseUrlWithMetaDataImage(t, socialMetaImage);
				}

		}

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {};

	},
	// setting internal states
	getInternalState: function getInternalState() {

		return {};

	} };exports.default =



SocialShareImage;

},{"elem-dataset":405}],59:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });
















var _elemDataset = require('elem-dataset');var _elemDataset2 = _interopRequireDefault(_elemDataset);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

/**
                                                                                                                                                                                                                                                                                                                                                                                                     * social button click handler. check type
                                                                                                                                                                                                                                                                                                                                                                                                     * @param  {[Object]} socialMeta [description]
                                                                                                                                                                                                                                                                                                                                                                                                     */
var socialBtnHandler = function socialBtnHandler(socialMeta) {var

	type = socialMeta.type,title = socialMeta.title,description = socialMeta.description,url = socialMeta.url;

	var target = '_blank';
	var shareURI = '';

	switch (type) {

		case 'twitter':

			shareURI = 'http://twitter.com/intent/tweet?url=' + url + '&text=' + title + ', ' + description;

			break;

		case 'facebook':

			shareURI = 'https://www.facebook.com/sharer/sharer.php?u=' + url;

			break;

		case 'google':

			shareURI = 'https://plus.google.com/share?url=' + url;

			break;

		case 'linkedin':

			shareURI = 'http://www.linkedin.com/shareArticle?mini=true&url=' + url + '&title=' + title + ', ' + description;

			break;

		case 'email':

			shareURI = 'mailto:?Subject=' + title + '&body=' + description + ', ' + url;

			target = '_self';

			break;

		case 'youtube':
			break;

		default:
		//
	}


	window.open(shareURI, target);

};


// a.ui-social will contain an actual social sharer uri. with parsable string in it.
// parse link's href and replace target strings with meta tag values
// (#|$){url} -> url
// (#|$){title} -> title
// (#|$){description} -> description
/**
* Social Share
*
* use:
* class="module social-share" data-name="social-share"
* class="module page-share" data-name="social-share"
*
* related src:
* view: Views/CSLShared/Modules/_SocialShare.cshtml
* view: Views/CSLShared/Modules/_PageShare.cshtml
* css: app/styles/modules/_social-share.scss
* css: app/styles/modules/_page-share.scss
*
* 
*/ // dependency
var parseUrlWithMetaData = function parseUrlWithMetaData(link, socialMeta) {var type = socialMeta.type,title = socialMeta.title,description = socialMeta.description,url = socialMeta.url,parseShareUrl = socialMeta.parseShareUrl;var target = type === 'email' ? '_self' : '_blank'; // replace title
	var shareURI = parseShareUrl.replace(/(#|\$){title}/ig, title).replace(/(#|\$){description}/ig, description).replace(/(#|\$){url}/ig, url);window.open(shareURI, target);};var SocialShare = {
	/**
                                                                                                                                                                                                                                                                                                                                                                                                * When mounted
                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                * start writing scrip here for this module
                                                                                                                                                                                                                                                                                                                                                                                                */
	mounted: function mounted() {

		this.el.addEventListener('click', this.clickHandler.bind(this));

	},

	/**
        * Click handler
        *
        * when each social btn clicked
        *
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		if (t.matches('a.ui-social')) {

			e.preventDefault();

			var moduleData = this.props.type === 'dynamic' ? (0, _elemDataset2.default)(this.el) : void 0;
			var parent = e.target.parentNode;
			var parentData = typeof parent.dataset === 'undefined' ? (0, _elemDataset2.default)(parent) : parent.dataset;

			// create meta obj
			var type = parentData.type.toLowerCase();
			var url = moduleData && moduleData.shareUrl ? encodeURIComponent(moduleData.shareUrl) : encodeURIComponent(window.location.href);
			var title = moduleData ? encodeURIComponent(moduleData.shareTitle) : encodeURIComponent(document.querySelector('meta[property="og:title"]').content || '');
			var description = moduleData ? encodeURIComponent(moduleData.shareDescription) : encodeURIComponent(document.querySelector('meta[property="og:description"]').content || '');
			var parseShareUrl = t.href;

			var socialMeta = {
				type: type,
				title: title,
				description: description,
				url: url,
				parseShareUrl: parseShareUrl };


			//added to check if the social share icon has disclaimer
			var shouldTriggerConfirm = t.getAttribute('data-confirm');
			if (shouldTriggerConfirm) {

				e.preventDefault();

				// ignore editor warning
				if (window.confirm(shouldTriggerConfirm)) {

					//t.removeAttribute('data-confirm');

					var _url = t.getAttribute('data-url');
					var target = t.getAttribute('target') ? t.getAttribute('target') : '_self';

					//window.open(url, target);
					parseUrlWithMetaData(t, socialMeta);

				}

			}

			//end added to check if the social share icon has disclaimer
			else
				{
					// socialBtnHandler.call(this, socialMeta);
					parseUrlWithMetaData(t, socialMeta);
				}

		}

	},

	// setting internal props
	getInternalProps: function getInternalProps() {

		return {};

	},
	// setting internal states
	getInternalState: function getInternalState() {

		return {};

	} };exports.default =



SocialShare;

},{"elem-dataset":405}],60:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });










var _framework = require('../../framework');

var SubscriptionBlock = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;

		var form = this.el.getElementsByTagName('form')[0];
		this.refs = {
			form: form,
			formGroups: [].slice.call(this.el.querySelectorAll('.form-group')), // sitecore form groups
			subscription: this.el.querySelector('.subscription'),
			thankyou: this.el.querySelector('.thankyou') };


		// sitecore form inputs, placeholder
		this.refs.formGroups.forEach(function (el) {

			var input = el.querySelector('input');

			var inputHandler = function inputHandler(e) {
				var target = e.target;

				// IE fires input event even when placeholder changes or focused. Known bug.
				// check if actually there is a value
				if (target.value && target.value.length > 0) {
					_this.el.classList.remove('phase-1');
					//TODO: dynamically add captcha
					//<script async="async" defer="defer" src="https://www.google.com/recaptcha/api.js?onload=onInvisRecaptchaLoadCallback&amp;hl=en-US"></script>
					input.removeEventListener('input', inputHandler);
				}
			};

			if (input) {
				// when any of sitecore input is active, then show the rest
				input.addEventListener('input', inputHandler);
			}
		});

		// form submit
		if (this.refs.form) {
			this.refs.form.addEventListener('submit', function (e) {
				_framework.util.gaSendEvent('Form', 'Form Submitted', 'Subscribe Newsletter', 1);
			});
		}
		// hide all form group except the first one
		this.el.classList.add('phase-1');
	},

	/**
        * Handles internal state based on captcha + sitecore form
        * @param  {[MouseEvent]} e
        */
	clickHandler: function clickHandler(e) {
	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {
	},

	// setting internal state
	getInternalState: function getInternalState() {
		return {};

	} }; /**
      * Subscription Block
      *
      * use:
      * class="module subscription-block" data-name="subscription-block"
      *
      * related src:
      * view: Views/CSLShared/Modules/_SubscriptionBlock.cshtml
      * css: app/styles/modules/_subscription-block.scss
      *
      */exports.default = SubscriptionBlock;

},{"../../framework":72}],61:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });





var _framework = require('../../framework');

var TIMELINE_T_DELAY = 700; /**
                            * TimeLine
                            *
                            * 
                            */var TIMELINE_T_DIR_FORWARD = 'forward';var TIMELINE_T_DIR_BACKWARD = 'backward';var getMaxNumberOfItemInView = function getMaxNumberOfItemInView(parent, itemWidth) {

	return Math.floor(parent.offsetWidth / itemWidth);

};

var createBulletUI = function createBulletUI(html, item, i) {

	var title = item.querySelector('.timeline-item__title').textContent.trim();
	var year = item.querySelector('.timeline-item__year').textContent.trim();

	var bulletUI = '';
	bulletUI += '<a href="#" class="bullet" aria-label="' + title + '" tabindex="0" data-id="' + i + '">';
	bulletUI += '\t<span class="year">' + year + '</span>';
	bulletUI += '	<span class="circle"></span>';
	bulletUI += '</a>';

	html += bulletUI;

	return html;


};

var Timeline = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;

		this.refs = {
			redCircle: this.el.querySelector('.red-circle'),
			bullets: [],
			bulletContainer: this.el.querySelector('.bullets'),
			timeLineItems: Array.from(this.el.getElementsByClassName('timeline-item')),
			timeLineContainer: this.el.getElementsByClassName('timeline-items')[0],
			dummyInput: this.el.querySelector('.dummy-input') };


		// click & gesture
		this.el.addEventListener('click', this.mouseHanlder.bind(this), false);

		// keyboard event
		this.el.addEventListener('keydown', this.keyboardHandler.bind(this));

		// gesture
		this.hammer = (0, _framework.swipe)(this.el.querySelector('.inner'), this.gestureHandler.bind(this));

		// create bullet ui with rendered entries(items)
		var renderedBullets = this.refs.timeLineItems.reduce(createBulletUI, '');

		this.refs.bulletContainer.innerHTML = renderedBullets;
		this.refs.bullets = Array.from(this.el.getElementsByClassName('bullet'));

		setTimeout(function () {

			_this.setState({
				currentId: _this.props.defaultId,
				length: _this.refs.bullets.length });


		}, 500);

	},

	active: function active() {

		// focus first bullet so keyboard works
		if (this.refs.bullets[0]) {

			this.refs.bullets[0].focus();

		}

	},

	mouseHanlder: function mouseHanlder(e) {

		var t = e.target;

		if (t.matches('.bullet')) {

			e.preventDefault();

			this.setState({
				prevId: this.state.currentId,
				currentId: +t.getAttribute('data-id') });


		}

	},


	gestureHandler: function gestureHandler(e) {

		if (this.el.classList.contains('lock')) {

			return;

		}var _state =

		this.state,currentId = _state.currentId,prevId = _state.prevId,length = _state.length;

		switch (e.type) {

			case 'swipeleft':

				this.setState({
					prevId: currentId,
					currentId: currentId < length - 1 ? currentId + 1 : 0 });


				break;

			case 'swiperight':

				this.setState({
					prevId: currentId,
					currentId: currentId > 0 ? currentId - 1 : length - 1 });


				break;

			default:
			//
		}


	},

	/**
        * keyboard down
        *
        * @param  {[KeyboardEvent]} e
        */
	keyboardHandler: function keyboardHandler(e) {

		if (this.el.classList.contains('lock')) {

			return;

		}var

		keyCode = e.keyCode;var _state2 =
		this.state,currentId = _state2.currentId,length = _state2.length;

		if (keyCode === 37 || keyCode === 39) {

			var id = currentId;

			if (keyCode === 37) {

				id = currentId > 0 ? currentId - 1 : length - 1;

			} else {

				id = currentId < length - 1 ? currentId + 1 : 0;

			}

			this.setState({
				prevId: currentId,
				currentId: id });


		}

	},


	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate(prevState, state) {

		if (prevState.currentId !== state.currentId) {

			this.
			updateUI().
			updateTimeline();

		}

	},

	updateUI: function updateUI() {var _state3 =

		this.state,currentId = _state3.currentId,prevId = _state3.prevId,length = _state3.length;
		var prevBullet = this.refs.bullets[prevId];
		var currentBullet = this.refs.bullets[currentId];

		// bullet ui
		if (prevBullet) {

			prevBullet.classList.remove('active');

		}

		if (currentBullet) {

			currentBullet.classList.add('active');

		}

		// transform ui container
		// check if the current bullet is within range
		// get how many items can be contains in the current view with
		var _refs =
		this.refs,bullets = _refs.bullets,bulletContainer = _refs.bulletContainer,redCircle = _refs.redCircle;
		var tx = 0;
		var leftX = currentBullet.offsetLeft + (currentBullet.offsetWidth - redCircle.offsetWidth) * 0.5;

		if (length > 1) {

			var firstItem = this.refs.bullets[0];
			var lastItem = this.refs.bullets[length - 1];
			var totalItemWidth = lastItem.offsetLeft + lastItem.offsetWidth;
			var itemWidth = firstItem.offsetLeft + firstItem.offsetWidth;
			var maxNumberOfItemInView = getMaxNumberOfItemInView(bulletContainer, itemWidth);

			// console.log(`${currentId}/${length}, max id: ${maxNumberOfItemInView}`);
			// within range and not the last item
			if (currentId + 1 >= maxNumberOfItemInView) {

				var range = currentId !== length - 1 ? 2 : 1;

				tx = (currentId + range - maxNumberOfItemInView) * -itemWidth;

			}

			leftX += tx;

		}

		// console.log(`leftX: ${leftX}`);
		// console.log(`tx: ${tx}`);

		bulletContainer.style.transform = 'translateX(' + tx + 'px)';

		// red circle
		redCircle.style.left = leftX + 'px';

		return this;

	},

	updateTimeline: function updateTimeline() {var _this2 = this;

		clearTimeout(this.animationTimer);
		this.el.classList.add('lock');var _state4 =

		this.state,currentId = _state4.currentId,prevId = _state4.prevId;
		var prevItem = this.refs.timeLineItems[prevId];
		var currentItem = this.refs.timeLineItems[currentId];
		var direction = currentId - prevId > 0 ? TIMELINE_T_DIR_FORWARD : TIMELINE_T_DIR_BACKWARD;

		// 1.
		if (prevItem) {

			['active', 'before-animate-in', 'animate-in', TIMELINE_T_DIR_FORWARD, TIMELINE_T_DIR_BACKWARD].forEach(function (c) {return prevItem.classList.remove(c);});

			prevItem.classList.add('before-animate-out');
			prevItem.classList.add(direction);

		}

		// 2.
		if (currentItem) {

			['active', direction, 'before-animate-in'].forEach(function (c) {return currentItem.classList.add(c);});

			this.animationTimer = setTimeout(function () {

				if (prevItem) {

					prevItem.classList.add('animate-out');

				}

				currentItem.classList.add('animate-in');

			}, TIMELINE_T_DELAY * 0.5);

		}

		// 3.
		(function (item) {var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TIMELINE_T_DELAY * 2;

			setTimeout(function () {

				_this2.el.classList.remove('lock');

				if (item) {

					['before-animate-out', 'animate-out', TIMELINE_T_DIR_FORWARD, TIMELINE_T_DIR_BACKWARD].forEach(function (c) {return item.classList.remove(c);});

				}

			}, delay);

		})(prevItem);

		return this;

	},

	resize: function resize(e) {

		this.updateUI();

	},

	/*
       	scroll(e, normalized) {
       
       		// const isInView = util.checkInView(this.el);
       
       		// if (isInView && document.activeElement !== this.refs.dummyInput) {
       
       		// 	// this enables keyboard event
       		// 	this.refs.dummyInput.focus();
       
       		// }
       	},
       	*/

	getInternalProps: function getInternalProps() {

		return {
			defaultId: 0 };


	},

	getInternalState: function getInternalState() {

		return {
			currentId: -1,
			prevId: void 0 };


	} };exports.default =



Timeline;

},{"../../framework":72}],62:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });







var _framework = require('../../framework');

var handleCustomPopup = function handleCustomPopup(popup, active) {var textToDisplay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

	if (!popup) {
		return new Error('popup can\'t be null or undefiend');
	}

	var errorEl = popup.querySelector('.api-error');
	var inner = popup.querySelector('.inner');

	// display error message
	if (errorEl) {
		errorEl.innerHTML = textToDisplay;
	}

	if (inner) {
		inner.scrollTop = 0;
	}

	popup.classList[active ? 'add' : 'remove']('active');

	return false;
}; /**
   * Use rform
   * Used for
   * UpdateAccount
   * ForgotPassword
   * UserRegistration
   */var UserForm = { refs: {}, /**
                                 * When mounted
                                 *
                                 * start writing scrip here for this module
                                 */mounted: function mounted() {var _this = this;var

		type = this.props.type;
		var popupEl = this.el.getElementsByClassName('simple-popup')[0];

		this.refs = {
			form: this.el.getElementsByTagName('form')[0],
			buttons: this.el.getElementsByClassName('btn'),
			currentPopup: void 0,
			popup: _framework.ModuleManager.getInstance().getModuleById(popupEl ? popupEl.getAttribute('mid') : null) };


		// forgot passwor form
		if (type === 'forgot-password') {

			var forgotPasswordForm = this.el.getElementsByTagName('form')[0];
			var forgotPasswordSubmit = this.el.querySelector('input[type=submit]');

			forgotPasswordForm.addEventListener('submit', this.formSubmitHandler.bind(this));

		}

		// user registration
		if (type === 'user-registration') {

			// sitecore form inputs, placeholder
			var capcha = this.el.querySelector('.g-recaptcha');

			// check grecaptcha and its load
			if (capcha) {
				this.el.classList.add('has-capcha');

				/* not used with invisible captcha
                                                                              				// register handler to clear interval before reload
                                                                              				window.addEventListener('beforeunload', () => {
                                                                              					window.removeEventListener('beforeunload');
                                                                              					clearInterval(this.cslRecapchatInterval);
                                                                              				}, false);
                                                                              
                                                                              				// https://developers.google.com/recaptcha/docs/display
                                                                              				this.cslRecapchatInterval = setInterval(() => {
                                                                              					if (window.grecaptcha) {
                                                                              						this.setState({
                                                                              							hasCapcha: true,
                                                                              							grecaptchaLoaded: true,
                                                                              						}, false);
                                                                              					}
                                                                              
                                                                              					// check recapcha state
                                                                              					// submit button will be disabled till capcah is passed when it is present.
                                                                              					// Note, local environment will not send the form value correctly. so test in dev.
                                                                              					// when grecaptcha is loaded, check response.
                                                                              					if (this.state.grecaptchaLoaded && window.grecaptcha.getResponse().length !== 0) {
                                                                              						// show/enable submit button
                                                                              						this.el.classList.add('recapcha-success');
                                                                              					} else {
                                                                              						this.el.classList.remove('recapcha-success');
                                                                              					}
                                                                              
                                                                              				}, 750);
                                                                              */
			}

		}

		// all input change handle
		var allInputs = this.el.getElementsByTagName('input');
		var inputChangeHanlder = function inputChangeHanlder(e) {
			var input = e.target;

			if (input.type === 'checkbox') {
				// find target data-change-bind
				// when checkbox is checked, set active on target button/submit
				var targetClass = input.getAttribute('data-change-bind');
				var targetEl = _this.el.querySelector('.' + targetClass);
				targetEl.disabled = !input.checked;
			}
		};

		for (var i = 0; i < allInputs.length; i++) {
			var input = allInputs[i];

			if (input.hasAttribute('data-change-bind')) {
				input.addEventListener('change', inputChangeHanlder);
			}
		}

		this.el.addEventListener('click', this.clickHandler.bind(this));

		// find js-show-on-pageload element to show(active) upon page load
		setTimeout(function () {
			var initialPopupContent = _this.el.getElementsByClassName('js-show-on-pageload')[0];

			if (initialPopupContent && _this.refs.popup) {
				_this.refs.popup.setState({
					active: true,
					contentName: 'default popup',
					content: initialPopupContent.innerHTML });

			}
		}, 250);
	},

	/**
        * Form submit handler.
        * Currently using for Forgotpassword form
        * @param {FormEvent}
        */
	formSubmitHandler: function formSubmitHandler(e) {var _this2 = this;

		// prevent submit
		e.preventDefault();

		var forgotPasswordForm = this.refs.form;
		var formData = new FormData(forgotPasswordForm);

		var CurrentEmail = formData.get('UserEmailAddress');

		// form query string with formData to post
		var bodyData = '';
		var i = 0;

		// ignore
		var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {for (var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var pair = _step.value;
				if (i !== 0) {
					bodyData += '&';
				}

				// encode only value
				bodyData += pair[0] + '=' + encodeURIComponent(pair[1]);
				i++;
			}

			// fetch it instead
		} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}_framework.util.post(forgotPasswordForm.action, {
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				Accept: 'application/json, application/xml, text/plain, text/html, *.*',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },

			body: bodyData }).

		then(function (response) {return response.text();}).
		then(function (html) {

			// render html in the dom first
			var placeholder = _this2.el.querySelector('.js-placeholder');
			placeholder.innerHTML = html;

			// detect if view renders success or error
			// get the content to display
			// rendered/returned  ForgotPassword.cshtml
			var returnedView = placeholder.querySelector('.csl-form.forgot-password');
			var response = returnedView.getAttribute('data-response');

			// find swappable content from returned view
			// swap content & show it in this context
			_this2.el.querySelector('.swappable-content').innerHTML = returnedView.querySelector('.swappable-content').innerHTML || '';

			// empty placeholder otherwise, HTML validation error will occur(dup id elements)
			placeholder.innerHTML = '';

		}).
		catch(function (error) {
			console.log('Forgot password form submit error, ', error);
		});

		return false;
	},

	clickHandler: function clickHandler(e) {var _this3 = this;
		var t = e.target;
		var clickBind = t.getAttribute('data-click');
		var parentPopup = _framework.util.findParent(t, '.simple-popup', '.module');
		var formData = new FormData(this.refs.form);

		// show popup content of el.data-popup-content
		if (clickBind === 'showPopup') {

			e.preventDefault();

			var contentClass = t.getAttribute('data-popup-content');

			// find popup to show
			var targetContent = this.el.getElementsByClassName(contentClass)[0];

			this.refs.popup.setState({
				active: true,
				content: targetContent,
				contentName: contentClass,
				contentOriginalParent: targetContent.parentNode });

		}

		// handle partial API
		// call api(data-action)
		if (clickBind === 'deactivateUser') {

			// post these
			var url = t.getAttribute('data-action');
			var Email = formData.get('Email');
			var DeactivateCheckbox = formData.get('DeactivateCheckbox');
			var RequestVerificationToken = formData.get('__RequestVerificationToken');

			// from form data, we need to construct what's needed for API.
			var bodyData = 'Email=' + encodeURIComponent(Email);
			bodyData += '&Deactivate=' + (DeactivateCheckbox === 'on');
			bodyData += '&itemId=' + this.props.srcId;
			bodyData += '&__RequestVerificationToken=' + RequestVerificationToken;

			_framework.util.post(url, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					Accept: 'application/json, application/xml, text/plain, text/html, *.*',
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },

				body: bodyData }).

			then(function (response) {return response.json();}).
			then(function (response) {var

				Success = response.Success,_response$Message = response.Message,Message = _response$Message === undefined ? '' : _response$Message;

				if (Success) {

					// swap content with success message
					_this3.refs.popup.
					revertContent().
					setState({
						content: '<h4>' + Message + '</h4>',
						contentOriginalParent: void 0,
						exitCallBack: function exitCallBack(popup) {

							// when deactivation succeeded, reroute with given url
							window.location.href = _this3.context.props.rootURL;

						} });


				} else {

					// error mesage popup
					_this3.refs.popup.setMessage(Message);
				}
			}).
			catch(function (error) {
				console.log('error: ' + error);
			});
		}

		// call api(data-action)
		if (clickBind === 'updatePassword') {
			e.preventDefault();

			// post these
			var NewPassword = formData.get('NewPassword');
			var CurrentPassword = formData.get('CurrentPassword');
			var ConfirmNewPassword = formData.get('ConfirmNewPassword');
			var _Email = formData.get('Email');
			var _RequestVerificationToken = formData.get('__RequestVerificationToken');

			var _url = t.getAttribute('data-action');

			// string
			var _bodyData = 'Email=' + encodeURIComponent(_Email);
			_bodyData += '&Password=' + CurrentPassword;
			_bodyData += '&NewPassword=' + NewPassword;
			_bodyData += '&ConfirmNewPassword=' + ConfirmNewPassword;
			_bodyData += '&itemId=' + this.props.srcId;
			_bodyData += '&__RequestVerificationToken=' + _RequestVerificationToken;

			_framework.util.post(_url, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					Accept: 'application/json, application/xml, text/plain, text/html, *.*',
					'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8' },

				body: _bodyData }).

			then(function (response) {return response.json();}).
			then(function (response) {var

				Success = response.Success,_response$ErrorMessag = response.ErrorMessage,ErrorMessage = _response$ErrorMessag === undefined ? '' : _response$ErrorMessag;

				// whether Success is true or not, we display the value of ErrorMessage.
				if (Success) {

					// swap content with success message
					_this3.refs.popup.
					revertContent().
					setState({
						content: '<h4>' + ErrorMessage + '</h4>',
						contentOriginalParent: void 0 });


				} else {
					_this3.refs.popup.setMessage(ErrorMessage);
				}
			}).
			catch(function (error) {
				console.log('error: ' + error);
			});
		}

	},

	getInternalProps: function getInternalProps() {
		return {};
	},

	getInternalState: function getInternalState() {
		return {
			/* not used
                 		hasCapcha: false, // boolean: if capcha exist
                 		grecaptchaLoaded: false, // boolean: if capcha loaded
                 */};


	} };exports.default =



UserForm;

},{"../../framework":72}],63:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * Popup - brightcove video player
                                                                            *
                                                                            * use:
                                                                            * class="module video-brightcove" data-name="video-brightcove"
                                                                            *
                                                                            * related src:
                                                                            * view: Views/CSLShared/Shared/Controls/_BasicVideo.cshtml
                                                                            *
                                                                            */

var VideoBrightcove = {

	refs: {},

	/**
                      * When mounted
                      */
	mounted: function mounted() {
		this.loadBrightCoveScript();
	},

	loadBrightCoveScript: function loadBrightCoveScript() {var
		brightcoveinstalled = this.context.state.brightcoveinstalled;
		if (this.context.props.brightcoveURL.length > 0 && !brightcoveinstalled)
		{
			this.context.state.brightcoveinstalled = true;
			var script = document.createElement('script');
			script.src = this.context.props.brightcoveURL;
			document.body.appendChild(script);
		}
	},

	// when internal state changes
	onStateUpdate: function onStateUpdate() {},

	// setting internal state
	getInternalState: function getInternalState() {
		return {};
	} };exports.default =


VideoBrightcove;

},{}],64:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * Video
                                                                            *
                                                                            * see documentation for details(https:// plyr.io/)
                                                                            * In order to custimize video player styles, look at both custom style sheets
                                                                            *
                                                                            * Caption: VTT support
                                                                            *
                                                                            * use:
                                                                            * class="module mosaic" data-name="mosaic"
                                                                            *
                                                                            * related src:
                                                                            * css: app/styles/modules/_video.scss
                                                                            *
                                                                            * currently being used in these other modules.
                                                                            *
                                                                            * Views/CSLShared/Modules/_HomeHeroEntry.cshtml
                                                                            * Views/CSLShared/Modules/Article/_ArticleVideo.cshtml
                                                                            * Views/CSLShared/Shared/_VideoModal.cshtml
                                                                            *
                                                                            * Sample html
                                                                            
                                                                              <div class="module video" data-name="video" data-autoplay="true">
                                                                                  <div class="video__container">
                                                                                      <video class="video-player csl-skin" width="100%" height="100%" poster="" data-eventname="">
                                                                                          <source src="" type="video/mp4">
                                                                                          <track kind="subtitles" srclang="en" src="">
                                                                                      </video>
                                                                                  </div>
                                                                              </div>
                                                                            
                                                                            *
                                                                            * video data sample:
                                                                            *
                                                                            * {
                                                                                CallToActionButtonLink,
                                                                                CallToActionButtonText,
                                                                                CallToActionButtonTracking,
                                                                                Duration,
                                                                                File,
                                                                                Headline,
                                                                                Text,
                                                                                Image,
                                                                                PlayButtonEventTracking,
                                                                            	VideoId,
                                                                            	Caption,
                                                                            * }
                                                                            *
                                                                            */

//included directly in layout
//import Plyr from 'plyr';

// propType
var VideoProps = {
	name: 'video', // string
	autoplay: false, // boolean
	isInline: false, // boolean
	video: '' // string. uri to API to fetch video data
};

var Video = {

	refs: {},

	/**
                      * When mounted
                      *
                      * start writing scrip here for this module
                      */
	mounted: function mounted() {var _this = this;

		if (typeof Plyr == "undefined")
		{
			return;
		}var _props =




		this.props,autoplay = _props.autoplay,isInline = _props.isInline;

		// check IOS devices
		var browserVer = this.context.props.browserVer;
		var isIOS = browserVer.match('ios') !== null;
		var isIE = browserVer.match('ie') !== null;
		var videoEl = this.el.getElementsByTagName('video')[0];
		var supported = Plyr.supported('video', 'html5', true);

		this.setState({
			isIOS: isIOS,
			isIE: isIE },
		false);

		// set plyr options
		var videoOptions = {
			controls: ['play-large', 'play', 'progress', 'mute', 'fullscreen', 'captions'],
			autoplay: false, //isIOS ? false : autoplay,
			clickToPlay: true,
			loadSprite: true,
			iconUrl: '/app/common/etc/plyr.svg', // get the video related asset(svg icons)
			captions: {
				active: {
					active: true,
					language: window.navigator.language ? window.navigator.language.split('-')[0] : 'en' } } };




		var poster = this.el.getAttribute('data-poster');
		this.refs = {
			videoEl: videoEl,
			plyr: new Plyr(videoEl, videoOptions), // this version requires url-polyfill. See package.json
			poster: poster };


		// See https:// github.com/Selz/plyr#events
		// Video events
		if (this.refs['plyr']) {
			['ready', 'play', 'playing', 'pause', 'ended'].forEach(function (e) {return _this.refs['plyr'].on(e, _this.videoEventHandler.bind(_this));});
		}

		// check plyr embeds inline styles.
		var inlineEl = document.getElementById('sprite-plyr');

		if (inlineEl) {
			var removalble = ['style', 'title'];
			var t = Array.from(document.getElementById('sprite-plyr').children).
			filter(function (tag) {return removalble.indexOf(tag.tagName.toLowerCase()) !== -1;}).
			forEach(function (tag) {return inlineEl.removeChild(tag);});
		}

		// when this is used as inline mode
		if (isInline && this.refs.plyr) {
			try {
				this.playWithFetch(this.props.video);
			} catch (error) {
				console.log(error);
			}
		}
	},

	/**
        * Video events handler
        * see documentation for details(https:// plyr.io/)
        *
        * @param  {[Event]} e [Video events]
        */
	videoEventHandler: function videoEventHandler(e) {
	},

	/**
        * requires service call with given end point to fetch video data
        * @param  {[Object]} args [videoId,....]
        */
	playWithFetch: function playWithFetch() {var _this2 = this;

		var videoId = arguments.length <= 0 ? undefined : arguments[0];

		// remove quote strings
		videoId = videoId.replace(/("|')+/g, '');

		// production end point
		var videoService = '/video-api/videodetails?videoid=' + videoId;
		var uri = videoService;

		fetch(uri, {
			method: 'get',
			credentials: 'same-origin',
			cache: 'default' }).

		then(function (res) {return res.json();}).
		then(function (videoData) {

			if (Object.prototype.hasOwnProperty.call(videoData, 'VideoId')) {

				// set
				_this2.setState({
					videoData: videoData,
					shoudTrackVideo: true,
					isPlaying: true,
					videoLoaded: false,
					videoPlayed: false,
					videoEnded: false });


			} else {

				console.log('Video error, video id is missing.');

			}

		}).
		catch(function (e) {

			console.log(e);

		});


	},

	/**
        * Play with youtube id
        * @param  {[String]} vid                 [youtube video id]
        * @param  {String} [videoType='youtube'] [video type. default is youtube]
        */
	playYoutube: function playYoutube(vid) {var videoType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'youtube';

		var videoData = {
			VideoId: vid,
			videoType: videoType };


		this.setState({
			videoData: videoData,
			shoudTrackVideo: true,
			videoLoaded: false,
			videoPlayed: false,
			videoEnded: false,
			isPlaying: true });


	},

	/**
        * Play with data object.
        *
        * @param  {[Object]} videoData [use data sample to see object structure ]
        * @return {[type]}           [description]
        */
	playWithData: function playWithData(videoData) {

		this.setState({
			videoData: videoData,
			isPlaying: true });


	},

	stop: function stop() {

		if (this.refs.plyr) {

			this.refs.plyr.stop();
			this.refs.videoEl.innerHTML = '';

		}

		this.setState(this.getInternalState(), false);

	},

	/**
        * When internal state changes
        *
        * @param  {[type]} prevState [previous internal state]
        * @param  {[type]} state     [current internal state]
        */
	onStateUpdate: function onStateUpdate() {var


		videoData =
		this.state.videoData;

		if (this.prevState.videoData !== videoData) {var


			CallToActionButtonLink =











			videoData.CallToActionButtonLink,CallToActionButtonText = videoData.CallToActionButtonText,CallToActionButtonTracking = videoData.CallToActionButtonTracking,Duration = videoData.Duration,File = videoData.File,Headline = videoData.Headline,Text = videoData.Text,Image = videoData.Image,PlayButtonEventTracking = videoData.PlayButtonEventTracking,VideoId = videoData.VideoId,Caption = videoData.Caption,videoType = videoData.videoType;var _refs =

			this.refs,videoEl = _refs.videoEl,plyr = _refs.plyr,poster = _refs.poster;

			if (typeof plyr == "undefined")
			{
				return;
			}

			// gert srclang
			var srclang = window.navigator.language ? window.navigator.language : this.context.props.locale;
			srclang = srclang.split('-')[0];

			// check video type
			var type = videoType;
			if (!type) {
				var isMp4 = /(mp4)/.exec(File);
				type = isMp4 ? 'video/mp4' : 'youtube';
			}

			if (this.refs.plyr.currentTime !== 0 || this.refs.plyr.playing) {
				this.refs.plyr.pause();
			}

			// plyr set source
			// ~IE or IOS
			if (this.state.isIE ||
			this.state.isIOS) {

				// for IE/IOS, do not use source tag
				videoEl.src = File;

				// append track(caption)
				videoEl.innerHTML = '';

				// caption
				if (Caption) {
					var trackEl = document.createElement('track');
					trackEl.kind = 'captions';
					trackEl.srclang = srclang;
					trackEl.src = Caption;
					trackEl.default = true;

					videoEl.appendChild(trackEl);
				}

				// in IOS, autoplay is set false
				if (this.props.autoplay) {
					plyr.play();
				}

			} else {

				// non IOS/IE10/11,Edge
				// user setter source
				plyr.source = {
					type: 'video',
					poster: poster,
					title: Headline || '',
					sources: [
					{
						src: File,
						type: type }],


					tracks: [
					{
						kind: 'captions',
						label: 'English',
						srclang: srclang,
						src: Caption,
						default: true }] };




			}

			this.resize();
		}

	},

	// override to do nothing
	resize: function resize() {},

	getInternalState: function getInternalState() {

		// default false
		return {
			videoData: void 0, // object: see data sample
			shoudTrackVideo: false, // boolean: video tracking
			videoLoaded: false, // boolean: video loads successfully
			videoPlayed: false, // boolean: if video played at least once
			videoEnded: false, // boolean: video ended or not
			isPlaying: false // boolean: video is playing or not
		};

	} };exports.default =


Video;

},{}],65:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });






var _framework = require('../framework');


var _modules = require('./../common/modules');var commonModules = _interopRequireWildcard(_modules);


var _modules2 = require('./modules');var cslModules = _interopRequireWildcard(_modules2);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}

// This object inherits AppProto for shared functionalities.See app - proto.js
// shared module list
var App = _framework.Proto.create(_framework.AppProto, {
	// set modules to load. Combine common + project specific ones
	modules: Object.assign(commonModules, cslModules),

	// all life cycle fiinshed
	mount: function mount() {

		// ready
		// console.log(this.props);

	} }); // target modules for this project
/*
* App(CSL Root)
*
* 
*/ // dependencies
exports.default = App;

},{"../framework":72,"./../common/modules":38,"./modules":67}],66:[function(require,module,exports){
'use strict';





require('babel-polyfill');
require('isomorphic-fetch');
require('es6-promise');
require('formdata-polyfill');
require('url-polyfill');


require('./../framework/custom-polyfill');

var _app = require('./app');var _app2 = _interopRequireDefault(_app);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}


// Dom ready
// custom polyfills
document.addEventListener('DOMContentLoaded', function () {
  _app2.default.init();

}); /*
    * entry
    *
    */ // polyfills(must be at the top)

},{"./../framework/custom-polyfill":71,"./app":65,"babel-polyfill":80,"es6-promise":406,"formdata-polyfill":407,"isomorphic-fetch":408,"url-polyfill":411}],67:[function(require,module,exports){
"use strict";Object.defineProperty(exports, "__esModule", { value: true });

},{}],68:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /*
                                                                            * Globals Constants(view mode, breakpoints...)
                                                                            *
                                                                            * For screen sizes, please look at _base.scss to reference. Both should match.
                                                                            *
                                                                            * 
                                                                            */

// See _base.scss to see what's defined
var BP = exports.BP = {
	SIZE_XXL: 1600,
	SIZE_XL: 1440,
	SIZE_LG: 1200,
	SIZE_MD: 1024,
	SIZE_SM: 768,
	SIZE_XS: 480,
	SIZE_XXS: 320,
	SIZE_0: 0 };


// global events
var CUSTOM_EVENT = exports.CUSTOM_EVENT = {
	SIDEBAR: 'sidebar',
	VIDEO: 'video',
	SHOW_SEARCH: 'show-search' };


// window orientation
var ORIENTATION = exports.ORIENTATION = {
	DEVICE_PORTRAIT: 'portrait',
	DEVICE_LANDSCAPE: 'landscape' };


/**
                                                                     * type checking reference to perform regular expression
                                                                     */
var LINK_TYPES = exports.LINK_TYPES = [
// images
{
	reg: /.(jpg|png|gif|svg)(\/)?$/i,
	type: 'image' },


// playable media type
{
	reg: /.(mp4|m4v)$/i,
	type: 'mp4' },


// doc type
{
	reg: /.(pdf|docx|xlt|xls|xml)$/i,
	type: 'document' },


// simple external link
{
	//  reg: /^(?:[a-zA-Z]+):/i,
	reg: /^(https?)/i,
	type: 'external' },


// youtube
{
	reg: /^(http(s)??\:\/\/)?(www\.)?((youtube\.com\/watch\?v=)|(youtu.be\/))([a-zA-Z0-9\-_])+$/,
	type: 'youtube' }];

},{}],69:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /*
                                                                            * Analytic function
                                                                            *
                                                                            * how to use(examples)
                                                                            * // event
                                                                              updateAnalytic.call(null, 'event', {
                                                                               hitType: 'event',
                                                                               eventCategory : 'cta',
                                                                               eventAction : 'click',
                                                                               eventLabel: eventLabel
                                                                               eventValue: val
                                                                              });
                                                                            
                                                                              updateAnalytic.call(null, 'event', {
                                                                               hitType: 'event',
                                                                               eventCategory : 'video',
                                                                               eventAction : 'playing' ,
                                                                               eventLabel: this.props.File,
                                                                               eventValue: val,
                                                                               nonInteraction: true
                                                                              });
                                                                            
                                                                              // analytic(set page)
                                                                              updateAnalytic.call(null, 'page', window.location.pathname, 'set')
                                                                              updateAnalytic.call(null, 'title', this.props.name, 'set');
                                                                              updateAnalytic.call(null, 'pageview');
                                                                            
                                                                              -- Used in search-result.js
                                                                            * 
                                                                            */

var updateAnalytic = function updateAnalytic(type) {var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};var action = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'send';
  if (typeof window.ga !== 'undefined') {
    window.ga(action, type, field);
    //console.log("updateAnalytic:"+action+", "+type+", "+field);
  }
};exports.default =

updateAnalytic;

},{}],70:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });






var _lodash = require('lodash');var _lodash2 = _interopRequireDefault(_lodash);

var _browserDetect = require('browser-detect');var _browserDetect2 = _interopRequireDefault(_browserDetect);

var _enum = require('../enum');
var _action = require('../action');
var _index = require('./index');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} //import normalize from 'normalize-wheel';

var App = {

	el: void 0,

	modules: {}, // empty by default

	/**
  * Initialize App
  */
	init: function init() {var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

		// default props, states
		// See actions(/scrips/action)
		this.prevState = void 0;
		this.state = _action.appActions.getDefaultAppState();

		// check browser version
		var _Browser = (0, _browserDetect2.default)(),name = _Browser.name,versionNumber = _Browser.versionNumber;
		var browserVer = (name + '-' + parseInt(versionNumber, 10)).toLowerCase();

		// document body
		var rootEl = document.getElementById('root');
		var classes = rootEl.classList;
		rootEl.classList.add(browserVer); //used for IE exceptions in CSS

		this.props = Object.assign({}, _action.appActions.getDefaultProps(), {
			el: rootEl,
			bodyClasses: classes,
			browserVer: browserVer,
			rootURL: rootEl.getAttribute('data-root-url') || window.location.origin,
			theme: rootEl.getAttribute('data-theme'),
			brightcoveURL: rootEl.getAttribute('data-brightcove-url'),
			dataPageId: rootEl.getAttribute('data-pageid'),
			locale: rootEl.getAttribute('data-locale'),
			userLogin: rootEl.classList.contains('logged-in'),
			touchSupport: document.documentElement.classList.contains('touchevents') || 'ontouchstart' in document.documentElement });


		// reassign el
		this.el = this.props.el;
		delete this.props.el;

		// App composition(life cycle)
		_index.util.cp('fetch', 'initModule', 'initEvent', 'beforeMount', 'mount')(this);

		return this;

	},

	// empty, fill this to load initial data, if nec
	fetch: function fetch() {

		return this;

	},

	/**
        * Init all modules/components in the page
        */
	initModule: function initModule() {

		this.moduleManager = _index.ModuleManager.getInstance().init({
			context: this,
			modules: this.modules,
			className: ['module', 'ui-component'] });


		// clear
		delete this.modules;

	},

	/**
        * Init App level events
        */
	initEvent: function initEvent() {var _this = this;

		window.addEventListener('resize', _lodash2.default.debounce(this.resize.bind(this), 300), false);
		document.addEventListener('scroll', _lodash2.default.throttle(this.scroll.bind(this), 150));
		window.addEventListener('keydown', this.keyBoardHandler.bind(this));
		this.el.addEventListener('click', this.clickHandler.bind(this));

		// page visibility
		_index.util.pageVisibility(function () {for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}var

			isPageHidden = args[0];
			_this.setState(_action.appActions.pageVisibilityChange(isPageHidden));

		});

	},

	/**
        * When mounted. Similar to onRender or componentDidMount
        */
	beforeMount: function beforeMount() {

		// subscribers(modules)
		this.moduleManager.children.forEach(function (m) {return m.mounted();});

		// detect hero type -> set the header mode
		var heroTypes = ['home-hero', 'hero', 'internal-hero', 'hero-carousel', 'news-hub', 'has-hero-image', 'hero-large', 'js-hero'];
		var allModules = this.moduleManager.children.slice(0);
		var heroTypeMatch = allModules.filter(function (m) {

			var classes = m.el.className.split(/\s/);

			return classes.some(function (c) {return heroTypes.includes(c);});

		});

		var hasHero = heroTypeMatch.length !== 0;

		this.setState({ hasHero: hasHero }, false);
		this.el.classList[hasHero ? 'remove' : 'add']('no-hero');

		// set main element as "mainContent". This will be anchored by skip-to-content banner
		// const mainContentArea = document.getElementsByTagName('main')[0];
		// mainContentArea.id = 'mainContent';

		// call resize & scroll
		setTimeout(function () {

			window.dispatchEvent(_index.util.createEvent('resize'));
			document.dispatchEvent(_index.util.createEvent('scroll'));

		}, 500);

	},

	/**
        * general click handler
        * Globally, links are the trigger to global features, such as video popup, marketo forms, download gated etc.
        * All handled here mostly. Make sure each module, components don't stop propagation otherwise it won't reach here.
        * Use preventDefault and check defaultPrevented flag.
        *
        * @param  {[MouseEvent]} e [MouseEvent on link click globally]
        */
	clickHandler: function clickHandler(e) {

		var t = e.target;

		if (t && (t.tagName === 'A' || t.tagName === 'IMG')) {

			// /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/gmi.test(t.href)
			var isVideo = t.hasAttribute('data-youtubevideoid') || t.hasAttribute('data-video-id') || t.classList.contains('js-media');
			var isBrightcoveVideo = t.hasAttribute('data-brightcoveplayer');

			var shouldTriggerConfirm = t.getAttribute('data-confirm');

			var popup = {};

			if (isVideo) {

				var REG = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/i;

				e.preventDefault();
				popup = {
					type: 'video',
					videoId: t.getAttribute('data-youtubevideoid') || t.href.match(REG)[2] };


				this.setState(_action.appActions.showPopup(popup));
			} else
			if (isBrightcoveVideo) {
				var playerID = t.getAttribute('data-brightcoveplayer');
				var playerEl = this.el.querySelector('#' + playerID);
				var playerModule = playerEl ? _index.ModuleManager.getInstance().getModuleById(playerEl.getAttribute('mid')) : null;
				if (playerModule != null) {
					playerModule.setState({ active: true });
				}
			}

			// confirmation
			if (shouldTriggerConfirm && !(t.matches('a.ui-social') || t.matches('a.ui-social-image'))) {
				e.preventDefault();

				// ignore editor warning
				if (window.confirm(shouldTriggerConfirm)) {
					var url = t.getAttribute('data-url') ? t.getAttribute('data-url') : t.getAttribute('href');
					var target = t.getAttribute('target') ? t.getAttribute('target') : '_blank';
					_index.util.gaSendEvent('Link', 'Outbound Link Click', url, 1);

					window.open(url, target);
				}
			}

		}

		// reset ui selector in the footer when click ouside
		var isFooterOrChildren = _index.util.findParent(t, '.footer', '.footer');
		if (!t.matches('.ui-selector-label') && isFooterOrChildren) {

			var uiSelectorInFooterEl = this.el.querySelector('.footer .ui-selector');
			var uiSelectorInFooter = uiSelectorInFooterEl ? _index.ModuleManager.getInstance().getComponentById(uiSelectorInFooterEl.getAttribute('cid')) : null;

			if (uiSelectorInFooter) {

				uiSelectorInFooter.reset();

			}

		}

		// since header became only interactive with "touch" & click, we need to close it when outside of it clicked
		// See Header.js
		if (!e.defaultPrevented) {

			var header = _index.ModuleManager.getInstance().getModulesByName('header')[0];

			if (header) {

				header.reset();

			}

		}

	},

	/**
        * Global Keyboard handler
        */
	keyBoardHandler: function keyBoardHandler(e) {

		var code = e.keyCode;

		switch (code) {

			case 27:

				// ESC, close modal && search module in case open
				this.setState({
					modal: null,
					searchProps: {
						active: false,
						target: this.searchModuleOverlay ? this.searchModuleOverlay.state.target : void 0 } });



				// close header
				var header = _index.ModuleManager.getInstance().getModulesByName('header')[0];

				if (header) {

					header.reset();

				}

				break;

			default:
			// nothing
		}


	},

	// event delegating to page, components in app
	resize: function resize(e) {

		var bp = _index.util.detectViewMode(_enum.BP);

		if (bp !== this.state.bp) {

			this.setState(_action.appActions.bpChange(bp));

		}

		this.moduleManager.children.forEach(function (m) {

			if (typeof m.resize === 'function') {

				m.resize(e);

			}

		});
		this.moduleManager.components.forEach(function (c) {

			if (typeof c.resize === 'function') {

				c.resize(e);

			}

		});

	},

	/**
        * Scroll Handler
        *
        * event delegating to page, moduels/components in app
        * @param  {[Event]} e [description]
        */
	scroll: function scroll(e) {

		this.setState(_action.appActions.scrollTopChange(document.documentElement.scrollTop || document.body.scrollTop), false);

		this.moduleManager.children.forEach(function (m) {

			if (typeof m.scroll === 'function') {

				//m.scroll(e, normalize(e));
				m.scroll(e);

			}

		});

	},

	/**
        * This method updates any state change and subsequently calls onStateUpdate method if exist to handle post-change state.
        * This is similar to any type of "reducer"
        *
        * See actions(scripts/action)
        *
        * @param  {Object} newStates - incoming new states
        * @param  {Boolean} notifyUpdate - flag whether onStateUpdate method gets called or not
        */
	setState: function setState(action) {var notifyUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

		var s = Object.assign({}, this.state);

		switch (action.type) {

			case _action.appActions.APP_BP_CHANGE:
				Object.assign(s, { bp: action.bp });
				break;

			case _action.appActions.APP_SCROLL_TOP_CHANGE:
				Object.assign(s, { scrollTop: action.scrollTop });
				break;

			case _action.appActions.APP_PAGE_VISIBILITY:
				Object.assign(s, { isPageHidden: action.isPageHidden });
				break;

			case _action.appActions.APP_SHOW_SEARCH:
				Object.assign(s, { searchProps: action.searchProps });
				break;

			case _action.appActions.APP_SIDEBAR:
				Object.assign(s, { isSidbarActive: action.isSidbarActive });
				break;

			case _action.appActions.APP_POPUP:
				Object.assign(s, { popup: action.content });
				break;

			case _action.appActions.APP_LANG_SELECTOR:
				Object.assign(s, { isLangSelectorActive: action.isLangSelectorActive });
				break;

			default:
			// nothing
		}


		this.prevState = this.state;
		this.state = s;

		if (notifyUpdate && !_index.util.compareObjects(this.prevState, this.state)) {

			this.onStateUpdate(this.prevState, this.state);

		}

	},

	/**
        * handler method that handles post-state update.
        */
	onStateUpdate: function onStateUpdate(prevState, state) {var _state =









		this.state,isSidbarActive = _state.isSidbarActive,isLangSelectorActive = _state.isLangSelectorActive,isPageHidden = _state.isPageHidden,searchProps = _state.searchProps,bp = _state.bp,popup = _state.popup,scrollTop = _state.scrollTop;

		// set sidebar internal state
		var sidebar = _index.ModuleManager.getInstance().getModulesByName('sidebar')[0];
		var searchModuleOverlay = _index.ModuleManager.getInstance().getModulesByName('search-overlay').filter(function (m) {return !m.state.isInline;})[0];
		var globalSelector = _index.ModuleManager.getInstance().getModulesByName('global-selector').filter(function (m) {return !m.state.isInline;})[0];

		if (!this.popup) {

			this.popup = _index.ModuleManager.getInstance().getModulesByName('popup')[0];

		}

		// viewmodeUpdate(bp)
		if (this.prevState.bp !== bp) {

			this.moduleManager.children.forEach(function (m) {

				if (typeof m.viewmodeUpdate === 'function') {

					m.viewmodeUpdate();

				}

			});

		}

		// page visibility
		if (this.prevState.isPageHidden !== isPageHidden) {

			this.moduleManager.children.forEach(function (m) {

				if (typeof m.pageVisibilityChange === 'function') {

					m.pageVisibilityChange(isPageHidden);

				}

			});

		}

		// side bar
		if (this.prevState.isSidbarActive !== isSidbarActive && sidebar) {

			this.el.classList[isSidbarActive ? 'add' : 'remove']('sidebar-active');
			sidebar.setState({ isActive: isSidbarActive });

		}

		// popup
		if (this.prevState.v !== popup) {

			this.popup.setState({
				active: popup !== null,
				content: popup });


		}

		// global selector
		if (this.prevState.isLangSelectorActive !== isLangSelectorActive) {
			this.el.classList[isLangSelectorActive ? 'add' : 'remove']('lang-selector-active');

			if (globalSelector) {
				globalSelector.setState({ isActive: isLangSelectorActive });
			}
		}

		// search
		if (this.prevState.searchProps !== searchProps) {var


			active =


			searchProps.active,keyword = searchProps.keyword,target = searchProps.target;

			if (searchModuleOverlay) {

				this.el.classList[active ? 'add' : 'remove']('search-active');

				if (active) {

					this.state.lastScrollTop = scrollTop;

				} else {

					document.documentElement.scrollTop = this.state.lastScrollTop;
					document.body.scrollTop = this.state.lastScrollTop;

				}

				if (!Object.prototype.hasOwnProperty.call(this, 'searchModuleOverlay')) {

					this.searchModuleOverlay = searchModuleOverlay;

				}

				searchModuleOverlay.setState({
					active: active,
					keyword: keyword,
					target: target });


			}

		}

		// subscribers
		this.moduleManager.children.forEach(function (m) {return m.update(prevState, state);});

	} }; /*
      * App Proto
      *
      * not using jquery 
      */ // dependencies
exports.default = App;

},{"../action":2,"../enum":68,"./index":72,"browser-detect":81,"lodash":"lodash"}],71:[function(require,module,exports){
'use strict'; /*
              * Custom polyfill.
              *
              * Note, Current Ariba.com uses polyfills based on es2015.
              * Other javascripts features that are either experiental or not a part of the current preset,
              * those must be polyfilled here.
              *
              * 
              */


//Element.prototype.matches polyfill
if (!Element.prototype.matches) {
	Element.prototype.matches =
	Element.prototype.matchesSelector ||
	Element.prototype.mozMatchesSelector ||
	Element.prototype.msMatchesSelector ||
	Element.prototype.oMatchesSelector ||
	Element.prototype.webkitMatchesSelector ||
	function (s) {
		var matches = (this.document || this.ownerDocument).querySelectorAll(s),
		i = matches.length;
		while (--i >= 0 && matches.item(i) !== this) {}
		return i > -1;
	};
}

//
//String.prototype.endsWith polyfill
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString, position) {
		var subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position -= searchString.length;
		var lastIndex = subjectString.lastIndexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}


//IE 9,10,11, custom event polyfill
(function () {

	if (typeof window.CustomEvent === "function") return false;

	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: undefined };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();


// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
	Object.defineProperty(Array.prototype, 'includes', {
		value: function value(searchElement, fromIndex) {

			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			// 1. Let O be ? ToObject(this value).
			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If len is 0, return false.
			if (len === 0) {
				return false;
			}

			// 4. Let n be ? ToInteger(fromIndex).
			//    (If fromIndex is undefined, this step produces the value 0.)
			var n = fromIndex | 0;

			// 5. If n ≥ 0, then
			//  a. Let k be n.
			// 6. Else n < 0,
			//  a. Let k be len + n.
			//  b. If k < 0, let k be 0.
			var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

			function sameValueZero(x, y) {
				return x === y || typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y);
			}

			// 7. Repeat, while k < len
			while (k < len) {
				// a. Let elementK be the result of ? Get(O, ! ToString(k)).
				// b. If SameValueZero(searchElement, elementK) is true, return true.
				if (sameValueZero(o[k], searchElement)) {
					return true;
				}
				// c. Increase k by 1.
				k++;
			}

			// 8. Return false
			return false;
		} });

}

},{}],72:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.ModuleManager = exports.AppProto = exports.Proto = exports.iso = exports.swipe = exports.analytic = exports.util = undefined;




var _util = require('./util');var util = _interopRequireWildcard(_util);
var _analytic = require('./analytic');var _analytic2 = _interopRequireDefault(_analytic);
var _swipe = require('./swipe');var _swipe2 = _interopRequireDefault(_swipe);
var _iso = require('./iso');var _iso2 = _interopRequireDefault(_iso);
var _proto = require('./proto');var _proto2 = _interopRequireDefault(_proto);
var _appProto = require('./app-proto');var _appProto2 = _interopRequireDefault(_appProto);

var _moduleManager = require('./module-manager');var _moduleManager2 = _interopRequireDefault(_moduleManager);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}exports.


util = util;exports.
analytic = _analytic2.default;exports.
swipe = _swipe2.default;exports.
iso = _iso2.default;exports.
Proto = _proto2.default;exports.
AppProto = _appProto2.default;exports.

ModuleManager = _moduleManager2.default; //import imageLoader from './image-loader';
/*
* Framework Index
*
*/

},{"./analytic":69,"./app-proto":70,"./iso":73,"./module-manager":74,"./proto":75,"./swipe":76,"./util":77}],73:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });










var _isotopeLayout = require('isotope-layout');var _isotopeLayout2 = _interopRequireDefault(_isotopeLayout);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// factory function to return iso instance
exports.default = function (grid, option) {return new _isotopeLayout2.default(grid, option);}; /*
                                                                                               * Iso factory
                                                                                               * 
                                                                                               */ /**
                                                                                                   * dependency
                                                                                                   * See the site for more information
                                                                                                   * https://www.npmjs.com/package/isotope-layout
                                                                                                   */

},{"isotope-layout":"isotope-layout"}],74:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });







var _elemDataset = require('elem-dataset');var _elemDataset2 = _interopRequireDefault(_elemDataset);


var _proto = require('./proto');var _proto2 = _interopRequireDefault(_proto);
var _abstract = require('../common/modules/abstract');var _abstract2 = _interopRequireDefault(_abstract);
var _component = require('../common/component');var _component2 = _interopRequireDefault(_component);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// colleciton of instantiated module objs
/*
* Module Manager
* handles all modules here. Mediating event delegations, registeration, etc
*
* 
*/ //  System polyfill
var moduleInstances = []; // colleciton of instantiated component objs
// common dependencies
var uiComponentInstances = []; //  recursion checking string value and covert to type
var evalValue = function evalValue(val) {if (typeof val === 'string') {var sIndex = val.indexOf('[');

		// array like
		if (sIndex !== -1) {

			for (var i = sIndex; i < val.length; i++) {

				var s = val.charAt(i);
				if (s === ']') {

					val = val.replace(/("|'|\[|]$)/g, '');
					return val.split(',').map(function (ele) {return evalValue(ele);});

				}

			}

		} else if (val === 'true' || val === 'false') {

			// boo
			val = val === 'true';

		} else if (!Number.isNaN(+val)) {

			// number
			val = +val;

		} else if (val.indexOf('{') !== -1 && val.indexOf('}') !== -1 && val.indexOf(':') !== -1) {

			var obj = {};

			// object like
			val = val.replace(/({|})/g, '');
			var pair = val.split(':');
			obj[pair[0].trim()] = pair[1];

			return obj;

		}

	}

	return val;

};

/**
       * Add each module to reference, dom tree
       * Also See RegisteredModules(/module/index.js)
       *
       * @param  {HTMLElement} module dom element
       */
var addModule = function addModule(el, modules, context) {

	// Object assign won'be preditable in Safari with dataset & IE10
	var data = typeof el.dataset === 'undefined' ? (0, _elemDataset2.default)(el) : el.dataset;

	data = Object.getOwnPropertyNames(data).
	reduce(function (obj, key) {

		if (!Object.prototype.hasOwnProperty.call(obj, key)) {

			obj[key] = evalValue(data[key]);

		}

		return obj;

	}, {});

	var mName = data.name || 'undefined';

	var protoExist = Object.keys(modules).
	filter(function (mFile) {

		// replace - to UpperCase
		mName = mName.split('-').map(function (str) {return str.charAt(0).toUpperCase().concat(str.slice(1));}).join('');

		return mFile === mName;

	});

	if (protoExist.length) {

		var moduleProto = modules[protoExist.pop()];
		var option = { data: data, el: el, context: context, theme: context.props.theme };
		var moduleInstance = _proto2.default.create(_abstract2.default, moduleProto).init(option);

		moduleInstances.push(moduleInstance);

	}

};


var removeModule = function removeModule(module) {

	var fId = moduleInstances.findIndex(function (m) {return m === module;});

	if (fId !== -1) {

		moduleInstances.splice(fId, 1);

	} else {

		console.log('Module Manager, can\'t find module, ' + m);

	}

};
/**
       * this is ui level object(ui-filter, ...)
       * @param {[HTMLElement]} el [target dom element per each module object]
       */
var addComponent = function addComponent(el) {var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var props = typeof el.dataset === 'undefined' ? (0, _elemDataset2.default)(el) : el.dataset;

	props = Object.getOwnPropertyNames(props).reduce(function (obj, p) {

		if (!Object.prototype.hasOwnProperty.call(obj, p)) {

			obj[p] = evalValue(props[p]);

		}

		return obj;

	}, {});

	var c = _component2.default.create(props, el);
	if (c && Object.prototype.hasOwnProperty.call(c, 'init') && typeof c.init === 'function') {

		c.init();

	}

	uiComponentInstances.push(c);

};

/**
       * Find the single target component instance with component id
       * @param  {[String]} mId unique component id(cId).
       * @return {[Object]} module instance if found or undefined
       */
var getComponentById = function getComponentById(cId) {return cId ? uiComponentInstances.filter(function (c) {return c.cId === cId;}).pop() : undefined;};

/**
                                                                                                                                                                                                                                                                                                                       * Find the single target module instance with module id
                                                                                                                                                                                                                                                                                                                       * @param  {[String]} mId unique module id.
                                                                                                                                                                                                                                                                                                                       * @return {[Object]} module instance if found or undefined
                                                                                                                                                                                                                                                                                                                       */
var getModuleById = function getModuleById(mId) {return mId ? moduleInstances.filter(function (m) {return m.props.mId === mId;}).pop() : undefined;};

/**
                                                                                                                                                                                                                                                                                                              * Find the multiple target module instances with module name
                                                                                                                                                                                                                                                                                                              * @param  {[String]} name module name.
                                                                                                                                                                                                                                                                                                              * @return {[Array]} module instances if found
                                                                                                                                                                                                                                                                                                              */
var getModulesByName = function getModulesByName(mName) {return moduleInstances.filter(function (m) {return m.props.name === mName;});};

// module manager object
var moduleManager = {

	/**
                                            * init module obj with all target module dom elements
                                            * @return {[Object]} [self]
                                            */
	init: function init(props) {

		this.props = props || {};var _props =

		this.props,className = _props.className,modules = _props.modules;

		// init module obj with all target module dom elements
		className.
		reduce(function (elements, m) {return elements.concat(Array.prototype.slice.call(document.querySelectorAll('.' + m)));}, []).
		filter(function (el) {return !el.classList.contains('no-js') && !el.classList.contains('init');}).
		forEach(function (el) {

			if (el.classList.contains('module')) {

				addModule.call(null, el, modules, props.context);

			} else if (el.classList.contains('ui-component')) {

				addComponent.call(null, el, props.context);

			}

		});
		return this;

	},

	// expose private functions
	getModulesByName: getModulesByName,

	getModuleById: getModuleById,

	getComponentById: getComponentById,

	removeModule: removeModule,

	children: moduleInstances,

	components: uiComponentInstances,

	/**
                                                                      * check if active modueles is zero
                                                                      */
	isEmpty: function isEmpty() {

		return moduleInstances.length === 0;

	} };


// Singleton entity. This gets used in anywhere in app, so prevent multiple instances.
var ModuleSingle = function () {

	var instance = void 0;

	return {

		getInstance: function getInstance() {

			if (typeof instance === 'undefined') {

				instance = moduleManager;

			}

			return instance;

		} };



}(window);exports.default =

ModuleSingle;

},{"../common/component":4,"../common/modules/abstract":13,"./proto":75,"elem-dataset":405}],75:[function(require,module,exports){
"use strict";Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * Module Prototype
                                                                            *
                                                                            * 
                                                                            */

var Proto = {

	create: function create(proto, props) {

		var m = this.extend(proto, props);
		return m;

	},

	extend: function extend() {

		// delegation
		var obj = Object.create(this);

		// concat with extention
		for (var _len = arguments.length, extentions = Array(_len), _key = 0; _key < _len; _key++) {extentions[_key] = arguments[_key];}var _loop = function _loop(i) {

			var ext = extentions[i];

			Object.getOwnPropertyNames(ext).forEach(function (p) {

				obj[p] = ext[p];

			});};for (var i = 0; i < extentions.length; i++) {_loop(i);

		}

		return obj;

	} };exports.default =


Proto;

},{}],76:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true }); /**
                                                                            * dependency
                                                                            * See the site for more information
                                                                            * https://hammerjs.github.io/
                                                                            */

// included in layout.cshtml
//import Hammer from 'hammerjs';
exports.default =
function (container, callBack) {var threshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;var gesture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'swiperight swipeleft';

	var h = new Hammer(container, {});

	h.get('swipe').set({
		threshold: threshold });


	h.on(gesture, callBack);

	return h;

};

},{}],77:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.checkIfInView = exports.ancestorMatchTag = exports.ancestorMatchClass = exports.gaSendEvent = exports.setFocusable = exports.post = exports.checkInView = exports.queryString = exports.findApp = exports.elementVisible = exports.findParent = exports.nodeHasChildren = exports.compareObjects = exports.getParent = exports.cp = exports.debounce = exports.detectViewMode = exports.createEvent = exports.pageVisibility = exports.compose = undefined;




var _enum = require('../enum');

var compose = exports.compose = function compose() {for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {fns[_key] = arguments[_key];}return function (initialArgs) {return fns.reduce(function (curr, fn) {return fn.apply(initialArgs, curr);}, initialArgs);};}; /*
                                                                                                                                                                                                                                                                                                    * Util functions index
                                                                                                                                                                                                                                                                                                    *
                                                                                                                                                                                                                                                                                                    * 
                                                                                                                                                                                                                                                                                                    */var pageVisibility = exports.pageVisibility = function pageVisibility(cb) {var keyName = void 0;
	var visibilityChangeEvtName = void 0;

	// Opera 12.10 and Firefox 18 and later support
	if (typeof document.hidden !== 'undefined') {

		keyName = 'hidden';
		visibilityChangeEvtName = 'visibilitychange';

	} else if (typeof document.msHidden !== 'undefined') {

		keyName = 'msHidden';
		visibilityChangeEvtName = 'msvisibilitychange';

	} else if (typeof document.webkitHidden !== 'undefined') {

		keyName = 'webkitHidden';
		visibilityChangeEvtName = 'webkitvisibilitychange';

	}

	var handleVisibilityChange = function handleVisibilityChange(e) {

		if (typeof cb === 'function') {

			var hidden = document[keyName];

			cb.apply(null, [hidden, e]);

		}

	};

	if (typeof document.addEventListener === 'undefined' || typeof document[keyName] === 'undefined') {

		console.log('Warning in Util.js, pageVisibility requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.');

	} else {

		document.addEventListener(visibilityChangeEvtName, handleVisibilityChange, false);

	}

};

var createEvent = exports.createEvent = function createEvent(name) {

	if (typeof Event === 'function') {

		return new Event(name);

	}

	var evt = document.createEvent('Event');
	evt.initEvent(name, true, true);

	return evt;

};

var detectViewMode = exports.detectViewMode = function detectViewMode(BP) {

	var bps = Object.keys(BP);
	var matched = BP[bps[0]];

	for (var i = 0; i < bps.length; i++) {

		var bp = bps[i];

		if (window.matchMedia('screen and (min-width: ' + BP[bp] + 'px)').matches) {

			matched = bp;
			break;

		}

	}

	return BP[matched];

};

var debounce = exports.debounce = function debounce(fn, delay) {

	var ticker = void 0;

	return function () {for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {args[_key2] = arguments[_key2];}

		clearTimeout(ticker);

		ticker = setTimeout(function () {

			fn(args);

		}, delay);

	};

};

var cp = exports.cp = function cp() {for (var _len3 = arguments.length, fns = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {fns[_key3] = arguments[_key3];}return function () {var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

		fns.forEach(function (fn) {

			if (typeof context[fn] === 'function') {

				context[fn].call(context);

			}

		});

	};};

var getParent = exports.getParent = function getParent(m, name) {return m.props.name === name ? m : getParent(m.context, name);};

var compareObjects = exports.compareObjects = function compareObjects(obj1, obj2) {

	var props1 = Object.getOwnPropertyNames(obj1);
	var props2 = Object.getOwnPropertyNames(obj2);

	if (props1.length === props2.length) {

		var isStricklyEqual = true;
		props1.forEach(function (k) {

			if (obj1[k] !== obj2[k]) {

				isStricklyEqual = false;

			}

		});

		return isStricklyEqual;

	}

	return false;

};

var nodeHasChildren = exports.nodeHasChildren = function nodeHasChildren(n, selector) {return Array.from(n.children).some(function (c) {return c.matches(selector);});};

var findParent = exports.findParent = function findParent(node, selector, boundary) {

	var p = node.parentNode;

	if (p === null || node === null) {
		return null;
	}

	// base case
	if (typeof p.matches !== 'function')
	{
		return null;
	}

	if (p.matches(selector)) {
		return p;
	}

	return p === document.body || p.matches(boundary) ? null : findParent(p, selector, boundary);

};

var elementVisible = exports.elementVisible = function elementVisible(element) {return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);};

var findApp = exports.findApp = function findApp(m) {return m.props.name === 'app' ? m : findApp(m.context);};

var queryString = exports.queryString = function queryString(s) {

	return s.split('&').reduce(function (obj, query) {

		var reg = /(^\?|$&)/g;
		var pair = query.split('=');

		var key = pair[0] ? pair[0].replace(reg, '') : '';
		var val = pair[1] ? pair[1].replace(reg, '') : '';

		obj[key] = val;

		return obj;

	}, {});

};


/**
       * Check if the element is in the viewport
       * @param {Element} el
       */
var checkInView = exports.checkInView = function checkInView(el) {

	if (!el) {

		return false;

	}

	var box = el.getBoundingClientRect();
	var isIn = box.top < window.innerHeight && box.bottom > 0;

	return isIn;

};

/**
       *
       * @param {String} url
       * @param {Object} option
       */
var post = exports.post = function post(url) {var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { method: 'POST', credentials: '*' };
	return fetch(url, option);
};

/**
       * Set focusable
       * @param {HTMLElement} el
       * @param {Boolean} focusable
       */
var setFocusable = exports.setFocusable = function setFocusable(el, focusable) {
	if (el instanceof HTMLElement) {
		if (focusable) {
			el.setAttribute('aria-hidden', false);
			el.setAttribute('tabindex', 0);
		} else {
			el.setAttribute('aria-hidden', true);
			el.setAttribute('tabindex', -1);
		}
	} else {
		console.log('Error in setFocusable. El should be instance of HTMLElement.');
	}
};

//send a Google Analytics event
var gaSendEvent = exports.gaSendEvent = function gaSendEvent(category, action, label, value)
{
	if (typeof window.ga !== "undefined")
	{
		if (typeof value !== 'undefined')
		{
			window.ga('send', 'event', category, action, label, value);
		} else

		{
			window.ga('send', 'event', category, action, label);
		}
		// console.log("gaSendEvent:" + "cat: "+ category+", act: " + action+", lbl: "+ label+", val: "+ value); 
	}
};

//find the first ancestor with the class
var ancestorMatchClass = exports.ancestorMatchClass = function ancestorMatchClass(elem, cls)
{
	// Get the closest matching element
	for (; elem && elem !== document; elem = elem.parentNode) {
		if (elem.classList.contains(cls)) return elem;
	}
	return null;
};

//find the ancestor with the tagname
var ancestorMatchTag = exports.ancestorMatchTag = function ancestorMatchTag(el, tagname)
{
	tagname = tagname.toUpperCase();
	do {
		if (el.nodeName === tagname) {
			return el;
		}
	} while (el = el.parentNode);

	return null;
};

//return true if the component is within the view, offset by LOAD_WITHIN_RANGE
var checkIfInView = exports.checkIfInView = function checkIfInView(el, bp)
{
	var LOAD_WITHIN_RANGE = -200; //load if within this range

	var shouldLoad = false;
	if (bp)
	{
		var isNotMobileViewPort = bp >= _enum.BP['SIZE_MD'];
		shouldLoad = isNotMobileViewPort; //always load if not mobile
		if (!shouldLoad)
		{
			var rect = el.getBoundingClientRect();
			var wh = window.innerHeight;
			var inViewPort = wh - rect.top >= LOAD_WITHIN_RANGE && rect.bottom >= LOAD_WITHIN_RANGE;
			shouldLoad = inViewPort;
		}
	}
	return shouldLoad;
};

},{"../enum":68}],78:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });











var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
var _framework = require('../framework');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                       * Slider mixin
                                                                                                                                       *
                                                                                                                                       * super class of sliders. Use this one as an Interface.
                                                                                                                                       * Do not directly use this. Use concatenation
                                                                                                                                       *
                                                                                                                                       *
                                                                                                                                       * dependency
                                                                                                                                       *
                                                                                                                                       * -scss: mixin/_slider.scss
                                                                                                                                       *
                                                                                                                                       */var SupportedEventsInSlider = ['mouseenter', 'mouseleave', 'mousemove', 'mousedown', 'touchstart', 'click']; // queue
var sliderQueue = function sliderQueue(qId, cb, eachDelay) {return new Promise(function (res, reject) {setTimeout(function () {// 1. invoke the callback
			cb.call(undefined);
			// 2. return resolve
			return res('queue : ' + qId + ' is complete');

		}, eachDelay);

		// fail
		if (!cb) {

			return reject('call back ' + qId + ' is empty');

		}

	});

};

var Slider = {

	sliderInit: function sliderInit() {

		// slide inner container
		this.slideInner = this.el.querySelector('.js-slider-inner');
		this.slides = this.slideInner && Array.from(this.slideInner.children);
		this.props.totalLength = this.slides.length;

		// refs
		this.pauseButton = this.el.querySelector('.js-focusable-pause');
		this.resumeButton = this.el.querySelector('.js-focusable-resume');

		this.initEvent();

		return this;

	},

	initEvent: function initEvent() {var _this = this;

		SupportedEventsInSlider.forEach(function (etype) {

			_this.el.addEventListener(etype, _this.mouseHandler.bind(_this), false);

		});

		this.hammer = (0, _framework.swipe)(this.el.querySelector('.js-slider-inner'), this.gestureHandler.bind(this), this.props.gestureThreshold);

	},

	mouseHandler: function mouseHandler(e) {var _this2 = this;

		// stop the slide timer
		clearInterval(this.ticker);var

		type = e.type,target = e.target,defaultPrevented = e.defaultPrevented;
		var isSupporedEvent = SupportedEventsInSlider.findIndex(function (etype) {return etype === type;}) !== -1;
		var isForcePaused = this.el.classList.contains('pause');

		if (isSupporedEvent && !isForcePaused) {

			if (defaultPrevented) {

				return;

			}var _props =




			this.props,totalLength = _props.totalLength,autoPlay = _props.autoPlay;

			if (totalLength > 1 && autoPlay) {

				this.tickReset();

				// start idle timer
				clearTimeout(this.idleTimer);
				this.idleTimer = setTimeout(function () {

					_this2.handleTimer(true);

				}, this.props.idleInterval);

			}

		}

		if (type === 'click') {

			//AA
			if (target.matches('.js-focusable-pause') || target.matches('.js-focusable-resume')) {

				var bind = target.getAttribute('data-focus-bind');

				if (bind === 'pause') {

					this.pause();

					_framework.util.setFocusable(this.pauseButton, false);
					_framework.util.setFocusable(this.resumeButton, true);

					if (this.resumeButton) {

						this.resumeButton.focus();

					}

				}

				if (bind === 'resume') {

					this.resume();

					_framework.util.setFocusable(this.pauseButton, true);
					_framework.util.setFocusable(this.resumeButton, false);

					if (this.pauseButton) {

						this.pauseButton.focus();

					}

				}

			}
		}

	},

	beforeSlide: function beforeSlide() {

		this.el.classList.add('lock');

	},

	slide: function slide(previousSlideId, slideId) {var _this3 = this;var isFirst = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		clearInterval(this.ticker);var _props2 =








		this.props,activeClass = _props2.activeClass,duration = _props2.duration,cubicBezier = _props2.cubicBezier,animteOuterEl = _props2.animteOuterEl,slideProperty = _props2.slideProperty,slideType = _props2.slideType;

		var prevSlideItem = this.slides[previousSlideId];
		var prevSlideInner = void 0;

		if (prevSlideItem) {

			prevSlideItem.classList.remove(activeClass);

			prevSlideInner = prevSlideItem.querySelector('.js-slider-inside-animation');

		}

		var currentSlideItem = this.slides[slideId];
		var slideInner = void 0;

		if (currentSlideItem) {

			currentSlideItem.classList.add(activeClass);

			slideInner = currentSlideItem.querySelector('.js-slider-inside-animation');

		}
		var slideOuter = this.el.querySelector('.js-slider-outer-animation');

		var animatinComplete = function animatinComplete() {

			_this3.el.classList.remove('lock');

			if (slideType === 'container') {

				if (animteOuterEl && slideOuter) {

					slideOuter.classList.add('animate-in');

				}

				// reset prev
				if (prevSlideInner) {

					['already-in', 'before-animate-in', 'animate-in', 'before-animate-out', 'animate-out'].forEach(function (c) {return prevSlideInner.classList.remove(c);});

				}

			} else if (slideType === 'each') {

				if (prevSlideItem) {

					['already-in', 'before-animate-in', 'animate-in', 'before-animate-out', 'animate-out'].forEach(function (c) {return prevSlideItem.classList.remove(c);});

				}

			}

			_this3.afterSlide();

		};

		// Queue 0. before the slider slides.
		var q0 = sliderQueue(0, function () {

			_this3.beforeSlide();

			if (slideType === 'container') {

				// movine entire container
				if (prevSlideInner) {

					['before-animate-out', 'animate-out'].forEach(function (c) {return prevSlideInner.classList.add(c);});

				}

				if (slideInner) {

					slideInner.classList.add('before-animate-in');

				}

				if (animteOuterEl && slideOuter) {

					['before-animate-in', 'animate-in', 'before-animate-out', 'animate-out'].forEach(function (c) {return slideOuter.classList.remove(c);});
					slideOuter.classList.add('before-animate-in');

				}

			} else if (slideType === 'each') {

				if (prevSlideItem) {

					['before-animate-in', 'animate-in'].forEach(function (c) {return prevSlideItem.classList.remove(c);});
					prevSlideItem.classList.add('before-animate-out');

				}

				if (currentSlideItem) {

					// isFirst is true, no animation. otherwise, prep animate-in
					currentSlideItem.classList.add(isFirst ? 'already-in' : 'before-animate-in');

				}

			}


		}, 0);

		// Queue 1. this is for entire slider slides.
		var q1 = sliderQueue(1, function () {

			if (slideType === 'container') {

				var vOption = {};
				vOption[slideProperty] = slideId * -100 + '%';

				(0, _velocityAnimate2.default)(_this3.slideInner, vOption, {
					duration: duration,
					complete: animatinComplete,
					easing: cubicBezier });


			} else if (slideType === 'each') {

				if (prevSlideItem) {

					prevSlideItem.classList.add('animate-out');

				}

				if (currentSlideItem) {

					currentSlideItem.classList.add('animate-in');

				}

				setTimeout(function () {

					animatinComplete();

				}, duration);

			}

		}, 300);

		// Queue 2. for inside element.
		var q2 = sliderQueue(2, function () {

			if (slideId !== -1) {

				if (slideInner) {

					slideInner.classList.add('animate-in');

				}

			}

		}, duration + 75);

		// listen to the all complete
		Promise.all([q0, q1, q2]).
		then(function () {

			// AA. if forced paused, no tikcer
			var isForcePaused = _this3.el.classList.contains('pause');

			if (!isForcePaused) {

				_this3.handleTimer();

			}

		}).
		catch(function (error) {return console.log(error);});

		return this;

	},

	// after slide
	afterSlide: function afterSlide() {},

	handleTimer: function handleTimer() {var _this4 = this;

		clearInterval(this.ticker);var _props3 =






		this.props,interval = _props3.interval,totalLength = _props3.totalLength,autoPlay = _props3.autoPlay,tick = _props3.tick;

		// auto play with given interval
		if (totalLength > 1 && autoPlay) {

			var counter = 0;

			this.tickStart(0);

			this.ticker = setInterval(function () {

				if (counter * tick >= interval) {

					_this4.tickComplete(100);

				} else {

					_this4.tickProgress(counter * tick / (interval * 100));
					counter++;

				}

			}, tick);

		}

		return this;

	},

	pause: function pause() {

		if (this.el instanceof HTMLElement) {

			this.el.classList.add('pause');

		}

		clearTimeout(this.idleTimer);
		clearInterval(this.ticker);

		this.ticker = void 0;
		this.idleTimer = void 0;

		this.tickReset();

	},

	resume: function resume() {

		if (this.el instanceof HTMLElement) {

			this.el.classList.remove('pause');

		}

		this.handleTimer();

	},

	// override below if necessary
	// swipe
	gestureHandler: function gestureHandler(e) {},

	// tick reset
	tickReset: function tickReset() {},

	// tick start
	tickStart: function tickStart() {var percent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;},

	// tick complete
	tickComplete: function tickComplete(percent) {},

	// progress
	tickProgress: function tickProgress() {var percent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;},

	// refs
	ticker: void 0,

	slideTimer: void 0,

	// default prop getter
	get props() {

		return {
			tick: 100,
			interval: 8000, // int: rotation interval in millesec
			idleInterval: 2000,
			autoPlay: true, // bool: true | false
			duration: 1000,
			delay: 1000,
			activeClass: 'active',
			slideType: 'container', // container || each
			slideProperty: 'translateX',
			cubicBezier: [0.59, 0.02, 0.2, 0.95],
			direction: 0, // int: 0: hor | 1: vertical. direction of animation.
			slides: [],
			gestureThreshold: 10,
			animteOuterEl: false };


	},

	// default state getter
	get state() {

		return {
			slideId: -1, // int: current slide id
			forcePaused: false };


	} };exports.default =



Slider;

},{"../framework":72,"velocity-animate":"velocity-animate"}],79:[function(require,module,exports){
/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global.Glide = factory());
}(this, (function () { 'use strict';

  var defaults = {
    /**
     * Type of the movement.
     *
     * Available types:
     * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
     * `carousel` - Changes slides without starting over when it reaches the first or last slide.
     *
     * @type {String}
     */
    type: 'slider',

    /**
     * Start at specific slide number defined with zero-based index.
     *
     * @type {Number}
     */
    startAt: 0,

    /**
     * A number of slides visible on the single viewport.
     *
     * @type {Number}
     */
    perView: 1,

    /**
     * Focus currently active slide at a specified position in the track.
     *
     * Available inputs:
     * `center` - Current slide will be always focused at the center of a track.
     * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
     *
     * @type {String|Number}
     */
    focusAt: 0,

    /**
     * A size of the gap added between slides.
     *
     * @type {Number}
     */
    gap: 10,

    /**
     * Change slides after a specified interval. Use `false` for turning off autoplay.
     *
     * @type {Number|Boolean}
     */
    autoplay: false,

    /**
     * Stop autoplay on mouseover event.
     *
     * @type {Boolean}
     */
    hoverpause: true,

    /**
     * Allow for changing slides with left and right keyboard arrows.
     *
     * @type {Boolean}
     */
    keyboard: true,

    /**
     * Stop running `perView` number of slides from the end. Use this
     * option if you don't want to have an empty space after
     * a slider. Works only with `slider` type and a
     * non-centered `focusAt` setting.
     *
     * @type {Boolean}
     */
    bound: false,

    /**
     * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
     *
     * @type {Number|Boolean}
     */
    swipeThreshold: 80,

    /**
     * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
     *
     * @type {Number|Boolean}
     */
    dragThreshold: 120,

    /**
     * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
     *
     * @type {Number|Boolean}
     */
    perTouch: false,

    /**
     * Moving distance ratio of the slides on a swiping and dragging.
     *
     * @type {Number}
     */
    touchRatio: 0.5,

    /**
     * Angle required to activate slides moving on swiping or dragging.
     *
     * @type {Number}
     */
    touchAngle: 45,

    /**
     * Duration of the animation in milliseconds.
     *
     * @type {Number}
     */
    animationDuration: 400,

    /**
     * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
     *
     * @type {Boolean}
     */
    rewind: true,

    /**
     * Duration of the rewinding animation of the `slider` type in milliseconds.
     *
     * @type {Number}
     */
    rewindDuration: 800,

    /**
     * Easing function for the animation.
     *
     * @type {String}
     */
    animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

    /**
     * Throttle costly events at most once per every wait milliseconds.
     *
     * @type {Number}
     */
    throttle: 10,

    /**
     * Moving direction mode.
     *
     * Available inputs:
     * - 'ltr' - left to right movement,
     * - 'rtl' - right to left movement.
     *
     * @type {String}
     */
    direction: 'ltr',

    /**
     * The distance value of the next and previous viewports which
     * have to peek in the current view. Accepts number and
     * pixels as a string. Left and right peeking can be
     * set up separately with a directions object.
     *
     * For example:
     * `100` - Peek 100px on the both sides.
     * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
     *
     * @type {Number|String|Object}
     */
    peek: 0,

    /**
     * Collection of options applied at specified media breakpoints.
     * For example: display two slides per view under 800px.
     * `{
     *   '800px': {
     *     perView: 2
     *   }
     * }`
     */
    breakpoints: {},

    /**
     * Collection of internally used HTML classes.
     *
     * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
     * @type {Object}
     */
    classes: {
      direction: {
        ltr: 'glide--ltr',
        rtl: 'glide--rtl'
      },
      slider: 'glide--slider',
      carousel: 'glide--carousel',
      swipeable: 'glide--swipeable',
      dragging: 'glide--dragging',
      cloneSlide: 'glide__slide--clone',
      activeNav: 'glide__bullet--active',
      activeSlide: 'glide__slide--active',
      disabledArrow: 'glide__arrow--disabled'
    }
  };

  /**
   * Outputs warning message to the bowser console.
   *
   * @param  {String} msg
   * @return {Void}
   */
  function warn(msg) {
    console.error("[Glide warn]: " + msg);
  }

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  var get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);

    if (desc === undefined) {
      var parent = Object.getPrototypeOf(object);

      if (parent === null) {
        return undefined;
      } else {
        return get(parent, property, receiver);
      }
    } else if ("value" in desc) {
      return desc.value;
    } else {
      var getter = desc.get;

      if (getter === undefined) {
        return undefined;
      }

      return getter.call(receiver);
    }
  };

  var inherits = function (subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  };

  var possibleConstructorReturn = function (self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  };

  /**
   * Converts value entered as number
   * or string to integer value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toInt(value) {
    return parseInt(value);
  }

  /**
   * Converts value entered as number
   * or string to flat value.
   *
   * @param {String} value
   * @returns {Number}
   */
  function toFloat(value) {
    return parseFloat(value);
  }

  /**
   * Indicates whether the specified value is a string.
   *
   * @param  {*}   value
   * @return {Boolean}
   */
  function isString(value) {
    return typeof value === 'string';
  }

  /**
   * Indicates whether the specified value is an object.
   *
   * @param  {*} value
   * @return {Boolean}
   *
   * @see https://github.com/jashkenas/underscore
   */
  function isObject(value) {
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
  }

  /**
   * Indicates whether the specified value is a number.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isNumber(value) {
    return typeof value === 'number';
  }

  /**
   * Indicates whether the specified value is a function.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isFunction(value) {
    return typeof value === 'function';
  }

  /**
   * Indicates whether the specified value is undefined.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * Indicates whether the specified value is an array.
   *
   * @param  {*} value
   * @return {Boolean}
   */
  function isArray(value) {
    return value.constructor === Array;
  }

  /**
   * Creates and initializes specified collection of extensions.
   * Each extension receives access to instance of glide and rest of components.
   *
   * @param {Object} glide
   * @param {Object} extensions
   *
   * @returns {Object}
   */
  function mount(glide, extensions, events) {
    var components = {};

    for (var name in extensions) {
      if (isFunction(extensions[name])) {
        components[name] = extensions[name](glide, components, events);
      } else {
        warn('Extension must be a function');
      }
    }

    for (var _name in components) {
      if (isFunction(components[_name].mount)) {
        components[_name].mount();
      }
    }

    return components;
  }

  /**
   * Defines getter and setter property on the specified object.
   *
   * @param  {Object} obj         Object where property has to be defined.
   * @param  {String} prop        Name of the defined property.
   * @param  {Object} definition  Get and set definitions for the property.
   * @return {Void}
   */
  function define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
  }

  /**
   * Sorts aphabetically object keys.
   *
   * @param  {Object} obj
   * @return {Object}
   */
  function sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function (r, k) {
      r[k] = obj[k];

      return r[k], r;
    }, {});
  }

  /**
   * Merges passed settings object with default options.
   *
   * @param  {Object} defaults
   * @param  {Object} settings
   * @return {Object}
   */
  function mergeOptions(defaults, settings) {
    var options = _extends({}, defaults, settings);

    // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty('classes')) {
      options.classes = _extends({}, defaults.classes, settings.classes);

      if (settings.classes.hasOwnProperty('direction')) {
        options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
      }
    }

    if (settings.hasOwnProperty('breakpoints')) {
      options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
    }

    return options;
  }

  var EventsBus = function () {
    /**
     * Construct a EventBus instance.
     *
     * @param {Object} events
     */
    function EventsBus() {
      var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, EventsBus);

      this.events = events;
      this.hop = events.hasOwnProperty;
    }

    /**
     * Adds listener to the specifed event.
     *
     * @param {String|Array} event
     * @param {Function} handler
     */


    createClass(EventsBus, [{
      key: 'on',
      value: function on(event, handler) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.on(event[i], handler);
          }
        }

        // Create the event's object if not yet created
        if (!this.hop.call(this.events, event)) {
          this.events[event] = [];
        }

        // Add the handler to queue
        var index = this.events[event].push(handler) - 1;

        // Provide handle back for removal of event
        return {
          remove: function remove() {
            delete this.events[event][index];
          }
        };
      }

      /**
       * Runs registered handlers for specified event.
       *
       * @param {String|Array} event
       * @param {Object=} context
       */

    }, {
      key: 'emit',
      value: function emit(event, context) {
        if (isArray(event)) {
          for (var i = 0; i < event.length; i++) {
            this.emit(event[i], context);
          }
        }

        // If the event doesn't exist, or there's no handlers in queue, just leave
        if (!this.hop.call(this.events, event)) {
          return;
        }

        // Cycle through events queue, fire!
        this.events[event].forEach(function (item) {
          item(context || {});
        });
      }
    }]);
    return EventsBus;
  }();

  var Glide = function () {
    /**
     * Construct glide.
     *
     * @param  {String} selector
     * @param  {Object} options
     */
    function Glide(selector) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      classCallCheck(this, Glide);

      this._c = {};
      this._t = [];
      this._e = new EventsBus();

      this.disabled = false;
      this.selector = selector;
      this.settings = mergeOptions(defaults, options);
      this.index = this.settings.startAt;
    }

    /**
     * Initializes glide.
     *
     * @param {Object} extensions Collection of extensions to initialize.
     * @return {Glide}
     */


    createClass(Glide, [{
      key: 'mount',
      value: function mount$$1() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this._e.emit('mount.before');

        if (isObject(extensions)) {
          this._c = mount(this, extensions, this._e);
        } else {
          warn('You need to provide a object on `mount()`');
        }

        this._e.emit('mount.after');

        return this;
      }

      /**
       * Collects an instance `translate` transformers.
       *
       * @param  {Array} transformers Collection of transformers.
       * @return {Void}
       */

    }, {
      key: 'mutate',
      value: function mutate() {
        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (isArray(transformers)) {
          this._t = transformers;
        } else {
          warn('You need to provide a array on `mutate()`');
        }

        return this;
      }

      /**
       * Updates glide with specified settings.
       *
       * @param {Object} settings
       * @return {Glide}
       */

    }, {
      key: 'update',
      value: function update() {
        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        this.settings = mergeOptions(this.settings, settings);

        if (settings.hasOwnProperty('startAt')) {
          this.index = settings.startAt;
        }

        this._e.emit('update');

        return this;
      }

      /**
       * Change slide with specified pattern. A pattern must be in the special format:
       * `>` - Move one forward
       * `<` - Move one backward
       * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
       * `>>` - Rewinds to end (last slide)
       * `<<` - Rewinds to start (first slide)
       *
       * @param {String} pattern
       * @return {Glide}
       */

    }, {
      key: 'go',
      value: function go(pattern) {
        this._c.Run.make(pattern);

        return this;
      }

      /**
       * Move track by specified distance.
       *
       * @param {String} distance
       * @return {Glide}
       */

    }, {
      key: 'move',
      value: function move(distance) {
        this._c.Transition.disable();
        this._c.Move.make(distance);

        return this;
      }

      /**
       * Destroy instance and revert all changes done by this._c.
       *
       * @return {Glide}
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        this._e.emit('destroy');

        return this;
      }

      /**
       * Start instance autoplaying.
       *
       * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Glide}
       */

    }, {
      key: 'play',
      value: function play() {
        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (interval) {
          this.settings.autoplay = interval;
        }

        this._e.emit('play');

        return this;
      }

      /**
       * Stop instance autoplaying.
       *
       * @return {Glide}
       */

    }, {
      key: 'pause',
      value: function pause() {
        this._e.emit('pause');

        return this;
      }

      /**
       * Sets glide into a idle status.
       *
       * @return {Glide}
       */

    }, {
      key: 'disable',
      value: function disable() {
        this.disabled = true;

        return this;
      }

      /**
       * Sets glide into a active status.
       *
       * @return {Glide}
       */

    }, {
      key: 'enable',
      value: function enable() {
        this.disabled = false;

        return this;
      }

      /**
       * Adds cuutom event listener with handler.
       *
       * @param  {String|Array} event
       * @param  {Function} handler
       * @return {Glide}
       */

    }, {
      key: 'on',
      value: function on(event, handler) {
        this._e.on(event, handler);

        return this;
      }

      /**
       * Checks if glide is a precised type.
       *
       * @param  {String} name
       * @return {Boolean}
       */

    }, {
      key: 'isType',
      value: function isType(name) {
        return this.settings.type === name;
      }

      /**
       * Gets value of the core options.
       *
       * @return {Object}
       */

    }, {
      key: 'settings',
      get: function get$$1() {
        return this._o;
      }

      /**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */
      ,
      set: function set$$1(o) {
        if (isObject(o)) {
          this._o = o;
        } else {
          warn('Options must be an `object` instance.');
        }
      }

      /**
       * Gets current index of the slider.
       *
       * @return {Object}
       */

    }, {
      key: 'index',
      get: function get$$1() {
        return this._i;
      }

      /**
       * Sets current index a slider.
       *
       * @return {Object}
       */
      ,
      set: function set$$1(i) {
        this._i = toInt(i);
      }

      /**
       * Gets type name of the slider.
       *
       * @return {String}
       */

    }, {
      key: 'type',
      get: function get$$1() {
        return this.settings.type;
      }

      /**
       * Gets value of the idle status.
       *
       * @return {Boolean}
       */

    }, {
      key: 'disabled',
      get: function get$$1() {
        return this._d;
      }

      /**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */
      ,
      set: function set$$1(status) {
        this._d = !!status;
      }
    }]);
    return Glide;
  }();

  function Run (Glide, Components, Events) {
    var Run = {
      /**
       * Initializes autorunning of the glide.
       *
       * @return {Void}
       */
      mount: function mount() {
        this._o = false;
      },


      /**
       * Makes glides running based on the passed moving schema.
       *
       * @param {String} move
       */
      make: function make(move) {
        var _this = this;

        if (!Glide.disabled) {
          Glide.disable();

          this.move = move;

          Events.emit('run.before', this.move);

          this.calculate();

          Events.emit('run', this.move);

          Components.Transition.after(function () {
            if (_this.isStart()) {
              Events.emit('run.start', _this.move);
            }

            if (_this.isEnd()) {
              Events.emit('run.end', _this.move);
            }

            if (_this.isOffset('<') || _this.isOffset('>')) {
              _this._o = false;

              Events.emit('run.offset', _this.move);
            }

            Events.emit('run.after', _this.move);

            Glide.enable();
          });
        }
      },


      /**
       * Calculates current index based on defined move.
       *
       * @return {Void}
       */
      calculate: function calculate() {
        var move = this.move,
            length = this.length;
        var steps = move.steps,
            direction = move.direction;


        var countableSteps = isNumber(toInt(steps)) && toInt(steps) !== 0;

        switch (direction) {
          case '>':
            if (steps === '>') {
              Glide.index = length;
            } else if (this.isEnd()) {
              if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
                this._o = true;

                Glide.index = 0;
              }
            } else if (countableSteps) {
              Glide.index += Math.min(length - Glide.index, -toInt(steps));
            } else {
              Glide.index++;
            }
            break;

          case '<':
            if (steps === '<') {
              Glide.index = 0;
            } else if (this.isStart()) {
              if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
                this._o = true;

                Glide.index = length;
              }
            } else if (countableSteps) {
              Glide.index -= Math.min(Glide.index, toInt(steps));
            } else {
              Glide.index--;
            }
            break;

          case '=':
            Glide.index = steps;
            break;

          default:
            warn('Invalid direction pattern [' + direction + steps + '] has been used');
            break;
        }
      },


      /**
       * Checks if we are on the first slide.
       *
       * @return {Boolean}
       */
      isStart: function isStart() {
        return Glide.index === 0;
      },


      /**
       * Checks if we are on the last slide.
       *
       * @return {Boolean}
       */
      isEnd: function isEnd() {
        return Glide.index === this.length;
      },


      /**
       * Checks if we are making a offset run.
       *
       * @param {String} direction
       * @return {Boolean}
       */
      isOffset: function isOffset(direction) {
        return this._o && this.move.direction === direction;
      }
    };

    define(Run, 'move', {
      /**
       * Gets value of the move schema.
       *
       * @returns {Object}
       */
      get: function get() {
        return this._m;
      },


      /**
       * Sets value of the move schema.
       *
       * @returns {Object}
       */
      set: function set(value) {
        var step = value.substr(1);

        this._m = {
          direction: value.substr(0, 1),
          steps: step ? toInt(step) ? toInt(step) : step : 0
        };
      }
    });

    define(Run, 'length', {
      /**
       * Gets value of the running distance based
       * on zero-indexing number of slides.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;
        var length = Components.Html.slides.length;

        // If the `bound` option is acitve, a maximum running distance should be
        // reduced by `perView` and `focusAt` settings. Running distance
        // should end before creating an empty space after instance.

        if (Glide.isType('slider') && settings.focusAt !== 'center' && settings.bound) {
          return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
        }

        return length - 1;
      }
    });

    define(Run, 'offset', {
      /**
       * Gets status of the offsetting flag.
       *
       * @return {Boolean}
       */
      get: function get() {
        return this._o;
      }
    });

    return Run;
  }

  /**
   * Returns a current time.
   *
   * @return {Number}
   */
  function now() {
    return new Date().getTime();
  }

  /**
   * Returns a function, that, when invoked, will only be triggered
   * at most once during a given window of time.
   *
   * @param {Function} func
   * @param {Number} wait
   * @param {Object=} options
   * @return {Function}
   *
   * @see https://github.com/jashkenas/underscore
   */
  function throttle(func, wait, options) {
    var timeout = void 0,
        context = void 0,
        args = void 0,
        result = void 0;
    var previous = 0;
    if (!options) options = {};

    var later = function later() {
      previous = options.leading === false ? 0 : now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function throttled() {
      var at = now();
      if (!previous && options.leading === false) previous = at;
      var remaining = wait - (at - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = at;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function () {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  }

  var MARGIN_TYPE = {
    ltr: ['marginLeft', 'marginRight'],
    rtl: ['marginRight', 'marginLeft']
  };

  function Gaps (Glide, Components, Events) {
    var Gaps = {
      /**
       * Applies gaps between slides. First and last
       * slides do not receive it's edge margins.
       *
       * @param {HTMLCollection} slides
       * @return {Void}
       */
      apply: function apply(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;
          var direction = Components.Direction.value;

          if (i !== 0) {
            style[MARGIN_TYPE[direction][0]] = this.value / 2 + 'px';
          } else {
            style[MARGIN_TYPE[direction][0]] = '';
          }

          if (i !== slides.length - 1) {
            style[MARGIN_TYPE[direction][1]] = this.value / 2 + 'px';
          } else {
            style[MARGIN_TYPE[direction][1]] = '';
          }
        }
      },


      /**
       * Removes gaps from the slides.
       *
       * @param {HTMLCollection} slides
       * @returns {Void}
      */
      remove: function remove(slides) {
        for (var i = 0, len = slides.length; i < len; i++) {
          var style = slides[i].style;

          style.marginLeft = '';
          style.marginRight = '';
        }
      }
    };

    define(Gaps, 'value', {
      /**
       * Gets value of the gap.
       *
       * @returns {Number}
       */
      get: function get() {
        return toInt(Glide.settings.gap);
      }
    });

    define(Gaps, 'grow', {
      /**
       * Gets additional dimentions value caused by gaps.
       * Used to increase width of the slides wrapper.
       *
       * @returns {Number}
       */
      get: function get() {
        return Gaps.value * (Components.Sizes.length - 1);
      }
    });

    define(Gaps, 'reductor', {
      /**
       * Gets reduction value caused by gaps.
       * Used to subtract width of the slides.
       *
       * @returns {Number}
       */
      get: function get() {
        var perView = Glide.settings.perView;

        return Gaps.value * (perView - 1) / perView;
      }
    });

    /**
     * Apply calculated gaps:
     * - after building, so slides (including clones) will receive proper margins
     * - on updating via API, to recalculate gaps with new options
     */
    Events.on(['build.after', 'update'], throttle(function () {
      Gaps.apply(Components.Html.wrapper.children);
    }, 30));

    /**
     * Remove gaps:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Gaps.remove(Components.Html.wrapper.children);
    });

    return Gaps;
  }

  /**
   * Finds siblings nodes of the passed node.
   *
   * @param  {Element} node
   * @return {Array}
   */
  function siblings(node) {
    if (node && node.parentNode) {
      var n = node.parentNode.firstChild;
      var matched = [];

      for (; n; n = n.nextSibling) {
        if (n.nodeType === 1 && n !== node) {
          matched.push(n);
        }
      }

      return matched;
    }

    return [];
  }

  /**
   * Checks if passed node exist and is a valid element.
   *
   * @param  {Element} node
   * @return {Boolean}
   */
  function exist(node) {
    if (node && node instanceof window.HTMLElement) {
      return true;
    }

    return false;
  }

  var TRACK_SELECTOR = '[data-glide-el="track"]';

  function Html (Glide, Components) {
    var Html = {
      /**
       * Setup slider HTML nodes.
       *
       * @param {Glide} glide
       */
      mount: function mount() {
        this.root = Glide.selector;
        this.track = this.root.querySelector(TRACK_SELECTOR);
        this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (slide) {
          return !slide.classList.contains(Glide.settings.classes.cloneSlide);
        });
      }
    };

    define(Html, 'root', {
      /**
       * Gets node of the glide main element.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._r;
      },


      /**
       * Sets node of the glide main element.
       *
       * @return {Object}
       */
      set: function set(r) {
        if (isString(r)) {
          r = document.querySelector(r);
        }

        if (exist(r)) {
          Html._r = r;
        } else {
          warn('Root element must be a existing Html node');
        }
      }
    });

    define(Html, 'track', {
      /**
       * Gets node of the glide track with slides.
       *
       * @return {Object}
       */
      get: function get() {
        return Html._t;
      },


      /**
       * Sets node of the glide track with slides.
       *
       * @return {Object}
       */
      set: function set(t) {
        if (exist(t)) {
          Html._t = t;
        } else {
          warn('Could not find track element. Please use ' + TRACK_SELECTOR + ' attribute.');
        }
      }
    });

    define(Html, 'wrapper', {
      /**
       * Gets node of the slides wrapper.
       *
       * @return {Object}
       */
      get: function get() {
        return Html.track.children[0];
      }
    });

    return Html;
  }

  function Peek (Glide, Components, Events) {
    var Peek = {
      /**
       * Setups how much to peek based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.peek;
      }
    };

    define(Peek, 'value', {
      /**
       * Gets value of the peek.
       *
       * @returns {Number|Object}
       */
      get: function get() {
        return Peek._v;
      },


      /**
       * Sets value of the peek.
       *
       * @param {Number|Object} value
       * @return {Void}
       */
      set: function set(value) {
        if (isObject(value)) {
          value.before = toInt(value.before);
          value.after = toInt(value.after);
        } else {
          value = toInt(value);
        }

        Peek._v = value;
      }
    });

    define(Peek, 'reductor', {
      /**
       * Gets reduction value caused by peek.
       *
       * @returns {Number}
       */
      get: function get() {
        var value = Peek.value;
        var perView = Glide.settings.perView;

        if (isObject(value)) {
          return value.before / perView + value.after / perView;
        }

        return value * 2 / perView;
      }
    });

    /**
     * Recalculate peeking sizes on:
     * - when resizing window to update to proper percents
     */
    Events.on(['resize', 'update'], function () {
      Peek.mount();
    });

    return Peek;
  }

  function Move (Glide, Components, Events) {
    var Move = {
      /**
       * Constructs move component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        this._o = 0;
      },


      /**
       * Calculates a movement value based on passed offset and currently active index.
       *
       * @param  {Number} offset
       * @return {Void}
       */
      make: function make() {
        var _this = this;

        var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        this.offset = offset;

        Events.emit('move', {
          movement: this.value
        });

        Components.Transition.after(function () {
          Events.emit('move.after', {
            movement: _this.value
          });
        });
      }
    };

    define(Move, 'offset', {
      /**
       * Gets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      get: function get() {
        return Move._o;
      },


      /**
       * Sets an offset value used to modify current translate.
       *
       * @return {Object}
       */
      set: function set(value) {
        Move._o = !isUndefined(value) ? toInt(value) : 0;
      }
    });

    define(Move, 'translate', {
      /**
       * Gets a raw movement value.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Sizes.slideWidth * Glide.index;
      }
    });

    define(Move, 'value', {
      /**
       * Gets an actual movement value corrected by offset.
       *
       * @return {Number}
       */
      get: function get() {
        var offset = this.offset;
        var translate = this.translate;

        if (Components.Direction.is('rtl')) {
          return translate + offset;
        }

        return translate - offset;
      }
    });

    /**
     * Make movement to proper slide on:
     * - before build, so glide will start at `startAt` index
     * - on each standard run to move to newly calculated index
     */
    Events.on(['build.before', 'run'], function () {
      Move.make();
    });

    return Move;
  }

  function Sizes (Glide, Components, Events) {
    var Sizes = {
      /**
       * Setups dimentions of slides.
       *
       * @return {Void}
       */
      setupSlides: function setupSlides() {
        var width = this.slideWidth + 'px';
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = width;
        }
      },


      /**
       * Setups dimentions of slides wrapper.
       *
       * @return {Void}
       */
      setupWrapper: function setupWrapper(dimention) {
        Components.Html.wrapper.style.width = this.wrapperSize + 'px';
      },


      /**
       * Removes applied styles from HTML elements.
       *
       * @returns {Void}
       */
      remove: function remove() {
        var slides = Components.Html.slides;

        for (var i = 0; i < slides.length; i++) {
          slides[i].style.width = '';
        }

        Components.Html.wrapper.style.width = '';
      }
    };

    define(Sizes, 'length', {
      /**
       * Gets count number of the slides.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.slides.length;
      }
    });

    define(Sizes, 'width', {
      /**
       * Gets width value of the glide.
       *
       * @return {Number}
       */
      get: function get() {
        return Components.Html.root.offsetWidth;
      }
    });

    define(Sizes, 'wrapperSize', {
      /**
       * Gets size of the slides wrapper.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
      }
    });

    define(Sizes, 'slideWidth', {
      /**
       * Gets width value of the single slide.
       *
       * @return {Number}
       */
      get: function get() {
        return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
      }
    });

    /**
     * Apply calculated glide's dimensions:
     * - before building, so other dimentions (e.g. translate) will be calculated propertly
     * - when resizing window to recalculate sildes dimensions
     * - on updating via API, to calculate dimensions based on new options
     */
    Events.on(['build.before', 'resize', 'update'], function () {
      Sizes.setupSlides();
      Sizes.setupWrapper();
    });

    /**
     * Remove calculated glide's dimensions:
     * - on destoting to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Sizes.remove();
    });

    return Sizes;
  }

  function Build (Glide, Components, Events) {
    var Build = {
      /**
       * Init glide building. Adds classes, sets
       * dimensions and setups initial state.
       *
       * @return {Void}
       */
      mount: function mount() {
        Events.emit('build.before');

        this.typeClass();
        this.activeClass();

        Events.emit('build.after');
      },


      /**
       * Adds `type` class to the glide element.
       *
       * @return {Void}
       */
      typeClass: function typeClass() {
        Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
      },


      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      activeClass: function activeClass() {
        var classes = Glide.settings.classes;
        var slide = Components.Html.slides[Glide.index];

        if (slide) {
          slide.classList.add(classes.activeSlide);

          siblings(slide).forEach(function (sibling) {
            sibling.classList.remove(classes.activeSlide);
          });
        }
      },


      /**
       * Removes HTML classes applied at building.
       *
       * @return {Void}
       */
      removeClasses: function removeClasses() {
        var classes = Glide.settings.classes;

        Components.Html.root.classList.remove(classes[Glide.settings.type]);

        Components.Html.slides.forEach(function (sibling) {
          sibling.classList.remove(classes.activeSlide);
        });
      }
    };

    /**
     * Clear building classes:
     * - on destroying to bring HTML to its initial state
     * - on updating to remove classes before remounting component
     */
    Events.on(['destroy', 'update'], function () {
      Build.removeClasses();
    });

    /**
     * Remount component:
     * - on resizing of the window to calculate new dimentions
     * - on updating settings via API
     */
    Events.on(['resize', 'update'], function () {
      Build.mount();
    });

    /**
     * Swap active class of current slide:
     * - after each move to the new index
     */
    Events.on('move.after', function () {
      Build.activeClass();
    });

    return Build;
  }

  function Clones (Glide, Components, Events) {
    var Clones = {
      /**
       * Create pattern map and collect slides to be cloned.
       */
      mount: function mount() {
        this.items = [];

        if (Glide.isType('carousel')) {
          this.items = this.collect();
        }
      },


      /**
       * Collect clones with pattern.
       *
       * @return {Void}
       */
      collect: function collect() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var slides = Components.Html.slides;
        var _Glide$settings = Glide.settings,
            perView = _Glide$settings.perView,
            classes = _Glide$settings.classes;


        var peekIncrementer = +!!Glide.settings.peek;
        var part = perView + peekIncrementer;
        var start = slides.slice(0, part);
        var end = slides.slice(-part);

        for (var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++) {
          for (var i = 0; i < start.length; i++) {
            var clone = start[i].cloneNode(true);

            clone.classList.add(classes.cloneSlide);

            items.push(clone);
          }

          for (var _i = 0; _i < end.length; _i++) {
            var _clone = end[_i].cloneNode(true);

            _clone.classList.add(classes.cloneSlide);

            items.unshift(_clone);
          }
        }

        return items;
      },


      /**
       * Append cloned slides with generated pattern.
       *
       * @return {Void}
       */
      append: function append() {
        var items = this.items;
        var _Components$Html = Components.Html,
            wrapper = _Components$Html.wrapper,
            slides = _Components$Html.slides;


        var half = Math.floor(items.length / 2);
        var prepend = items.slice(0, half).reverse();
        var append = items.slice(half, items.length);
        var width = Components.Sizes.slideWidth + 'px';

        for (var i = 0; i < append.length; i++) {
          wrapper.appendChild(append[i]);
        }

        for (var _i2 = 0; _i2 < prepend.length; _i2++) {
          wrapper.insertBefore(prepend[_i2], slides[0]);
        }

        for (var _i3 = 0; _i3 < items.length; _i3++) {
          items[_i3].style.width = width;
        }
      },


      /**
       * Remove all cloned slides.
       *
       * @return {Void}
       */
      remove: function remove() {
        var items = this.items;


        for (var i = 0; i < items.length; i++) {
          Components.Html.wrapper.removeChild(items[i]);
        }
      }
    };

    define(Clones, 'grow', {
      /**
       * Gets additional dimentions value caused by clones.
       *
       * @return {Number}
       */
      get: function get() {
        return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
      }
    });

    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */
    Events.on('update', function () {
      Clones.remove();
      Clones.mount();
      Clones.append();
    });

    /**
     * Append additional slide's clones:
     * - while glide's type is `carousel`
     */
    Events.on('build.before', function () {
      if (Glide.isType('carousel')) {
        Clones.append();
      }
    });

    /**
     * Remove clones HTMLElements:
     * - on destroying, to bring HTML to its initial state
     */
    Events.on('destroy', function () {
      Clones.remove();
    });

    return Clones;
  }

  var EventsBinder = function () {
    /**
     * Construct a EventsBinder instance.
     */
    function EventsBinder() {
      var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      classCallCheck(this, EventsBinder);

      this.listeners = listeners;
    }

    /**
     * Adds events listeners to arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Function} closure
     * @param  {Boolean|Object} capture
     * @return {Void}
     */


    createClass(EventsBinder, [{
      key: 'on',
      value: function on(events, el, closure) {
        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          this.listeners[events[i]] = closure;

          el.addEventListener(events[i], this.listeners[events[i]], capture);
        }
      }

      /**
       * Removes event listeners from arrows HTML elements.
       *
       * @param  {String|Array} events
       * @param  {Element|Window|Document} el
       * @param  {Boolean|Object} capture
       * @return {Void}
       */

    }, {
      key: 'off',
      value: function off(events, el) {
        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (isString(events)) {
          events = [events];
        }

        for (var i = 0; i < events.length; i++) {
          el.removeEventListener(events[i], this.listeners[events[i]], capture);
        }
      }

      /**
       * Destroy collected listeners.
       *
       * @returns {Void}
       */

    }, {
      key: 'destroy',
      value: function destroy() {
        delete this.listeners;
      }
    }]);
    return EventsBinder;
  }();

  function Resize (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Resize = {
      /**
       * Initializes window bindings.
       */
      mount: function mount() {
        this.bind();
      },


      /**
       * Binds `rezsize` listener to the window.
       * It's a costly event, so we are debouncing it.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('resize', window, throttle(function () {
          Events.emit('resize');
        }, Glide.settings.throttle));
      },


      /**
       * Unbinds listeners from the window.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('resize', window);
      }
    };

    /**
     * Remove bindings from window:
     * - on destroying, to remove added EventListener
     */
    Events.on('destroy', function () {
      Resize.unbind();
      Binder.destroy();
    });

    return Resize;
  }

  var VALID_DIRECTIONS = ['ltr', 'rtl'];
  var FLIPED_MOVEMENTS = {
    '>': '<',
    '<': '>',
    '=': '='
  };

  function Direction (Glide, Components, Events) {
    var Direction = {
      /**
       * Setups gap value based on settings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.value = Glide.settings.direction;
      },


      /**
       * Resolves pattern based on direction value
       *
       * @param {String} pattern
       * @returns {String}
       */
      resolve: function resolve(pattern) {
        var token = pattern.slice(0, 1);

        if (this.is('rtl')) {
          return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
        }

        return pattern;
      },


      /**
       * Checks value of direction mode.
       *
       * @param {String} direction
       * @returns {Boolean}
       */
      is: function is(direction) {
        return this.value === direction;
      },


      /**
       * Applies direction class to the root HTML element.
       *
       * @return {Void}
       */
      addClass: function addClass() {
        Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
      },


      /**
       * Removes direction class from the root HTML element.
       *
       * @return {Void}
       */
      removeClass: function removeClass() {
        Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
      }
    };

    define(Direction, 'value', {
      /**
       * Gets value of the direction.
       *
       * @returns {Number}
       */
      get: function get() {
        return Direction._v;
      },


      /**
       * Sets value of the direction.
       *
       * @param {String} value
       * @return {Void}
       */
      set: function set(value) {
        if (VALID_DIRECTIONS.indexOf(value) > -1) {
          Direction._v = value;
        } else {
          warn('Direction value must be `ltr` or `rtl`');
        }
      }
    });

    /**
     * Clear direction class:
     * - on destroy to bring HTML to its initial state
     * - on update to remove class before reappling bellow
     */
    Events.on(['destroy', 'update'], function () {
      Direction.removeClass();
    });

    /**
     * Remount component:
     * - on update to reflect changes in direction value
     */
    Events.on('update', function () {
      Direction.mount();
    });

    /**
     * Apply direction class:
     * - before building to apply class for the first time
     * - on updating to reapply direction class that may changed
     */
    Events.on(['build.before', 'update'], function () {
      Direction.addClass();
    });

    return Direction;
  }

  /**
   * Reflects value of glide movement.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Rtl (Glide, Components) {
    return {
      /**
       * Negates the passed translate if glide is in RTL option.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Components.Direction.is('rtl')) {
          return -translate;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `gap` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Gap (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with number in the `gap` settings.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Gaps.value * Glide.index;
      }
    };
  }

  /**
   * Updates glide movement with width of additional clones width.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Grow (Glide, Components) {
    return {
      /**
       * Adds to the passed translate width of the half of clones.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        return translate + Components.Clones.grow / 2;
      }
    };
  }

  /**
   * Updates glide movement with a `peek` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Peeking (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with a `peek` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        if (Glide.settings.focusAt >= 0) {
          var peek = Components.Peek.value;

          if (isObject(peek)) {
            return translate - peek.before;
          }

          return translate - peek;
        }

        return translate;
      }
    };
  }

  /**
   * Updates glide movement with a `focusAt` settings.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function Focusing (Glide, Components) {
    return {
      /**
       * Modifies passed translate value with index in the `focusAt` setting.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      modify: function modify(translate) {
        var gap = Components.Gaps.value;
        var width = Components.Sizes.width;
        var focusAt = Glide.settings.focusAt;
        var slideWidth = Components.Sizes.slideWidth;

        if (focusAt === 'center') {
          return translate - (width / 2 - slideWidth / 2);
        }

        return translate - slideWidth * focusAt - gap * focusAt;
      }
    };
  }

  /**
   * Applies diffrent transformers on translate value.
   *
   * @param  {Object} Glide
   * @param  {Object} Components
   * @return {Object}
   */
  function mutator (Glide, Components, Events) {
    /**
     * Merge instance transformers with collection of default transformers.
     * It's important that the Rtl component be last on the list,
     * so it reflects all previous transformations.
     *
     * @type {Array}
     */
    var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);

    return {
      /**
       * Piplines translate value with registered transformers.
       *
       * @param  {Number} translate
       * @return {Number}
       */
      mutate: function mutate(translate) {
        for (var i = 0; i < TRANSFORMERS.length; i++) {
          var transformer = TRANSFORMERS[i];

          if (isFunction(transformer) && isFunction(transformer().modify)) {
            translate = transformer(Glide, Components, Events).modify(translate);
          } else {
            warn('Transformer should be a function that returns an object with `modify()` method');
          }
        }

        return translate;
      }
    };
  }

  function Translate (Glide, Components, Events) {
    var Translate = {
      /**
       * Sets value of translate on HTML element.
       *
       * @param {Number} value
       * @return {Void}
       */
      set: function set(value) {
        var transform = mutator(Glide, Components).mutate(value);

        Components.Html.wrapper.style.transform = 'translate3d(' + -1 * transform + 'px, 0px, 0px)';
      },


      /**
       * Removes value of translate from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transform = '';
      }
    };

    /**
     * Set new translate value:
     * - on move to reflect index change
     * - on updating via API to reflect possible changes in options
     */
    Events.on('move', function (context) {
      var gap = Components.Gaps.value;
      var length = Components.Sizes.length;
      var width = Components.Sizes.slideWidth;

      if (Glide.isType('carousel') && Components.Run.isOffset('<')) {
        Components.Transition.after(function () {
          Events.emit('translate.jump');

          Translate.set(width * (length - 1));
        });

        return Translate.set(-width - gap * length);
      }

      if (Glide.isType('carousel') && Components.Run.isOffset('>')) {
        Components.Transition.after(function () {
          Events.emit('translate.jump');

          Translate.set(0);
        });

        return Translate.set(width * length + gap * length);
      }

      return Translate.set(context.movement);
    });

    /**
     * Remove translate:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Translate.remove();
    });

    return Translate;
  }

  function Transition (Glide, Components, Events) {
    /**
     * Holds inactivity status of transition.
     * When true transition is not applied.
     *
     * @type {Boolean}
     */
    var disabled = false;

    var Transition = {
      /**
       * Composes string of the CSS transition.
       *
       * @param {String} property
       * @return {String}
       */
      compose: function compose(property) {
        var settings = Glide.settings;

        if (!disabled) {
          return property + ' ' + this.duration + 'ms ' + settings.animationTimingFunc;
        }

        return property + ' 0ms ' + settings.animationTimingFunc;
      },


      /**
       * Sets value of transition on HTML element.
       *
       * @param {String=} property
       * @return {Void}
       */
      set: function set() {
        var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

        Components.Html.wrapper.style.transition = this.compose(property);
      },


      /**
       * Removes value of transition from HTML element.
       *
       * @return {Void}
       */
      remove: function remove() {
        Components.Html.wrapper.style.transition = '';
      },


      /**
       * Runs callback after animation.
       *
       * @param  {Function} callback
       * @return {Void}
       */
      after: function after(callback) {
        setTimeout(function () {
          callback();
        }, this.duration);
      },


      /**
       * Enable transition.
       *
       * @return {Void}
       */
      enable: function enable() {
        disabled = false;

        this.set();
      },


      /**
       * Disable transition.
       *
       * @return {Void}
       */
      disable: function disable() {
        disabled = true;

        this.set();
      }
    };

    define(Transition, 'duration', {
      /**
       * Gets duration of the transition based
       * on currently running animation type.
       *
       * @return {Number}
       */
      get: function get() {
        var settings = Glide.settings;

        if (Glide.isType('slider') && Components.Run.offset) {
          return settings.rewindDuration;
        }

        return settings.animationDuration;
      }
    });

    /**
     * Set transition `style` value:
     * - on each moving, because it may be cleared by offset move
     */
    Events.on('move', function () {
      Transition.set();
    });

    /**
     * Disable transition:
     * - before initial build to avoid transitioning from `0` to `startAt` index
     * - while resizing window and recalculating dimentions
     * - on jumping from offset transition at start and end edges in `carousel` type
     */
    Events.on(['build.before', 'resize', 'translate.jump'], function () {
      Transition.disable();
    });

    /**
     * Enable transition:
     * - on each running, because it may be disabled by offset move
     */
    Events.on('run', function () {
      Transition.enable();
    });

    /**
     * Remove transition:
     * - on destroying to bring markup to its inital state
     */
    Events.on('destroy', function () {
      Transition.remove();
    });

    return Transition;
  }

  /**
   * Test via a getter in the options object to see
   * if the passive property is accessed.
   *
   * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
   */

  var supportsPassive = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassive = true;
      }
    });

    window.addEventListener('testPassive', null, opts);
    window.removeEventListener('testPassive', null, opts);
  } catch (e) {}

  var supportsPassive$1 = supportsPassive;

  var START_EVENTS = ['touchstart', 'mousedown'];
  var MOVE_EVENTS = ['touchmove', 'mousemove'];
  var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
  var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

  function Swipe (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = supportsPassive$1 ? { passive: true } : false;

    var Swipe = {
      /**
       * Initializes swipe bindings.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bindSwipeStart();
      },


      /**
       * Handler for `swipestart` event. Calculates entry points of the user's tap.
       *
       * @param {Object} event
       * @return {Void}
       */
      start: function start(event) {
        if (!disabled && !Glide.disabled) {
          this.disable();

          var swipe = this.touches(event);

          swipeSin = null;
          swipeStartX = toInt(swipe.pageX);
          swipeStartY = toInt(swipe.pageY);

          this.bindSwipeMove();
          this.bindSwipeEnd();

          Events.emit('swipe.start');
        }
      },


      /**
       * Handler for `swipemove` event. Calculates user's tap angle and distance.
       *
       * @param {Object} event
       */
      move: function move(event) {
        if (!Glide.disabled) {
          var _Glide$settings = Glide.settings,
              touchAngle = _Glide$settings.touchAngle,
              touchRatio = _Glide$settings.touchRatio,
              classes = _Glide$settings.classes;


          var swipe = this.touches(event);

          var subExSx = toInt(swipe.pageX) - swipeStartX;
          var subEySy = toInt(swipe.pageY) - swipeStartY;
          var powEX = Math.abs(subExSx << 2);
          var powEY = Math.abs(subEySy << 2);
          var swipeHypotenuse = Math.sqrt(powEX + powEY);
          var swipeCathetus = Math.sqrt(powEY);

          swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

          if (swipeSin * 180 / Math.PI < touchAngle) {
            event.stopPropagation();

            Components.Move.make(subExSx * toFloat(touchRatio));

            Components.Html.root.classList.add(classes.dragging);

            Events.emit('swipe.move');
          } else {
            return false;
          }
        }
      },


      /**
       * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
       *
       * @param {Object} event
       * @return {Void}
       */
      end: function end(event) {
        if (!Glide.disabled) {
          var settings = Glide.settings;

          var swipe = this.touches(event);
          var threshold = this.threshold(event);

          var swipeDistance = swipe.pageX - swipeStartX;
          var swipeDeg = swipeSin * 180 / Math.PI;
          var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);

          this.enable();

          if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
            // While swipe is positive and greater than threshold move backward.
            if (settings.perTouch) {
              steps = Math.min(steps, toInt(settings.perTouch));
            }

            if (Components.Direction.is('rtl')) {
              steps = -steps;
            }

            Components.Run.make(Components.Direction.resolve('<' + steps));
          } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
            // While swipe is negative and lower than negative threshold move forward.
            if (settings.perTouch) {
              steps = Math.max(steps, -toInt(settings.perTouch));
            }

            if (Components.Direction.is('rtl')) {
              steps = -steps;
            }

            Components.Run.make(Components.Direction.resolve('>' + steps));
          } else {
            // While swipe don't reach distance apply previous transform.
            Components.Move.make();
          }

          Components.Html.root.classList.remove(settings.classes.dragging);

          this.unbindSwipeMove();
          this.unbindSwipeEnd();

          Events.emit('swipe.end');
        }
      },


      /**
       * Binds swipe's starting event.
       *
       * @return {Void}
       */
      bindSwipeStart: function bindSwipeStart() {
        var _this = this;

        var settings = Glide.settings;

        if (settings.swipeThreshold) {
          Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }

        if (settings.dragThreshold) {
          Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
            _this.start(event);
          }, capture);
        }
      },


      /**
       * Unbinds swipe's starting event.
       *
       * @return {Void}
       */
      unbindSwipeStart: function unbindSwipeStart() {
        Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
        Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
      },


      /**
       * Binds swipe's moving event.
       *
       * @return {Void}
       */
      bindSwipeMove: function bindSwipeMove() {
        var _this2 = this;

        Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
          _this2.move(event);
        }, Glide.settings.throttle), capture);
      },


      /**
       * Unbinds swipe's moving event.
       *
       * @return {Void}
       */
      unbindSwipeMove: function unbindSwipeMove() {
        Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
      },


      /**
       * Binds swipe's ending event.
       *
       * @return {Void}
       */
      bindSwipeEnd: function bindSwipeEnd() {
        var _this3 = this;

        Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
          _this3.end(event);
        });
      },


      /**
       * Unbinds swipe's ending event.
       *
       * @return {Void}
       */
      unbindSwipeEnd: function unbindSwipeEnd() {
        Binder.off(END_EVENTS, Components.Html.wrapper);
      },


      /**
       * Normalizes event touches points accorting to different types.
       *
       * @param {Object} event
       */
      touches: function touches(event) {
        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return event;
        }

        return event.touches[0] || event.changedTouches[0];
      },


      /**
       * Gets value of minimum swipe distance settings based on event type.
       *
       * @return {Number}
       */
      threshold: function threshold(event) {
        var settings = Glide.settings;

        if (MOUSE_EVENTS.indexOf(event.type) > -1) {
          return settings.dragThreshold;
        }

        return settings.swipeThreshold;
      },


      /**
       * Enables swipe event.
       *
       * @return {self}
       */
      enable: function enable() {
        disabled = false;

        Components.Transition.enable();

        return this;
      },


      /**
       * Disables swipe event.
       *
       * @return {self}
       */
      disable: function disable() {
        disabled = true;

        Components.Transition.disable();

        return this;
      }
    };

    /**
     * Add component class:
     * - after initial building
     */
    Events.on('build.after', function () {
      Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });

    /**
     * Remove swiping bindings:
     * - on destroying, to remove added EventListeners
     */
    Events.on('destroy', function () {
      Swipe.unbindSwipeStart();
      Swipe.unbindSwipeMove();
      Swipe.unbindSwipeEnd();
      Binder.destroy();
    });

    return Swipe;
  }

  function Images (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Images = {
      /**
       * Binds listener to glide wrapper.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.bind();
      },


      /**
       * Binds `dragstart` event on wrapper to prevent dragging images.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
      },


      /**
       * Unbinds `dragstart` event on wrapper.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('dragstart', Components.Html.wrapper);
      },


      /**
       * Event handler. Prevents dragging.
       *
       * @return {Void}
       */
      dragstart: function dragstart(event) {
        event.preventDefault();
      }
    };

    /**
     * Remove bindings from images:
     * - on destroying, to remove added EventListeners
     */
    Events.on('destroy', function () {
      Images.unbind();
      Binder.destroy();
    });

    return Images;
  }

  function Anchors (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    /**
     * Holds detaching status of anchors.
     * Prevents detaching of already detached anchors.
     *
     * @private
     * @type {Boolean}
     */
    var detached = false;

    /**
     * Holds preventing status of anchors.
     * If `true` redirection after click will be disabled.
     *
     * @private
     * @type {Boolean}
     */
    var prevented = false;

    var Anchors = {
      /**
       * Setups a initial state of anchors component.
       *
       * @returns {Void}
       */
      mount: function mount() {
        /**
         * Holds collection of anchors elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._a = Components.Html.wrapper.querySelectorAll('a');

        this.bind();
      },


      /**
       * Binds events to anchors inside a track.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('click', Components.Html.wrapper, this.click);
      },


      /**
       * Unbinds events attached to anchors inside a track.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('click', Components.Html.wrapper);
      },


      /**
       * Handler for click event. Prevents clicks when glide is in `prevent` status.
       *
       * @param  {Object} event
       * @return {Void}
       */
      click: function click(event) {
        if (prevented) {
          event.stopPropagation();
          event.preventDefault();
        }
      },


      /**
       * Detaches anchors click event inside glide.
       *
       * @return {self}
       */
      detach: function detach() {
        prevented = true;

        if (!detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = false;

            this.items[i].setAttribute('data-href', this.items[i].getAttribute('href'));

            this.items[i].removeAttribute('href');
          }

          detached = true;
        }

        return this;
      },


      /**
       * Attaches anchors click events inside glide.
       *
       * @return {self}
       */
      attach: function attach() {
        prevented = false;

        if (detached) {
          for (var i = 0; i < this.items.length; i++) {
            this.items[i].draggable = true;

            this.items[i].setAttribute('href', this.items[i].getAttribute('data-href'));
          }

          detached = false;
        }

        return this;
      }
    };

    define(Anchors, 'items', {
      /**
       * Gets collection of the arrows HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Anchors._a;
      }
    });

    /**
     * Detach anchors inside slides:
     * - on swiping, so they won't redirect to its `href` attributes
     */
    Events.on('swipe.move', function () {
      Anchors.detach();
    });

    /**
     * Attach anchors inside slides:
     * - after swiping and transitions ends, so they can redirect after click again
     */
    Events.on('swipe.end', function () {
      Components.Transition.after(function () {
        Anchors.attach();
      });
    });

    /**
     * Unbind anchors inside slides:
     * - on destroying, to bring anchors to its initial state
     */
    Events.on('destroy', function () {
      Anchors.attach();
      Anchors.unbind();
      Binder.destroy();
    });

    return Anchors;
  }

  var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
  var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';

  function Controls (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var capture = supportsPassive$1 ? { passive: true } : false;

    var Controls = {
      /**
       * Inits arrows. Binds events listeners
       * to the arrows HTML elements.
       *
       * @return {Void}
       */
      mount: function mount() {
        /**
         * Collection of navigation HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);

        /**
         * Collection of controls HTML elements.
         *
         * @private
         * @type {HTMLCollection}
         */
        this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);

        this.addBindings();
      },


      /**
       * Sets active class to current slide.
       *
       * @return {Void}
       */
      setActive: function setActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.addClass(this._n[i].children);
        }
      },


      /**
       * Removes active class to current slide.
       *
       * @return {Void}
       */
      removeActive: function removeActive() {
        for (var i = 0; i < this._n.length; i++) {
          this.removeClass(this._n[i].children);
        }
      },


      /**
       * Toggles active class on items inside navigation.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      addClass: function addClass(controls) {
        var settings = Glide.settings;
        var item = controls[Glide.index];

        if (item) {
          item.classList.add(settings.classes.activeNav);

          siblings(item).forEach(function (sibling) {
            sibling.classList.remove(settings.classes.activeNav);
          });
        }
      },


      /**
       * Removes active class from active control.
       *
       * @param  {HTMLElement} controls
       * @return {Void}
       */
      removeClass: function removeClass(controls) {
        var item = controls[Glide.index];

        if (item) {
          item.classList.remove(Glide.settings.classes.activeNav);
        }
      },


      /**
       * Adds handles to the each group of controls.
       *
       * @return {Void}
       */
      addBindings: function addBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.bind(this._c[i].children);
        }
      },


      /**
       * Removes handles from the each group of controls.
       *
       * @return {Void}
       */
      removeBindings: function removeBindings() {
        for (var i = 0; i < this._c.length; i++) {
          this.unbind(this._c[i].children);
        }
      },


      /**
       * Binds events to arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      bind: function bind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.on('click', elements[i], this.click);
          Binder.on('touchstart', elements[i], this.click, capture);
        }
      },


      /**
       * Unbinds events binded to the arrows HTML elements.
       *
       * @param {HTMLCollection} elements
       * @return {Void}
       */
      unbind: function unbind(elements) {
        for (var i = 0; i < elements.length; i++) {
          Binder.off(['click', 'touchstart'], elements[i]);
        }
      },


      /**
       * Handles `click` event on the arrows HTML elements.
       * Moves slider in driection precised in
       * `data-glide-dir` attribute.
       *
       * @param {Object} event
       * @return {Void}
       */
      click: function click(event) {
        event.preventDefault();

        Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute('data-glide-dir')));
      }
    };

    define(Controls, 'items', {
      /**
       * Gets collection of the controls HTML elements.
       *
       * @return {HTMLElement[]}
       */
      get: function get() {
        return Controls._c;
      }
    });

    /**
     * Swap active class of current navigation item:
     * - after mounting to set it to initial index
     * - after each move to the new index
     */
    Events.on(['mount.after', 'move.after'], function () {
      Controls.setActive();
    });

    /**
     * Remove bindings and HTML Classes:
     * - on destroying, to bring markup to its initial state
     */
    Events.on('destroy', function () {
      Controls.removeBindings();
      Controls.removeActive();
      Binder.destroy();
    });

    return Controls;
  }

  function Keyboard (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Keyboard = {
      /**
       * Binds keyboard events on component mount.
       *
       * @return {Void}
       */
      mount: function mount() {
        if (Glide.settings.keyboard) {
          this.bind();
        }
      },


      /**
       * Adds keyboard press events.
       *
       * @return {Void}
       */
      bind: function bind() {
        Binder.on('keyup', document, this.press);
      },


      /**
       * Removes keyboard press events.
       *
       * @return {Void}
       */
      unbind: function unbind() {
        Binder.off('keyup', document);
      },


      /**
       * Handles keyboard's arrows press and moving glide foward and backward.
       *
       * @param  {Object} event
       * @return {Void}
       */
      press: function press(event) {
        if (event.keyCode === 39) {
          Components.Run.make(Components.Direction.resolve('>'));
        }

        if (event.keyCode === 37) {
          Components.Run.make(Components.Direction.resolve('<'));
        }
      }
    };

    /**
     * Remove bindings from keyboard:
     * - on destroying to remove added events
     * - on updating to remove events before remounting
     */
    Events.on(['destroy', 'update'], function () {
      Keyboard.unbind();
    });

    /**
     * Remount component
     * - on updating to reflect potential changes in settings
     */
    Events.on('update', function () {
      Keyboard.mount();
    });

    /**
     * Destroy binder:
     * - on destroying to remove listeners
     */
    Events.on('destroy', function () {
      Binder.destroy();
    });

    return Keyboard;
  }

  function Autoplay (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    var Autoplay = {
      /**
       * Initializes autoplaying and events.
       *
       * @return {Void}
       */
      mount: function mount() {
        this.start();

        if (Glide.settings.hoverpause) {
          this.bind();
        }
      },


      /**
       * Starts autoplaying in configured interval.
       *
       * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
       * @return {Void}
       */
      start: function start() {
        var _this = this;

        if (Glide.settings.autoplay) {
          if (isUndefined(this._i)) {
            this._i = setInterval(function () {
              _this.stop();

              Components.Run.make('>');

              _this.start();
            }, this.time);
          }
        }
      },


      /**
       * Stops autorunning of the glide.
       *
       * @return {Void}
       */
      stop: function stop() {
        this._i = clearInterval(this._i);
      },


      /**
       * Stops autoplaying while mouse is over glide's area.
       *
       * @return {Void}
       */
      bind: function bind() {
        var _this2 = this;

        Binder.on('mouseover', Components.Html.root, function () {
          _this2.stop();
        });

        Binder.on('mouseout', Components.Html.root, function () {
          _this2.start();
        });
      },


      /**
       * Unbind mouseover events.
       *
       * @returns {Void}
       */
      unbind: function unbind() {
        Binder.off(['mouseover', 'mouseout'], Components.Html.root);
      }
    };

    define(Autoplay, 'time', {
      /**
       * Gets time period value for the autoplay interval. Prioritizes
       * times in `data-glide-autoplay` attrubutes over options.
       *
       * @return {Number}
       */
      get: function get() {
        var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

        if (autoplay) {
          return toInt(autoplay);
        }

        return toInt(Glide.settings.autoplay);
      }
    });

    /**
     * Stop autoplaying and unbind events:
     * - on destroying, to clear defined interval
     * - on updating via API to reset interval that may changed
     */
    Events.on(['destroy', 'update'], function () {
      Autoplay.unbind();
    });

    /**
     * Stop autoplaying:
     * - before each run, to restart autoplaying
     * - on pausing via API
     * - on destroying, to clear defined interval
     * - while starting a swipe
     * - on updating via API to reset interval that may changed
     */
    Events.on(['run.before', 'pause', 'destroy', 'swipe.start', 'update'], function () {
      Autoplay.stop();
    });

    /**
     * Start autoplaying:
     * - after each run, to restart autoplaying
     * - on playing via API
     * - while ending a swipe
     */
    Events.on(['run.after', 'play', 'swipe.end'], function () {
      Autoplay.start();
    });

    /**
     * Remount autoplaying:
     * - on updating via API to reset interval that may changed
     */
    Events.on('update', function () {
      Autoplay.mount();
    });

    /**
     * Destroy a binder:
     * - on destroying glide instance to clearup listeners
     */
    Events.on('destroy', function () {
      Binder.destroy();
    });

    return Autoplay;
  }

  /**
   * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
   *
   * @param {Object} points
   * @returns {Object}
   */
  function sortBreakpoints(points) {
    if (isObject(points)) {
      return sortKeys(points);
    } else {
      warn('Breakpoints option must be an object');
    }

    return {};
  }

  function Breakpoints (Glide, Components, Events) {
    /**
     * Instance of the binder for DOM Events.
     *
     * @type {EventsBinder}
     */
    var Binder = new EventsBinder();

    /**
     * Holds reference to settings.
     *
     * @type {Object}
     */
    var settings = Glide.settings;

    /**
     * Holds reference to breakpoints object in settings. Sorts breakpoints
     * from smaller to larger. It is required in order to proper
     * matching currently active breakpoint settings.
     *
     * @type {Object}
     */
    var points = sortBreakpoints(settings.breakpoints);

    /**
     * Cache initial settings before overwritting.
     *
     * @type {Object}
     */
    var defaults = _extends({}, settings);

    var Breakpoints = {
      /**
       * Matches settings for currectly matching media breakpoint.
       *
       * @param {Object} points
       * @returns {Object}
       */
      match: function match(points) {
        if (typeof window.matchMedia !== 'undefined') {
          for (var point in points) {
            if (points.hasOwnProperty(point)) {
              if (window.matchMedia('(max-width: ' + point + 'px)').matches) {
                return points[point];
              }
            }
          }
        }

        return defaults;
      }
    };

    /**
     * Overwrite instance settings with currently matching breakpoint settings.
     * This happens right after component initialization.
     */
    _extends(settings, Breakpoints.match(points));

    /**
     * Update glide with settings of matched brekpoint:
     * - window resize to update slider
     */
    Binder.on('resize', window, throttle(function () {
      Glide.settings = mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));

    /**
     * Resort and update default settings:
     * - on reinit via API, so breakpoint matching will be performed with options
     */
    Events.on('update', function () {
      points = sortBreakpoints(points);

      defaults = _extends({}, settings);
    });

    /**
     * Unbind resize listener:
     * - on destroying, to bring markup to its initial state
     */
    Events.on('destroy', function () {
      Binder.off('resize', window);
    });

    return Breakpoints;
  }

  var COMPONENTS = {
    // Required
    Html: Html,
    Translate: Translate,
    Transition: Transition,
    Direction: Direction,
    Peek: Peek,
    Sizes: Sizes,
    Gaps: Gaps,
    Move: Move,
    Clones: Clones,
    Resize: Resize,
    Build: Build,
    Run: Run,

    // Optional
    Swipe: Swipe,
    Images: Images,
    Anchors: Anchors,
    Controls: Controls,
    Keyboard: Keyboard,
    Autoplay: Autoplay,
    Breakpoints: Breakpoints
  };

  var Glide$1 = function (_Core) {
    inherits(Glide$$1, _Core);

    function Glide$$1() {
      classCallCheck(this, Glide$$1);
      return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
    }

    createClass(Glide$$1, [{
      key: 'mount',
      value: function mount() {
        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), 'mount', this).call(this, _extends({}, COMPONENTS, extensions));
      }
    }]);
    return Glide$$1;
  }(Glide);

  return Glide$1;

})));

},{}],80:[function(require,module,exports){
(function (global){(function (){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"core-js/fn/regexp/escape":82,"core-js/shim":404,"regenerator-runtime/runtime":410}],81:[function(require,module,exports){
(function (process){(function (){
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.browserDetect = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */

    var __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    var browsers = [
        ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
        ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
        ['opera', /OPR\/([0-9\.]+)(:?\s|$)$/],
        ['edge', /Edge\/([0-9\._]+)/],
        ['ie', /Trident\/7\.0.*rv\:([0-9\.]+)\).*Gecko$/],
        ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
        ['ie', /MSIE\s(7\.0)/],
        ['safari', /Version\/([0-9\._]+).*Safari/],
        ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
        ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
        ['android', /Android\s([0-9\.]+)/],
        ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
        ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
        ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/]
    ];
    var os = [
        'Windows Phone',
        'Android',
        'CentOS',
        { name: 'Chrome OS', pattern: 'CrOS' },
        'Debian',
        'Fedora',
        'FreeBSD',
        'Gentoo',
        'Haiku',
        'Kubuntu',
        'Linux Mint',
        'OpenBSD',
        'Red Hat',
        'SuSE',
        'Ubuntu',
        'Xubuntu',
        'Cygwin',
        'Symbian OS',
        'hpwOS',
        'webOS ',
        'webOS',
        'Tablet OS',
        'Tizen',
        'Linux',
        'Mac OS X',
        'Macintosh',
        'Mac',
        'Windows 98;',
        'Windows '
    ];
    var osVersions = {
        '10.0': '10',
        '6.4': '10 Technical Preview',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': 'Server 2008 R2 / 7',
        '6.0': 'Server 2008 / Vista',
        '5.2': 'Server 2003 / XP 64-bit',
        '5.1': 'XP',
        '5.01': '2000 SP1',
        '5.0': '2000',
        '4.0': 'NT',
        '4.90': 'ME'
    };

    var mobileRegExp = new RegExp(['(android|bb\\d+|meego).+mobile|avantgo|bada\\/|blackberry|blazer|',
        'compal|elaine|fennec|hiptop|iemobile|ip(hone|od|ad)|iris|kindle|lge |maemo|',
        'midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)',
        '\\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\\.(browser|link)|vodafone|',
        'wap|windows ce|xda|xiino'].join(''), 'i');
    var mobilePrefixRegExp = new RegExp(['1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\\-)|',
        'ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\\-m|r |s )|',
        'avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\\-(n|u)|c55\\/|capi|ccwa|cdm\\-|',
        'cell|chtm|cldc|cmd\\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\\-s|devi|dica|dmob|do(c|p)o|',
        'ds(12|\\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\\-|_)|',
        'g1 u|g560|gene|gf\\-5|g\\-mo|go(\\.w|od)|gr(ad|un)|haie|hcit|hd\\-(m|p|t)|hei\\-|',
        'hi(pt|ta)|hp( i|ip)|hs\\-c|ht(c(\\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\\-(20|go|ma)|',
        'i230|iac( |\\-|\\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|',
        'kddi|keji|kgt( |\\/)|klon|kpt |kwc\\-|kyo(c|k)|le(no|xi)|lg( g|\\/(k|l|u)|50|54|\\-[a-w])',
        '|libw|lynx|m1\\-w|m3ga|m50\\/|ma(te|ui|xo)|mc(01|21|ca)|m\\-cr|me(rc|ri)|mi(o8|oa|ts)|',
        'mmef|mo(01|02|bi|de|do|t(\\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|',
        'n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|',
        'op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\\-2|',
        'po(ck|rt|se)|prox|psio|pt\\-g|qa\\-a|qc(07|12|21|32|60|\\-[2-7]|i\\-)|qtek|r380|r600|',
        'raks|rim9|ro(ve|zo)|s55\\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\\-|oo|p\\-)|sdk\\/|',
        'se(c(\\-|0|1)|47|mc|nd|ri)|sgh\\-|shar|sie(\\-|m)|k\\-0|sl(45|id)|sm(al|ar|b3|it|t5)|',
        'so(ft|ny)|sp(01|h\\-|v\\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\\-|tdg\\-|',
        'tel(i|m)|tim\\-|t\\-mo|to(pl|sh)|ts(70|m\\-|m3|m5)|tx\\-9|up(\\.b|g1|si)|utst|v400|v750|',
        'veri|vi(rg|te)|vk(40|5[0-3]|\\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|',
        'w3c(\\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\\-|your|zeto|zte\\-'].join(''), 'i');

    var Detector = /** @class */ (function () {
        function Detector(userAgent, navigator, process) {
            this.navigator = navigator;
            this.process = process;
            this.userAgent = userAgent
                ? userAgent
                : this.navigator ? (navigator.userAgent || navigator.vendor) : '';
        }
        Detector.prototype.detect = function () {
            if (this.process && !this.userAgent) {
                var version = this.process.version.slice(1).split('.').slice(0, 3);
                var versionTail = Array.prototype.slice.call(version, 1).join('') || '0';
                return {
                    name: 'node',
                    version: version.join('.'),
                    versionNumber: parseFloat(version[0] + "." + versionTail),
                    mobile: false,
                    os: this.process.platform
                };
            }
            if (!this.userAgent)
                this.handleMissingError();
            return __assign({}, this.checkBrowser(), this.checkMobile(), this.checkOs());
        };
        Detector.prototype.checkBrowser = function () {
            var _this = this;
            return browsers
                .filter(function (definition) { return definition[1].test(_this.userAgent); })
                .map(function (definition) {
                var match = definition[1].exec(_this.userAgent);
                var version = match && match[1].split(/[._]/).slice(0, 3);
                var versionTails = Array.prototype.slice.call(version, 1).join('') || '0';
                if (version && version.length < 3)
                    Array.prototype.push.apply(version, version.length === 1 ? [0, 0] : [0]);
                return {
                    name: String(definition[0]),
                    version: version.join('.'),
                    versionNumber: Number(version[0] + "." + versionTails)
                };
            })
                .shift();
        };
        Detector.prototype.checkMobile = function () {
            var agentPrefix = this.userAgent.substr(0, 4);
            var mobile = mobileRegExp.test(this.userAgent) || mobilePrefixRegExp.test(agentPrefix);
            return { mobile: mobile };
        };
        Detector.prototype.checkOs = function () {
            var _this = this;
            return os
                .map(function (definition) {
                var name = definition.name || definition;
                var pattern = _this.getOsPattern(definition);
                return {
                    name: name,
                    pattern: pattern,
                    value: RegExp("\\b" + pattern.replace(/([ -])(?!$)/g, '$1?') + "(?:x?[\\d._]+|[ \\w.]*)", 'i').exec(_this.userAgent)
                };
            })
                .filter(function (definition) { return definition.value; })
                .map(function (definition) {
                var os$$1 = definition.value[0] || '';
                var osSuffix;
                if (definition.pattern &&
                    definition.name &&
                    /^Win/i.test(os$$1) &&
                    !/^Windows Phone /i.test(os$$1) &&
                    (osSuffix = osVersions[os$$1.replace(/[^\d.]/g, '')]))
                    os$$1 = "Windows " + osSuffix;
                if (definition.pattern && definition.name)
                    os$$1 = os$$1.replace(RegExp(definition.pattern, 'i'), definition.name);
                os$$1 = os$$1
                    .replace(/ ce$/i, ' CE')
                    .replace(/\bhpw/i, 'web')
                    .replace(/\bMacintosh\b/, 'Mac OS')
                    .replace(/_PowerPC\b/i, ' OS')
                    .replace(/\b(OS X) [^ \d]+/i, '$1')
                    .replace(/\bMac (OS X)\b/, '$1')
                    .replace(/\/(\d)/, ' $1')
                    .replace(/_/g, '.')
                    .replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '')
                    .replace(/\bx86\.64\b/gi, 'x86_64')
                    .replace(/\b(Windows Phone) OS\b/, '$1')
                    .replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1')
                    .split(' on ')[0]
                    .trim();
                os$$1 = /^(?:webOS|i(?:OS|P))/.test(os$$1)
                    ? os$$1
                    : (os$$1.charAt(0).toUpperCase() + os$$1.slice(1));
                return { os: os$$1 };
            })
                .shift();
        };
        Detector.prototype.getOsPattern = function (definition) {
            var definitionInterface = definition;
            return (typeof definition === 'string'
                ? definition
                : undefined) ||
                definitionInterface.pattern ||
                definitionInterface.name;
        };
        Detector.prototype.handleMissingError = function () {
            throw new Error('Please give user-agent.\n> browser(navigator.userAgent or res.headers[\'user-agent\']).');
        };
        return Detector;
    }());

    function createCommonjsModule(fn, module) {
    	return module = { exports: {} }, fn(module, module.exports), module.exports;
    }

    var _global = createCommonjsModule(function (module) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = typeof window != 'undefined' && window.Math == Math
      ? window : typeof self != 'undefined' && self.Math == Math ? self
      // eslint-disable-next-line no-new-func
      : Function('return this')();
    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
    });

    var _core = createCommonjsModule(function (module) {
    var core = module.exports = { version: '2.5.7' };
    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
    });
    var _core_1 = _core.version;

    var _isObject = function (it) {
      return typeof it === 'object' ? it !== null : typeof it === 'function';
    };

    var _anObject = function (it) {
      if (!_isObject(it)) throw TypeError(it + ' is not an object!');
      return it;
    };

    var _fails = function (exec) {
      try {
        return !!exec();
      } catch (e) {
        return true;
      }
    };

    // Thank's IE8 for his funny defineProperty
    var _descriptors = !_fails(function () {
      return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
    });

    var document = _global.document;
    // typeof document.createElement is 'object' in old IE
    var is = _isObject(document) && _isObject(document.createElement);
    var _domCreate = function (it) {
      return is ? document.createElement(it) : {};
    };

    var _ie8DomDefine = !_descriptors && !_fails(function () {
      return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
    });

    // 7.1.1 ToPrimitive(input [, PreferredType])

    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string
    var _toPrimitive = function (it, S) {
      if (!_isObject(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };

    var dP = Object.defineProperty;

    var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
      _anObject(O);
      P = _toPrimitive(P, true);
      _anObject(Attributes);
      if (_ie8DomDefine) try {
        return dP(O, P, Attributes);
      } catch (e) { /* empty */ }
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };

    var _objectDp = {
    	f: f
    };

    var _propertyDesc = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };

    var _hide = _descriptors ? function (object, key, value) {
      return _objectDp.f(object, key, _propertyDesc(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };

    var hasOwnProperty = {}.hasOwnProperty;
    var _has = function (it, key) {
      return hasOwnProperty.call(it, key);
    };

    var id = 0;
    var px = Math.random();
    var _uid = function (key) {
      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
    };

    var _redefine = createCommonjsModule(function (module) {
    var SRC = _uid('src');
    var TO_STRING = 'toString';
    var $toString = Function[TO_STRING];
    var TPL = ('' + $toString).split(TO_STRING);

    _core.inspectSource = function (it) {
      return $toString.call(it);
    };

    (module.exports = function (O, key, val, safe) {
      var isFunction = typeof val == 'function';
      if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
      if (O[key] === val) return;
      if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
      if (O === _global) {
        O[key] = val;
      } else if (!safe) {
        delete O[key];
        _hide(O, key, val);
      } else if (O[key]) {
        O[key] = val;
      } else {
        _hide(O, key, val);
      }
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, TO_STRING, function toString() {
      return typeof this == 'function' && this[SRC] || $toString.call(this);
    });
    });

    var _aFunction = function (it) {
      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
      return it;
    };

    // optional / simple context binding

    var _ctx = function (fn, that, length) {
      _aFunction(fn);
      if (that === undefined) return fn;
      switch (length) {
        case 1: return function (a) {
          return fn.call(that, a);
        };
        case 2: return function (a, b) {
          return fn.call(that, a, b);
        };
        case 3: return function (a, b, c) {
          return fn.call(that, a, b, c);
        };
      }
      return function (/* ...args */) {
        return fn.apply(that, arguments);
      };
    };

    var PROTOTYPE = 'prototype';

    var $export = function (type, name, source) {
      var IS_FORCED = type & $export.F;
      var IS_GLOBAL = type & $export.G;
      var IS_STATIC = type & $export.S;
      var IS_PROTO = type & $export.P;
      var IS_BIND = type & $export.B;
      var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
      var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
      var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
      var key, own, out, exp;
      if (IS_GLOBAL) source = name;
      for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        // export native or passed
        out = (own ? target : source)[key];
        // bind timers to global for call from export context
        exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
        // extend global
        if (target) _redefine(target, key, out, type & $export.U);
        // export
        if (exports[key] != out) _hide(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
      }
    };
    _global.core = _core;
    // type bitmap
    $export.F = 1;   // forced
    $export.G = 2;   // global
    $export.S = 4;   // static
    $export.P = 8;   // proto
    $export.B = 16;  // bind
    $export.W = 32;  // wrap
    $export.U = 64;  // safe
    $export.R = 128; // real proto method for `library`
    var _export = $export;

    var toString = {}.toString;

    var _cof = function (it) {
      return toString.call(it).slice(8, -1);
    };

    // fallback for non-array-like ES3 and non-enumerable old V8 strings

    // eslint-disable-next-line no-prototype-builtins
    var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
      return _cof(it) == 'String' ? it.split('') : Object(it);
    };

    // 7.2.1 RequireObjectCoercible(argument)
    var _defined = function (it) {
      if (it == undefined) throw TypeError("Can't call method on  " + it);
      return it;
    };

    // 7.1.13 ToObject(argument)

    var _toObject = function (it) {
      return Object(_defined(it));
    };

    // 7.1.4 ToInteger
    var ceil = Math.ceil;
    var floor = Math.floor;
    var _toInteger = function (it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };

    // 7.1.15 ToLength

    var min = Math.min;
    var _toLength = function (it) {
      return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
    };

    // 7.2.2 IsArray(argument)

    var _isArray = Array.isArray || function isArray(arg) {
      return _cof(arg) == 'Array';
    };

    var _shared = createCommonjsModule(function (module) {
    var SHARED = '__core-js_shared__';
    var store = _global[SHARED] || (_global[SHARED] = {});

    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: _core.version,
      mode: 'global',
      copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
    });
    });

    var _wks = createCommonjsModule(function (module) {
    var store = _shared('wks');

    var Symbol = _global.Symbol;
    var USE_SYMBOL = typeof Symbol == 'function';

    var $exports = module.exports = function (name) {
      return store[name] || (store[name] =
        USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
    };

    $exports.store = store;
    });

    var SPECIES = _wks('species');

    var _arraySpeciesConstructor = function (original) {
      var C;
      if (_isArray(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
        if (_isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      } return C === undefined ? Array : C;
    };

    // 9.4.2.3 ArraySpeciesCreate(originalArray, length)


    var _arraySpeciesCreate = function (original, length) {
      return new (_arraySpeciesConstructor(original))(length);
    };

    // 0 -> Array#forEach
    // 1 -> Array#map
    // 2 -> Array#filter
    // 3 -> Array#some
    // 4 -> Array#every
    // 5 -> Array#find
    // 6 -> Array#findIndex





    var _arrayMethods = function (TYPE, $create) {
      var IS_MAP = TYPE == 1;
      var IS_FILTER = TYPE == 2;
      var IS_SOME = TYPE == 3;
      var IS_EVERY = TYPE == 4;
      var IS_FIND_INDEX = TYPE == 6;
      var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
      var create = $create || _arraySpeciesCreate;
      return function ($this, callbackfn, that) {
        var O = _toObject($this);
        var self = _iobject(O);
        var f = _ctx(callbackfn, that, 3);
        var length = _toLength(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for (;length > index; index++) if (NO_HOLES || index in self) {
          val = self[index];
          res = f(val, index, O);
          if (TYPE) {
            if (IS_MAP) result[index] = res;   // map
            else if (res) switch (TYPE) {
              case 3: return true;             // some
              case 5: return val;              // find
              case 6: return index;            // findIndex
              case 2: result.push(val);        // filter
            } else if (IS_EVERY) return false; // every
          }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
      };
    };

    var _strictMethod = function (method, arg) {
      return !!method && _fails(function () {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
      });
    };

    var $filter = _arrayMethods(2);

    _export(_export.P + _export.F * !_strictMethod([].filter, true), 'Array', {
      // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
      filter: function filter(callbackfn /* , thisArg */) {
        return $filter(this, callbackfn, arguments[1]);
      }
    });

    var filter = _core.Array.filter;

    var $map = _arrayMethods(1);

    _export(_export.P + _export.F * !_strictMethod([].map, true), 'Array', {
      // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
      map: function map(callbackfn /* , thisArg */) {
        return $map(this, callbackfn, arguments[1]);
      }
    });

    var map = _core.Array.map;

    var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
      '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

    var space = '[' + _stringWs + ']';
    var non = '\u200b\u0085';
    var ltrim = RegExp('^' + space + space + '*');
    var rtrim = RegExp(space + space + '*$');

    var exporter = function (KEY, exec, ALIAS) {
      var exp = {};
      var FORCE = _fails(function () {
        return !!_stringWs[KEY]() || non[KEY]() != non;
      });
      var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
      if (ALIAS) exp[ALIAS] = fn;
      _export(_export.P + _export.F * FORCE, 'String', exp);
    };

    // 1 -> String#trimLeft
    // 2 -> String#trimRight
    // 3 -> String#trim
    var trim = exporter.trim = function (string, TYPE) {
      string = String(_defined(string));
      if (TYPE & 1) string = string.replace(ltrim, '');
      if (TYPE & 2) string = string.replace(rtrim, '');
      return string;
    };

    var _stringTrim = exporter;

    // 21.1.3.25 String.prototype.trim()
    _stringTrim('trim', function ($trim) {
      return function trim() {
        return $trim(this, 3);
      };
    });

    var trim$1 = _core.String.trim;

    var injectableNavigator = typeof window !== 'undefined'
        ? window.navigator
        : undefined;
    var injectableProcess = typeof process !== 'undefined'
        ? process
        : undefined;
    function browserDetect (userAgent) {
        var detector = new Detector(userAgent, injectableNavigator, injectableProcess);
        return detector.detect();
    }

    return browserDetect;

})));


}).call(this)}).call(this,require('_process'))
},{"_process":409}],82:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":103,"../../modules/core.regexp.escape":207}],83:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],84:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":98}],85:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":122,"./_wks":205}],86:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],87:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":131}],88:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":191,"./_to-length":195,"./_to-object":196}],89:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":191,"./_to-length":195,"./_to-object":196}],90:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":119}],91:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":191,"./_to-iobject":194,"./_to-length":195}],92:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":95,"./_ctx":105,"./_iobject":127,"./_to-length":195,"./_to-object":196}],93:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":83,"./_iobject":127,"./_to-length":195,"./_to-object":196}],94:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":129,"./_is-object":131,"./_wks":205}],95:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":94}],96:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":83,"./_invoke":126,"./_is-object":131}],97:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":98,"./_wks":205}],98:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],99:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":86,"./_ctx":105,"./_descriptors":109,"./_for-of":119,"./_iter-define":135,"./_iter-step":137,"./_meta":145,"./_object-create":150,"./_object-dp":151,"./_redefine-all":170,"./_set-species":177,"./_validate-collection":202}],100:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":90,"./_classof":97}],101:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":86,"./_an-object":87,"./_array-methods":92,"./_for-of":119,"./_has":121,"./_is-object":131,"./_meta":145,"./_redefine-all":170,"./_validate-collection":202}],102:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":86,"./_export":113,"./_fails":115,"./_for-of":119,"./_global":120,"./_inherit-if-required":125,"./_is-object":131,"./_iter-detect":136,"./_meta":145,"./_redefine":171,"./_redefine-all":170,"./_set-to-string-tag":178}],103:[function(require,module,exports){
var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],104:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":151,"./_property-desc":169}],105:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":83}],106:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":115}],107:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":87,"./_to-primitive":197}],108:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],109:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":115}],110:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":120,"./_is-object":131}],111:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],112:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":157,"./_object-keys":160,"./_object-pie":161}],113:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":103,"./_ctx":105,"./_global":120,"./_hide":122,"./_redefine":171}],114:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":205}],115:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],116:[function(require,module,exports){
'use strict';
var hide = require('./_hide');
var redefine = require('./_redefine');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":108,"./_fails":115,"./_hide":122,"./_redefine":171,"./_wks":205}],117:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":87}],118:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":105,"./_is-array":129,"./_is-object":131,"./_to-length":195,"./_wks":205}],119:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":87,"./_ctx":105,"./_is-array-iter":128,"./_iter-call":133,"./_to-length":195,"./core.get-iterator-method":206}],120:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],121:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],122:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":109,"./_object-dp":151,"./_property-desc":169}],123:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":120}],124:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":109,"./_dom-create":110,"./_fails":115}],125:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":131,"./_set-proto":176}],126:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],127:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":98}],128:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":138,"./_wks":205}],129:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":98}],130:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":131}],131:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],132:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":98,"./_is-object":131,"./_wks":205}],133:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":87}],134:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":122,"./_object-create":150,"./_property-desc":169,"./_set-to-string-tag":178,"./_wks":205}],135:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var has = require('./_has');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":113,"./_has":121,"./_hide":122,"./_iter-create":134,"./_iterators":138,"./_library":139,"./_object-gpo":158,"./_redefine":171,"./_set-to-string-tag":178,"./_wks":205}],136:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":205}],137:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],138:[function(require,module,exports){
module.exports = {};

},{}],139:[function(require,module,exports){
module.exports = false;

},{}],140:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],141:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":144}],142:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],143:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],144:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],145:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":115,"./_has":121,"./_is-object":131,"./_object-dp":151,"./_uid":201}],146:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":113,"./_shared":180,"./es6.map":237,"./es6.weak-map":343}],147:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if (Observer) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":98,"./_global":120,"./_task":190}],148:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":83}],149:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":115,"./_iobject":127,"./_object-gops":157,"./_object-keys":160,"./_object-pie":161,"./_to-object":196}],150:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":87,"./_dom-create":110,"./_enum-bug-keys":111,"./_html":123,"./_object-dps":152,"./_shared-key":179}],151:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":87,"./_descriptors":109,"./_ie8-dom-define":124,"./_to-primitive":197}],152:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":87,"./_descriptors":109,"./_object-dp":151,"./_object-keys":160}],153:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":115,"./_global":120,"./_library":139}],154:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":109,"./_has":121,"./_ie8-dom-define":124,"./_object-pie":161,"./_property-desc":169,"./_to-iobject":194,"./_to-primitive":197}],155:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":156,"./_to-iobject":194}],156:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":111,"./_object-keys-internal":159}],157:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],158:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":121,"./_shared-key":179,"./_to-object":196}],159:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":91,"./_has":121,"./_shared-key":179,"./_to-iobject":194}],160:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":111,"./_object-keys-internal":159}],161:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],162:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":103,"./_export":113,"./_fails":115}],163:[function(require,module,exports){
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

},{"./_object-keys":160,"./_object-pie":161,"./_to-iobject":194}],164:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":87,"./_global":120,"./_object-gopn":156,"./_object-gops":157}],165:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":120,"./_string-trim":188,"./_string-ws":189}],166:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":120,"./_string-trim":188,"./_string-ws":189}],167:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],168:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":87,"./_is-object":131,"./_new-promise-capability":148}],169:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],170:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":171}],171:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":103,"./_global":120,"./_has":121,"./_hide":122,"./_uid":201}],172:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],173:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],174:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":83,"./_ctx":105,"./_export":113,"./_for-of":119}],175:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":113}],176:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":87,"./_ctx":105,"./_is-object":131,"./_object-gopd":154}],177:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":109,"./_global":120,"./_object-dp":151,"./_wks":205}],178:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":121,"./_object-dp":151,"./_wks":205}],179:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":180,"./_uid":201}],180:[function(require,module,exports){
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

},{"./_global":120}],181:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":83,"./_an-object":87,"./_wks":205}],182:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":115}],183:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":108,"./_to-integer":193}],184:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":108,"./_is-regexp":132}],185:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":108,"./_export":113,"./_fails":115}],186:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":108,"./_string-repeat":187,"./_to-length":195}],187:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":108,"./_to-integer":193}],188:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":108,"./_export":113,"./_fails":115,"./_string-ws":189}],189:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],190:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":98,"./_ctx":105,"./_dom-create":110,"./_global":120,"./_html":123,"./_invoke":126}],191:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":193}],192:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":193,"./_to-length":195}],193:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],194:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":108,"./_iobject":127}],195:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":193}],196:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":108}],197:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":131}],198:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":86,"./_array-copy-within":88,"./_array-fill":89,"./_array-includes":91,"./_array-methods":92,"./_classof":97,"./_ctx":105,"./_descriptors":109,"./_export":113,"./_fails":115,"./_global":120,"./_has":121,"./_hide":122,"./_is-array-iter":128,"./_is-object":131,"./_iter-detect":136,"./_iterators":138,"./_library":139,"./_object-create":150,"./_object-dp":151,"./_object-gopd":154,"./_object-gopn":156,"./_object-gpo":158,"./_property-desc":169,"./_redefine-all":170,"./_set-species":177,"./_species-constructor":181,"./_to-absolute-index":191,"./_to-index":192,"./_to-integer":193,"./_to-length":195,"./_to-object":196,"./_to-primitive":197,"./_typed":200,"./_typed-buffer":199,"./_uid":201,"./_wks":205,"./core.get-iterator-method":206,"./es6.array.iterator":218}],199:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":86,"./_array-fill":89,"./_descriptors":109,"./_fails":115,"./_global":120,"./_hide":122,"./_library":139,"./_object-dp":151,"./_object-gopn":156,"./_redefine-all":170,"./_set-to-string-tag":178,"./_to-index":192,"./_to-integer":193,"./_to-length":195,"./_typed":200}],200:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":120,"./_hide":122,"./_uid":201}],201:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],202:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":131}],203:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":103,"./_global":120,"./_library":139,"./_object-dp":151,"./_wks-ext":204}],204:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":205}],205:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":120,"./_shared":180,"./_uid":201}],206:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":97,"./_core":103,"./_iterators":138,"./_wks":205}],207:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":113,"./_replacer":172}],208:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":85,"./_array-copy-within":88,"./_export":113}],209:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":92,"./_export":113,"./_strict-method":182}],210:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":85,"./_array-fill":89,"./_export":113}],211:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":92,"./_export":113,"./_strict-method":182}],212:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":85,"./_array-methods":92,"./_export":113}],213:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":85,"./_array-methods":92,"./_export":113}],214:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":92,"./_export":113,"./_strict-method":182}],215:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":104,"./_ctx":105,"./_export":113,"./_is-array-iter":128,"./_iter-call":133,"./_iter-detect":136,"./_to-length":195,"./_to-object":196,"./core.get-iterator-method":206}],216:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":91,"./_export":113,"./_strict-method":182}],217:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":113,"./_is-array":129}],218:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":85,"./_iter-define":135,"./_iter-step":137,"./_iterators":138,"./_to-iobject":194}],219:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":113,"./_iobject":127,"./_strict-method":182,"./_to-iobject":194}],220:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":113,"./_strict-method":182,"./_to-integer":193,"./_to-iobject":194,"./_to-length":195}],221:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":92,"./_export":113,"./_strict-method":182}],222:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":104,"./_export":113,"./_fails":115}],223:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":93,"./_export":113,"./_strict-method":182}],224:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":93,"./_export":113,"./_strict-method":182}],225:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":98,"./_export":113,"./_fails":115,"./_html":123,"./_to-absolute-index":191,"./_to-length":195}],226:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":92,"./_export":113,"./_strict-method":182}],227:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":83,"./_export":113,"./_fails":115,"./_strict-method":182,"./_to-object":196}],228:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":177}],229:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":113}],230:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":106,"./_export":113}],231:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":113,"./_fails":115,"./_to-object":196,"./_to-primitive":197}],232:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":107,"./_hide":122,"./_wks":205}],233:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":171}],234:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":96,"./_export":113}],235:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":131,"./_object-dp":151,"./_object-gpo":158,"./_wks":205}],236:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":109,"./_object-dp":151}],237:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":102,"./_collection-strong":99,"./_validate-collection":202}],238:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":113,"./_math-log1p":142}],239:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":113}],240:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":113}],241:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":113,"./_math-sign":144}],242:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":113}],243:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":113}],244:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":113,"./_math-expm1":140}],245:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":113,"./_math-fround":141}],246:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":113}],247:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":113,"./_fails":115}],248:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":113}],249:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":113,"./_math-log1p":142}],250:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":113}],251:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":113,"./_math-sign":144}],252:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":113,"./_fails":115,"./_math-expm1":140}],253:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":113,"./_math-expm1":140}],254:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":113}],255:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":98,"./_descriptors":109,"./_fails":115,"./_global":120,"./_has":121,"./_inherit-if-required":125,"./_object-create":150,"./_object-dp":151,"./_object-gopd":154,"./_object-gopn":156,"./_redefine":171,"./_string-trim":188,"./_to-primitive":197}],256:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":113}],257:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":113,"./_global":120}],258:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":113,"./_is-integer":130}],259:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":113}],260:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":113,"./_is-integer":130}],261:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":113}],262:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":113}],263:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":113,"./_parse-float":165}],264:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":113,"./_parse-int":166}],265:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":84,"./_export":113,"./_fails":115,"./_string-repeat":187,"./_to-integer":193}],266:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":84,"./_export":113,"./_fails":115}],267:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":113,"./_object-assign":149}],268:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":113,"./_object-create":150}],269:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":109,"./_export":113,"./_object-dps":152}],270:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":109,"./_export":113,"./_object-dp":151}],271:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":131,"./_meta":145,"./_object-sap":162}],272:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":154,"./_object-sap":162,"./_to-iobject":194}],273:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":155,"./_object-sap":162}],274:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":158,"./_object-sap":162,"./_to-object":196}],275:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":131,"./_object-sap":162}],276:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":131,"./_object-sap":162}],277:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":131,"./_object-sap":162}],278:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":113,"./_same-value":173}],279:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":160,"./_object-sap":162,"./_to-object":196}],280:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":131,"./_meta":145,"./_object-sap":162}],281:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":131,"./_meta":145,"./_object-sap":162}],282:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":113,"./_set-proto":176}],283:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":97,"./_redefine":171,"./_wks":205}],284:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":113,"./_parse-float":165}],285:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":113,"./_parse-int":166}],286:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  if (promise._h == 1) return false;
  var chain = promise._a || promise._c;
  var i = 0;
  var reaction;
  while (chain.length > i) {
    reaction = chain[i++];
    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
  } return true;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":83,"./_an-instance":86,"./_classof":97,"./_core":103,"./_ctx":105,"./_export":113,"./_for-of":119,"./_global":120,"./_is-object":131,"./_iter-detect":136,"./_library":139,"./_microtask":147,"./_new-promise-capability":148,"./_perform":167,"./_promise-resolve":168,"./_redefine-all":170,"./_set-species":177,"./_set-to-string-tag":178,"./_species-constructor":181,"./_task":190,"./_wks":205}],287:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":83,"./_an-object":87,"./_export":113,"./_fails":115,"./_global":120}],288:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":83,"./_an-object":87,"./_bind":96,"./_export":113,"./_fails":115,"./_global":120,"./_is-object":131,"./_object-create":150}],289:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":87,"./_export":113,"./_fails":115,"./_object-dp":151,"./_to-primitive":197}],290:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":87,"./_export":113,"./_object-gopd":154}],291:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":87,"./_export":113,"./_iter-create":134}],292:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":87,"./_export":113,"./_object-gopd":154}],293:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":87,"./_export":113,"./_object-gpo":158}],294:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":87,"./_export":113,"./_has":121,"./_is-object":131,"./_object-gopd":154,"./_object-gpo":158}],295:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":113}],296:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":87,"./_export":113}],297:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":113,"./_own-keys":164}],298:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":87,"./_export":113}],299:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":113,"./_set-proto":176}],300:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":87,"./_export":113,"./_has":121,"./_is-object":131,"./_object-dp":151,"./_object-gopd":154,"./_object-gpo":158,"./_property-desc":169}],301:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":109,"./_fails":115,"./_flags":117,"./_global":120,"./_inherit-if-required":125,"./_is-regexp":132,"./_object-dp":151,"./_object-gopn":156,"./_redefine":171,"./_set-species":177,"./_wks":205}],302:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":109,"./_flags":117,"./_object-dp":151}],303:[function(require,module,exports){
// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

},{"./_fix-re-wks":116}],304:[function(require,module,exports){
// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

},{"./_fix-re-wks":116}],305:[function(require,module,exports){
// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

},{"./_fix-re-wks":116}],306:[function(require,module,exports){
// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = require('./_is-regexp');
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

},{"./_fix-re-wks":116,"./_is-regexp":132}],307:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":87,"./_descriptors":109,"./_fails":115,"./_flags":117,"./_redefine":171,"./es6.regexp.flags":302}],308:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":102,"./_collection-strong":99,"./_validate-collection":202}],309:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":185}],310:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":185}],311:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":185}],312:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":185}],313:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":113,"./_string-at":183}],314:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":113,"./_fails-is-regexp":114,"./_string-context":184,"./_to-length":195}],315:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":185}],316:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":185}],317:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":185}],318:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":113,"./_to-absolute-index":191}],319:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":113,"./_fails-is-regexp":114,"./_string-context":184}],320:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":185}],321:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":135,"./_string-at":183}],322:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":185}],323:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":113,"./_to-iobject":194,"./_to-length":195}],324:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":113,"./_string-repeat":187}],325:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":185}],326:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":113,"./_fails-is-regexp":114,"./_string-context":184,"./_to-length":195}],327:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":185}],328:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":185}],329:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":185}],330:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":188}],331:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":87,"./_descriptors":109,"./_enum-keys":112,"./_export":113,"./_fails":115,"./_global":120,"./_has":121,"./_hide":122,"./_is-array":129,"./_library":139,"./_meta":145,"./_object-create":150,"./_object-dp":151,"./_object-gopd":154,"./_object-gopn":156,"./_object-gopn-ext":155,"./_object-gops":157,"./_object-keys":160,"./_object-pie":161,"./_property-desc":169,"./_redefine":171,"./_set-to-string-tag":178,"./_shared":180,"./_to-iobject":194,"./_to-primitive":197,"./_uid":201,"./_wks":205,"./_wks-define":203,"./_wks-ext":204}],332:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":87,"./_export":113,"./_fails":115,"./_global":120,"./_is-object":131,"./_set-species":177,"./_species-constructor":181,"./_to-absolute-index":191,"./_to-length":195,"./_typed":200,"./_typed-buffer":199}],333:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":113,"./_typed":200,"./_typed-buffer":199}],334:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],335:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],336:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],337:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],338:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],339:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],340:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],341:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":198}],342:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":198}],343:[function(require,module,exports){
'use strict';
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var fails = require('./_fails');
var validate = require('./_validate-collection');
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":92,"./_collection":102,"./_collection-weak":101,"./_fails":115,"./_is-object":131,"./_meta":145,"./_object-assign":149,"./_redefine":171,"./_validate-collection":202}],344:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":102,"./_collection-weak":101,"./_validate-collection":202}],345:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":83,"./_add-to-unscopables":85,"./_array-species-create":95,"./_export":113,"./_flatten-into-array":118,"./_to-length":195,"./_to-object":196}],346:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":85,"./_array-species-create":95,"./_export":113,"./_flatten-into-array":118,"./_to-integer":193,"./_to-length":195,"./_to-object":196}],347:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":85,"./_array-includes":91,"./_export":113}],348:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":98,"./_export":113,"./_global":120,"./_microtask":147}],349:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":98,"./_export":113}],350:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":113,"./_global":120}],351:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":174}],352:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":175}],353:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":100,"./_export":113}],354:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":113}],355:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":113}],356:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":113}],357:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":113,"./_math-fround":141,"./_math-scale":143}],358:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":113}],359:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":113}],360:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":113}],361:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":113}],362:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":113}],363:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":113,"./_math-scale":143}],364:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":113}],365:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":113}],366:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":83,"./_descriptors":109,"./_export":113,"./_object-dp":151,"./_object-forced-pam":153,"./_to-object":196}],367:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":83,"./_descriptors":109,"./_export":113,"./_object-dp":151,"./_object-forced-pam":153,"./_to-object":196}],368:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":113,"./_object-to-array":163}],369:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":104,"./_export":113,"./_object-gopd":154,"./_own-keys":164,"./_to-iobject":194}],370:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":109,"./_export":113,"./_object-forced-pam":153,"./_object-gopd":154,"./_object-gpo":158,"./_to-object":196,"./_to-primitive":197}],371:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":109,"./_export":113,"./_object-forced-pam":153,"./_object-gopd":154,"./_object-gpo":158,"./_to-object":196,"./_to-primitive":197}],372:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":113,"./_object-to-array":163}],373:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":83,"./_an-instance":86,"./_an-object":87,"./_core":103,"./_export":113,"./_for-of":119,"./_global":120,"./_hide":122,"./_microtask":147,"./_redefine-all":170,"./_set-species":177,"./_wks":205}],374:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":103,"./_export":113,"./_global":120,"./_promise-resolve":168,"./_species-constructor":181}],375:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":113,"./_new-promise-capability":148,"./_perform":167}],376:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":87,"./_metadata":146}],377:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":87,"./_metadata":146}],378:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":87,"./_array-from-iterable":90,"./_metadata":146,"./_object-gpo":158,"./es6.set":308}],379:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":87,"./_metadata":146,"./_object-gpo":158}],380:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":87,"./_metadata":146}],381:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":87,"./_metadata":146}],382:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":87,"./_metadata":146,"./_object-gpo":158}],383:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":87,"./_metadata":146}],384:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":83,"./_an-object":87,"./_metadata":146}],385:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":174}],386:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":175}],387:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":100,"./_export":113}],388:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":113,"./_string-at":183}],389:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":108,"./_export":113,"./_flags":117,"./_is-regexp":132,"./_iter-create":134,"./_to-length":195}],390:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');

$export($export.P, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":113,"./_string-pad":186}],391:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');

$export($export.P, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":113,"./_string-pad":186}],392:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":188}],393:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":188}],394:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":203}],395:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":203}],396:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":113,"./_global":120}],397:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":174}],398:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":175}],399:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":174}],400:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":175}],401:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":120,"./_hide":122,"./_iterators":138,"./_object-keys":160,"./_redefine":171,"./_wks":205,"./es6.array.iterator":218}],402:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":113,"./_task":190}],403:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var navigator = global.navigator;
var slice = [].slice;
var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":113,"./_global":120}],404:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":103,"./modules/es6.array.copy-within":208,"./modules/es6.array.every":209,"./modules/es6.array.fill":210,"./modules/es6.array.filter":211,"./modules/es6.array.find":213,"./modules/es6.array.find-index":212,"./modules/es6.array.for-each":214,"./modules/es6.array.from":215,"./modules/es6.array.index-of":216,"./modules/es6.array.is-array":217,"./modules/es6.array.iterator":218,"./modules/es6.array.join":219,"./modules/es6.array.last-index-of":220,"./modules/es6.array.map":221,"./modules/es6.array.of":222,"./modules/es6.array.reduce":224,"./modules/es6.array.reduce-right":223,"./modules/es6.array.slice":225,"./modules/es6.array.some":226,"./modules/es6.array.sort":227,"./modules/es6.array.species":228,"./modules/es6.date.now":229,"./modules/es6.date.to-iso-string":230,"./modules/es6.date.to-json":231,"./modules/es6.date.to-primitive":232,"./modules/es6.date.to-string":233,"./modules/es6.function.bind":234,"./modules/es6.function.has-instance":235,"./modules/es6.function.name":236,"./modules/es6.map":237,"./modules/es6.math.acosh":238,"./modules/es6.math.asinh":239,"./modules/es6.math.atanh":240,"./modules/es6.math.cbrt":241,"./modules/es6.math.clz32":242,"./modules/es6.math.cosh":243,"./modules/es6.math.expm1":244,"./modules/es6.math.fround":245,"./modules/es6.math.hypot":246,"./modules/es6.math.imul":247,"./modules/es6.math.log10":248,"./modules/es6.math.log1p":249,"./modules/es6.math.log2":250,"./modules/es6.math.sign":251,"./modules/es6.math.sinh":252,"./modules/es6.math.tanh":253,"./modules/es6.math.trunc":254,"./modules/es6.number.constructor":255,"./modules/es6.number.epsilon":256,"./modules/es6.number.is-finite":257,"./modules/es6.number.is-integer":258,"./modules/es6.number.is-nan":259,"./modules/es6.number.is-safe-integer":260,"./modules/es6.number.max-safe-integer":261,"./modules/es6.number.min-safe-integer":262,"./modules/es6.number.parse-float":263,"./modules/es6.number.parse-int":264,"./modules/es6.number.to-fixed":265,"./modules/es6.number.to-precision":266,"./modules/es6.object.assign":267,"./modules/es6.object.create":268,"./modules/es6.object.define-properties":269,"./modules/es6.object.define-property":270,"./modules/es6.object.freeze":271,"./modules/es6.object.get-own-property-descriptor":272,"./modules/es6.object.get-own-property-names":273,"./modules/es6.object.get-prototype-of":274,"./modules/es6.object.is":278,"./modules/es6.object.is-extensible":275,"./modules/es6.object.is-frozen":276,"./modules/es6.object.is-sealed":277,"./modules/es6.object.keys":279,"./modules/es6.object.prevent-extensions":280,"./modules/es6.object.seal":281,"./modules/es6.object.set-prototype-of":282,"./modules/es6.object.to-string":283,"./modules/es6.parse-float":284,"./modules/es6.parse-int":285,"./modules/es6.promise":286,"./modules/es6.reflect.apply":287,"./modules/es6.reflect.construct":288,"./modules/es6.reflect.define-property":289,"./modules/es6.reflect.delete-property":290,"./modules/es6.reflect.enumerate":291,"./modules/es6.reflect.get":294,"./modules/es6.reflect.get-own-property-descriptor":292,"./modules/es6.reflect.get-prototype-of":293,"./modules/es6.reflect.has":295,"./modules/es6.reflect.is-extensible":296,"./modules/es6.reflect.own-keys":297,"./modules/es6.reflect.prevent-extensions":298,"./modules/es6.reflect.set":300,"./modules/es6.reflect.set-prototype-of":299,"./modules/es6.regexp.constructor":301,"./modules/es6.regexp.flags":302,"./modules/es6.regexp.match":303,"./modules/es6.regexp.replace":304,"./modules/es6.regexp.search":305,"./modules/es6.regexp.split":306,"./modules/es6.regexp.to-string":307,"./modules/es6.set":308,"./modules/es6.string.anchor":309,"./modules/es6.string.big":310,"./modules/es6.string.blink":311,"./modules/es6.string.bold":312,"./modules/es6.string.code-point-at":313,"./modules/es6.string.ends-with":314,"./modules/es6.string.fixed":315,"./modules/es6.string.fontcolor":316,"./modules/es6.string.fontsize":317,"./modules/es6.string.from-code-point":318,"./modules/es6.string.includes":319,"./modules/es6.string.italics":320,"./modules/es6.string.iterator":321,"./modules/es6.string.link":322,"./modules/es6.string.raw":323,"./modules/es6.string.repeat":324,"./modules/es6.string.small":325,"./modules/es6.string.starts-with":326,"./modules/es6.string.strike":327,"./modules/es6.string.sub":328,"./modules/es6.string.sup":329,"./modules/es6.string.trim":330,"./modules/es6.symbol":331,"./modules/es6.typed.array-buffer":332,"./modules/es6.typed.data-view":333,"./modules/es6.typed.float32-array":334,"./modules/es6.typed.float64-array":335,"./modules/es6.typed.int16-array":336,"./modules/es6.typed.int32-array":337,"./modules/es6.typed.int8-array":338,"./modules/es6.typed.uint16-array":339,"./modules/es6.typed.uint32-array":340,"./modules/es6.typed.uint8-array":341,"./modules/es6.typed.uint8-clamped-array":342,"./modules/es6.weak-map":343,"./modules/es6.weak-set":344,"./modules/es7.array.flat-map":345,"./modules/es7.array.flatten":346,"./modules/es7.array.includes":347,"./modules/es7.asap":348,"./modules/es7.error.is-error":349,"./modules/es7.global":350,"./modules/es7.map.from":351,"./modules/es7.map.of":352,"./modules/es7.map.to-json":353,"./modules/es7.math.clamp":354,"./modules/es7.math.deg-per-rad":355,"./modules/es7.math.degrees":356,"./modules/es7.math.fscale":357,"./modules/es7.math.iaddh":358,"./modules/es7.math.imulh":359,"./modules/es7.math.isubh":360,"./modules/es7.math.rad-per-deg":361,"./modules/es7.math.radians":362,"./modules/es7.math.scale":363,"./modules/es7.math.signbit":364,"./modules/es7.math.umulh":365,"./modules/es7.object.define-getter":366,"./modules/es7.object.define-setter":367,"./modules/es7.object.entries":368,"./modules/es7.object.get-own-property-descriptors":369,"./modules/es7.object.lookup-getter":370,"./modules/es7.object.lookup-setter":371,"./modules/es7.object.values":372,"./modules/es7.observable":373,"./modules/es7.promise.finally":374,"./modules/es7.promise.try":375,"./modules/es7.reflect.define-metadata":376,"./modules/es7.reflect.delete-metadata":377,"./modules/es7.reflect.get-metadata":379,"./modules/es7.reflect.get-metadata-keys":378,"./modules/es7.reflect.get-own-metadata":381,"./modules/es7.reflect.get-own-metadata-keys":380,"./modules/es7.reflect.has-metadata":382,"./modules/es7.reflect.has-own-metadata":383,"./modules/es7.reflect.metadata":384,"./modules/es7.set.from":385,"./modules/es7.set.of":386,"./modules/es7.set.to-json":387,"./modules/es7.string.at":388,"./modules/es7.string.match-all":389,"./modules/es7.string.pad-end":390,"./modules/es7.string.pad-start":391,"./modules/es7.string.trim-left":392,"./modules/es7.string.trim-right":393,"./modules/es7.symbol.async-iterator":394,"./modules/es7.symbol.observable":395,"./modules/es7.system.global":396,"./modules/es7.weak-map.from":397,"./modules/es7.weak-map.of":398,"./modules/es7.weak-set.from":399,"./modules/es7.weak-set.of":400,"./modules/web.dom.iterable":401,"./modules/web.immediate":402,"./modules/web.timers":403}],405:[function(require,module,exports){
'use strict';

// <3 Modernizr
// https://raw.githubusercontent.com/Modernizr/Modernizr/master/feature-detects/dom/dataset.js

function useNative() {
	var elem = document.createElement('div');
	elem.setAttribute('data-a-b', 'c');

	return Boolean(elem.dataset && elem.dataset.aB === 'c');
}

function nativeDataset(element) {
	return element.dataset;
}

module.exports = useNative() ? nativeDataset : function (element) {
	var map = {};
	var attributes = element.attributes;

	function getter() {
		return this.value;
	}

	function setter(name, value) {
		if (typeof value === 'undefined') {
			this.removeAttribute(name);
		} else {
			this.setAttribute(name, value);
		}
	}

	for (var i = 0, j = attributes.length; i < j; i++) {
		var attribute = attributes[i];

		if (attribute) {
			var name = attribute.name;

			if (name.indexOf('data-') === 0) {
				var prop = name.slice(5).replace(/-./g, function (u) {
					return u.charAt(1).toUpperCase();
				});

				var value = attribute.value;

				Object.defineProperty(map, prop, {
					enumerable: true,
					get: getter.bind({ value: value || '' }),
					set: setter.bind(element, name)
				});
			}
		}
	}

	return map;
};


},{}],406:[function(require,module,exports){
(function (process,global){(function (){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));





}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":409}],407:[function(require,module,exports){
(function (global){(function (){
;(function(){var h;function l(a){var c=0;return function(){return c<a.length?{done:!1,value:a[c++]}:{done:!0}}}var m="function"==typeof Object.defineProperties?Object.defineProperty:function(a,c,b){if(a==Array.prototype||a==Object.prototype)return a;a[c]=b.value;return a};
function n(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var c=0;c<a.length;++c){var b=a[c];if(b&&b.Math==Math)return b}throw Error("Cannot find global object");}var p=n(this);function r(a,c){if(c){for(var b=p,d=a.split("."),e=0;e<d.length-1;e++){var f=d[e];f in b||(b[f]={});b=b[f]}d=d[d.length-1];e=b[d];f=c(e);f!=e&&null!=f&&m(b,d,{configurable:!0,writable:!0,value:f})}}
r("Symbol",function(a){function c(e){if(this instanceof c)throw new TypeError("Symbol is not a constructor");return new b("jscomp_symbol_"+(e||"")+"_"+d++,e)}function b(e,f){this.o=e;m(this,"description",{configurable:!0,writable:!0,value:f})}if(a)return a;b.prototype.toString=function(){return this.o};var d=0;return c});
r("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var c="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),b=0;b<c.length;b++){var d=p[c[b]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&m(d.prototype,a,{configurable:!0,writable:!0,value:function(){return u(l(this))}})}return a});function u(a){a={next:a};a[Symbol.iterator]=function(){return this};return a}
function v(a){var c="undefined"!=typeof Symbol&&Symbol.iterator&&a[Symbol.iterator];return c?c.call(a):{next:l(a)}}var w;if("function"==typeof Object.setPrototypeOf)w=Object.setPrototypeOf;else{var y;a:{var z={u:!0},A={};try{A.__proto__=z;y=A.u;break a}catch(a){}y=!1}w=y?function(a,c){a.__proto__=c;if(a.__proto__!==c)throw new TypeError(a+" is not extensible");return a}:null}var B=w;function C(){this.h=!1;this.f=null;this.m=void 0;this.b=1;this.l=this.v=0;this.g=null}
function D(a){if(a.h)throw new TypeError("Generator is already running");a.h=!0}C.prototype.i=function(a){this.m=a};C.prototype.j=function(a){this.g={w:a,A:!0};this.b=this.v||this.l};C.prototype["return"]=function(a){this.g={"return":a};this.b=this.l};function E(a,c){a.b=3;return{value:c}}function F(a){this.a=new C;this.B=a}F.prototype.i=function(a){D(this.a);if(this.a.f)return G(this,this.a.f.next,a,this.a.i);this.a.i(a);return H(this)};
function I(a,c){D(a.a);var b=a.a.f;if(b)return G(a,"return"in b?b["return"]:function(d){return{value:d,done:!0}},c,a.a["return"]);a.a["return"](c);return H(a)}F.prototype.j=function(a){D(this.a);if(this.a.f)return G(this,this.a.f["throw"],a,this.a.i);this.a.j(a);return H(this)};
function G(a,c,b,d){try{var e=c.call(a.a.f,b);if(!(e instanceof Object))throw new TypeError("Iterator result "+e+" is not an object");if(!e.done)return a.a.h=!1,e;var f=e.value}catch(g){return a.a.f=null,a.a.j(g),H(a)}a.a.f=null;d.call(a.a,f);return H(a)}function H(a){for(;a.a.b;)try{var c=a.B(a.a);if(c)return a.a.h=!1,{value:c.value,done:!1}}catch(b){a.a.m=void 0,a.a.j(b)}a.a.h=!1;if(a.a.g){c=a.a.g;a.a.g=null;if(c.A)throw c.w;return{value:c["return"],done:!0}}return{value:void 0,done:!0}}
function J(a){this.next=function(c){return a.i(c)};this["throw"]=function(c){return a.j(c)};this["return"]=function(c){return I(a,c)};this[Symbol.iterator]=function(){return this}}function K(a,c){var b=new J(new F(c));B&&B(b,a.prototype);return b}
if("undefined"!==typeof Blob&&("undefined"===typeof FormData||!FormData.prototype.keys)){var L=function(a,c){for(var b=0;b<a.length;b++)c(a[b])},M=function(a,c,b){return c instanceof Blob?[String(a),c,void 0!==b?b+"":"string"===typeof c.name?c.name:"blob"]:[String(a),String(c)]},N=function(a,c){if(a.length<c)throw new TypeError(c+" argument required, but only "+a.length+" present.");},O=function(a){var c=v(a);a=c.next().value;var b=c.next().value;c=c.next().value;b instanceof Blob&&(b=new File([b],
c,{type:b.type,lastModified:b.lastModified}));return[a,b]},P="object"===typeof globalThis?globalThis:"object"===typeof window?window:"object"===typeof self?self:this,Q=P.FormData,R=P.XMLHttpRequest&&P.XMLHttpRequest.prototype.send,S=P.Request&&P.fetch,T=P.navigator&&P.navigator.sendBeacon,U=P.Element&&P.Element.prototype,V=P.Symbol&&Symbol.toStringTag;V&&(Blob.prototype[V]||(Blob.prototype[V]="Blob"),"File"in P&&!File.prototype[V]&&(File.prototype[V]="File"));try{new File([],"")}catch(a){P.File=function(c,
b,d){c=new Blob(c,d);d=d&&void 0!==d.lastModified?new Date(d.lastModified):new Date;Object.defineProperties(c,{name:{value:b},lastModifiedDate:{value:d},lastModified:{value:+d},toString:{value:function(){return"[object File]"}}});V&&Object.defineProperty(c,V,{value:"File"});return c}}var W=function(a){this.c=[];var c=this;a&&L(a.elements,function(b){if(b.name&&!b.disabled&&"submit"!==b.type&&"button"!==b.type&&!b.matches("form fieldset[disabled] *"))if("file"===b.type){var d=b.files&&b.files.length?
b.files:[new File([],"",{type:"application/octet-stream"})];L(d,function(e){c.append(b.name,e)})}else"select-multiple"===b.type||"select-one"===b.type?L(b.options,function(e){!e.disabled&&e.selected&&c.append(b.name,e.value)}):"checkbox"===b.type||"radio"===b.type?b.checked&&c.append(b.name,b.value):(d="textarea"===b.type?b.value.replace(/\r\n/g,"\n").replace(/\n/g,"\r\n"):b.value,c.append(b.name,d))})};h=W.prototype;h.append=function(a,c,b){N(arguments,2);this.c.push(M(a,c,b))};h["delete"]=function(a){N(arguments,
1);var c=[];a=String(a);L(this.c,function(b){b[0]!==a&&c.push(b)});this.c=c};h.entries=function c(){var b,d=this;return K(c,function(e){1==e.b&&(b=0);if(3!=e.b)return b<d.c.length?e=E(e,O(d.c[b])):(e.b=0,e=void 0),e;b++;e.b=2})};h.forEach=function(c,b){N(arguments,1);for(var d=v(this),e=d.next();!e.done;e=d.next()){var f=v(e.value);e=f.next().value;f=f.next().value;c.call(b,f,e,this)}};h.get=function(c){N(arguments,1);var b=this.c;c=String(c);for(var d=0;d<b.length;d++)if(b[d][0]===c)return O(b[d])[1];
return null};h.getAll=function(c){N(arguments,1);var b=[];c=String(c);L(this.c,function(d){d[0]===c&&b.push(O(d)[1])});return b};h.has=function(c){N(arguments,1);c=String(c);for(var b=0;b<this.c.length;b++)if(this.c[b][0]===c)return!0;return!1};h.keys=function b(){var d=this,e,f,g,k,q;return K(b,function(t){1==t.b&&(e=v(d),f=e.next());if(3!=t.b){if(f.done){t.b=0;return}g=f.value;k=v(g);q=k.next().value;return E(t,q)}f=e.next();t.b=2})};h.set=function(b,d,e){N(arguments,2);b=String(b);var f=[],g=M(b,
d,e),k=!0;L(this.c,function(q){q[0]===b?k&&(k=!f.push(g)):f.push(q)});k&&f.push(g);this.c=f};h.values=function d(){var e=this,f,g,k,q,t;return K(d,function(x){1==x.b&&(f=v(e),g=f.next());if(3!=x.b){if(g.done){x.b=0;return}k=g.value;q=v(k);q.next();t=q.next().value;return E(x,t)}g=f.next();x.b=2})};W.prototype._asNative=function(){for(var d=new Q,e=v(this),f=e.next();!f.done;f=e.next()){var g=v(f.value);f=g.next().value;g=g.next().value;d.append(f,g)}return d};W.prototype._blob=function(){for(var d=
"----formdata-polyfill-"+Math.random(),e=[],f=v(this),g=f.next();!g.done;g=f.next()){var k=v(g.value);g=k.next().value;k=k.next().value;e.push("--"+d+"\r\n");k instanceof Blob?e.push('Content-Disposition: form-data; name="'+g+'"; filename="'+k.name+'"\r\nContent-Type: '+((k.type||"application/octet-stream")+"\r\n\r\n"),k,"\r\n"):e.push('Content-Disposition: form-data; name="'+g+'"\r\n\r\n'+k+"\r\n")}e.push("--"+d+"--");return new Blob(e,{type:"multipart/form-data; boundary="+d})};W.prototype[Symbol.iterator]=
function(){return this.entries()};W.prototype.toString=function(){return"[object FormData]"};U&&!U.matches&&(U.matches=U.matchesSelector||U.mozMatchesSelector||U.msMatchesSelector||U.oMatchesSelector||U.webkitMatchesSelector||function(d){d=(this.document||this.ownerDocument).querySelectorAll(d);for(var e=d.length;0<=--e&&d.item(e)!==this;);return-1<e});V&&(W.prototype[V]="FormData");if(R){var X=P.XMLHttpRequest.prototype.setRequestHeader;P.XMLHttpRequest.prototype.setRequestHeader=function(d,e){X.call(this,
d,e);"content-type"===d.toLowerCase()&&(this.s=!0)};P.XMLHttpRequest.prototype.send=function(d){d instanceof W?(d=d._blob(),this.s||this.setRequestHeader("Content-Type",d.type),R.call(this,d)):R.call(this,d)}}S&&(P.fetch=function(d,e){e&&e.body&&e.body instanceof W&&(e.body=e.body._blob());return S.call(this,d,e)});T&&(P.navigator.sendBeacon=function(d,e){e instanceof W&&(e=e._asNative());return T.call(this,d,e)});P.FormData=W};
})();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],408:[function(require,module,exports){
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
require('whatwg-fetch');
module.exports = self.fetch.bind(self);

},{"whatwg-fetch":412}],409:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],410:[function(require,module,exports){
(function (global){(function (){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],411:[function(require,module,exports){
(function (global){(function (){
(function(global) {
  /**
   * Polyfill URLSearchParams
   *
   * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
   */

  var checkIfIteratorIsSupported = function() {
    try {
      return !!Symbol.iterator;
    } catch (error) {
      return false;
    }
  };


  var iteratorSupported = checkIfIteratorIsSupported();

  var createIterator = function(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return { done: value === void 0, value: value };
      }
    };

    if (iteratorSupported) {
      iterator[Symbol.iterator] = function() {
        return iterator;
      };
    }

    return iterator;
  };

  /**
   * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
   * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
   */
  var serializeParam = function(value) {
    return encodeURIComponent(value).replace(/%20/g, '+');
  };

  var deserializeParam = function(value) {
    return decodeURIComponent(String(value).replace(/\+/g, ' '));
  };

  var polyfillURLSearchParams = function() {

    var URLSearchParams = function(searchString) {
      Object.defineProperty(this, '_entries', { writable: true, value: {} });
      var typeofSearchString = typeof searchString;

      if (typeofSearchString === 'undefined') {
        // do nothing
      } else if (typeofSearchString === 'string') {
        if (searchString !== '') {
          this._fromString(searchString);
        }
      } else if (searchString instanceof URLSearchParams) {
        var _this = this;
        searchString.forEach(function(value, name) {
          _this.append(name, value);
        });
      } else if ((searchString !== null) && (typeofSearchString === 'object')) {
        if (Object.prototype.toString.call(searchString) === '[object Array]') {
          for (var i = 0; i < searchString.length; i++) {
            var entry = searchString[i];
            if ((Object.prototype.toString.call(entry) === '[object Array]') || (entry.length !== 2)) {
              this.append(entry[0], entry[1]);
            } else {
              throw new TypeError('Expected [string, any] as entry at index ' + i + ' of URLSearchParams\'s input');
            }
          }
        } else {
          for (var key in searchString) {
            if (searchString.hasOwnProperty(key)) {
              this.append(key, searchString[key]);
            }
          }
        }
      } else {
        throw new TypeError('Unsupported input\'s type for URLSearchParams');
      }
    };

    var proto = URLSearchParams.prototype;

    proto.append = function(name, value) {
      if (name in this._entries) {
        this._entries[name].push(String(value));
      } else {
        this._entries[name] = [String(value)];
      }
    };

    proto.delete = function(name) {
      delete this._entries[name];
    };

    proto.get = function(name) {
      return (name in this._entries) ? this._entries[name][0] : null;
    };

    proto.getAll = function(name) {
      return (name in this._entries) ? this._entries[name].slice(0) : [];
    };

    proto.has = function(name) {
      return (name in this._entries);
    };

    proto.set = function(name, value) {
      this._entries[name] = [String(value)];
    };

    proto.forEach = function(callback, thisArg) {
      var entries;
      for (var name in this._entries) {
        if (this._entries.hasOwnProperty(name)) {
          entries = this._entries[name];
          for (var i = 0; i < entries.length; i++) {
            callback.call(thisArg, entries[i], name, this);
          }
        }
      }
    };

    proto.keys = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push(name);
      });
      return createIterator(items);
    };

    proto.values = function() {
      var items = [];
      this.forEach(function(value) {
        items.push(value);
      });
      return createIterator(items);
    };

    proto.entries = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
      });
      return createIterator(items);
    };

    if (iteratorSupported) {
      proto[Symbol.iterator] = proto.entries;
    }

    proto.toString = function() {
      var searchArray = [];
      this.forEach(function(value, name) {
        searchArray.push(serializeParam(name) + '=' + serializeParam(value));
      });
      return searchArray.join('&');
    };


    global.URLSearchParams = URLSearchParams;
  };

  var checkIfURLSearchParamsSupported = function() {
    try {
      var URLSearchParams = global.URLSearchParams;

      return (
        (new URLSearchParams('?a=1').toString() === 'a=1') &&
        (typeof URLSearchParams.prototype.set === 'function') &&
        (typeof URLSearchParams.prototype.entries === 'function')
      );
    } catch (e) {
      return false;
    }
  };

  if (!checkIfURLSearchParamsSupported()) {
    polyfillURLSearchParams();
  }

  var proto = global.URLSearchParams.prototype;

  if (typeof proto.sort !== 'function') {
    proto.sort = function() {
      var _this = this;
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
        if (!_this._entries) {
          _this.delete(name);
        }
      });
      items.sort(function(a, b) {
        if (a[0] < b[0]) {
          return -1;
        } else if (a[0] > b[0]) {
          return +1;
        } else {
          return 0;
        }
      });
      if (_this._entries) { // force reset because IE keeps keys index
        _this._entries = {};
      }
      for (var i = 0; i < items.length; i++) {
        this.append(items[i][0], items[i][1]);
      }
    };
  }

  if (typeof proto._fromString !== 'function') {
    Object.defineProperty(proto, '_fromString', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: function(searchString) {
        if (this._entries) {
          this._entries = {};
        } else {
          var keys = [];
          this.forEach(function(value, name) {
            keys.push(name);
          });
          for (var i = 0; i < keys.length; i++) {
            this.delete(keys[i]);
          }
        }

        searchString = searchString.replace(/^\?/, '');
        var attributes = searchString.split('&');
        var attribute;
        for (var i = 0; i < attributes.length; i++) {
          attribute = attributes[i].split('=');
          this.append(
            deserializeParam(attribute[0]),
            (attribute.length > 1) ? deserializeParam(attribute[1]) : ''
          );
        }
      }
    });
  }

  // HTMLAnchorElement

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

(function(global) {
  /**
   * Polyfill URL
   *
   * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
   */

  var checkIfURLIsSupported = function() {
    try {
      var u = new global.URL('b', 'http://a');
      u.pathname = 'c d';
      return (u.href === 'http://a/c%20d') && u.searchParams;
    } catch (e) {
      return false;
    }
  };


  var polyfillURL = function() {
    var _URL = global.URL;

    var URL = function(url, base) {
      if (typeof url !== 'string') url = String(url);
      if (base && typeof base !== 'string') base = String(base);

      // Only create another document if the base is different from current location.
      var doc = document, baseElement;
      if (base && (global.location === void 0 || base !== global.location.href)) {
        base = base.toLowerCase();
        doc = document.implementation.createHTMLDocument('');
        baseElement = doc.createElement('base');
        baseElement.href = base;
        doc.head.appendChild(baseElement);
        try {
          if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
        } catch (err) {
          throw new Error('URL unable to set base ' + base + ' due to ' + err);
        }
      }

      var anchorElement = doc.createElement('a');
      anchorElement.href = url;
      if (baseElement) {
        doc.body.appendChild(anchorElement);
        anchorElement.href = anchorElement.href; // force href to refresh
      }

      var inputElement = doc.createElement('input');
      inputElement.type = 'url';
      inputElement.value = url;

      if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href) || (!inputElement.checkValidity() && !base)) {
        throw new TypeError('Invalid URL');
      }

      Object.defineProperty(this, '_anchorElement', {
        value: anchorElement
      });


      // create a linked searchParams which reflect its changes on URL
      var searchParams = new global.URLSearchParams(this.search);
      var enableSearchUpdate = true;
      var enableSearchParamsUpdate = true;
      var _this = this;
      ['append', 'delete', 'set'].forEach(function(methodName) {
        var method = searchParams[methodName];
        searchParams[methodName] = function() {
          method.apply(searchParams, arguments);
          if (enableSearchUpdate) {
            enableSearchParamsUpdate = false;
            _this.search = searchParams.toString();
            enableSearchParamsUpdate = true;
          }
        };
      });

      Object.defineProperty(this, 'searchParams', {
        value: searchParams,
        enumerable: true
      });

      var search = void 0;
      Object.defineProperty(this, '_updateSearchParams', {
        enumerable: false,
        configurable: false,
        writable: false,
        value: function() {
          if (this.search !== search) {
            search = this.search;
            if (enableSearchParamsUpdate) {
              enableSearchUpdate = false;
              this.searchParams._fromString(this.search);
              enableSearchUpdate = true;
            }
          }
        }
      });
    };

    var proto = URL.prototype;

    var linkURLWithAnchorAttribute = function(attributeName) {
      Object.defineProperty(proto, attributeName, {
        get: function() {
          return this._anchorElement[attributeName];
        },
        set: function(value) {
          this._anchorElement[attributeName] = value;
        },
        enumerable: true
      });
    };

    ['hash', 'host', 'hostname', 'port', 'protocol']
      .forEach(function(attributeName) {
        linkURLWithAnchorAttribute(attributeName);
      });

    Object.defineProperty(proto, 'search', {
      get: function() {
        return this._anchorElement['search'];
      },
      set: function(value) {
        this._anchorElement['search'] = value;
        this._updateSearchParams();
      },
      enumerable: true
    });

    Object.defineProperties(proto, {

      'toString': {
        get: function() {
          var _this = this;
          return function() {
            return _this.href;
          };
        }
      },

      'href': {
        get: function() {
          return this._anchorElement.href.replace(/\?$/, '');
        },
        set: function(value) {
          this._anchorElement.href = value;
          this._updateSearchParams();
        },
        enumerable: true
      },

      'pathname': {
        get: function() {
          return this._anchorElement.pathname.replace(/(^\/?)/, '/');
        },
        set: function(value) {
          this._anchorElement.pathname = value;
        },
        enumerable: true
      },

      'origin': {
        get: function() {
          // get expected port from protocol
          var expectedPort = { 'http:': 80, 'https:': 443, 'ftp:': 21 }[this._anchorElement.protocol];
          // add port to origin if, expected port is different than actual port
          // and it is not empty f.e http://foo:8080
          // 8080 != 80 && 8080 != ''
          var addPortToOrigin = this._anchorElement.port != expectedPort &&
            this._anchorElement.port !== '';

          return this._anchorElement.protocol +
            '//' +
            this._anchorElement.hostname +
            (addPortToOrigin ? (':' + this._anchorElement.port) : '');
        },
        enumerable: true
      },

      'password': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },

      'username': { // TODO
        get: function() {
          return '';
        },
        set: function(value) {
        },
        enumerable: true
      },
    });

    URL.createObjectURL = function(blob) {
      return _URL.createObjectURL.apply(_URL, arguments);
    };

    URL.revokeObjectURL = function(url) {
      return _URL.revokeObjectURL.apply(_URL, arguments);
    };

    global.URL = URL;

  };

  if (!checkIfURLIsSupported()) {
    polyfillURL();
  }

  if ((global.location !== void 0) && !('origin' in global.location)) {
    var getOrigin = function() {
      return global.location.protocol + '//' + global.location.hostname + (global.location.port ? (':' + global.location.port) : '');
    };

    try {
      Object.defineProperty(global.location, 'origin', {
        get: getOrigin,
        enumerable: true
      });
    } catch (e) {
      setInterval(function() {
        global.location.origin = getOrigin();
      }, 100);
    }
  }

})(
  (typeof global !== 'undefined') ? global
    : ((typeof window !== 'undefined') ? window
    : ((typeof self !== 'undefined') ? self : this))
);

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],412:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.WHATWGFetch = {})));
}(this, (function (exports) { 'use strict';

  var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof self !== 'undefined' && self) ||
    (typeof global !== 'undefined' && global);

  var support = {
    searchParams: 'URLSearchParams' in global,
    iterable: 'Symbol' in global && 'iterator' in Symbol,
    blob:
      'FileReader' in global &&
      'Blob' in global &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in global,
    arrayBuffer: 'ArrayBuffer' in global
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
      throw new TypeError('Invalid character in header field name: "' + name + '"')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */
      this.bodyUsed = this.bodyUsed;
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          var isConsumed = consumed(this);
          if (isConsumed) {
            return isConsumed
          }
          if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
            return Promise.resolve(
              this._bodyArrayBuffer.buffer.slice(
                this._bodyArrayBuffer.byteOffset,
                this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
              )
            )
          } else {
            return Promise.resolve(this._bodyArrayBuffer)
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    if (!(this instanceof Request)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }

    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);

    if (this.method === 'GET' || this.method === 'HEAD') {
      if (options.cache === 'no-store' || options.cache === 'no-cache') {
        // Search for a '_' parameter in the query string
        var reParamSearch = /([?&])_=[^&]*/;
        if (reParamSearch.test(this.url)) {
          // If it already exists then set the value with the current time
          this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
        } else {
          // Otherwise add a new '_' parameter to the end with the current time
          var reQueryString = /\?/;
          this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
        }
      }
    }
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders
      .split('\r')
      .map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
      })
      .forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
          var value = parts.join(':').trim();
          headers.append(key, value);
        }
      });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!(this instanceof Response)) {
      throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
    }
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = global.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        setTimeout(function() {
          resolve(new Response(body, options));
        }, 0);
      };

      xhr.onerror = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.ontimeout = function() {
        setTimeout(function() {
          reject(new TypeError('Network request failed'));
        }, 0);
      };

      xhr.onabort = function() {
        setTimeout(function() {
          reject(new exports.DOMException('Aborted', 'AbortError'));
        }, 0);
      };

      function fixUrl(url) {
        try {
          return url === '' && global.location.href ? global.location.href : url
        } catch (e) {
          return url
        }
      }

      xhr.open(request.method, fixUrl(request.url), true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr) {
        if (support.blob) {
          xhr.responseType = 'blob';
        } else if (
          support.arrayBuffer &&
          request.headers.get('Content-Type') &&
          request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
        ) {
          xhr.responseType = 'arraybuffer';
        }
      }

      if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
        Object.getOwnPropertyNames(init.headers).forEach(function(name) {
          xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
        });
      } else {
        request.headers.forEach(function(value, name) {
          xhr.setRequestHeader(name, value);
        });
      }

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!global.fetch) {
    global.fetch = fetch;
    global.Headers = Headers;
    global.Request = Request;
    global.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

},{}]},{},[66]);
